// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../icomoon/style.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Assistant-Regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/Assistant-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/Assistant-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/Assistant-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/Assistant-Regular.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/Assistant-ExtraBold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../fonts/Assistant-ExtraBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../fonts/Assistant-ExtraBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../fonts/Assistant-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../fonts/Assistant-ExtraBold.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../fonts/Assistant-Bold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../fonts/Assistant-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../fonts/Assistant-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../fonts/Assistant-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../fonts/Assistant-Bold.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../fonts/Assistant-ExtraLight.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../fonts/Assistant-ExtraLight.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../fonts/Assistant-ExtraLight.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../fonts/Assistant-ExtraLight.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../fonts/Assistant-ExtraLight.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../fonts/Assistant-Medium.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../fonts/Assistant-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../fonts/Assistant-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../fonts/Assistant-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../fonts/Assistant-Medium.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../fonts/Assistant-Light.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../fonts/Assistant-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../fonts/Assistant-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../fonts/Assistant-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../fonts/Assistant-Light.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("../fonts/Assistant-SemiBold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("../fonts/Assistant-SemiBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("../fonts/Assistant-SemiBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("../fonts/Assistant-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("../fonts/Assistant-SemiBold.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "#Assistant-Regular" });
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___, { hash: "#Assistant-ExtraBold" });
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___, { hash: "#Assistant-Bold" });
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___, { hash: "#Assistant-ExtraLight" });
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___, { hash: "#Assistant-Medium" });
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___, { hash: "#Assistant-Light" });
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___, { hash: "#Assistant-SemiBold" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Assistant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Assistant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("svg");
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Assistant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("svg");
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Assistant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format("svg");
  font-weight: 200;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Assistant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_28___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format("svg");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Assistant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_31___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_32___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_33___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_34___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_35___}) format("svg");
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Assistant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_37___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_38___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_39___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_40___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_41___}) format("svg");
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  font-size: 16px;
}

body {
  font-family: "Assistant", sans-serif;
  background: #fff;
  color: #364048;
  overflow: hidden;
}
body.setting__body .main,
body.setting__body .wrapper {
  overflow: unset;
  height: auto;
}
body.setting__body {
  overflow: auto;
}

.wrapper {
  width: 100%;
  overflow: hidden;
  margin: 0 auto;
  position: relative;
  background: #F0F0F3;
}

.row {
  display: flex;
  flex-wrap: wrap;
}

.clear {
  clear: both;
}

/* width */
::-webkit-scrollbar {
  width: 8px;
  display: block;
}

.filter__block .asset__block::-webkit-scrollbar {
  width: inherit !important;
}

.recycle__layout {
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  bottom: 0;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 4px 4px 4px rgba(174, 174, 192, 0.2);
  border-radius: 67px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 8px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: transparent;
}

.add__defi__item, .card__product__stake__amount__max, .wallet__addresses__top__right__btn, .zoom__page__btn,
.layout__list,
.layout__grid, .to__top, .reset__btn, .risk__btn, .card__product__unstacked, .card__product__stake, .card__risk__alert, .card__settings {
  transition: all 0.4s;
}

.limit__block__top, .wallet__type__btn {
  transition: all 0.4s;
}

.login__btn, .password__change__btn, .card__product__stake__amount__confirm, .wallet__type__save {
  transition: all 0.4s;
}
.login__btn:hover, .password__change__btn:hover, .card__product__stake__amount__confirm:hover, .wallet__type__save:hover {
  background: #1762A2;
}

.card__risk__alert.active {
  transition: all 0.4s;
  box-shadow: inset 3px 3px 3px rgba(174, 174, 192, 0.2), inset -3px -3px 3px rgba(255, 255, 255, 0.6980392157);
}

.limit__block__top.active {
  transition: all 0.4s;
  box-shadow: 3px 3px 3px rgba(174, 174, 192, 0.2), -3px -3px 3px rgba(255, 255, 255, 0.6980392157);
}

.align-items-center {
  align-items: center;
}

.dropdown {
  position: relative;
  width: 272px;
}
.dropdown.open .dropdown__selected {
  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);
}
.dropdown.open .dropdown__selected .dropdown__arrow {
  transform: rotate(-180deg);
}
.dropdown.open .dropdown__body {
  display: block;
}

.dropdown__selected {
  height: 48px;
  width: 100%;
  background: #EDEDEF;
  box-shadow: -3px -3px 9px #FFFFFF, 3px 3px 9px rgba(174, 174, 192, 0.4039215686);
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 20px;
  position: relative;
  z-index: 2;
  cursor: pointer;
}

.dropdown__arrow {
  display: flex;
  right: 25px;
  position: absolute;
}

.dropdown__body {
  background: #F0F0F3;
  box-shadow: 0 5px 15px rgba(56, 70, 82, 0.2549019608);
  border-radius: 0 0 20px 20px;
  padding: 35px 16px 16px;
  position: absolute;
  width: 100%;
  z-index: 1;
  top: 25px;
  display: none;
}

.dropdown__copy {
  width: 100%;
  border-radius: 80px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #A9B6C1;
  font-weight: 600;
  font-size: 20px;
  position: relative;
  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);
}

.dropdown__copy__icon__wrapper {
  width: 32px;
  height: 32px;
  box-shadow: -3px -3px 9px #FFFFFF, 3px 3px 9px rgba(174, 174, 192, 0.4039215686);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 8px;
  top: 8px;
  cursor: pointer;
}

.dropdown__sub {
  margin-top: 16px;
  position: relative;
  width: 248px;
}
.dropdown__sub.open .dropdown__sub__selected {
  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);
}
.dropdown__sub.open .dropdown__sub__selected .dropdown__arrow {
  transform: rotate(-180deg);
}
.dropdown__sub.open .dropdown__sub__body {
  display: block;
}

.dropdown__sub__selected {
  height: 48px;
  width: 100%;
  background: #EDEDEF;
  box-shadow: -3px -3px 9px #FFFFFF, 3px 3px 9px rgba(174, 174, 192, 0.4039215686);
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 20px;
  position: relative;
  z-index: 2;
  cursor: pointer;
}

.dropdown__sub__body {
  position: absolute;
  box-shadow: 0 5px 15px rgba(56, 70, 82, 0.2549019608);
  border-radius: 0 0 25px 25px;
  background: #F0F0F3;
  width: 100%;
  top: 35px;
  padding: 20px 16px 16px;
}

.dropdown__sub__item {
  color: #364048;
  font-weight: 600;
  font-size: 20px;
  padding: 13px 0;
  border-bottom: 1px solid #A9B6C1;
  cursor: pointer;
}
.dropdown__sub__item:last-child {
  border-bottom: 0;
  padding-bottom: 3px;
}
.dropdown__sub__item:first-child {
  padding-top: 0;
}

input:autofill {
  background: transparent !important; /* or any other */
}

.modal__wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: fit-content;
  margin: auto;
  min-height: 500px;
  height: auto;
  display: flex;
  justify-content: center;
  z-index: 9999999;
  overflow-y: auto;
  overflow-x: hidden;
  box-shadow: 0 5px 15px 0 rgb(56, 70, 82);
  margin-top: 115px;
  border-radius: 20px;
}

.modal {
  width: 992px;
  border-radius: 20px;
  box-shadow: 0 5px 15px 0 rgba(56, 70, 82, 0.25);
  background-color: #f0f0f3;
  padding: 24px 24px;
  height: 500px;
  overflow-y: scroll;
}
.modal__header {
  display: flex;
  position: relative;
  padding-right: 24px;
}

::-webkit-scrollbar-track {
  background: none !important;
  box-shadow: none !important;
}

.card {
  width: 312px;
  height: 488px;
  background: #F0F0F3;
  box-shadow: -8px -8px 24px #FFFFFF, 8px 8px 24px rgba(174, 174, 192, 0.4039215686);
  border-radius: 24px;
  margin-right: 40px;
  margin-bottom: 40px;
  padding: 24px;
  position: relative;
}
.card.aside__card__big {
  margin: 49px auto 8px;
  padding: 0;
  box-shadow: unset;
}
.card.aside__card__big .card__wallet__row {
  background-color: transparent;
}
.card.aside__card__big .card__title {
  font-size: 18px;
  text-align: center;
  max-width: 225px;
  margin: 0 auto;
}
.card.aside__card__big .card__wallet__usd {
  font-size: 20px;
  color: #364048;
  font-weight: 700;
}
.card.aside__card__big .card__product__number.cold {
  color: #4DC7B5;
}
.card.aside__card__big .card__product__number.cold.empty {
  color: #889096;
}
.card.aside__card__big .card__product__number.hold {
  color: #EFB661;
}
.card.aside__card__big .card__product__number.hold.empty {
  color: #889096;
}
.card.aside__card__big .card__product__number.risky {
  color: #F27281;
}
.card.aside__card__big .card__product__number.risky.empty {
  color: #889096;
}
.card .add__wallet {
  display: none;
}
.card.new .new__layer {
  border-radius: 24px;
  background: rgba(240, 240, 243, 0.7);
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1;
  position: absolute;
}
.card.new .add__wallet {
  background: #F0F0F3;
  box-shadow: inset 10px 10px 10px rgba(174, 174, 192, 0.2), inset -10px -10px 10px rgba(255, 255, 255, 0.6980392157);
  width: 136px;
  height: 136px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.4s;
  cursor: pointer;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 2;
}
.card.new .add__wallet .save__text {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  opacity: 0;
  visibility: hidden;
  color: #ffffff;
  text-transform: uppercase;
  font-size: 18px;
  font-weight: normal;
  max-width: max-content;
  max-height: max-content;
}
.card.new .add__wallet .plus__wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  visibility: hidden;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
}
.card.new .add__wallet .plus__wrapper span {
  width: 30px;
  height: 5px;
  background: #F0F0F3;
  border-radius: 2px;
  position: absolute;
}
.card.new .add__wallet .plus__wrapper span:nth-child(2) {
  transform: rotate(90deg);
}
.card.new .add__wallet.new .plus__wrapper {
  visibility: visible;
  opacity: 1;
}
.card.new .add__wallet.save {
  top: 288px;
}
.card.new .add__wallet.save .plus__wrapper {
  position: absolute;
  visibility: hidden;
  opacity: 0;
}
.card.new .add__wallet.save .save__text {
  opacity: 1;
  visibility: visible;
}
.card.new .add__wallet .add__wallet__btn__bg {
  background: #1762A2;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: inset 2px 2px 2px rgba(255, 255, 255, 0.44), 10px 10px 30px rgba(174, 174, 192, 0.44), inset -2px -2px 2px rgba(29, 29, 29, 0.2549019608), -10px -10px 30px #FFFFFF;
  position: relative;
}
.card.trash .trash__layer {
  border-radius: 24px;
  background: rgba(240, 240, 243, 0.7);
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1;
  position: absolute;
}
.card.trash .trash__wallet {
  background: #F0F0F3;
  box-shadow: -8px -8px 24px #FFFFFF, 10px 10px 30px rgba(174, 174, 192, 0.4039215686);
  width: 136px;
  height: 136px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.4s;
  cursor: pointer;
  position: absolute;
  top: 110px;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 2;
}
.card.trash .unstacking {
  display: none;
}
.card.trash .trash__wallet__icon {
  width: 44px;
  height: 48px;
}
.card.trash .card__settings {
  opacity: 0;
  visibility: hidden;
}
.card.new__defi .card__risk {
  margin-top: 0;
}
.card.empty .card__nft__img,
.card.empty .card__risk__range,
.card.empty .unstacking {
  opacity: 0;
  visibility: hidden;
}
.card.empty .card__product__unstacked,
.card.empty .card__product__stake,
.card.empty .card__risk__chart__number__of,
.card.empty .card__risk__chart__number,
.card.empty .card__risk__alert__title,
.card.empty .card__risk__alert__number,
.card.empty .card__price {
  color: #C4C4C4;
}
.card.empty .card__risk__chart__min {
  box-shadow: inset 0 3px 6px rgba(0, 0, 0, 0.1607843137);
  border-color: transparent;
  width: 130px;
  height: 130px;
  position: relative;
}
.card.empty .card__risk__chart__min:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: inline-flex;
  margin: 0 auto;
  width: 9px;
  height: 9px;
  background: #c3c3c3;
  border-radius: 50%;
}
.card.empty .card__wallet__row {
  opacity: 0;
  visibility: hidden;
}
.card.empty .add__wallet {
  background: #F0F0F3;
  box-shadow: inset 10px 10px 10px rgba(174, 174, 192, 0.2), inset -10px -10px 10px rgba(255, 255, 255, 0.6980392157);
  width: 136px;
  height: 136px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.4s;
  cursor: pointer;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 2;
}
.card.empty .add__wallet .save__text {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  opacity: 0;
  visibility: hidden;
  color: #ffffff;
  text-transform: uppercase;
  font-size: 18px;
  font-weight: normal;
  max-width: max-content;
  max-height: max-content;
}
.card.empty .add__wallet .plus__wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  visibility: hidden;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
}
.card.empty .add__wallet .plus__wrapper span {
  width: 30px;
  height: 5px;
  background: #F0F0F3;
  border-radius: 2px;
  position: absolute;
}
.card.empty .add__wallet .plus__wrapper span:nth-child(2) {
  transform: rotate(90deg);
}
.card.empty .add__wallet.new .plus__wrapper {
  visibility: visible;
  opacity: 1;
}
.card.empty .add__wallet.save {
  top: 305px;
}
.card.empty .add__wallet.save .plus__wrapper {
  position: absolute;
  visibility: hidden;
  opacity: 0;
}
.card.empty .add__wallet.save .save__text {
  opacity: 1;
  visibility: visible;
}
.card.empty .add__wallet .add__wallet__btn__bg {
  background: #1762A2;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: inset 2px 2px 2px rgba(255, 255, 255, 0.44), 10px 10px 30px rgba(174, 174, 192, 0.44), inset -2px -2px 2px rgba(29, 29, 29, 0.2549019608), -10px -10px 30px #FFFFFF;
  position: relative;
}
.card.cold .card__risk__chart__min {
  border-color: #4DC7B5;
}
.card.cold .card__product__number,
.card.cold .card__risk__chart__number__of,
.card.cold .card__risk__chart__number {
  color: #4DC7B5;
}
.card.cold .card__product__number.empty,
.card.cold .card__risk__chart__number__of.empty,
.card.cold .card__risk__chart__number.empty {
  color: #889096;
}
.card.cold .card__risk__info:hover {
  background: #4DC7B5;
  color: #ffffff;
}
.card.hold .card__risk__chart__min {
  border-color: #EFB661;
}
.card.hold .card__product__number,
.card.hold .card__risk__chart__number__of,
.card.hold .card__risk__chart__number {
  color: #EFB661;
}
.card.hold .card__product__number.empty,
.card.hold .card__risk__chart__number__of.empty,
.card.hold .card__risk__chart__number.empty {
  color: #889096;
}
.card.hold .card__risk__info:hover {
  background: #EFB661;
  color: #ffffff;
}
.card.risky .card__risk__chart__min {
  border-color: #F27281;
}
.card.risky .card__product__number,
.card.risky .card__risk__chart__number__of,
.card.risky .card__risk__chart__number {
  color: #F27281;
}
.card.risky .card__product__number.empty,
.card.risky .card__risk__chart__number__of.empty,
.card.risky .card__risk__chart__number.empty {
  color: #889096;
}
.card.risky .card__risk__info:hover {
  background: #F27281;
  color: #ffffff;
}
.card__header {
  margin-bottom: 8px;
}
.card__header .row {
  align-items: flex-start;
  justify-content: space-between;
}
.card__settings {
  border: 0;
  width: 17px;
  height: 17px;
  background: #F0F0F3;
  border-radius: 50%;
  box-shadow: -2px -2px 2px #FFFFFF, 2px 2px 2px rgba(174, 174, 192, 0.4039215686);
  color: #364048;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 40px;
  cursor: pointer;
}
.card__title {
  font-weight: 600;
  font-size: 18px;
  color: #364048;
  text-align: center;
}
.card__title span {
  display: block;
}
.card__close {
  width: 16px;
  height: 16px;
  border: 0;
  background-color: transparent;
  position: relative;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
}
.card__close span {
  height: 100%;
  position: absolute;
  top: 0;
  width: 2px;
  background: #364048;
  transform: rotate(45deg);
}
.card__close span:nth-child(2) {
  transform: rotate(-45deg);
}
.card__price {
  height: 48px;
  width: 100%;
  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);
  border-radius: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4DC7B5;
  font-size: 18px;
  line-height: 23px;
  font-weight: bold;
  margin-bottom: 16px;
}
.card__wallet {
  width: 100%;
  height: 108px;
  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);
  border-radius: 17px;
  background: rgba(240, 240, 243, 0.05);
  overflow-x: hidden;
  overflow-y: auto;
  margin-bottom: 34px;
}
.card__wallet::-webkit-scrollbar-track {
  display: none;
}
.card__wallet::-webkit-scrollbar-thumb {
  display: none;
}
.card__wallet__row {
  display: flex;
  justify-content: space-between;
  height: 35px;
  padding: 0 15px;
  align-items: center;
  overflow: hidden;
  width: 100%;
  transition: all 0.4s;
}
.card__wallet__row:nth-child(2n+1) {
  background: rgba(132, 132, 132, 0.05);
}
.card__wallet__usd, .card__wallet__rates {
  font-weight: 600;
  font-size: 16px;
  line-height: 26px;
  color: #364049;
}
.card__wallet__usd {
  color: #889096;
  font-weight: 400;
}
.card__risk {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}
.card__risk__title {
  color: #717679;
  font-weight: 600;
  font-size: 18px;
  line-height: 23px;
  margin-bottom: 15px;
}
.card__risk__chart {
  width: 144px;
  height: 144px;
  box-shadow: inset 6px 6px 6px rgba(174, 174, 192, 0.2), inset -6px -6px 6px rgba(255, 255, 255, 0.6980392157);
  background: #F0F0F3;
  border-radius: 92px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.card__risk__chart__min {
  width: 108px;
  height: 108px;
  box-shadow: inset 0 3px 6px rgba(0, 0, 0, 0.1607843137), 0 3px 6px rgba(0, 0, 0, 0.1607843137);
  border-width: 10px;
  border-style: solid;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.card__risk__chart__number {
  font-weight: bold;
  font-size: 26px;
  line-height: 34px;
}
.card__risk__chart__number__of {
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
}
.card__risk__alert {
  width: 65px;
  height: 65px;
  border-radius: 50%;
  background: #F0F0F3;
  box-shadow: -3px -3px 9px #FFFFFF, 3px 3px 9px rgba(174, 174, 192, 0.4039215686);
  position: absolute;
  right: 0;
  top: 19px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  transition: all 0.4s;
}
.card__risk__alert__title {
  color: #889096;
  font-size: 18px;
  line-height: 18px;
}
.card__risk__alert__number {
  color: #f27281;
  font-weight: 600;
  font-size: 16px;
  line-height: 18px;
}
.card__risk__info {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: #EBEBEB;
  border-radius: 50%;
  color: #cbcbcb;
  font-size: 12px;
  position: absolute;
  bottom: -10px;
  left: 48px;
  box-shadow: -2px -2px 2px #FFFFFF, 2px 2px 2px rgba(145, 145, 165, 0.4039215686);
  transition: all 0.4s;
  cursor: pointer;
}
.card__product__row {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 5px;
  padding-bottom: 5px;
  position: relative;
  width: 100%;
}
.card__product__row:after {
  content: "";
  width: 100%;
  border-radius: 67px;
  height: 3px;
  box-shadow: inset 10px 10px 10px rgba(174, 174, 192, 0.2), inset -10px -10px 10px rgba(255, 255, 255, 0.6980392157);
}
.card__product__row .product__row__dropdown {
  width: 100%;
  background: #F0F0F3;
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.1529411765), -8px -8px 24px #FFFFFF;
  border-radius: 0 0 8px 8px;
  position: absolute;
  opacity: 0;
  visibility: hidden;
  transition: all 0.4s;
  padding: 4px 16px;
  z-index: 9999;
  top: 30px;
  left: 0;
}
.card__product__row .product__row__dropdown .product__row__dropdown__item {
  color: #889096;
  font-size: 18px;
  line-height: 23px;
  width: 100%;
  border-bottom: 1px solid #c9c9ca;
  text-transform: uppercase;
  padding: 5px 0;
  cursor: pointer;
}
.card__product__row .product__row__dropdown .product__row__dropdown__item:last-child {
  border-bottom: 0;
}
.card__product__row .product__row__dropdown.open {
  visibility: visible;
  opacity: 1;
}
.card__product__title {
  color: #889096;
  font-size: 18px;
  line-height: 23px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.4s;
}
.card__product__number {
  font-size: 24px;
  line-height: 32px;
  text-shadow: 0 3px 6px rgba(77, 199, 181, 0.2039215686);
  font-weight: bold;
}
.card__product__unstacked, .card__product__stake {
  background: #F0F0F3;
  box-shadow: inset -5px -5px 5px rgba(127, 127, 173, 0.1294117647), -5px -5px 15px #FFFFFF, inset 5px 5px 5px #FFFFFF, 5px 5px 15px rgba(142, 142, 181, 0.2);
  border-radius: 20px;
  cursor: pointer;
  width: 112px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  outline: none;
  font-size: 18px;
  line-height: 22px;
}
.card__product__stake__block {
  display: flex;
  justify-content: space-between;
  width: 100%;
  position: relative;
  margin-top: 10px;
  margin-bottom: 10px;
}
.card__product__unstacked {
  color: #BA8557;
}
.card__product__stake {
  color: #5781BA;
}
.card__risk__range {
  width: 8px;
  height: 176px;
  position: absolute;
  left: 5px;
  top: 0;
  display: none;
}
.card__risk__range.active {
  display: block;
}
.card__risk__range__bg {
  width: 100%;
  height: 50%;
  background: #F27281;
  box-shadow: inset 3px 3px 3px rgba(64, 64, 80, 0.3254901961);
  border-radius: 0 0 20px 20px;
  position: absolute;
  bottom: 0;
}
.card__risk__range__btn {
  width: 24px;
  height: 24px;
  background: #F0F0F3;
  box-shadow: -2px -2px 6px #FFFFFF, 2px 2px 6px rgba(54, 54, 77, 0.4039215686);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: -8px;
  cursor: pointer;
}
.card__risk__range__btn__min {
  background: #F27281;
  width: 16px;
  display: flex;
  height: 16px;
  border-radius: 50%;
  box-shadow: inset 2px 2px 2px rgba(54, 54, 70, 0.6), inset -2px -2px 2px rgba(255, 255, 255, 0.6);
}
.card__risk__range__hr {
  width: 176px;
  height: 8px;
  border-radius: 88px;
  position: absolute;
  left: 5px;
  top: 0;
  display: none;
}
.card__risk__range__hr.active {
  display: block;
}
.card__risk__range__bg__hr {
  width: 50%;
  height: 100%;
  border-radius: 20px 0 0 20px;
  position: absolute;
  left: 0;
}
.card__risk__range__btn__hr {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  position: absolute;
  top: -8px;
  left: 50%;
  cursor: pointer;
}
.card__risk__range__btn__hr__min {
  background: #F27281;
  width: 16px;
  display: flex;
  height: 16px;
  border-radius: 50%;
  box-shadow: inset 2px 2px 2px rgba(54, 54, 70, 0.6), inset -2px -2px 2px rgba(255, 255, 255, 0.6);
}
.card__nft__wrapper {
  width: 264px;
  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);
  border-radius: 17px;
  margin-bottom: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.card__nft__img {
  width: 232px;
  height: 160px;
  border-radius: 17px;
}

.card__list {
  width: 344px;
  height: 88px;
  background: #F0F0F3;
  box-shadow: -8px -8px 24px #FFFFFF, 8px 8px 24px rgba(174, 174, 192, 0.4039215686);
  border-radius: 24px;
  display: flex;
  align-items: center;
  position: relative;
  padding: 16px;
  margin-right: 80px;
  margin-bottom: 48px;
  cursor: pointer;
}
.list.active .card__list:not(.active) {
  opacity: 0.5;
  -webkit-user-select: none;
          user-select: none;
  cursor: default;
}
.card__list.cold .card__risk__chart__list__min {
  border-color: #4DC7B5;
}
.card__list.cold .card__risk__chart__list__number {
  color: #4DC7B5;
}
.card__list.cold .card__risk__chart__list__number.empty {
  color: #889096;
}
.card__list.hold .card__risk__chart__list__min {
  border-color: #EFB661;
}
.card__list.hold .card__risk__chart__list__number {
  color: #EFB661;
}
.card__list.hold .card__risk__chart__list__number.empty {
  color: #889096;
}
.card__list.risky .card__risk__chart__list__min {
  border-color: #F27281;
}
.card__list.risky .card__risk__chart__list__number {
  color: #F27281;
}
.card__list.risky .card__risk__chart__list__number.empty {
  color: #889096;
}

.card__list__percent {
  display: flex;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);
  font-size: 16px;
  font-weight: bold;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
}

.card__risk__chart__list {
  width: 104px;
  height: 104px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #F0F0F3;
  position: absolute;
  right: -52px;
  top: -10px;
  border-radius: 50%;
  box-shadow: inset 6px 6px 6px rgba(174, 174, 192, 0.2), inset -6px -6px 6px rgba(255, 255, 255, 0.6980392157);
}

.card__risk__chart__list__min {
  width: 56px;
  height: 56px;
  display: flex;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  border-width: 8px;
  border-style: solid;
  box-shadow: inset 0 3px 6px rgba(0, 0, 0, 0.1607843137), 0 3px 6px rgba(0, 0, 0, 0.1607843137);
}

.card__risk__chart__list__number {
  font-size: 24px;
  font-weight: bold;
}

.card__list__anchor,
.card__list__title {
  font-weight: 600;
  font-size: 18px;
  color: #364048;
}

.card__risk__alert {
  cursor: pointer !important;
}

.unstacking {
  cursor: pointer;
}

.card__risk__alert:hover {
  background: #F5F5FA;
  color: #1762A2;
}

.unstacking:hover {
  background: #F5F5FA;
  color: #1762A2;
}

.card__risk__chart__list__number {
  font-size: 24px;
  font-weight: bold;
}

.card__list__anchor,
.card__list__title {
  font-weight: 600;
  font-size: 18px;
  color: #364048;
}

.card__product__unstacked:hover,
.card__product__stake:hover,
.wallet__addresses__top__right__btn:hover,
.anomalies_detection:hover,
.limit__block__tabs__list:hover,
.wallet__addresses__top__input__add:hover,
.alerts__input__add:hover,
.layout__grid:hover,
.layout__list:hover,
.card__settings:hover,
.wallet__type:hover,
.to__top:hover,
.dropdown__selected:hover,
.dropdown__sub__selectedm:hover,
.limit__block__top:hover {
  background: #F5F5FA !important;
}

.upload_label:hover,
.add__wallet__btn__plus__bg:hover {
  background: #1762A2;
}

.add__wallet__btn__bg:hover,
.card.new .add__wallet .add__wallet__btn__bg:hover {
  background: #214175 !important;
}

.card__risk__chart > div {
  display: flex;
  align-items: center;
  justify-content: center;
}

.card.empty .error__message.requests__message ~ .add__wallet.save {
  top: 295px;
}

.ntf__filter__content input {
  align-items: center;
  margin: 0 10px;
}
.ntf__filter__content input::placeholder {
  color: #889096 !important;
  font-size: 15px !important;
  font-weight: 500 !important;
  line-height: 26px !important;
  text-decoration: none !important;
}

.layout__block {
  position: fixed;
  z-index: 9;
  right: 355px;
  top: 90px;
}

.recycle__layout {
  position: fixed;
  top: 35px;
  left: 0;
  right: 0;
  bottom: 0;
}

.wallet__type__item:hover {
  color: #214175 !important;
}

.card__chart__wrapper {
  width: 736px;
  height: 530px;
  background: #f0f0f3;
  box-shadow: -8px -8px 24px #ffffff, 8px 8px 24px rgba(174, 174, 192, 0.4039215686);
  border-radius: 24px;
  position: absolute;
  padding: 25px 40px 32px 72px;
  transition: opacity 0.4s;
  margin: auto;
  position: relative;
}

.card__chart {
  width: 624px;
  height: 384px;
  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);
  border-radius: 24px;
}

.card__chart__title {
  font-weight: 600;
  font-size: 18px;
  color: #364048;
  margin-right: 25px;
}

.card__chart__header {
  margin-bottom: 24px;
  display: flex;
  align-items: center;
}

.check__wrapper {
  display: flex;
  align-items: center;
  white-space: nowrap;
  margin-right: 24px;
  cursor: pointer;
}
.check__wrapper:last-child {
  margin-right: 0;
}
.check__wrapper [type=checkbox] {
  display: none;
}
.check__wrapper [type=checkbox]:checked ~ .checkbox__label .check__icon {
  opacity: 1;
  visibility: visible;
}
.check__wrapper.white .checkbox__box {
  background: #ebebeb;
}
.check__wrapper.purple .checkbox__box {
  background: #c9ceff;
}
.check__wrapper.blue .checkbox__box {
  background: #97eaea;
}
.check__wrapper.yellow .checkbox__box {
  background: #f0dc8b;
}
.check__wrapper .checkbox__box {
  width: 24px;
  height: 24px;
  box-shadow: inset 2px 2px 2px rgba(174, 174, 192, 0.2), inset -2px -2px 2px rgba(255, 255, 255, 0.6980392157);
  border-radius: 6px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.check__wrapper .checkbox__box .check__icon {
  opacity: 0;
  visibility: hidden;
  transition: all 0.4s;
  width: 12px;
  height: 12px;
}
.check__wrapper .checkbox__text {
  display: inline-flex;
  margin-left: 7px;
  cursor: pointer;
}
.check__wrapper .checkbox__label {
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 18px;
  line-height: 23px;
  color: #889096;
}

.check__wrapper__all {
  flex-grow: 1;
  display: flex;
  justify-content: flex-end;
}

.card__chart__dropdown {
  width: 72px;
  position: relative;
  cursor: pointer;
}

.card__chart__dropdown__selected {
  font-size: 16px;
  line-height: 23px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  color: #2267a4;
  position: relative;
}
.card__chart__dropdown__selected:after {
  content: "";
  position: absolute;
  width: 72px;
  height: 3px;
  box-shadow: inset 10px 10px 10px rgba(174, 174, 192, 0.2), inset -10px -10px 10px rgba(255, 255, 255, 0.6980392157);
  border-radius: 67px;
  opacity: 0.93;
  bottom: -2px;
}
.card__chart__dropdown__selected .card__chart__dropdown__selected__arrow {
  width: 7px;
  height: 7px;
  border-bottom: 1px solid #2267a4;
  border-right: 1px solid #2267a4;
  transform: rotate(45deg);
}

.card__chart__dropdown__block {
  background: #f0f0f3;
  width: 100%;
  padding: 4px 0 4px 7px;
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.1529411765);
  border-radius: 0 0 8px 8px;
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 25px;
  z-index: 9;
  transition: opacity 0.4s;
}
.open .card__chart__dropdown__block {
  opacity: 1;
  visibility: visible;
}

.card__chart__dropdown__list {
  color: #889096;
  font-size: 14px;
  line-height: 23px;
}
.card__chart__dropdown__list:hover {
  color: #2267a4;
}

.chart__open__btn {
  position: absolute;
  left: 10px;
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.chart__open__btn__icon,
.chart__opened__btn__icon {
  width: 24px;
  height: 24px;
  position: absolute;
  top: 0;
  left: 0;
  transition: all 0.4s;
}

.card__chart__close {
  position: absolute;
  right: 10px;
  top: 0;
  bottom: 0;
  margin-top: auto;
  margin-bottom: auto;
  width: 20px;
  height: 20px;
  transform: rotate(180deg);
}

.card__chart__close__icon {
  height: 100%;
  width: 100%;
  cursor: pointer;
}

.card__chart__dropdown__selected .card__chart__dropdown__selected__arrow:hover {
  border-bottom: 2px solid #2658aa;
  border-right: 2px solid #2658aa;
  transform: rotate(45deg);
  width: 7px;
  height: 7px;
}

.filter__block {
  position: fixed;
  right: -100%;
  bottom: 0;
  height: calc(100% - 90px);
  width: 338px;
  box-shadow: 10px 10px 30px rgba(174, 174, 192, 0.4);
  z-index: 2;
  border-radius: 0 15px 15px 15px;
}
.filter__block.open {
  right: 0;
}

.filter__block__scroll {
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
  width: 100%;
  height: 100%;
  padding: 15px;
  background: #F0F0F3;
  z-index: 2;
}

.filter__block__btn__block {
  position: absolute;
  top: 0;
  left: -75px;
  width: 90px;
  height: 60px;
  background: #F0F0F3;
  box-shadow: 10px 10px 30px rgba(174, 174, 192, 0.4);
  border-radius: 15px 0 0 15px;
  z-index: 1;
}

.filter__block__title {
  text-align: center;
  margin-bottom: 30px;
  font-weight: bold;
  font-size: 22px;
  line-height: 28px;
  color: #364048;
}

.risk__btn__row {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
}

.risk__btn {
  width: 40px;
  height: 40px;
  background: #F0F0F3;
  box-shadow: -2px -2px 6px #FFFFFF, 2px 2px 6px rgba(174, 174, 192, 0.4039215686);
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.4s;
  cursor: pointer;
  outline: none;
  margin-right: 16px;
  border: 0;
}

.risk__btn__text {
  font-weight: 600;
  font-size: 18px;
  display: inline-flex;
  color: #364048;
}

.asset__wrapper {
  margin-bottom: 10px;
}

.asset__title {
  text-align: center;
  margin-bottom: 12px;
  font-size: 22px;
  line-height: 28px;
  color: #364048;
}

.asset__block {
  width: 100%;
  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.7);
  border-radius: 17px;
  list-style-type: none;
  overflow: hidden;
  max-height: 160px;
  overflow: auto;
  min-height: auto;
}

.asset__list:nth-child(2n+1) {
  background: #ebebee;
  width: 98%;
}

.disabled__asset__list {
  background: #ebebee !important;
}

.asset__list__check {
  display: none;
}
.asset__list__check:checked ~ .asset__list__label .asset__list__box:after {
  opacity: 1;
}

.asset__list__label {
  display: inline-flex;
  align-items: center;
  padding: 8px;
}

.asset__list__box {
  width: 24px;
  height: 24px;
  box-shadow: inset 2px 2px 2px rgba(174, 174, 192, 0.2), inset -2px -2px 2px rgba(255, 255, 255, 0.7);
  border-radius: 6px;
  display: inline-flex;
  margin-right: 14px;
  position: relative;
}
.asset__list__box:after {
  content: "";
  width: 6px;
  height: 12px;
  border-bottom: 2px solid #364048;
  border-right: 2px solid #364048;
  transform: rotate(40deg) skew(2deg);
  position: absolute;
  left: 8px;
  top: 2px;
  display: inline-flex;
  opacity: 0;
  transition: all 0.4s;
}

.asset__list__text {
  font-weight: 600;
  font-size: 18px;
  line-height: 23px;
}

.reset__btn {
  position: absolute;
  right: 8px;
  top: 8px;
  width: 40px;
  height: 40px;
  background: #F0F0F3;
  box-shadow: -2px -2px 6px #FFFFFF, 2px 2px 6px rgba(174, 174, 192, 0.4039215686);
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.4s;
  cursor: pointer;
  outline: none;
  border: 0;
}

.filter__icon {
  position: relative;
  z-index: 9999;
}

.header {
  height: 80px;
  min-height: 80px;
  box-shadow: inset 10px 10px 10px rgba(174, 174, 192, 0.2), inset -10px -10px 10px rgba(255, 255, 255, 0.5019607843);
  width: 100%;
  background: #F0F0F3;
  padding: 0 25px 0 120px;
  position: relative;
  z-index: 1;
  transition: all 0.4s;
}
.header.open {
  padding-left: 296px;
}
.header .row {
  height: 100%;
  align-items: center;
}
.header__title {
  font-weight: 700;
  line-height: 27px;
  font-size: 22px;
  transition: all 0.4s;
}
.open .header__title {
  font-size: 26px;
  line-height: 32px;
}
.header__right {
  display: flex;
  margin-left: auto;
  align-items: center;
  height: 100%;
}

.notification {
  display: flex;
  align-items: center;
  justify-content: center;
}
.notification__btn {
  border: 0;
  background-color: transparent;
  cursor: pointer;
  font-size: 17px;
  position: relative;
  color: #868e95;
}
.notification__status {
  background: #F5B452;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.2509803922);
  width: 10px;
  height: 10px;
  border-radius: 50%;
  position: absolute;
  top: -5px;
  right: -2px;
}

.user {
  height: 48px;
  width: 145px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 40px;
  flex-wrap: wrap;
  transition: all 0.4s;
  cursor: pointer;
}
.user.open {
  border-radius: 24px;
  width: 145px;
  height: 136px;
  background: #F0F0F3;
  box-shadow: -4px -4px 12px #FFFFFF, 4px 4px 12px rgba(174, 174, 192, 0.4039215686);
  align-self: flex-start;
}
.user.open .log__out {
  display: inline-flex;
}
.user.open:before, .user.open:after {
  display: none;
}
.user:before, .user:after {
  content: "";
  box-shadow: inset 10px 10px 10px rgba(174, 174, 192, 0.2);
  border-radius: 67px;
  height: 100%;
  width: 3px;
  position: absolute;
  top: 0;
}
.user:before {
  left: 0;
}
.user:after {
  right: 0;
}
.user__avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 20px;
}
.user__name {
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
}
.user .log__out {
  width: 100%;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  position: relative;
  padding-top: 14px;
  margin-bottom: 10px;
  display: none;
}
.user .log__out:before {
  position: absolute;
  top: 0;
  content: "";
  width: 112px;
  height: 4px;
  box-shadow: inset 2px 2px 2px rgba(174, 174, 192, 0.2), inset -2px -2px 2px rgba(255, 255, 255, 0.6980392157);
  border-radius: 67px;
}
.user .log__out__icon {
  margin-right: 8px;
}

.setting__btn {
  border: 0;
  cursor: pointer;
  color: #868e95;
  font-size: 16px;
}

.zoom__page__btn {
  position: relative;
  cursor: pointer;
}
.zoom__page__btn .zoom__page__btn__minus,
.zoom__page__btn .zoom__page__btn__plus {
  position: absolute;
  width: 25px;
  height: 25px;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  display: inline-block;
  transition: opacity 0.4s;
}
.zoom__page__btn .zoom__page__btn__minus {
  opacity: 0;
  visibility: hidden;
}

.logo {
  width: 32px;
  height: 36px;
  margin-top: 10px;
  margin-bottom: 45px;
  position: relative;
}
.logo__img {
  width: 100%;
  height: 100%;
}
.logo__img__big {
  width: 0;
  height: 0;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  transition: all 0.4s;
}

.nav {
  width: 96px;
  height: 100vh;
  background: #F0F0F3;
  box-shadow: inset 0 3px 6px rgba(0, 0, 0, 0.1607843137), 3px 0 6px rgba(67, 96, 121, 0.1490196078);
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 3;
  padding-right: 10px;
  transition: all 0.4s;
}
.nav.open {
  width: 272px;
}
.nav.open .logo {
  width: 200px;
}
.nav.open .logo__img {
  display: none;
}
.nav.open .logo__img__big {
  display: inline-block;
  width: 100%;
  height: 100%;
}
.nav.open .nav__link {
  width: 208px;
}
.nav.open .nav__link .nav__text {
  font-size: 20px;
  position: relative;
  opacity: 1;
  visibility: visible;
  color: #364048;
}
.nav__block {
  list-style-type: none;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.nav__list {
  margin-bottom: 10px;
}
.nav__list.trash {
  margin-top: auto;
}
.nav__link {
  font-size: 30px;
  text-decoration: none;
  padding: 16px;
  display: inline-flex;
  color: #7e92a3;
  transition: all 0.4s;
  width: 64px;
  height: 64px;
  align-items: center;
  justify-content: center;
}
.nav__link:hover, .nav__link.active {
  background: #F0F0F3;
  box-shadow: inset -3px -3px 3px rgba(255, 255, 255, 0.6980392157), inset 0px 3px 6px rgba(0, 0, 0, 0.1607843137), 3px 0px 6px rgba(67, 96, 121, 0.1490196078);
  border-radius: 12px;
  color: #2267a4;
}
.nav__link:hover .trash__icon, .nav__link.active .trash__icon {
  filter: brightness(0) saturate(100%) invert(33%) sepia(7%) saturate(5984%) hue-rotate(169deg) brightness(102%) contrast(91%);
}
.nav__link i {
  position: relative;
  z-index: 1;
}
.nav__link .nav__text {
  display: inline-flex;
  color: transparent;
  margin-right: auto;
  margin-left: 15px;
  white-space: nowrap;
  font-size: 0;
  transition: font-size 0.2s, visibility 0.4s, opacity 0.4s;
  opacity: 0;
  visibility: hidden;
  position: absolute;
}

.trash__icon {
  height: 25px;
}

.menu__open {
  background: #F0F0F3;
  box-shadow: inset 0px 3px 6px rgba(0, 0, 0, 0.1607843137), 3px 0px 6px rgba(67, 96, 121, 0.1490196078);
  width: 106px;
  height: 106px;
  position: absolute;
  border-radius: 50%;
  top: 50%;
  right: -53px;
  clip-path: polygon(0 0, 50% 0, 50% 100%, 0% 100%);
  transition: all 0.4s;
}
.menu__open.open .menu__open__btn {
  transform: rotate(180deg);
}

.menu__open__btn {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: #F0F0F3;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: -2px -2px 6px #FFFFFF, 2px 2px 6px rgba(174, 174, 192, 0.4039215686);
  cursor: pointer;
  position: absolute;
  margin-top: auto;
  margin-bottom: auto;
  top: 0;
  bottom: 0;
  left: 10px;
  transition: all 0.4s;
}

.main {
  height: calc(100vh - 56px);
  overflow: hidden;
  padding-left: 72px;
  background: #F0F0F3;
  display: flex;
  width: 100%;
  transition: padding-left 0.4s;
}
.main.open {
  padding-left: 325px;
}
.main.setting_main:after {
  display: none;
}
.main.empty__trash {
  position: relative;
}
.main.empty__trash + .main:after {
  display: none;
}
.main:after {
  content: "";
  width: 8px;
  height: calc(100vh - 110px);
  position: absolute;
  right: 338px;
  top: 100px;
  box-shadow: inset 4px 4px 4px rgba(174, 174, 192, 0.2), inset -4px -4px 4px rgba(255, 255, 255, 0.6980392157);
  border-radius: 67px;
}
.main .content {
  overflow-y: auto;
  overflow-x: hidden;
  padding: 56px 24px 24px 24px;
  height: 100%;
  width: calc(100% - 338px);
  margin-left: 24px;
  margin-top: -24px;
  position: relative;
}
.main .content::-webkit-scrollbar-track {
  box-shadow: unset;
}
.main .content::-webkit-scrollbar-track-piece:end {
  background: transparent;
}
.main .content::-webkit-scrollbar-track-piece:start {
  background: transparent;
}
.main .content.list {
  padding-left: 120px;
}

.to__top {
  position: fixed;
  right: 362px;
  margin-left: auto;
  bottom: 24px;
  z-index: 3;
  width: 40px;
  height: 40px;
  background: #F0F0F3;
  box-shadow: -2px -2px 6px #FFFFFF, 2px 2px 6px rgba(174, 174, 192, 0.4039215686);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.4s;
  cursor: pointer;
}
.to__top__icon {
  width: 26px;
  height: 26px;
}

.zoom__page__btn,
.layout__list,
.layout__grid {
  margin-left: auto;
  width: 45px;
  height: 45px;
  background: #F0F0F3;
  box-shadow: -2px -2px 6px #FFFFFF, 2px 2px 6px rgba(174, 174, 192, 0.4039215686);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.4s;
  margin-bottom: 24px;
  margin-top: 10px;
  cursor: pointer;
}

.empty__trash__title {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: max-content;
  height: max-content;
  font-size: 100px;
  font-weight: normal;
  font-style: normal;
  letter-spacing: 0;
  color: transparent;
  background: rgba(102, 102, 102, 0.2);
  -webkit-background-clip: text;
  -moz-background-clip: text;
  background-clip: text;
  padding-right: 5px;
  text-shadow: 0px 3px 3px rgba(255, 255, 255, 0.5);
}

.light_core_activate_title {
  font-size: 30px;
}

.light_core_activate_text {
  font-size: 40px;
}

.light_core_activate_text, .light_core_activate_title {
  margin: auto;
  width: max-content;
  height: max-content;
  font-weight: normal;
  font-style: normal;
  letter-spacing: 0;
  color: transparent;
  background: rgba(102, 102, 102, 0.4);
  -webkit-background-clip: text;
  -moz-background-clip: text;
  background-clip: text;
  text-shadow: 0 3px 3px rgba(255, 255, 255, 0.5);
}

.trash__clean {
  position: fixed;
  display: inline-flex;
  bottom: 58px;
  left: -1px;
  z-index: 3;
  width: 80px;
  height: 60px !important;
  background: #f7f7f9;
  box-shadow: unset;
  color: #2267A4;
  backdrop-filter: blur(7px);
  -webkit-backdrop-filter: blur(7px);
  border-radius: 14px;
  justify-content: flex-start;
}
.trash__clean:hover .trash__text__all {
  text-decoration: none;
}
.trash__clean .trash__text__all {
  text-decoration: underline;
  margin-left: 10px;
}

.trash__icon__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left: 20px;
  margin-top: 10px;
}
.trash__icon__wrapper .trash__icon {
  filter: brightness(0) saturate(100%) invert(33%) sepia(7%) saturate(5984%) hue-rotate(169deg) brightness(102%) contrast(91%);
}

.aside {
  width: 338px;
  padding: 24px;
  overflow-y: auto;
  height: 100%;
  flex-direction: column;
  align-items: center;
  overflow-x: hidden;
}

.add__wallet__btn {
  box-shadow: -4px -4px 12px #FFFFFF, 4px 4px 12px rgba(174, 174, 192, 0.4039215686);
  background-color: #f0f0f3;
  border-radius: 24px;
  width: 288px;
  height: 88px;
  display: flex;
  align-items: center;
  text-decoration: none;
  padding-left: 24px;
  padding-right: 30px;
  justify-content: space-between;
  font-size: 24px;
  color: #364048;
  text-transform: capitalize;
  font-weight: 600;
  transition: all 0.4s;
}
.add__wallet__btn:hover {
  background: #F5F5FA;
  color: #1762A2;
}
.add__wallet__btn.defi {
  padding: 0 16px;
}
.add__wallet__btn.defi .add__wallet__btn__plus {
  width: 88px;
  height: 56px;
  border-radius: 157px;
  padding: 0 8px;
  margin-right: 12px;
}

.add__wallet__btn__plus {
  background: #F0F0F3;
  box-shadow: inset 10px 10px 10px rgba(174, 174, 192, 0.2), inset -10px -10px 10px rgba(255, 255, 255, 0.6980392157);
  width: 56px;
  height: 56px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.add__wallet__btn__plus.defi {
  width: auto;
}
.add__wallet__btn__plus .fox {
  width: 32px;
  height: 25px;
  margin-right: 8px;
}
.add__wallet__btn__plus .coinbase {
  width: 25px;
  height: 25px;
}

.add__wallet__btn__plus__bg {
  background: #1762A2;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: inset 2px 2px 2px rgba(255, 255, 255, 0.44), 10px 10px 30px rgba(174, 174, 192, 0.44), inset -2px -2px 2px rgba(29, 29, 29, 0.2549019608), -10px -10px 30px #FFFFFF;
  position: relative;
  cursor: pointer;
}
.add__wallet__btn__plus__bg span {
  width: 12px;
  height: 2px;
  background: #F0F0F3;
  border-radius: 2px;
  position: absolute;
}
.add__wallet__btn__plus__bg span:nth-child(2) {
  transform: rotate(90deg);
}

.aside__wallet__title {
  color: #364048;
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  margin-top: 39px;
  margin-bottom: 25px;
  text-align: center;
}

.aside__chart__wrapper {
  position: relative;
  margin-bottom: 45px;
  height: 315px;
}
.aside__chart__wrapper.cold .card__risk__chart__min {
  border-color: #4DC7B5;
}
.aside__chart__wrapper.cold .card__risk__chart__number__of,
.aside__chart__wrapper.cold .card__risk__chart__number {
  color: #4DC7B5;
}
.aside__chart__wrapper.cold .card__risk__info:hover {
  background: #4DC7B5;
  color: #ffffff;
}
.aside__chart__wrapper.hold .card__risk__chart__min {
  border-color: #EFB661;
}
.aside__chart__wrapper.hold .card__risk__chart__number__of,
.aside__chart__wrapper.hold .card__risk__chart__number {
  color: #EFB661;
}
.aside__chart__wrapper.hold .card__risk__info:hover {
  background: #EFB661;
  color: #ffffff;
}
.aside__chart__wrapper.risky .card__risk__chart__min {
  border-color: #F27281;
}
.aside__chart__wrapper.risky .card__risk__chart__number__of,
.aside__chart__wrapper.risky .card__risk__chart__number {
  color: #F27281;
}
.aside__chart__wrapper.risky .card__risk__info:hover {
  background: #F27281;
  color: #ffffff;
}
.aside__chart__wrapper .card__risk__chart {
  width: 232px;
  height: 232px;
  border-radius: 50%;
  margin: 0 auto;
}
.aside__chart__wrapper .card__risk__chart > div {
  display: flex;
  align-items: center;
  justify-content: center;
}
.aside__chart__wrapper .card__risk__chart__min {
  width: 178px;
  height: 178px;
  border-width: 20px;
}
.aside__chart__wrapper .card__risk__chart__number {
  font-size: 35px;
}
.aside__chart__wrapper .card__risk__chart__number__of {
  font-size: 19px;
}
.aside__chart__wrapper .card__risk__alert {
  width: 90px;
  height: 90px;
  top: unset;
  bottom: 6px;
  right: -8px;
  cursor: pointer;
}
.aside__chart__wrapper .card__risk__alert__title {
  font-size: 20px;
  line-height: 26px;
}
.aside__chart__wrapper .card__risk__alert__number {
  font-size: 20px;
  line-height: 26px;
}
.aside__chart__wrapper .card__risk__range__hr {
  top: unset;
  bottom: 47px;
  left: 0;
}

.aside__tabs {
  display: flex;
  list-style-type: none;
  justify-content: space-between;
  position: relative;
  margin-bottom: 34px;
}
.aside__tabs:after {
  content: "";
  width: calc(100% + 24px);
  left: -12px;
  bottom: -10px;
  height: 3px;
  box-shadow: inset 4px 4px 4px rgba(174, 174, 192, 0.2), inset -4px -4px 0px rgba(255, 255, 255, 0.6980392157);
  position: absolute;
  background: #F0F0F3;
}
.aside__tabs__link {
  text-decoration: none;
  color: #9CA3A8;
  font-weight: 600;
  font-size: 18px;
  line-height: 23px;
  position: relative;
  display: flex;
  border: none;
  outline: none;
}
.aside__tabs__link:after {
  content: "";
  width: 0;
  transition: all 0.4s;
  height: 3px;
  background: #2658AA;
  box-shadow: inset -2px -2px 2px rgba(29, 29, 29, 0.2549019608), -10px -10px 30px #FFFFFF;
  border-radius: 67px;
  position: absolute;
  bottom: -10px;
  z-index: 1;
}
.aside__tabs__link:hover, .aside__tabs__link.active {
  color: #364048;
}
.aside__tabs__link:hover:after, .aside__tabs__link.active:after {
  width: 100%;
}

.aside__card {
  background: #F0F0F3;
  box-shadow: -5px -5px 15px #FFFFFF, 5px 5px 15px rgba(174, 174, 192, 0.4039215686);
  border-radius: 24px;
  padding: 21px 24px 15px;
  position: relative;
  margin-bottom: 24px;
}
.aside__card.cold .aside__card__progress__bg {
  background: #28B663;
}
.aside__card.hot .aside__card__progress__bg {
  background: #EFB661;
}
.aside__card__title {
  color: #9CA3A8;
  font-weight: 600;
  font-size: 18px;
  line-height: 23px;
  margin-bottom: 8px;
}
.aside__card__numbers {
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  display: flex;
  align-items: flex-end;
  margin-bottom: 15px;
}
.aside__card__numbers span {
  font-size: 14px;
  display: flex;
  margin-bottom: -10px;
}
.aside__card__progress {
  width: 100%;
  height: 8px;
  box-shadow: inset 4px 4px 4px rgba(174, 174, 192, 0.2), inset -4px -4px 0px rgba(255, 255, 255, 0.6980392157);
  border-radius: 67px;
  background: #F0F0F3;
}
.aside__card__progress__bg {
  height: 100%;
  box-shadow: inset -2px -2px 2px rgba(29, 29, 29, 0.2549019608), -10px -10px 30px #FFFFFF, inset 4px 4px 4px rgba(174, 174, 192, 0.2);
  border-radius: 67px;
  transition: all 0.4s;
}
.aside__card .card__risk__alert {
  position: relative;
  margin-left: auto;
  font-weight: 600;
  width: 64px;
  height: 64px;
  top: 4px;
  right: -11px;
}
.aside__card .card__risk__alert__number,
.aside__card .card__risk__alert__title {
  line-height: 16px;
  font-size: 16px;
}
.aside__card .card__risk__range__hr {
  width: 105px;
  top: 60px;
  left: 80px;
}

.wallet__type {
  width: 168px;
  padding: 9px 0;
  position: relative;
  border-radius: 24px;
  box-shadow: -3px -3px 9px 0 #fff, 3px 3px 9px 0 rgba(174, 174, 192, 0.4);
  background-color: #ededef;
  cursor: pointer;
  position: absolute;
}
.wallet__type__item {
  font-size: 18px;
  font-weight: 600;
  letter-spacing: normal;
  text-align: center;
  width: 100%;
  margin-top: 12px;
  display: flex;
  align-items: center;
  padding-left: 18px;
  color: #364048;
}
.wallet__type__item:nth-of-type(1) {
  margin-top: 0;
}
.wallet__type .wallet__type__arrow {
  position: absolute;
  right: 17px;
  top: 17px;
  filter: brightness(0) saturate(100%) invert(24%) sepia(8%) saturate(958%) hue-rotate(165deg) brightness(93%) contrast(94%);
  height: 8px;
  cursor: pointer;
}

.wallet__type__btn {
  width: 336px;
  height: 48px;
  border-radius: 80px;
  background: #F0F0F3;
  margin-left: 40px;
  color: #889096;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: 18px;
  box-shadow: inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157), inset 5px 5px 5px rgba(174, 174, 192, 0.2);
  border: none;
  outline: none;
  text-align: center;
  padding: 0 10px;
}

.wallet__type__btn::placeholder {
  font-weight: 600;
  font-size: 18px;
  color: #889096;
  font-weight: 500;
}

.wallet__type__save {
  width: 104px;
  height: 40px;
  border-radius: 67px;
  box-shadow: -5px -5px 15px 0 #fff, 5px 5px 15px 0 rgba(174, 174, 192, 0.4);
  background-color: #214175;
  font-size: 18px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  margin-left: auto;
  cursor: pointer;
  border: 0;
}

.wallet__addresses {
  border-radius: 22px;
  background-color: #ededef;
  padding: 24px;
  margin-top: 24px;
}

.wallet__addresses__top {
  position: relative;
}
.wallet__addresses__top .card__close {
  position: absolute;
}

.wallet__addresses__top__left {
  margin-right: 16px;
}
.wallet__addresses__top__label {
  margin-bottom: 4px;
  font-size: 22px;
  font-weight: 600;
  line-height: 1.36;
  text-align: left;
  color: #364048;
}

.wallet__addresses__top__middle {
  margin-right: 16px;
}
.wallet__addresses__top__middle .wallet__addresses__top__label {
  margin-left: 70px;
}

.wallet__addresses__top__input__wrapper {
  width: 584px;
  height: 48px;
  border-radius: 80px;
  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);
  background: #EDEDEF;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  padding: 8px;
}

.wallet__addresses__top__input {
  width: calc(100% - 32px);
  height: 100%;
  background-color: transparent;
  border: 0;
  text-align: center;
  outline: none;
  font-size: 18px;
  font-weight: 600;
  color: #364048;
}

.wallet__addresses__top__input__add {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background: #EDEDEF;
  box-shadow: -2px -2px 6px #FFFFFF, 2px 2px 6px rgba(174, 174, 192, 0.4039215686);
  border-radius: 24px;
  width: 32px;
  height: 32px;
  border: 0;
  outline: none;
  cursor: pointer;
}
.wallet__addresses__top__input__add span {
  width: 12px;
  height: 2px;
  background: #2167A4;
  border-radius: 2px;
  position: absolute;
}
.wallet__addresses__top__input__add span:nth-child(2) {
  transform: rotate(90deg);
}

.wallet__addresses__top__right__btn {
  width: 112px;
  height: 48px;
  padding: 9px 0;
  position: relative;
  border-radius: 24px;
  box-shadow: -3px -3px 9px 0 #fff, 3px 3px 9px 0 rgba(174, 174, 192, 0.4);
  background-color: #ededef;
  font-size: 18px;
  color: #364048;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  cursor: pointer;
  outline: none;
  font-weight: 500;
}

.limit__block {
  width: 168px;
  height: 96px;
  background: #EDEDEF;
  border-radius: 21px;
}
.limit__block__bottom, .limit__block__top {
  height: 50%;
  font-size: 18px;
  line-height: 23px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  outline: none;
  width: 100%;
  text-align: center;
  cursor: pointer;
}
.limit__block .limit__block__bottom::placeholder {
  color: #4DC7B5;
  font-weight: 600;
  font-size: 13px;
  line-height: 23px;
}
.limit__block__top {
  color: #364048;
  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);
  border-radius: 21px 21px 0 0;
}
.limit__block__top.active .limit__block__top__slider {
  opacity: 1;
  visibility: visible;
}
.limit__block__top {
  position: relative;
}
.limit__block__bottom {
  color: #4DC7B5;
  font-weight: 600;
  background-color: #f0f0f3;
  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);
  border-radius: 0 0 21px 21px;
}

.limit__block__wrapper {
  display: flex;
  padding: 16px;
  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);
  border-radius: 0 21px 21px 21px;
}

.wallet__addresses__bottom {
  display: flex;
  align-items: flex-end;
  margin-top: 10px;
}
.wallet__addresses__bottom .limit__block {
  margin-right: 16px;
}
.wallet__addresses__bottom .limit__block:last-child {
  margin-right: 0;
}

.wallet__addresses__bottom__right,
.wallet__addresses__bottom__left {
  padding-bottom: 15px;
}

.wallet__addresses__bottom__middle {
  margin-left: 16px;
  margin-right: 32px;
}

.limit__block__tabs {
  list-style-type: none;
  display: flex;
}

.limit__block__tabs__list {
  padding: 14px 16px 8px;
  font-weight: 600;
  font-size: 20px;
  line-height: 26px;
  color: #364048;
  background: #EDEDEF;
  box-shadow: -2px 0px 6px rgba(174, 174, 192, 0.1843137255);
  border-radius: 24px 24px 0 0;
  cursor: pointer;
  transition: all 0.4s;
}
.limit__block__tabs__list.active {
  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);
}

.anomalies__label {
  width: 112px;
  height: 112px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: -3px -3px 9px #FFFFFF, 3px 3px 9px rgba(174, 174, 192, 0.4039215686);
}

.anomalies__check {
  display: none;
}
.anomalies__check:checked ~ .anomalies__label {
  background: transparent linear-gradient(51deg, #EDEDEF 0%, #DEE5F0 100%) 0% 0% no-repeat padding-box;
  box-shadow: inset 4px 4px 4px rgba(174, 174, 192, 0.2), inset -4px -4px 2px rgba(255, 255, 255, 0.6980392157);
}
.anomalies__check:checked ~ .anomalies__label .anomalies__check__box:after {
  opacity: 1;
  visibility: visible;
}

.anomalies__text {
  font-weight: 600;
  font-size: 16px;
  line-height: 18px;
  color: #364048;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: column;
  margin-bottom: 6px;
}

.anomalies__check__box {
  width: 24px;
  display: flex;
  height: 24px;
  box-shadow: inset 2px 2px 2px rgba(174, 174, 192, 0.2), inset -2px -2px 2px rgba(255, 255, 255, 0.6980392157);
  border-radius: 6px;
  position: relative;
  margin-top: 12px;
}
.anomalies__check__box:after {
  content: "";
  width: 6px;
  position: absolute;
  left: 8px;
  top: 2px;
  height: 12px;
  border-bottom: 2px solid #364048;
  border-right: 2px solid #364048;
  transform: rotate(45deg) skew(10deg);
  opacity: 0;
  visibility: hidden;
}

.limit__block__top__slider {
  background: #EDEDEF;
  box-shadow: -2px -2px 6px #ffffff, 2px 2px 6px rgba(174, 174, 192, 0.4);
  width: 150px;
  height: 150px;
  border-radius: 50%;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: -51px;
  opacity: 0;
  transition: all 0.4s;
  visibility: hidden;
  margin: auto;
  left: 10px;
  flex-direction: column;
}

.limit__block__top__slider__info {
  width: 152px;
  height: 152px;
  box-shadow: inset 0 3px 6px rgba(0, 0, 0, 0.1607843137), 0 3px 6px rgba(0, 0, 0, 0.1607843137);
  border-radius: 50%;
  border: 20px solid #214175;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.limit__block__top__slider__info__time {
  color: #214175;
  font-weight: bold;
  font-size: 26px;
  line-height: 34px;
}

.limit__block__top__slider__info__time__of {
  color: #214175;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
}

.whitelist__ad__block {
  position: absolute;
  background: #F0F0F3;
  box-shadow: 0 5px 15px rgba(56, 70, 82, 0.2509803922);
  border-radius: 20px;
  width: 920px;
  padding: 32px 32px 24px;
  left: 0;
  top: 90px;
  z-index: 1;
}
.whitelist__ad__block .row {
  justify-content: space-between;
}

.whitelist__ad__block__bottom {
  width: 100%;
  position: relative;
  margin-top: 8px;
}
.whitelist__ad__block__bottom .add__wallet__btn__plus__bg {
  margin: 0 auto;
  cursor: pointer;
  display: flex;
}
.whitelist__ad__block__bottom .dropdown {
  position: absolute;
  right: 0;
  top: 0;
}

.whitelist__ad__block__input__wrapper {
  width: 416px;
  height: 48px;
  border-radius: 80px;
  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);
  background: #EDEDEF;
  margin: 8px 8px 8px 0;
  display: flex;
  align-items: center;
  padding: 8px;
}

.whitelist__ad__block__input {
  width: 100%;
  height: 100%;
  background-color: transparent;
  border: 0;
  text-align: center;
  outline: none;
  font-size: 15px;
  line-height: 23px;
  color: #364048;
}

.wallet__unstaking .unstacking {
  right: -45px;
  bottom: -40px;
}

.card__unstaking__slider .rangeslider-vertical .rangeslider__handle-label {
  background: #385483;
}

.card__unstaking__slider .rangeslider-vertical .rangeslider__fill {
  background: #385483;
}

.card.defi {
  padding-top: 8px;
  position: relative;
}
.card.defi .card__header .row {
  align-items: center;
}
.card.defi .card__wallet__row {
  background-color: transparent;
}
.card.defi .card__wallet__rates {
  color: #889096;
}
.card.defi .card__wallet__usd {
  color: #364048;
  font-weight: bold;
}
.card.defi .card__product__row {
  padding-bottom: 0;
}
.card.defi .card__title {
  font-weight: 600;
  display: inline-flex;
  align-items: center;
}
.card.defi .card__header {
  padding: 10px 0;
}
.card.defi .card__header .row {
  align-items: center;
  justify-content: center;
}
.card.defi .card__price {
  margin-bottom: 5px;
}
.card.defi .card__risk__title {
  margin-bottom: 10px;
}

.card__product__stake__amount {
  opacity: 0;
  visibility: hidden;
  position: fixed;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 408px;
  background: #F0F0F3;
  box-shadow: 10px 10px 30px rgba(111, 111, 132, 0.4039215686);
  border-radius: 12px;
  z-index: 999999999999999;
  padding: 24px 16px 16px 24px;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  margin: auto;
}
.card__product__stake__amount.open {
  visibility: visible;
  opacity: 1;
}

.card__product__stake__amount__input__wrapper {
  width: 224px;
  height: 48px;
  border-radius: 80px;
  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);
  background: #EDEDEF;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  padding: 8px;
}

.card__product__stake__amount__input {
  width: 100%;
  height: 100%;
  background-color: transparent;
  border: 0;
  text-align: center;
  outline: none;
  font-size: 18px;
  font-weight: 600;
  color: #364048;
}

.card__product__stake__amount__max {
  font-weight: 600;
  font-size: 18px;
  line-height: 23px;
  width: 128px;
  height: 48px;
  color: #364048;
  border-radius: 24px;
  box-shadow: -3px -3px 9px 0 #fff, 3px 3px 9px 0 rgba(174, 174, 192, 0.4);
  background-color: #ededef;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  cursor: pointer;
  outline: none;
}

.card__product__stake__amount__confirm {
  width: 100%;
  height: 40px;
  border-radius: 67px;
  box-shadow: -5px -5px 15px 0 #fff, 5px 5px 15px 0 rgba(174, 174, 192, 0.4);
  background-color: #214175;
  font-size: 18px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  cursor: pointer;
  border: 0;
  margin-top: 8px;
}

.unstacking {
  width: 95px;
  height: 95px;
  border-radius: 50%;
  background: #F0F0F3;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: -3px -3px 9px #FFFFFF, 3px 3px 9px rgba(174, 174, 192, 0.4039215686);
  color: #889096;
  font-size: 16px;
  line-height: 18px;
  flex-direction: column;
  text-align: center;
  position: absolute;
  right: -13px;
  bottom: -18px;
  transition: all 0.4s;
}
.unstacking span {
  color: #F27281;
}
.unstacking.active, .unstacking:hover {
  box-shadow: unset;
  color: rgba(136, 144, 150, 0.49);
}
.unstacking.active span, .unstacking:hover span {
  color: rgba(136, 144, 150, 0.49);
}

.add__defi__block {
  width: 56px;
  padding: 16px 0;
  background: #F0F0F3;
  box-shadow: inset 4px 4px 4px rgba(174, 174, 192, 0.2), inset -4px -4px 4px rgba(255, 255, 255, 0.6980392157);
  border-radius: 10px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  position: absolute;
  right: 0px;
  top: 320px;
}

.contract__address_container {
  width: 660px;
  height: fit-content;
  background: #F0F0F3;
  box-shadow: -8px -8px 24px #ffffff, 8px 8px 24px rgba(174, 174, 192, 0.4);
  padding: 20px;
  border-radius: 24px;
  position: absolute;
  z-index: 9999;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
}

.add__defi__item {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #F0F0F3;
  border-radius: 8px;
  margin-bottom: 16px;
  cursor: pointer;
}
.add__defi__item:nth-child(1) {
  height: auto;
  margin-bottom: 8px;
  box-shadow: unset;
  background-color: transparent;
}
.add__defi__item:last-child {
  margin-bottom: 0;
}

.defi_shild__modal .ReactModal__Content .ReactModal__Content--after-open {
  background: none !important;
  border: none !important;
  max-width: 320px !important;
  height: 490px !important;
}

.defi_shild__modal {
  max-width: 320px !important;
  height: 490px !important;
  margin: 112px 116px;
}

.add_investment_btn {
  margin: 20px auto !important;
}

.card__product__title_item {
  font-weight: bold;
}

.title_item {
  display: flex;
  justify-content: flex-end;
}

::-webkit-scrollbar-track {
  background: none !important;
  box-shadow: none !important;
}

.defi__select__wrapper {
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  text-align: center;
  border-bottom: 1px solid rgba(174, 174, 192, 0.2) !important;
}

.investment_card .rangeslider-horizontal {
  width: 117px !important;
}

.setting {
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  padding-top: 50px;
}
.setting > .row {
  width: 100%;
  align-items: stretch;
  height: 100%;
}

.user__info {
  height: 865px;
  width: 368px;
  position: relative;
  margin-left: 100px;
  margin-right: 70px;
}

.user__info__avatar__block {
  width: 100%;
  height: 368px;
  background: #F0F0F3 linear-gradient(132deg, #ECECF0 0%, #F2F2F5 100%) 0 0;
  border-radius: 50%;
  box-shadow: -8px -8px 15px #FFFFFF, 8px 8px 15px rgba(174, 174, 192, 0.4039215686);
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.user__info__avatar__wrapper {
  width: 336px;
  height: 336px;
  border-radius: 50%;
  position: relative;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.user__info__avatar__wrapper:hover .upload__content {
  opacity: 1;
}

.user__info__desc__block {
  width: 100%;
  background: #F0F0F3;
  box-shadow: -5px -5px 15px #FFFFFF, 5px 5px 15px rgba(174, 174, 192, 0.4039215686);
  border-radius: 30px;
  padding-top: 200px;
  margin-top: -200px;
  display: flex;
  flex-direction: column;
}

.user__info__name {
  font-weight: 600;
  font-size: 22px;
  line-height: 28px;
  color: #364048;
  text-align: center;
  box-shadow: inset 0 5px 5px rgba(174, 174, 192, 0.2), inset 0px -5px 5px rgba(255, 255, 255, 0.6980392157);
  margin-top: 25px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.user__info__desc {
  box-shadow: inset 0 5px 5px rgba(174, 174, 192, 0.2), inset 0px -5px 5px rgba(255, 255, 255, 0.6980392157);
  text-align: center;
  margin-top: 24px;
  padding: 24px 32px;
  margin-bottom: 99px;
}

.user__info__desc__text {
  font-size: 22px;
  line-height: 28px;
  color: #364048;
  border: none;
  outline: none;
  background: none;
  text-align: center;
  height: 250px;
  resize: none;
}

.settings__tabs {
  list-style-type: none;
  display: flex;
  position: relative;
  z-index: 1;
  max-width: max-content;
}

.settings__tabs__link {
  padding: 32px 28px;
  font-weight: 600;
  font-size: 22px;
  line-height: 28px;
  color: #364048;
  text-align: center;
  text-decoration: none;
  display: inline-flex;
  width: 295px;
  justify-content: center;
  align-items: center;
  transition: all 0.4s;
  box-shadow: 5px 5px 5px rgba(174, 174, 192, 0.2);
}
.settings__tabs__link.active, .settings__tabs__link:hover {
  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);
  border-radius: 21px 21px 0 0;
}

.settings__tabs__list {
  cursor: pointer;
}
.settings__tabs__list:first-child .settings__tabs__link {
  border-top-left-radius: 21px;
}
.settings__tabs__list:last-child .settings__tabs__link {
  border-top-right-radius: 21px;
}

.password__change__block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 400px;
  margin-left: 88px;
}

.password__change__block__title {
  font-weight: 600;
  font-size: 17px;
  line-height: 19px;
  color: #364048;
  text-align: center;
  margin-bottom: 16px;
  margin-top: 10px;
}

.password__change__input {
  width: 304px;
  height: 48px;
  background: #F0F0F3;
  border: 0;
  border-radius: 67px;
  text-align: center;
  font-size: 18px;
  line-height: 23px;
  font-weight: 600;
  outline: none;
  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);
  margin-bottom: 16px;
  display: inline-flex;
}
.password__change__input::placeholder {
  color: #939A9F;
}

.password__change__btn {
  width: 304px;
  height: 40px;
  box-shadow: -5px -5px 15px #FFFFFF, 5px 5px 15px rgba(174, 174, 192, 0.4039215686);
  background: #214175;
  color: #FFFFFF;
  font-weight: 600;
  font-size: 18px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 67px;
  cursor: pointer;
  outline: none;
  border: 0;
}

.qr__wrapper {
  width: 112px;
  height: 112px;
  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);
  border-radius: 16px;
  padding: 8px;
  margin-top: 16px;
}

.qr__img {
  width: 96px;
  height: 96px;
  overflow: hidden;
  border-right: 16px;
}

.alerts__input__box {
  width: 350px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.alerts__input__box__all {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  flex-direction: column;
  height: 515px;
}
.alerts__input__box__all .alerts__input__wrapper {
  margin-right: 40px;
}

.alerts__input__wrapper {
  width: 370px;
  transition: all 0.4s;
  height: 48px;
  background: #F0F0F3;
  border-radius: 67px;
  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);
  display: flex;
  align-items: center;
  position: relative;
}
.alerts__input__wrapper.disable {
  width: 370px;
}
.alerts__input__wrapper.disable .alerts__input__add {
  display: none;
}
.alerts__input__wrapper.disable .alerts__input {
  color: #939A9F;
}
.alerts__input__wrapper.disable .alerts__input__check {
  display: flex;
}
.alerts__input__wrapper.active {
  width: 370px;
}
.alerts__input__wrapper.active .alerts__input__add {
  display: none;
}
.alerts__input__wrapper.active .alerts__input {
  color: #364048;
}
.alerts__input__wrapper.active.one .alerts__input__add {
  display: flex;
}
.alerts__input__wrapper.links .alerts__input__icon__wrapper {
  width: auto;
  box-shadow: unset;
  padding-left: 8px;
}
.alerts__input__wrapper.links .alerts__input__icon {
  cursor: pointer;
  margin-right: 10px;
}
.alerts__input__wrapper.links .alerts__input__icon:last-child {
  margin-right: 0;
}
.alerts__input__wrapper.links .alerts__input {
  display: none;
}
.alerts__input__wrapper.links .alerts__input__check {
  display: none;
}
.alerts__input__wrapper .alerts__input {
  width: 270px;
  background-color: transparent;
  border: 0;
  outline: none;
  text-align: center;
  font-size: 18px;
  line-height: 23px;
  transition: all 0.4s;
}
.alerts__input__wrapper .alerts__input::placeholder {
  color: #939A9F;
}
.alerts__input__wrapper .alerts__input__check {
  width: 24px;
  min-width: 24px;
  height: 24px;
  min-height: 24px;
  box-shadow: inset 2px 2px 2px rgba(174, 174, 192, 0.2), inset -2px -2px 2px rgba(255, 255, 255, 0.6980392157);
  border-radius: 6px;
  margin-right: 15px;
  margin-left: 10px;
  transition: all 0.4s;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.alerts__input__wrapper .alerts__input__check .alerts__input__check__icon {
  opacity: 0;
  visibility: hidden;
  transition: all 0.4s;
}
.alerts__input__wrapper .alerts__check__input {
  display: none;
}
.alerts__input__wrapper .alerts__check__input:checked ~ .alerts__input__check .alerts__input__check__icon {
  visibility: visible;
  opacity: 1;
}
.alerts__input__wrapper .remove__input {
  position: absolute;
  width: 11px;
  height: 11px;
  right: -20px;
  cursor: pointer;
}

.alerts__input__icon__wrapper {
  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);
  display: flex;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  align-items: center;
  justify-content: center;
}

.alerts__input__add {
  width: 370px;
  height: 48px;
  border-radius: 24px;
  box-shadow: -2px -2px 6px #FFFFFF, 2px 2px 6px rgba(174, 174, 192, 0.4039215686);
  background: #EDEDEF;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.login__settings__wrapper {
  width: 1208px;
  height: 865px;
  background: #F0F0F3;
  box-shadow: -10px -10px 30px #FFFFFF, 10px 10px 30px rgba(174, 174, 192, 0.4039215686);
  border-radius: 30px;
  position: relative;
}

.password__change__label {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.password__change__label.hasValue .password__change__label__text {
  visibility: visible;
  opacity: 1;
  position: relative;
}

.password__change__label__text {
  display: inline-flex;
  width: 95px;
  height: 16px;
  justify-content: center;
  align-items: center;
  border-radius: 8px 8px 0 0;
  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);
  position: absolute;
  visibility: hidden;
  opacity: 0;
  transition: all 0.4s;
}

.login__settings {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 100%;
  transition: opacity 0.4s;
  padding-top: 40px;
}
.login__settings.active {
  opacity: 1;
  visibility: visible;
}

.login__settings__body {
  position: relative;
  box-shadow: inset 0 5px 5px rgba(174, 174, 192, 0.2), inset 0px -5px 5px rgba(255, 255, 255, 0.6980392157);
  height: calc(100% - 152px);
}

.login__settings__tabs {
  display: flex;
  width: 370px;
  height: 48px;
  box-shadow: 5px 5px 5px rgba(174, 174, 192, 0.2039215686), inset 5px 5px 5px rgba(174, 174, 192, 0.2);
  border-radius: 67px;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
  margin-left: 88px;
}

.login__settings__tabs__list {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.4s;
  cursor: pointer;
}
.login__settings__tabs__list.active, .login__settings__tabs__list:hover {
  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);
}
.login__settings__tabs__list.active .login__settings__tabs__icon, .login__settings__tabs__list:hover .login__settings__tabs__icon {
  filter: brightness(0) saturate(100%) invert(27%) sepia(99%) saturate(929%) hue-rotate(182deg) brightness(92%) contrast(83%);
}

.card {
  position: relative;
}
.card.light {
  padding-top: 25px;
  position: relative;
}
.card.light .card__header {
  margin-bottom: 30px;
  position: relative;
}
.card.light .card__header .row {
  align-items: center;
  justify-content: center;
}
.card.light .card__wallet__row {
  background-color: transparent;
}
.card.light .card__wallet__rates {
  color: #889096;
}
.card.light .card__wallet__usd {
  color: #364048;
  font-weight: bold;
}
.card.light .card__title {
  font-weight: 600;
  display: inline-flex;
  align-items: center;
}
.card.light .card__product__arrow {
  margin-left: 10px;
}

.card__risk__range {
  width: 8px;
  height: 176px;
  position: absolute;
  left: 8px;
  top: 0;
  display: none;
}

.card__risk__range.active {
  display: block;
  -webkit-user-select: none;
          user-select: none;
}

.card__risk__range__bg {
  width: 100%;
  height: 50%;
  background: #F27281;
  box-shadow: inset 3px 3px 3px rgba(64, 64, 80, 0.3254901961);
  border-radius: 0 0 20px 20px;
  position: absolute;
  bottom: 0;
}

.card__risk__range__btn {
  width: 24px;
  height: 24px;
  background: #F0F0F3;
  box-shadow: -2px -2px 6px #FFFFFF, 2px 2px 6px rgba(54, 54, 77, 0.4039215686);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: -8px;
  cursor: pointer;
}

.card__risk__range__btn__min {
  background: #F27281;
  width: 16px;
  display: flex;
  height: 16px;
  border-radius: 50%;
  box-shadow: inset 2px 2px 2px rgba(54, 54, 70, 0.6), inset -2px -2px 2px rgba(255, 255, 255, 0.6);
}

.card__risk__range__hr {
  width: 176px;
  height: 8px;
  border-radius: 88px;
  position: absolute;
  left: 5px;
  top: 0;
  display: none;
}

.card__risk__range__hr.active {
  -webkit-user-select: none;
          user-select: none;
  display: block;
}

.card__risk__range__bg__hr {
  width: 50%;
  height: 100%;
  background: #F27281;
  box-shadow: inset 3px 3px 3px rgba(64, 64, 80, 0.3254901961);
  border-radius: 20px 0 0 20px;
  position: absolute;
  left: 0;
}

.card__risk__range__btn__hr {
  width: 24px;
  height: 24px;
  background: #F0F0F3;
  box-shadow: -2px -2px 6px #FFFFFF, 2px 2px 6px rgba(54, 54, 77, 0.4039215686);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  position: absolute;
  top: -8px;
  left: 50%;
  cursor: pointer;
}

.card__risk__range__btn__hr__min {
  background: #F27281;
  width: 16px;
  display: flex;
  height: 16px;
  border-radius: 50%;
  box-shadow: inset 2px 2px 2px rgba(54, 54, 70, 0.6), inset -2px -2px 2px rgba(255, 255, 255, 0.6);
}

.light_defi__unstaking .unstacking {
  right: -20px;
  bottom: -30px;
}

.card__price input::placeholder {
  color: #889096 !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  line-height: 26px !important;
}

.nft .card__title {
  align-items: center;
  margin: 8px 0;
}

.card__nft__wrapper {
  width: 264px;
  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);
  border-radius: 17px;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card__nft__img {
  width: 232px;
  height: 160px;
  border-radius: 17px;
  object-fit: inherit;
}

@keyframes rotation_big {
  from {
    transform: rotate(243deg);
  }
  to {
    transform: rotate(603deg);
  }
}
@keyframes rotation__middle {
  from {
    transform: rotate(77deg);
  }
  to {
    transform: rotate(437deg);
  }
}
@keyframes rotation__small {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.login__wrapper {
  width: 100%;
  min-height: 100vh;
  max-height: 1080px;
  overflow: hidden;
  margin: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: relative;
}

.login__big {
  width: 1790px;
  height: 1782px;
  position: absolute;
  object-fit: contain;
  object-position: 44px;
  padding-left: 44px;
  z-index: 4;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  animation: rotation_big 30s infinite linear;
}

.login__middle {
  width: 1100px;
  height: 1100px;
  position: absolute;
  object-fit: contain;
  z-index: 3;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  animation: rotation__middle 30s infinite linear reverse;
}

.login__small {
  width: 828px;
  height: 828px;
  position: absolute;
  object-fit: contain;
  z-index: 2;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  animation: rotation__small 30s infinite linear;
}

.login__round {
  width: 1208px;
  height: 1208px;
  position: absolute;
  object-fit: contain;
  object-position: center 55px;
  z-index: 1;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
}

.login__form {
  width: 554px;
  height: 554px;
  background: #F0F0F3;
  box-shadow: -10px -10px 30px #FFFFFF, 10px 10px 30px rgba(174, 174, 192, 0.4039215686);
  border-radius: 50%;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  z-index: 5;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.login__logo {
  width: 200px;
  height: 36px;
  margin-bottom: 20px;
  display: inline-flex;
}

.login__input__wrapper {
  width: 304px;
  height: 48px;
  background: #F0F0F3;
  border-radius: 67px;
  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}
.login__input__wrapper .login__input {
  width: 100%;
  background-color: transparent;
  border: 0;
  outline: none;
  text-align: center;
  font-size: 18px;
  line-height: 23px;
  transition: all 0.4s;
}
.login__input__wrapper .login__input::placeholder {
  color: #939A9F;
}

.login__btn {
  width: 304px;
  height: 40px;
  box-shadow: -5px -5px 15px #FFFFFF, 5px 5px 15px rgba(174, 174, 192, 0.4039215686);
  background: #214175;
  color: #FFFFFF;
  font-weight: 600;
  font-size: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 67px;
  cursor: pointer;
  outline: none;
  border: 0;
}

.login__user__btn {
  position: fixed;
  cursor: pointer;
  width: 128px;
  height: 128px;
  bottom: 24px;
  right: 16px;
  z-index: 99;
}

.purchase__form {
  background: #F0F0F3;
  width: 408px;
  border-radius: 67px;
  box-shadow: -10px -10px 30px #FFFFFF, 10px 10px 30px rgba(174, 174, 192, 0.4039215686);
  padding: 40px 48px 33px;
  position: fixed;
  bottom: 24px;
  right: 16px;
  z-index: 100;
  transition: all 0.4s;
}
.purchase__form.open {
  visibility: visible;
  opacity: 1;
}

.purchase__form__title {
  text-align: center;
  font-weight: 600;
  font-size: 18px;
  line-height: 23px;
  margin-bottom: 32px;
}

.lds-ring {
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
}

.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 20px;
  height: 20px;
  margin: 0 10px;
  border: 3px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}

.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}

.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}

.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}

@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes rotation_l_big {
  from {
    transform: rotate(153deg);
  }
  to {
    transform: rotate(513deg);
  }
}
@keyframes rotation_l_mid {
  from {
    transform: rotate(77deg);
  }
  to {
    transform: rotate(437deg);
  }
}
@keyframes rotation_l_small {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.loading__layer {
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f0f0f3;
}

.logo-loading {
  z-index: 0 !important;
}

.loading__wrapper {
  width: 232px;
  height: 232px;
  position: relative;
  overflow: hidden;
  margin: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.l_big {
  width: 225px;
  height: 225px;
  position: absolute;
  object-fit: contain;
  object-position: 8px 8px;
  z-index: 4;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  animation: rotation_l_big 5s infinite linear;
}

.l_mid {
  width: 135px;
  height: 135px;
  position: absolute;
  object-fit: contain;
  z-index: 3;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  object-position: 4px 4px;
  animation: rotation_l_mid 5s infinite linear reverse;
}

.l_small {
  width: 110px;
  height: 110px;
  position: absolute;
  object-fit: contain;
  z-index: 2;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  object-position: 0.5px -0.5px;
  animation: rotation_l_small 5s infinite linear;
}

.l_round {
  width: 155px;
  height: 155px;
  position: absolute;
  object-fit: contain;
  z-index: 1;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
}

.l_logo {
  width: 36px;
  height: 36px;
  display: inline-block;
  object-fit: contain;
}

.error__message,
.custom__error__message {
  text-align: center;
  font-size: 13px;
  line-height: 23px;
  color: #be6161;
  display: flex;
  justify-content: center;
  margin: 3px 0 5px 0;
  line-break: anywhere;
  padding-bottom: 20px;
}

.custom__error__message {
  width: 100%;
}

@media only screen and (min-width: 1701px) and (max-width: 1930px) {
  .wrapper.zoom__page .logo {
    width: 32px;
    height: 36px;
    margin-top: 10px;
    margin-bottom: 45px;
    position: relative;
  }
  .wrapper.zoom__page .logo__img {
    width: 100%;
    height: 100%;
  }
  .wrapper.zoom__page .logo__img__big {
    width: 0;
    height: 0;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    transition: all 0.4s;
  }
  .wrapper.zoom__page .nav {
    width: 96px;
    height: 100vh;
    background: #F0F0F3;
    box-shadow: inset 0 3px 6px rgba(0, 0, 0, 0.1607843137), 3px 0 6px rgba(67, 96, 121, 0.1490196078);
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 3;
    padding-right: 10px;
    transition: all 0.4s;
  }
  .wrapper.zoom__page .nav.open {
    width: 272px;
  }
  .wrapper.zoom__page .nav.open .logo {
    width: 200px;
  }
  .wrapper.zoom__page .nav.open .logo__img {
    display: none;
  }
  .wrapper.zoom__page .nav.open .logo__img__big {
    display: inline-block;
    width: 100%;
    height: 100%;
  }
  .wrapper.zoom__page .nav.open .nav__link {
    width: 208px;
  }
  .wrapper.zoom__page .nav.open .nav__link .nav__text {
    font-size: 20px;
    position: relative;
    opacity: 1;
    visibility: visible;
    color: #364048;
  }
  .wrapper.zoom__page .nav__block {
    list-style-type: none;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .wrapper.zoom__page .nav__list {
    margin-bottom: 10px;
  }
  .wrapper.zoom__page .nav__list.trash {
    margin-top: auto;
  }
  .wrapper.zoom__page .nav__link {
    font-size: 30px;
    text-decoration: none;
    padding: 16px;
    display: inline-flex;
    color: #7e92a3;
    transition: all 0.4s;
    width: 64px;
    height: 64px;
    align-items: center;
    justify-content: center;
  }
  .wrapper.zoom__page .nav__link:hover, .wrapper.zoom__page .nav__link.active {
    background: #F0F0F3;
    box-shadow: inset -3px -3px 3px rgba(255, 255, 255, 0.6980392157), inset 0px 3px 6px rgba(0, 0, 0, 0.1607843137), 3px 0px 6px rgba(67, 96, 121, 0.1490196078);
    border-radius: 12px;
    color: #2267a4;
  }
  .wrapper.zoom__page .nav__link:hover .trash__icon, .wrapper.zoom__page .nav__link.active .trash__icon {
    filter: brightness(0) saturate(100%) invert(33%) sepia(7%) saturate(5984%) hue-rotate(169deg) brightness(102%) contrast(91%);
  }
  .wrapper.zoom__page .nav__link i {
    position: relative;
    z-index: 1;
  }
  .wrapper.zoom__page .nav__link .nav__text {
    display: inline-flex;
    color: transparent;
    margin-right: auto;
    margin-left: 15px;
    white-space: nowrap;
    font-size: 0;
    transition: font-size 0.2s, visibility 0.4s, opacity 0.4s;
    opacity: 0;
    visibility: hidden;
    position: absolute;
  }
  .wrapper.zoom__page .trash__icon {
    height: 25px;
  }
  .wrapper.zoom__page .menu__open {
    background: #F0F0F3;
    box-shadow: inset 0px 3px 6px rgba(0, 0, 0, 0.1607843137), 3px 0px 6px rgba(67, 96, 121, 0.1490196078);
    width: 106px;
    height: 106px;
    position: absolute;
    border-radius: 50%;
    top: 50%;
    right: -53px;
    clip-path: polygon(0 0, 50% 0, 50% 100%, 0% 100%);
    transition: all 0.4s;
  }
  .wrapper.zoom__page .menu__open.open .menu__open__btn {
    transform: rotate(180deg);
  }
  .wrapper.zoom__page .menu__open__btn {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    background: #F0F0F3;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: -2px -2px 6px #FFFFFF, 2px 2px 6px rgba(174, 174, 192, 0.4039215686);
    cursor: pointer;
    position: absolute;
    margin-top: auto;
    margin-bottom: auto;
    top: 0;
    bottom: 0;
    left: 10px;
    transition: all 0.4s;
  }
  .wrapper.zoom__page .header {
    height: 80px;
    min-height: 80px;
    box-shadow: inset 10px 10px 10px rgba(174, 174, 192, 0.2), inset -10px -10px 10px rgba(255, 255, 255, 0.5019607843);
    width: 100%;
    background: #F0F0F3;
    padding: 0 25px 0 120px;
    position: relative;
    z-index: 1;
    transition: all 0.4s;
  }
  .wrapper.zoom__page .header.open {
    padding-left: 296px;
  }
  .wrapper.zoom__page .header .row {
    height: 100%;
    align-items: center;
  }
  .wrapper.zoom__page .header__title {
    font-weight: 700;
    line-height: 27px;
    font-size: 22px;
    transition: all 0.4s;
  }
  .open .wrapper.zoom__page .header__title {
    font-size: 26px;
    line-height: 32px;
  }
  .wrapper.zoom__page .header__right {
    display: flex;
    margin-left: auto;
    align-items: center;
    height: 100%;
  }
  .wrapper.zoom__page .notification {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .wrapper.zoom__page .notification__btn {
    border: 0;
    background-color: transparent;
    cursor: pointer;
    font-size: 17px;
    position: relative;
    color: #868e95;
  }
  .wrapper.zoom__page .notification__status {
    background: #F5B452;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.2509803922);
    width: 10px;
    height: 10px;
    border-radius: 50%;
    position: absolute;
    top: -5px;
    right: -2px;
  }
  .wrapper.zoom__page .user {
    height: 48px;
    width: 145px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 40px;
    flex-wrap: wrap;
    transition: all 0.4s;
    cursor: pointer;
  }
  .wrapper.zoom__page .user.open {
    border-radius: 24px;
    width: 145px;
    height: 136px;
    background: #F0F0F3;
    box-shadow: -4px -4px 12px #FFFFFF, 4px 4px 12px rgba(174, 174, 192, 0.4039215686);
    align-self: flex-start;
  }
  .wrapper.zoom__page .user.open .log__out {
    display: inline-flex;
  }
  .wrapper.zoom__page .user.open:before, .wrapper.zoom__page .user.open:after {
    display: none;
  }
  .wrapper.zoom__page .user:before, .wrapper.zoom__page .user:after {
    content: "";
    box-shadow: inset 10px 10px 10px rgba(174, 174, 192, 0.2);
    border-radius: 67px;
    height: 100%;
    width: 3px;
    position: absolute;
    top: 0;
  }
  .wrapper.zoom__page .user:before {
    left: 0;
  }
  .wrapper.zoom__page .user:after {
    right: 0;
  }
  .wrapper.zoom__page .user__avatar {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    margin-right: 20px;
  }
  .wrapper.zoom__page .user__name {
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
  }
  .wrapper.zoom__page .user .log__out {
    width: 100%;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    position: relative;
    padding-top: 14px;
    margin-bottom: 10px;
    display: none;
  }
  .wrapper.zoom__page .user .log__out:before {
    position: absolute;
    top: 0;
    content: "";
    width: 112px;
    height: 4px;
    box-shadow: inset 2px 2px 2px rgba(174, 174, 192, 0.2), inset -2px -2px 2px rgba(255, 255, 255, 0.6980392157);
    border-radius: 67px;
  }
  .wrapper.zoom__page .user .log__out__icon {
    margin-right: 8px;
  }
  .wrapper.zoom__page .setting__btn {
    border: 0;
    cursor: pointer;
    color: #868e95;
    font-size: 16px;
  }
  .wrapper.zoom__page .zoom__page__btn {
    position: relative;
    cursor: pointer;
  }
  .wrapper.zoom__page .zoom__page__btn .zoom__page__btn__minus,
  .wrapper.zoom__page .zoom__page__btn .zoom__page__btn__plus {
    position: absolute;
    width: 25px;
    height: 25px;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    display: inline-block;
    transition: opacity 0.4s;
  }
  .wrapper.zoom__page .zoom__page__btn .zoom__page__btn__minus {
    opacity: 0;
    visibility: hidden;
  }
  .wrapper.zoom__page .zoom__page__btn .zoom__page__btn__minus {
    opacity: 1;
    visibility: visible;
  }
  .wrapper.zoom__page .nav {
    width: 71px;
  }
  .wrapper.zoom__page .header {
    height: 56px;
    min-height: 56px;
    padding-left: 90px;
  }
  .wrapper.zoom__page .nav__link {
    width: 40px;
    height: 40px;
    font-size: 22px;
  }
  .wrapper.zoom__page .nav__link:hover, .wrapper.zoom__page .nav__link.active {
    border-radius: 8px;
  }
  .wrapper.zoom__page .card {
    max-width: 240px;
    height: 352px;
    margin-right: 30px;
    margin-bottom: 30px;
  }
  .wrapper.zoom__page .card__product__title {
    font-size: 14px;
  }
  .wrapper.zoom__page .card__risk {
    margin-top: 12px;
  }
  .wrapper.zoom__page .card__risk__chart {
    width: 112px;
    height: 112px;
  }
  .wrapper.zoom__page .card.empty .card__risk__chart__min,
  .wrapper.zoom__page .card__risk__chart__min {
    width: 90px;
    height: 90px;
  }
  .wrapper.zoom__page .card__risk__chart__number {
    font-size: 20px;
    line-height: 26px;
  }
  .wrapper.zoom__page .card__wallet__usd, .wrapper.zoom__page .card__wallet__rates {
    font-size: 13px;
  }
  .wrapper.zoom__page .cart__walet__text__title {
    font-size: 12px !important;
  }
  .wrapper.zoom__page .unstacking {
    width: 80px;
    height: 80px;
    font-size: 14px;
  }
  .wrapper.zoom__page .card {
    padding: 16px;
    border-radius: 24px;
  }
  .wrapper.zoom__page .card__price {
    height: 32px;
    border-radius: 80px;
    font-size: 14px;
  }
  .wrapper.zoom__page .card__title {
    font-size: 14px;
  }
  .wrapper.zoom__page .card.light {
    padding-top: 20px;
  }
  .wrapper.zoom__page .card.light .card__header {
    margin-bottom: 12px;
  }
  .wrapper.zoom__page .card__close {
    width: 12px;
    height: 12px;
  }
  .wrapper.zoom__page .card__close span {
    width: 1px;
  }
  .wrapper.zoom__page .card__product__row {
    margin: 0;
    padding: 0;
  }
  .wrapper.zoom__page .card__product__number {
    font-size: 18px;
    line-height: 23px;
  }
  .wrapper.zoom__page .card__risk__range {
    width: 6px;
    height: 133px;
  }
  .wrapper.zoom__page .card__risk__range__btn {
    width: 18px;
    height: 18px;
    left: -6px;
  }
  .wrapper.zoom__page .card__risk__info {
    bottom: -15px;
    width: 19px;
    height: 19px;
    font-size: 10px;
  }
  .wrapper.zoom__page .card__wallet__row {
    padding: 0 10px;
  }
  .wrapper.zoom__page .zoom__page__btn,
  .wrapper.zoom__page .layout__list, .wrapper.zoom__page .layout__grid {
    width: 45px;
    height: 45px;
    margin-bottom: 16px;
  }
  .wrapper.zoom__page .layout__block {
    right: 250px;
    top: 65px;
    position: fixed;
    z-index: 9;
  }
  .wrapper.zoom__page .contract__address_container {
    width: 510px;
  }
  .wrapper.zoom__page .layout__grid__icon {
    width: 18px;
    height: 18px;
  }
  .wrapper.zoom__page .layout__list__icon {
    width: 19px;
    height: 19px;
  }
  .wrapper.zoom__page .card__risk__title {
    font-size: 14px;
    line-height: 15px;
    margin-bottom: 5px;
    margin-top: 10px;
  }
  .wrapper.zoom__page .card__risk__range__btn__min {
    width: 12px;
    height: 12px;
  }
  .wrapper.zoom__page .card__risk__alert {
    width: 48px;
    height: 48px;
  }
  .wrapper.zoom__page .card__risk__alert__title {
    font-size: 13px;
  }
  .wrapper.zoom__page .aside__wallet__title {
    font-size: 16px;
    line-height: 21px;
    margin-bottom: 20px;
    margin-top: 25px;
  }
  .wrapper.zoom__page .main .content {
    margin-left: 0;
    width: calc(100% - 234px);
    padding: 16px 24px 0 17px;
    margin-top: 0;
  }
  .wrapper.zoom__page .main:after {
    right: 234px;
    width: 5px;
    top: 72px;
  }
  .wrapper.zoom__page .filter__block__btn__block {
    left: -90px;
  }
  .wrapper.zoom__page .filter__block {
    height: calc(100% - 62px);
    width: 228px;
  }
  .wrapper.zoom__page .asset__list__text {
    font-size: 14px;
  }
  .wrapper.zoom__page .asset__list__box {
    width: 20px;
    height: 20px;
    border-radius: 4px;
  }
  .wrapper.zoom__page .asset__list__box:after {
    width: 5px;
    height: 10px;
  }
  .wrapper.zoom__page .asset__block {
    border-radius: 8px;
  }
  .wrapper.zoom__page .aside {
    width: 234px;
    padding: 16px;
  }
  .wrapper.zoom__page .add__wallet__btn {
    width: 200px;
    height: 64px;
    border-radius: 18px;
    font-size: 16px;
    line-height: 21px;
    padding-left: 16px;
  }
  .wrapper.zoom__page .add__wallet__btn__plus {
    width: 40px;
    height: 40px;
  }
  .wrapper.zoom__page .add__wallet__btn__plus__bg {
    width: 25px;
    height: 25px;
  }
  .wrapper.zoom__page .setting {
    margin-left: 30px;
  }
  .wrapper.zoom__page .card__risk__range__hr {
    width: 121px;
    height: 5px;
  }
  .wrapper.zoom__page .card__risk__range__btn__hr {
    width: 17px;
    height: 17px;
  }
  .wrapper.zoom__page .card__risk__range__btn__hr__min {
    width: 11px;
    height: 11px;
  }
  .wrapper.zoom__page .aside__tabs__link {
    font-size: 14px;
    border: none;
    outline: none;
  }
  .wrapper.zoom__page .aside__chart__wrapper {
    height: 235px;
    margin-bottom: 30px;
  }
  .wrapper.zoom__page .aside__chart__wrapper .card__risk__chart {
    width: 158px;
    height: 158px;
  }
  .wrapper.zoom__page .aside__chart__wrapper .card__risk__chart__min {
    width: 122px;
    height: 122px;
    border-width: 14px;
  }
  .wrapper.zoom__page .aside__chart__wrapper .card__risk__alert {
    width: 64px;
    height: 64px;
  }
  .wrapper.zoom__page .aside__chart__wrapper .card__risk__alert__title,
  .wrapper.zoom__page .aside__chart__wrapper .card__risk__alert__number {
    font-size: 14px;
    line-height: 18px;
  }
  .wrapper.zoom__page .aside__card__title {
    font-size: 13px;
    margin-bottom: 3px;
    line-height: 17px;
  }
  .wrapper.zoom__page .aside__card__numbers {
    font-size: 16px;
  }
  .wrapper.zoom__page .aside__card {
    padding: 14px 16px;
    border-radius: 18px;
  }
  .wrapper.zoom__page .aside__card .card__risk__alert {
    width: 44px;
    height: 44px;
    top: 0;
  }
  .wrapper.zoom__page .aside__card .card__risk__alert__number,
  .wrapper.zoom__page .aside__card .card__risk__alert__title {
    font-size: 13px;
  }
  .wrapper.zoom__page .aside__card .card__risk__range__hr {
    width: 71px;
    height: 6px;
  }
  .wrapper.zoom__page .aside__card__progress {
    height: 6px;
  }
  .wrapper.zoom__page .card__wallet {
    margin-bottom: 10px;
    height: 70px;
  }
  .wrapper.zoom__page .to__top {
    width: 32px;
    height: 32px;
    right: 249px;
  }
  .wrapper.zoom__page .recycle_top {
    right: 180px !important;
  }
  .wrapper.zoom__page .to__top__icon {
    width: 20px;
    height: 20px;
  }
  .wrapper.zoom__page .card__product__unstacked,
  .wrapper.zoom__page .card__product__stake {
    width: 70px;
    height: 32px;
    font-size: 14px;
  }
  .wrapper.zoom__page .card.defi .card__header {
    padding: 0;
  }
  .wrapper.zoom__page .card.defi .card__risk {
    margin-top: -10px;
  }
  .wrapper.zoom__page .card__product__stake__block {
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .wrapper.zoom__page .card__product__stake__amount__max,
  .wrapper.zoom__page .card__product__stake__amount__input {
    font-size: 14px;
  }
  .wrapper.zoom__page .card__product__stake__amount__max,
  .wrapper.zoom__page .card__product__stake__amount__input__wrapper {
    height: 40px;
  }
  .wrapper.zoom__page .card__product__stake__amount__confirm {
    font-size: 14px;
    height: 35px;
  }
  .wrapper.zoom__page .add__defi__block {
    width: 42px;
    padding: 8px 0;
    top: 300px;
    right: 0px;
  }
  .wrapper.zoom__page .add__defi__item {
    width: 28px;
    height: 28px;
    margin-bottom: 8px;
  }
  .wrapper.zoom__page .add__defi__item__icon {
    height: 20px;
    width: auto;
  }
  .wrapper.zoom__page .card__nft__wrapper {
    width: 192px;
    margin: 0 auto;
  }
  .wrapper.zoom__page .card__nft__img {
    width: 165px;
    height: 110px;
    object-fit: inherit;
  }
  .wrapper.zoom__page .card.nft .card__header {
    margin-bottom: 0;
  }
  .wrapper.zoom__page .card.nft .card__risk {
    margin-top: 4px;
  }
  .wrapper.zoom__page .login__big {
    width: 1376.9230769231px;
    height: 1370.7692307692px;
  }
  .wrapper.zoom__page .login__middle {
    width: 846.1538461538px;
    height: 846.1538461538px;
  }
  .wrapper.zoom__page .login__small {
    width: 636.9230769231px;
    height: 636.9230769231px;
  }
  .wrapper.zoom__page .login__round {
    width: 929.2307692308px;
    height: 929.2307692308px;
  }
  .wrapper.zoom__page .login__form {
    width: 418.4615384615px;
    height: 418.4615384615px;
  }
  .wrapper.zoom__page .login__input__wrapper {
    width: 285px;
    height: 40px;
  }
  .wrapper.zoom__page .login__btn {
    width: 285px;
  }
  .wrapper.zoom__page .login__logo {
    margin-bottom: 20px;
  }
  .wrapper.zoom__page .card.new .add__wallet,
  .wrapper.zoom__page .card.empty .add__wallet {
    width: 112px;
    height: 112px;
  }
  .wrapper.zoom__page .card.new .add__wallet .add__wallet__btn__bg,
  .wrapper.zoom__page .card.empty .add__wallet .add__wallet__btn__bg {
    width: 60px;
    height: 60px;
  }
  .wrapper.zoom__page .card.new .add__wallet .save__text,
  .wrapper.zoom__page .card.empty .add__wallet .save__text {
    font-size: 16px;
  }
  .wrapper.zoom__page .card.new .add__wallet .plus__wrapper span,
  .wrapper.zoom__page .card.empty .add__wallet .plus__wrapper span {
    width: 20px;
    height: 3px;
  }
  .wrapper.zoom__page .card.new .add__wallet.save,
  .wrapper.zoom__page .card.empty .add__wallet.save {
    top: 190px;
  }
  .wrapper.zoom__page .card__product__row .product__row__dropdown .product__row__dropdown__item {
    font-size: 14px;
    padding: 3px 0;
  }
  .wrapper.zoom__page .card__product__row .product__row__dropdown {
    top: 24px;
    padding: 2px 12px;
  }
  .wrapper.zoom__page .menu__open {
    width: 80px;
    height: 80px;
    right: -40px;
  }
  .wrapper.zoom__page .menu__open__btn {
    width: 24px;
    height: 24px;
  }
  .wrapper.zoom__page .menu__open__icon {
    width: 14px;
    height: 14px;
  }
  .wrapper.zoom__page .card.trash .trash__wallet {
    width: 100px;
    height: 100px;
    top: 60px;
  }
  .wrapper.zoom__page .trash__wallet__icon {
    width: 33px;
    height: 36px;
  }
  .wrapper.zoom__page .empty__trash__title {
    font-size: 76px;
  }
  .wrapper.zoom__page .light_core_activate_title {
    font-size: 40px !important;
  }
  .wrapper.zoom__page .card__list__anchor,
  .wrapper.zoom__page .card__list__title {
    font-size: 14px;
  }
  .wrapper.zoom__page .card__list {
    width: 256px;
    height: 64px;
    border-radius: 20px;
    padding: 8px;
    margin-right: 70px;
  }
  .wrapper.zoom__page .card__risk__chart__list {
    width: 80px;
    height: 80px;
    right: -40px;
  }
  .wrapper.zoom__page .card__list__percent {
    margin-right: 13px;
    width: 48px;
    height: 48px;
  }
  .wrapper.zoom__page .card__risk__chart__list__number {
    font-size: 18px;
  }
  .wrapper.zoom__page .zoom__page__btn {
    display: none;
  }
  .wrapper.zoom__page .card__chart__wrapper {
    width: 572px;
    height: 410px;
    padding: 17px 40px 17px 56px;
  }
  .wrapper.zoom__page .card__chart {
    width: 464px;
    height: 282px;
  }
  .wrapper.zoom__page .check__wrapper .checkbox__box {
    width: 18px;
    height: 18px;
  }
  .wrapper.zoom__page .check__wrapper .checkbox__label {
    font-size: 14px;
    line-height: 18px;
    font-weight: 600;
  }
  .wrapper.zoom__page .card__chart__title {
    font-size: 14px;
    line-height: 18px;
    font-weight: 600;
  }
  .wrapper.zoom__page .card__chart__dropdown__selected {
    font-size: 14px;
    line-height: 18px;
    width: 70px;
  }
  .wrapper.zoom__page .card__chart__dropdown__selected:after {
    width: 70px;
  }
  .wrapper.zoom__page .card__chart__header {
    margin-bottom: 17px;
  }
  .wrapper.zoom__page .card__chart__close {
    width: 15px;
    height: 15px;
  }
  .wrapper.zoom__page .card__round__shadow {
    width: 90px;
    height: 90px;
  }
  .wrapper.zoom__page .round__shdow {
    width: 120px;
    height: 120px;
  }
  .wrapper.zoom__page .rangeslider-vertical {
    height: 133px !important;
  }
  .wrapper.zoom__page .card__round__shadow__defi__list {
    top: 13px;
    left: 13px;
  }
  .wrapper.zoom__page .aside__nth__title {
    font-size: 14px !important;
    line-height: 20px !important;
  }
  .wrapper.zoom__page .card__product__title {
    width: 168px !important;
  }
  .wrapper.zoom__page .current__card .rangeslider-horizontal {
    width: 105px !important;
  }
  .wrapper.zoom__page .card .card__risk__chart svg {
    width: 95px;
    height: 95px;
  }
  .wrapper.zoom__page .aside__chart__wrapper .card__risk__chart svg {
    width: 128px;
    width: 128px;
  }
  .wrapper.zoom__page .login_requests__message {
    width: 85% !important;
  }
  .wrapper.zoom__page .psw_requests__message {
    width: 80% !important;
  }
  .wrapper.zoom__page .ntf__security__title {
    text-overflow: ellipsis;
    overflow: hidden;
    width: 118px;
    height: 1.2em;
    white-space: nowrap;
  }
  .wrapper.zoom__page .card.empty .error__message.requests__message ~ .add__wallet.save {
    top: 160px;
  }
  .wrapper.zoom__page .user__info {
    margin-left: 30px;
    margin-right: 30px;
  }
  .wrapper.zoom__page .login__settings__wrapper {
    max-width: 1208px;
    width: calc(100% - 460px);
  }
  .wrapper.zoom__page .settings__tabs__link {
    font-size: 18px;
    width: 230px;
  }
  .wrapper.zoom__page .unstake__error__modal {
    width: 247px !important;
    left: -19px !important;
  }
  .wrapper.zoom__page .contract__address_content {
    width: 340px;
  }
  .wrapper.zoom__page {
    /*Staking Risk CSS*/
  }
  .wrapper.zoom__page .card__product__wrapper .card_product_scroller_item {
    display: flex;
    justify-content: space-around;
    flex-wrap: nowrap;
    padding: 5px 10px;
  }
  .wrapper.zoom__page .card__product__wrapper .card_product_scroller_item:nth-child(odd) {
    background: rgba(132, 132, 132, 0.0509803922);
  }
  .wrapper.zoom__page .card__product__wrapper .card_product_scroller_item_title {
    font-family: Assistant;
    font-weight: 600;
    font-size: 14px;
    padding-left: 10px;
    color: #364048;
  }
  .wrapper.zoom__page .card__product__wrapper .card_product_scroller_item_level {
    font-family: Assistant;
    font-weight: 600;
    font-size: 14px;
    padding-right: 10px;
    text-align: right;
    color: #4DC7B5;
  }
  .wrapper.zoom__page .zoom__page__btn {
    display: block;
  }
  .wrapper.zoom__page .zoom__page__btn__minus {
    visibility: visible;
    opacity: 1;
  }
  .wrapper.zoom__page .zoom__page__btn__plus {
    opacity: 0;
    visibility: hidden;
  }
}
@media only screen and (max-width: 1700px) {
  .nav {
    width: 71px;
  }
  .header {
    height: 56px;
    min-height: 56px;
    padding-left: 90px;
  }
  .nav__link {
    width: 40px;
    height: 40px;
    font-size: 22px;
  }
  .nav__link:hover, .nav__link.active {
    border-radius: 8px;
  }
  .card {
    max-width: 240px;
    height: 352px;
    margin-right: 30px;
    margin-bottom: 30px;
  }
  .card__product__title {
    font-size: 14px;
  }
  .card__risk {
    margin-top: 12px;
  }
  .card__risk__chart {
    width: 112px;
    height: 112px;
  }
  .card.empty .card__risk__chart__min,
  .card__risk__chart__min {
    width: 90px;
    height: 90px;
  }
  .card__risk__chart__number {
    font-size: 20px;
    line-height: 26px;
  }
  .card__wallet__usd, .card__wallet__rates {
    font-size: 13px;
  }
  .cart__walet__text__title {
    font-size: 12px !important;
  }
  .unstacking {
    width: 80px;
    height: 80px;
    font-size: 14px;
  }
  .card {
    padding: 16px;
    border-radius: 24px;
  }
  .card__price {
    height: 32px;
    border-radius: 80px;
    font-size: 14px;
  }
  .card__title {
    font-size: 14px;
  }
  .card.light {
    padding-top: 20px;
  }
  .card.light .card__header {
    margin-bottom: 12px;
  }
  .card__close {
    width: 12px;
    height: 12px;
  }
  .card__close span {
    width: 1px;
  }
  .card__product__row {
    margin: 0;
    padding: 0;
  }
  .card__product__number {
    font-size: 18px;
    line-height: 23px;
  }
  .card__risk__range {
    width: 6px;
    height: 133px;
  }
  .card__risk__range__btn {
    width: 18px;
    height: 18px;
    left: -6px;
  }
  .card__risk__info {
    bottom: -15px;
    width: 19px;
    height: 19px;
    font-size: 10px;
  }
  .card__wallet__row {
    padding: 0 10px;
  }
  .zoom__page__btn,
  .layout__list, .layout__grid {
    width: 45px;
    height: 45px;
    margin-bottom: 16px;
  }
  .layout__block {
    right: 250px;
    top: 65px;
    position: fixed;
    z-index: 9;
  }
  .contract__address_container {
    width: 510px;
  }
  .layout__grid__icon {
    width: 18px;
    height: 18px;
  }
  .layout__list__icon {
    width: 19px;
    height: 19px;
  }
  .card__risk__title {
    font-size: 14px;
    line-height: 15px;
    margin-bottom: 5px;
    margin-top: 10px;
  }
  .card__risk__range__btn__min {
    width: 12px;
    height: 12px;
  }
  .card__risk__alert {
    width: 48px;
    height: 48px;
  }
  .card__risk__alert__title {
    font-size: 13px;
  }
  .aside__wallet__title {
    font-size: 16px;
    line-height: 21px;
    margin-bottom: 20px;
    margin-top: 25px;
  }
  .main .content {
    margin-left: 0;
    width: calc(100% - 234px);
    padding: 16px 24px 0 17px;
    margin-top: 0;
  }
  .main:after {
    right: 234px;
    width: 5px;
    top: 72px;
  }
  .filter__block__btn__block {
    left: -90px;
  }
  .filter__block {
    height: calc(100% - 62px);
    width: 228px;
  }
  .asset__list__text {
    font-size: 14px;
  }
  .asset__list__box {
    width: 20px;
    height: 20px;
    border-radius: 4px;
  }
  .asset__list__box:after {
    width: 5px;
    height: 10px;
  }
  .asset__block {
    border-radius: 8px;
  }
  .aside {
    width: 234px;
    padding: 16px;
  }
  .add__wallet__btn {
    width: 200px;
    height: 64px;
    border-radius: 18px;
    font-size: 16px;
    line-height: 21px;
    padding-left: 16px;
  }
  .add__wallet__btn__plus {
    width: 40px;
    height: 40px;
  }
  .add__wallet__btn__plus__bg {
    width: 25px;
    height: 25px;
  }
  .setting {
    margin-left: 30px;
  }
  .card__risk__range__hr {
    width: 121px;
    height: 5px;
  }
  .card__risk__range__btn__hr {
    width: 17px;
    height: 17px;
  }
  .card__risk__range__btn__hr__min {
    width: 11px;
    height: 11px;
  }
  .aside__tabs__link {
    font-size: 14px;
    border: none;
    outline: none;
  }
  .aside__chart__wrapper {
    height: 235px;
    margin-bottom: 30px;
  }
  .aside__chart__wrapper .card__risk__chart {
    width: 158px;
    height: 158px;
  }
  .aside__chart__wrapper .card__risk__chart__min {
    width: 122px;
    height: 122px;
    border-width: 14px;
  }
  .aside__chart__wrapper .card__risk__alert {
    width: 64px;
    height: 64px;
  }
  .aside__chart__wrapper .card__risk__alert__title,
  .aside__chart__wrapper .card__risk__alert__number {
    font-size: 14px;
    line-height: 18px;
  }
  .aside__card__title {
    font-size: 13px;
    margin-bottom: 3px;
    line-height: 17px;
  }
  .aside__card__numbers {
    font-size: 16px;
  }
  .aside__card {
    padding: 14px 16px;
    border-radius: 18px;
  }
  .aside__card .card__risk__alert {
    width: 44px;
    height: 44px;
    top: 0;
  }
  .aside__card .card__risk__alert__number,
  .aside__card .card__risk__alert__title {
    font-size: 13px;
  }
  .aside__card .card__risk__range__hr {
    width: 71px;
    height: 6px;
  }
  .aside__card__progress {
    height: 6px;
  }
  .card__wallet {
    margin-bottom: 10px;
    height: 70px;
  }
  .to__top {
    width: 32px;
    height: 32px;
    right: 249px;
  }
  .recycle_top {
    right: 180px !important;
  }
  .to__top__icon {
    width: 20px;
    height: 20px;
  }
  .card__product__unstacked,
  .card__product__stake {
    width: 70px;
    height: 32px;
    font-size: 14px;
  }
  .card.defi .card__header {
    padding: 0;
  }
  .card.defi .card__risk {
    margin-top: -10px;
  }
  .card__product__stake__block {
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .card__product__stake__amount__max,
  .card__product__stake__amount__input {
    font-size: 14px;
  }
  .card__product__stake__amount__max,
  .card__product__stake__amount__input__wrapper {
    height: 40px;
  }
  .card__product__stake__amount__confirm {
    font-size: 14px;
    height: 35px;
  }
  .add__defi__block {
    width: 42px;
    padding: 8px 0;
    top: 300px;
    right: 0px;
  }
  .add__defi__item {
    width: 28px;
    height: 28px;
    margin-bottom: 8px;
  }
  .add__defi__item__icon {
    height: 20px;
    width: auto;
  }
  .card__nft__wrapper {
    width: 192px;
    margin: 0 auto;
  }
  .card__nft__img {
    width: 165px;
    height: 110px;
    object-fit: inherit;
  }
  .card.nft .card__header {
    margin-bottom: 0;
  }
  .card.nft .card__risk {
    margin-top: 4px;
  }
  .login__big {
    width: 1376.9230769231px;
    height: 1370.7692307692px;
  }
  .login__middle {
    width: 846.1538461538px;
    height: 846.1538461538px;
  }
  .login__small {
    width: 636.9230769231px;
    height: 636.9230769231px;
  }
  .login__round {
    width: 929.2307692308px;
    height: 929.2307692308px;
  }
  .login__form {
    width: 418.4615384615px;
    height: 418.4615384615px;
  }
  .login__input__wrapper {
    width: 285px;
    height: 40px;
  }
  .login__btn {
    width: 285px;
  }
  .login__logo {
    margin-bottom: 20px;
  }
  .card.new .add__wallet,
  .card.empty .add__wallet {
    width: 112px;
    height: 112px;
  }
  .card.new .add__wallet .add__wallet__btn__bg,
  .card.empty .add__wallet .add__wallet__btn__bg {
    width: 60px;
    height: 60px;
  }
  .card.new .add__wallet .save__text,
  .card.empty .add__wallet .save__text {
    font-size: 16px;
  }
  .card.new .add__wallet .plus__wrapper span,
  .card.empty .add__wallet .plus__wrapper span {
    width: 20px;
    height: 3px;
  }
  .card.new .add__wallet.save,
  .card.empty .add__wallet.save {
    top: 190px;
  }
  .card__product__row .product__row__dropdown .product__row__dropdown__item {
    font-size: 14px;
    padding: 3px 0;
  }
  .card__product__row .product__row__dropdown {
    top: 24px;
    padding: 2px 12px;
  }
  .menu__open {
    width: 80px;
    height: 80px;
    right: -40px;
  }
  .menu__open__btn {
    width: 24px;
    height: 24px;
  }
  .menu__open__icon {
    width: 14px;
    height: 14px;
  }
  .card.trash .trash__wallet {
    width: 100px;
    height: 100px;
    top: 60px;
  }
  .trash__wallet__icon {
    width: 33px;
    height: 36px;
  }
  .empty__trash__title {
    font-size: 76px;
  }
  .light_core_activate_title {
    font-size: 40px !important;
  }
  .card__list__anchor,
  .card__list__title {
    font-size: 14px;
  }
  .card__list {
    width: 256px;
    height: 64px;
    border-radius: 20px;
    padding: 8px;
    margin-right: 70px;
  }
  .card__risk__chart__list {
    width: 80px;
    height: 80px;
    right: -40px;
  }
  .card__list__percent {
    margin-right: 13px;
    width: 48px;
    height: 48px;
  }
  .card__risk__chart__list__number {
    font-size: 18px;
  }
  .zoom__page__btn {
    display: none;
  }
  .card__chart__wrapper {
    width: 572px;
    height: 410px;
    padding: 17px 40px 17px 56px;
  }
  .card__chart {
    width: 464px;
    height: 282px;
  }
  .check__wrapper .checkbox__box {
    width: 18px;
    height: 18px;
  }
  .check__wrapper .checkbox__label {
    font-size: 14px;
    line-height: 18px;
    font-weight: 600;
  }
  .card__chart__title {
    font-size: 14px;
    line-height: 18px;
    font-weight: 600;
  }
  .card__chart__dropdown__selected {
    font-size: 14px;
    line-height: 18px;
    width: 70px;
  }
  .card__chart__dropdown__selected:after {
    width: 70px;
  }
  .card__chart__header {
    margin-bottom: 17px;
  }
  .card__chart__close {
    width: 15px;
    height: 15px;
  }
  .card__round__shadow {
    width: 90px;
    height: 90px;
  }
  .round__shdow {
    width: 120px;
    height: 120px;
  }
  .rangeslider-vertical {
    height: 133px !important;
  }
  .card__round__shadow__defi__list {
    top: 13px;
    left: 13px;
  }
  .aside__nth__title {
    font-size: 14px !important;
    line-height: 20px !important;
  }
  .card__product__title {
    width: 168px !important;
  }
  .current__card .rangeslider-horizontal {
    width: 105px !important;
  }
  .card .card__risk__chart svg {
    width: 95px;
    height: 95px;
  }
  .aside__chart__wrapper .card__risk__chart svg {
    width: 128px;
    width: 128px;
  }
  .login_requests__message {
    width: 85% !important;
  }
  .psw_requests__message {
    width: 80% !important;
  }
  .ntf__security__title {
    text-overflow: ellipsis;
    overflow: hidden;
    width: 118px;
    height: 1.2em;
    white-space: nowrap;
  }
  .card.empty .error__message.requests__message ~ .add__wallet.save {
    top: 160px;
  }
  .user__info {
    margin-left: 30px;
    margin-right: 30px;
  }
  .login__settings__wrapper {
    max-width: 1208px;
    width: calc(100% - 460px);
  }
  .settings__tabs__link {
    font-size: 18px;
    width: 230px;
  }
  .unstake__error__modal {
    width: 247px !important;
    left: -19px !important;
  }
  .contract__address_content {
    width: 340px;
  }
  /*Staking Risk CSS*/
  .card__product__wrapper .card_product_scroller_item {
    display: flex;
    justify-content: space-around;
    flex-wrap: nowrap;
    padding: 5px 10px;
  }
  .card__product__wrapper .card_product_scroller_item:nth-child(odd) {
    background: rgba(132, 132, 132, 0.0509803922);
  }
  .card__product__wrapper .card_product_scroller_item_title {
    font-family: Assistant;
    font-weight: 600;
    font-size: 14px;
    padding-left: 10px;
    color: #364048;
  }
  .card__product__wrapper .card_product_scroller_item_level {
    font-family: Assistant;
    font-weight: 600;
    font-size: 14px;
    padding-right: 10px;
    text-align: right;
    color: #4DC7B5;
  }
}
@media only screen and (max-width: 992px) {
  .active__page__main {
    width: 100% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/Assets/css/base/_fonts.scss","webpack://./src/Assets/css/style.scss","webpack://./src/Assets/css/base/_core.scss","webpack://./src/Assets/css/base/_var.scss","webpack://./src/Assets/css/components/_form.scss","webpack://./src/Assets/css/components/_modal.scss","webpack://./src/Assets/css/components/_card.scss","webpack://./src/Assets/css/components/_chart.scss","webpack://./src/Assets/css/components/_filter.scss","webpack://./src/Assets/css/layout/_header.scss","webpack://./src/Assets/css/layout/_nav.scss","webpack://./src/Assets/css/layout/_main.scss","webpack://./src/Assets/css/layout/_aside.scss","webpack://./src/Assets/css/pages/_wallets_shield.scss","webpack://./src/Assets/css/pages/_defi_shield.scss","webpack://./src/Assets/css/pages/_settings.scss","webpack://./src/Assets/css/pages/_light_defi.scss","webpack://./src/Assets/css/pages/_light_nft.scss","webpack://./src/Assets/css/pages/_login.scss","webpack://./src/Assets/css/pages/_loading.scss","webpack://./src/Assets/css/_custom.scss","webpack://./src/Assets/css/media/_media.scss","webpack://./src/Assets/css/media/_mx1440.scss","webpack://./src/Assets/css/media/_mx992.scss"],"names":[],"mappings":"AAEA;EACE,wBAAA;EACA,4CAAA;EACA,4SAAA;EAKA,mBAAA;EACA,kBAAA;EACA,kBAAA;ACJF;ADOA;EACE,wBAAA;EACA,4CAAA;EACA,8SAAA;EAKA,iBAAA;EACA,kBAAA;EACA,kBAAA;ACTF;ADYA;EACE,wBAAA;EACA,6CAAA;EACA,iTAAA;EAKA,iBAAA;EACA,kBAAA;EACA,kBAAA;ACdF;ADiBA;EACE,wBAAA;EACA,6CAAA;EACA,iTAAA;EAKA,gBAAA;EACA,kBAAA;EACA,kBAAA;ACnBF;ADsBA;EACE,wBAAA;EACA,6CAAA;EACA,iTAAA;EAKA,gBAAA;EACA,kBAAA;EACA,kBAAA;ACxBF;AD2BA;EACE,wBAAA;EACA,6CAAA;EACA,iTAAA;EAKA,gBAAA;EACA,kBAAA;EACA,kBAAA;AC7BF;ADgCA;EACE,wBAAA;EACA,6CAAA;EACA,iTAAA;EAKA,gBAAA;EACA,kBAAA;EACA,kBAAA;AClCF;ACxDA;EACE,SAAA;EACA,UAAA;EACA,sBAAA;AD0DF;;ACvDA;EAEE,eCJG;AF6DL;;ACtDA;EACE,oCCPK;EDQL,gBCXM;EDYN,cCXO;EDYP,gBAAA;ADyDF;ACvDI;;EAEE,eAAA;EACA,YAAA;ADyDN;AC7DE;EAME,cAAA;AD0DJ;;ACtDA;EACE,WAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;ADyDF;;ACtDA;EACE,aAAA;EACA,eAAA;ADyDF;;ACtDA;EACE,WAAA;ADyDF;;ACrDA,UAAA;AACA;EACE,UAAA;EACA,cAAA;ADwDF;;ACpDE;EAEE,yBAAA;ADsDJ;;AClDA;EACE,eAAA;EACE,SAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;ADqDJ;;ACjDA,UAAA;AACA;EACE,sDAAA;EACA,mBAAA;ADoDF;;AChDA,WAAA;AACA;EACE,uBAAA;EACA,kBAAA;ADmDF;;AChDA,oBAAA;AACA;EACE,uBAAA;ADmDF;;AChDA;;;EACE,oBAAA;ADqDF;;AC9CA;EACE,oBAAA;ADiDF;;AC1CA;EACE,oBAAA;AD6CF;AC3CE;EACE,mBAAA;AD6CJ;;ACzCA;EACE,oBAAA;EACA,6GAAA;AD4CF;;ACzCA;EACE,oBAAA;EACA,iGAAA;AD4CF;;AC1CA;EACE,mBAAA;AD6CF;;AGnKA;EACE,kBAAA;EACA,YAAA;AHsKF;AGnKI;EACE,6GAAA;AHqKN;AGnKM;EACE,0BAAA;AHqKR;AGjKI;EACE,cAAA;AHmKN;;AG9JA;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,gFAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;AHiKF;;AG9JA;EACE,aAAA;EACA,WAAA;EACA,kBAAA;AHiKF;;AG9JA;EACE,mBAAA;EACA,qDAAA;EACA,4BAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;AHiKF;;AG9JA;EACE,WAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,6GAAA;AHiKF;;AG9JA;EACE,WAAA;EACA,YAAA;EACA,gFAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,eAAA;AHiKF;;AG9JA;EACE,gBAAA;EACA,kBAAA;EACA,YAAA;AHiKF;AG9JI;EACE,6GAAA;AHgKN;AG9JM;EACE,0BAAA;AHgKR;AG5JI;EACE,cAAA;AH8JN;;AGxJA;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,gFAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;AH2JF;;AGvJA;EACE,kBAAA;EACA,qDAAA;EACA,4BAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;EACA,uBAAA;AH0JF;;AGrJA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,gCAAA;EACA,eAAA;AHwJF;AGtJE;EACE,gBAAA;EACA,mBAAA;AHwJJ;AGrJE;EACE,cAAA;AHuJJ;;AGlJA;EACE,kCAAA,EAAA,iBAAA;AHqJF;;AI5SA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,wCAAA;EACA,iBAAA;EACA,mBAAA;AJ+SF;;AI5SA;EACE,YAAA;EACA,mBAAA;EACA,+CAAA;EACA,yBAAA;EACA,kBAAA;EAEA,aAAA;EAED,kBAAA;AJ6SD;AI3SE;EACE,aAAA;EACA,kBAAA;EAGA,mBAAA;AJ2SJ;;AIvSA;EACE,2BAAA;EACA,2BAAA;AJ0SF;;AKnVA;EACE,YAAA;EAEA,aAAA;EACA,mBAAA;EACA,kFAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;ALqVF;AKrUE;EACE,qBAAA;EACA,UAAA;EACA,iBAAA;ALuUJ;AKrUI;EACE,6BAAA;ALuUN;AKpUI;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;ALsUN;AKnUI;EACE,eAAA;EACA,cAAA;EACA,gBAAA;ALqUN;AKjUM;EACE,cAAA;ALmUR;AKjUQ;EACE,cAAA;ALmUV;AK/TM;EACE,cAAA;ALiUR;AK/TQ;EACE,cAAA;ALiUV;AK7TM;EACE,cAAA;AL+TR;AK7TQ;EACE,cAAA;AL+TV;AKvTE;EACE,aAAA;ALyTJ;AKrTI;EACE,mBAAA;EACA,oCAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,kBAAA;ALuTN;AKpTI;EACE,mBAAA;EACA,mHAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;ALsTN;AKpTM;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;ALsTR;AKnTM;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;ALqTR;AKnTQ;EACE,WAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;ALqTV;AKnTU;EACE,wBAAA;ALqTZ;AK/SQ;EACE,mBAAA;EACA,UAAA;ALiTV;AK7SM;EACE,UAAA;AL+SR;AK7SQ;EACE,kBAAA;EACA,kBAAA;EACA,UAAA;AL+SV;AK5SQ;EACE,UAAA;EACA,mBAAA;AL8SV;AK1SM;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,+KAAA;EACA,kBAAA;AL4SR;AKlSI;EACE,mBAAA;EACA,oCAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,kBAAA;ALoSN;AKjSI;EACE,mBAAA;EACA,oFAAA;EAEA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;ALkSN;AK/RI;EACE,aAAA;ALiSN;AK9RI;EACE,WAAA;EACA,YAAA;ALgSN;AK7RI;EACE,UAAA;EACA,kBAAA;AL+RN;AKzRI;EACE,aAAA;AL2RN;AKrRI;;;EAGE,UAAA;EACA,kBAAA;ALuRN;AKpRI;;;;;;;EAOE,cAAA;ALsRN;AKnRI;EACE,uDAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;ALqRN;AKnRM;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,oBAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;ALqRR;AKjRI;EACE,UAAA;EACA,kBAAA;ALmRN;AKhRI;EACE,mBAAA;EACA,mHAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;ALkRN;AKhRM;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;ALkRR;AK/QM;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;ALiRR;AK/QQ;EACE,WAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;ALiRV;AK/QU;EACE,wBAAA;ALiRZ;AK3QQ;EACE,mBAAA;EACA,UAAA;AL6QV;AKzQM;EACE,UAAA;AL2QR;AKzQQ;EACE,kBAAA;EACA,kBAAA;EACA,UAAA;AL2QV;AKxQQ;EACE,UAAA;EACA,mBAAA;AL0QV;AKtQM;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,+KAAA;EACA,kBAAA;ALwQR;AKhQI;EACE,qBAAA;ALkQN;AK/PI;;;EAGE,cAAA;ALiQN;AK/PM;;;EACE,cAAA;ALmQR;AK/PI;EACE,mBAAA;EACA,cAAA;ALiQN;AK5PI;EACE,qBAAA;AL8PN;AK3PI;;;EAGE,cAAA;AL6PN;AK3PM;;;EACE,cAAA;AL+PR;AK3PI;EACE,mBAAA;EACA,cAAA;AL6PN;AKxPI;EACE,qBAAA;AL0PN;AKvPI;;;EAGE,cAAA;ALyPN;AKvPM;;;EACE,cAAA;AL2PR;AKvPI;EACE,mBAAA;EACA,cAAA;ALyPN;AKrPE;EACE,kBAAA;ALuPJ;AKrPI;EACE,uBAAA;EACA,8BAAA;ALuPN;AKjPE;EACE,SAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,gFAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;ALmPJ;AK/OE;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;ALiPJ;AK/OI;EACE,cAAA;ALiPN;AK3OE;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,6BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;AL6OJ;AKzOI;EACE,YAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,mBAAA;EACA,wBAAA;AL2ON;AKzOM;EACE,yBAAA;AL2OR;AKtOE;EACE,YAAA;EACA,WAAA;EACA,6GAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;ALwOJ;AKrOE;EACE,WAAA;EACA,aAAA;EACA,6GAAA;EACA,mBAAA;EACA,qCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;ALuOJ;AKrOI;EACE,aAAA;ALuON;AKpOI;EACE,aAAA;ALsON;AKjOE;EACE,aAAA;EACA,8BAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,oBAAA;ALmOJ;AKjOI;EACE,qCAAA;ALmON;AK/NE;EAEE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ALgOJ;AK7NE;EACE,cAAA;EACA,gBAAA;AL+NJ;AK5NE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AL8NJ;AK3NE;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AL6NJ;AK1NE;EACE,YAAA;EACA,aAAA;EACA,6GAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AL4NJ;AKxNE;EACE,YAAA;EACA,aAAA;EACA,8FAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AL0NJ;AKvNE;EACE,iBAAA;EACA,eAAA;EACA,iBAAA;ALyNJ;AKtNE;EAEE,gBAAA;EACA,eAAA;EACA,iBAAA;ALuNJ;AKpNE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gFAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,oBAAA;ALsNJ;AK7ME;EACE,cAAA;EACA,eAAA;EACA,iBAAA;AL+MJ;AK5ME;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AL8MJ;AK3ME;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,UAAA;EACA,gFAAA;EACA,oBAAA;EACA,eAAA;AL6MJ;AK1ME;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AL4MJ;AK1MI;EACE,WAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,mHAAA;AL4MN;AKxMI;EACE,WAAA;EACA,mBAAA;EACA,0EAAA;EAEA,0BAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,aAAA;EACA,SAAA;EACA,OAAA;ALyMN;AKvMM;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,gCAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;ALyMR;AKvMQ;EACE,gBAAA;ALyMV;AKrMM;EACE,mBAAA;EACA,UAAA;ALuMR;AKjME;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;ALmMJ;AKhME;EACE,eAAA;EACA,iBAAA;EACA,uDAAA;EACA,iBAAA;ALkMJ;AK/LE;EAEE,mBAAA;EACA,2JAAA;EAEA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;AL+LJ;AK3LE;EACE,aAAA;EACA,8BAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AL6LJ;AK1LE;EACE,cAAA;AL4LJ;AKzLE;EACE,cAAA;AL2LJ;AKxLE;EACE,UAAA;EACA,aAAA;EAIA,kBAAA;EACA,SAAA;EACA,MAAA;EACA,aAAA;ALuLJ;AKrLI;EACE,cAAA;ALuLN;AKnLE;EACE,WAAA;EACA,WAAA;EACA,mBAAA;EACA,4DAAA;EACA,4BAAA;EACA,kBAAA;EACA,SAAA;ALqLJ;AKlLE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,6EAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;ALoLJ;AKlLI;EAEE,mBAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,iGAAA;ALmLN;AK/KE;EACE,YAAA;EACA,WAAA;EAEA,mBAAA;EAEA,kBAAA;EACA,SAAA;EACA,MAAA;EACA,aAAA;AL+KJ;AK7KI;EACE,cAAA;AL+KN;AK3KE;EACE,UAAA;EACA,YAAA;EAGA,4BAAA;EACA,kBAAA;EACA,OAAA;AL2KJ;AKxKE;EACE,WAAA;EACA,YAAA;EAGA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,eAAA;ALwKJ;AKtKI;EAEE,mBAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,iGAAA;ALuKN;AKnKE;EACE,YAAA;EAEA,6GAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ALoKJ;AKjKE;EACE,YAAA;EACA,aAAA;EACA,mBAAA;ALmKJ;;AK7JA;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kFAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;ALgKF;AK7JI;EACE,YAAA;EACA,yBAAA;UAAA,iBAAA;EACA,eAAA;AL+JN;AK1JI;EACE,qBAAA;AL4JN;AKzJI;EACE,cAAA;AL2JN;AKzJM;EACE,cAAA;AL2JR;AKpJI;EACE,qBAAA;ALsJN;AKnJI;EACE,cAAA;ALqJN;AKnJM;EACE,cAAA;ALqJR;AK9II;EACE,qBAAA;ALgJN;AK7II;EACE,cAAA;AL+IN;AK7IM;EACE,cAAA;AL+IR;;AKzIA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6GAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AL4IF;;AKzIA;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,6GAAA;AL4IF;;AKzIA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;EACA,8FAAA;AL4IF;;AKzIA;EACE,eAAA;EACA,iBAAA;AL4IF;;AKzIA;;EAEE,gBAAA;EACA,eAAA;EACA,cAAA;AL4IF;;AKtIA;EACE,0BAAA;ALyIF;;AKtIA;EACE,eAAA;ALyIF;;AKrIE;EACE,mBAAA;EACA,cAAA;ALwIJ;;AKnIE;EACE,mBAAA;EACA,cAAA;ALsIJ;;AKlIA;EACE,eAAA;EACA,iBAAA;ALqIF;;AKlIA;;EAEE,gBAAA;EACA,eAAA;EACA,cAAA;ALqIF;;AKjHE;;;;;;;;;;;;;;;EACE,8BAAA;ALkIJ;;AK5HE;;EACE,mBAAA;ALgIJ;;AK1HE;;EACE,8BAAA;AL8HJ;;AKlHE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;ALqHJ;;AKhHE;EAEE,UAAA;ALkHJ;;AK1GE;EACE,mBAAA;EACA,cAAA;AL6GJ;AK3GI;EACE,yBAAA;EACA,0BAAA;EACA,2BAAA;EACA,4BAAA;EACA,gCAAA;AL6GN;;AKtGA;EACE,eAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;ALyGF;;AKvGA;EACE,eAAA;EACE,SAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;AL0GJ;;AKpGE;EACE,yBAAA;ALuGJ;;AMtwCA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kFAAA;EACA,mBAAA;EACA,kBAAA;EAIA,4BAAA;EAGA,wBAAA;EACA,YAAA;EACA,kBAAA;ANowCF;;AM7vCA;EACE,YAAA;EACA,aAAA;EACA,6GAAA;EACA,mBAAA;ANgwCF;;AM7vCA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;ANgwCF;;AM7vCA;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;ANgwCF;;AM7vCA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;ANgwCF;AM9vCE;EACE,eAAA;ANgwCJ;AM7vCE;EACE,aAAA;AN+vCJ;AM3vCQ;EACE,UAAA;EACA,mBAAA;AN6vCV;AMvvCE;EACE,mBAAA;ANyvCJ;AMtvCE;EACE,mBAAA;ANwvCJ;AMrvCE;EACE,mBAAA;ANuvCJ;AMpvCE;EACE,mBAAA;ANsvCJ;AMnvCE;EACE,WAAA;EACA,YAAA;EACA,6GAAA;EACA,kBAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;ANqvCJ;AMnvCI;EACE,UAAA;EACA,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;ANqvCN;AMjvCE;EACE,oBAAA;EACA,gBAAA;EACA,eAAA;ANmvCJ;AMhvCE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ANkvCJ;;AM9uCA;EACE,YAAA;EACA,aAAA;EACA,yBAAA;ANivCF;;AM9uCA;EACE,WAAA;EACA,kBAAA;EACA,eAAA;ANivCF;;AM9uCA;EACE,eAAA;EACA,iBAAA;EACA,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;ANivCF;AM/uCE;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,mHAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;ANivCJ;AM9uCE;EACE,UAAA;EACA,WAAA;EACA,gCAAA;EACA,+BAAA;EACA,wBAAA;ANgvCJ;;AM5uCA;EACE,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,kDAAA;EACA,0BAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EAGA,wBAAA;AN6uCF;AM5uCE;EACE,UAAA;EACA,mBAAA;AN8uCJ;;AM3uCA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;AN8uCF;AM7uCE;EACE,cAAA;AN+uCJ;;AM5uCA;EACE,kBAAA;EAEA,UAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AN8uCF;;AM5uCA;;EAEE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,oBAAA;AN+uCF;;AM/tCA;EACE,kBAAA;EACA,WAAA;EACA,MAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;ANkuCF;;AMhuCA;EACE,YAAA;EACA,WAAA;EACA,eAAA;ANmuCF;;AMhuCA;EACE,gCAAA;EACA,+BAAA;EACA,wBAAA;EACA,UAAA;EACA,WAAA;ANmuCF;;AOj9CA;EACE,eAAA;EACA,YAAA;EACA,SAAA;EACA,yBAAA;EACA,YAAA;EAEA,mDAAA;EACA,UAAA;EAGA,+BAAA;APi9CF;AO/8CE;EACE,QAAA;APi9CJ;;AO58CA;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;AP+8CF;;AO58CA;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mDAAA;EACA,4BAAA;EACA,UAAA;AP+8CF;;AO58CA;EACE,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AP+8CF;;AO58CA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AP+8CF;;AO58CA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gFAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EAEA,eAAA;EACA,aAAA;EACA,kBAAA;EACA,SAAA;AP88CF;;AO38CA;EACE,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;AP88CF;;AO38CA;EACE,mBAAA;AP88CF;;AO38CA;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AP88CF;;AO38CA;EACE,WAAA;EACA,oGAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AP88CF;;AO18CE;EACE,mBAAA;EACA,UAAA;AP68CJ;;AOz8CA;EACE,8BAAA;AP48CF;;AOz8CA;EACE,aAAA;AP48CF;AOx8CM;EACE,UAAA;AP08CR;;AOp8CA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;APu8CF;;AOp8CA;EACE,WAAA;EACA,YAAA;EACA,oGAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;APu8CF;AOr8CE;EACE,WAAA;EACA,UAAA;EACA,YAAA;EACA,gCAAA;EACA,+BAAA;EACA,mCAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,oBAAA;EACA,UAAA;EACA,oBAAA;APu8CJ;;AOn8CA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;APs8CF;;AOn8CA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gFAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EAEA,eAAA;EACA,aAAA;EACA,SAAA;APq8CF;;AOn8CA;EACE,kBAAA;EACA,aAAA;APs8CF;;AQ9nDA;EACE,YAAA;EACA,gBAAA;EACA,mHAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;ARioDF;AQ/nDE;EACE,mBAAA;ARioDJ;AQ9nDE;EACE,YAAA;EACA,mBAAA;ARgoDJ;AQ7nDE;EACE,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,oBAAA;AR+nDJ;AQ7nDI;EACE,eAAA;EACA,iBAAA;AR+nDN;AQ3nDE;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;AR6nDJ;;AQznDA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AR4nDF;AQ1nDE;EACE,SAAA;EACA,6BAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;AR4nDJ;AQznDE;EACE,mBAAA;EACA,iDAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AR2nDJ;;AQvnDA;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,eAAA;AR0nDF;AQxnDE;EACE,mBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kFAAA;EACA,sBAAA;AR0nDJ;AQxnDI;EACE,oBAAA;AR0nDN;AQvnDI;EAEE,aAAA;ARwnDN;AQpnDE;EAEE,WAAA;EACA,yDAAA;EACA,mBAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,MAAA;ARqnDJ;AQlnDE;EACE,OAAA;ARonDJ;AQjnDE;EACE,QAAA;ARmnDJ;AQhnDE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;ARknDJ;AQ/mDE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;ARinDJ;AQ7mDE;EACE,WAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;AR+mDJ;AQ7mDI;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,6GAAA;EACA,mBAAA;AR+mDN;AQ3mDE;EACE,iBAAA;AR6mDJ;;AQzmDA;EACE,SAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AR4mDF;;AQzmDA;EACE,kBAAA;EACA,eAAA;AR4mDF;AQ3mDE;;EAEE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,qBAAA;EACA,wBAAA;AR6mDJ;AQ1mDE;EACE,UAAA;EACA,kBAAA;AR4mDJ;;ASjyDA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AToyDF;ASnyDE;EACE,WAAA;EACA,YAAA;ATqyDJ;ASlyDE;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,oBAAA;AToyDJ;;AShyDA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,kGAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,UAAA;EACA,mBAAA;EACA,oBAAA;ATmyDF;ASjyDE;EACE,YAAA;ATmyDJ;ASlyDI;EACE,YAAA;AToyDN;ASlyDI;EACE,aAAA;AToyDN;ASlyDI;EACE,qBAAA;EACA,WAAA;EACA,YAAA;AToyDN;ASjyDI;EACE,YAAA;ATmyDN;ASjyDM;EACE,eAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,cAAA;ATmyDR;AS9xDE;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;ATgyDJ;AS7xDE;EACE,mBAAA;AT+xDJ;AS7xDI;EACE,gBAAA;AT+xDN;AS3xDE;EACE,eAAA;EACA,qBAAA;EACA,aAAA;EACA,oBAAA;EACA,cAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AT6xDJ;AS3xDI;EAEE,mBAAA;EACA,6JAAA;EACA,mBAAA;EACA,cAAA;AT4xDN;AS1xDM;EACE,4HAAA;AT4xDR;ASvxDI;EAEE,kBAAA;EACA,UAAA;ATwxDN;ASrxDI;EACE,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,yDAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;ATuxDN;;ASlxDA;EACE,YAAA;ATqxDF;;ASlxDA;EACE,mBAAA;EACA,sGAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;EACA,iDAAA;EACA,oBAAA;ATqxDF;ASlxDI;EACE,yBAAA;AToxDN;;AS9wDA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gFAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,oBAAA;ATixDF;;AUx7DA;EACE,0BAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,6BAAA;AV27DF;AUz7DE;EACE,mBAAA;AV27DJ;AUv7DI;EACE,aAAA;AVy7DN;AUr7DE;EACE,kBAAA;AVu7DJ;AUp7DM;EACE,aAAA;AVs7DR;AUj7DE;EACE,WAAA;EACA,UAAA;EACA,2BAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,6GAAA;EACA,mBAAA;AVm7DJ;AUh7DE;EACE,gBAAA;EACA,kBAAA;EACA,4BAAA;EACA,YAAA;EACA,yBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AVk7DJ;AUh7DI;EACE,iBAAA;AVk7DN;AU/6DI;EACE,uBAAA;AVi7DN;AU96DI;EACE,uBAAA;AVg7DN;AU76DI;EACE,mBAAA;AV+6DN;;AUz6DA;EACE,eAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gFAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,eAAA;AV46DF;AU16DE;EACE,WAAA;EACA,YAAA;AV46DJ;;AUt6DA;;;EAGE,iBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gFAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EAEA,eAAA;AVw6DF;;AUr6DA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,oCAAA;EACA,6BAAA;EACA,0BAAA;EACA,qBAAA;EACA,kBAAA;EACA,iDAAA;AVw6DF;;AUr6DA;EACE,eAAA;AVw6DF;;AUr6DA;EACE,eAAA;AVw6DF;;AUr6DA;EACE,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,oCAAA;EACA,6BAAA;EACA,0BAAA;EACA,qBAAA;EACA,+CAAA;AVw6DF;;AUn6DA;EACE,eAAA;EACA,oBAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,0BAAA;EACA,kCAAA;EACA,mBAAA;EACA,2BAAA;AVs6DF;AUp6DE;EACE,qBAAA;AVs6DJ;AUn6DE;EACE,0BAAA;EACA,iBAAA;AVq6DJ;;AUj6DA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AVo6DF;AUl6DE;EACE,4HAAA;AVo6DJ;;AWvmEA;EACE,YAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AX0mEF;;AWvmEA;EACE,kFAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,cAAA;EACA,0BAAA;EACA,gBAAA;EACA,oBAAA;AX0mEF;AWxmEE;EACE,mBAAA;EACA,cAAA;AX0mEJ;AWvmEE;EACE,eAAA;AXymEJ;AWxmEI;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,cAAA;EACA,kBAAA;AX0mEN;;AWrmEA;EACE,mBAAA;EACA,mHAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AXwmEF;AWtmEE;EACE,WAAA;AXwmEJ;AWrmEE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AXumEJ;AWpmEE;EACE,WAAA;EACA,YAAA;AXsmEJ;;AWlmEA;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,+KAAA;EACA,kBAAA;EACA,eAAA;AXqmEF;AWnmEE;EACE,WAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AXqmEJ;AWnmEI;EACE,wBAAA;AXqmEN;;AWhmEA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AXmmEF;;AWhmEA;EACE,kBAAA;EACA,mBAAA;EACA,aAAA;AXmmEF;AWhmEI;EACE,qBAAA;AXkmEN;AW/lEI;;EAEE,cAAA;AXimEN;AW9lEI;EACE,mBAAA;EACA,cAAA;AXgmEN;AW3lEI;EACE,qBAAA;AX6lEN;AW1lEI;;EAEE,cAAA;AX4lEN;AWzlEI;EACE,mBAAA;EACA,cAAA;AX2lEN;AWtlEI;EACE,qBAAA;AXwlEN;AWrlEI;;EAEE,cAAA;AXulEN;AWplEI;EACE,mBAAA;EACA,cAAA;AXslEN;AWllEE;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;AXolEJ;AWnlEI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AXqlEN;AWjlEE;EACE,YAAA;EACA,aAAA;EACA,kBAAA;AXmlEJ;AWhlEE;EACE,eAAA;AXklEJ;AW/kEE;EACE,eAAA;AXilEJ;AW9kEE;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;AXglEJ;AW7kEE;EACE,eAAA;EACA,iBAAA;AX+kEJ;AW5kEE;EACE,eAAA;EACA,iBAAA;AX8kEJ;AW5kEE;EACE,UAAA;EACA,YAAA;EACA,OAAA;AX8kEJ;;AW1kEA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,kBAAA;EACA,mBAAA;AX6kEF;AW3kEE;EACE,WAAA;EACA,wBAAA;EACA,WAAA;EACA,aAAA;EACA,WAAA;EACA,6GAAA;EACA,kBAAA;EACA,mBAAA;AX6kEJ;AWzkEE;EACE,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;AX2kEJ;AWzkEI;EACE,WAAA;EACA,QAAA;EACA,oBAAA;EACA,WAAA;EACA,mBAAA;EACA,wFAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,UAAA;AX2kEN;AWxkEI;EAEE,cAAA;AXykEN;AWvkEM;EACE,WAAA;AXykER;;AWnkEA;EACE,mBAAA;EACA,kFAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;AXskEF;AWpkEI;EACE,mBAAA;AXskEN;AWjkEI;EACE,mBAAA;AXmkEN;AW/jEE;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AXikEJ;AW9jEE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;AXgkEJ;AW9jEI;EACE,eAAA;EACA,aAAA;EACA,oBAAA;AXgkEN;AW5jEE;EACE,WAAA;EACA,WAAA;EACA,6GAAA;EACA,mBAAA;EACA,mBAAA;AX8jEJ;AW5jEI;EACE,YAAA;EACA,oIAAA;EACA,mBAAA;EACA,oBAAA;AX8jEN;AW1jEE;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,YAAA;AX4jEJ;AWzjEE;;EAEE,iBAAA;EACA,eAAA;AX2jEJ;AWzjEE;EACE,YAAA;EACA,SAAA;EACA,UAAA;AX2jEJ;;AY94EA;EACE,YAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,wEAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;AZi5EF;AY/4EE;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AZi5EJ;AY/4EI;EACE,aAAA;AZi5EN;AY74EE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,0HAAA;EACA,WAAA;EACA,eAAA;AZ+4EJ;;AY34EA;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,6GAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;AZ84EF;;AY14EA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AZ64EF;;AY14EA;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,0EAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,SAAA;AZ64EF;;AYz4EA;EACE,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,gBAAA;AZ44EF;;AYz4EA;EAEE,kBAAA;AZ24EF;AYz4EE;EACE,kBAAA;AZ24EJ;;AYt4EA;EACE,kBAAA;AZy4EF;AYl4EA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AZo4EF;;AYj4EA;EACE,kBAAA;AZo4EF;AYl4EE;EACE,iBAAA;AZo4EJ;;AYh4EA;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,6GAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AZm4EF;;AYh4EA;EACE,wBAAA;EACA,YAAA;EACA,6BAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AZm4EF;;AYh4EA;EAEE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gFAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;AZk4EF;AYh4EE;EACE,WAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AZk4EJ;AYh4EI;EACE,wBAAA;AZk4EN;;AY73EA;EACE,YAAA;EACA,YAAA;EAEA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,wEAAA;EACA,yBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EAEA,gBAAA;AZ83EF;;AY13EA;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;AZ63EF;AY33EE;EAEE,WAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;AZ43EJ;AYz3EE;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AZ23EJ;AYx3EE;EACE,cAAA;EACA,6GAAA;EAEA,4BAAA;AZy3EJ;AYn3EM;EACE,UAAA;EACA,mBAAA;AZq3ER;AYj4EE;EAgBE,kBAAA;AZo3EJ;AYj3EE;EACE,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,6GAAA;EAEA,4BAAA;AZk3EJ;;AY92EA;EACE,aAAA;EACA,aAAA;EACA,6GAAA;EACA,+BAAA;AZi3EF;;AY92EA;EACE,aAAA;EACA,qBAAA;EACA,gBAAA;AZi3EF;AY/2EE;EACE,kBAAA;AZi3EJ;AY/2EI;EACE,eAAA;AZi3EN;;AY52EA;;EAEE,oBAAA;AZ+2EF;;AY52EA;EACE,iBAAA;EACA,kBAAA;AZ+2EF;;AY52EA;EACE,qBAAA;EACA,aAAA;AZ+2EF;;AY52EA;EACE,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,oBAAA;AZ+2EF;AY52EE;EACE,6GAAA;AZ82EJ;;AY12EA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gFAAA;AZ62EF;;AYx2EA;EACE,aAAA;AZ22EF;AYx2EI;EACE,oGAAA;EACA,6GAAA;AZ02EN;AYv2EQ;EACE,UAAA;EACA,mBAAA;AZy2EV;;AYl2EA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;AZq2EF;;AYl2EA;EACE,WAAA;EACA,aAAA;EACA,YAAA;EACA,6GAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AZq2EF;AYn2EE;EACE,WAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,gCAAA;EACA,+BAAA;EACA,oCAAA;EACA,UAAA;EACA,kBAAA;AZq2EJ;;AYj2EA;EACE,mBAAA;EACE,uEAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,UAAA;EACA,oBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,sBAAA;AZo2EJ;;AYj2EA;EACE,YAAA;EACA,aAAA;EACA,8FAAA;EACA,kBAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AZo2EF;;AYh2EA;EACE,cAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;AZm2EF;;AYh2EA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AZm2EF;;AYh2EA;EACE,kBAAA;EACA,mBAAA;EACA,qDAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,OAAA;EACA,SAAA;EACA,UAAA;AZm2EF;AYj2EE;EACE,8BAAA;AZm2EJ;;AY/1EA;EACE,WAAA;EACA,kBAAA;EACA,eAAA;AZk2EF;AYh2EE;EACE,cAAA;EACA,eAAA;EACA,aAAA;AZk2EJ;AY/1EE;EACE,kBAAA;EACA,QAAA;EACA,MAAA;AZi2EJ;;AY71EA;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,6GAAA;EACA,mBAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AZg2EF;;AY71EA;EACE,WAAA;EACA,YAAA;EACA,6BAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AZg2EF;;AY71EA;EACE,YAAA;EACA,aAAA;AZg2EF;;AY71EA;EACE,mBAAA;AZg2EF;;AY71EA;EACE,mBAAA;AZg2EF;;Aaz0FE;EACE,gBAAA;EACA,kBAAA;Ab40FJ;Aa10FI;EACE,mBAAA;Ab40FN;Aaz0FI;EACE,6BAAA;Ab20FN;Aax0FI;EACE,cAAA;Ab00FN;Aav0FI;EACE,cAAA;EACA,iBAAA;Aby0FN;Aat0FI;EACE,iBAAA;Abw0FN;Aar0FI;EACE,gBAAA;EACA,oBAAA;EACA,mBAAA;Abu0FN;Aap0FI;EACE,eAAA;Abs0FN;Aan0FI;EACE,mBAAA;EACA,uBAAA;Abq0FN;Aa5zFI;EACE,kBAAA;Ab8zFN;Aa3zFI;EACE,mBAAA;Ab6zFN;;AaxzFA;EACE,UAAA;EACA,kBAAA;EACA,eAAA;EAEA,aAAA;EACA,eAAA;EACA,8BAAA;EACA,YAAA;EACA,mBAAA;EACA,4DAAA;EACA,mBAAA;EACA,wBAAA;EACA,4BAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,MAAA;EACA,YAAA;Ab0zFF;AaxzFE;EACE,mBAAA;EACA,UAAA;Ab0zFJ;;AatzFA;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,6GAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AbyzFF;;AarzFA;EACE,WAAA;EACA,YAAA;EACA,6BAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AbwzFF;;AarzFA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,wEAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;AbwzFF;;AapzFA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,0EAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,SAAA;EACA,eAAA;AbuzFF;;AanzFA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gFAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,oBAAA;AbszFF;AapzFE;EACE,cAAA;AbszFJ;AanzFE;EAEE,iBAAA;EACA,gCAAA;AbozFJ;AalzFI;EACE,gCAAA;AbozFN;;Aa/yFA;EACE,WAAA;EACA,eAAA;EACA,mBAAA;EACA,6GAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;AbkzFF;;Aa5yFA;EACE,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,yEAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,MAAA;Ab+yFF;;Aa3yFA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EAEA,kBAAA;EACA,mBAAA;EACA,eAAA;Ab6yFF;Aa1yFE;EACE,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;Ab4yFJ;AazyFE;EACE,gBAAA;Ab2yFJ;;AatyFA;EACE,2BAAA;EACA,uBAAA;EACA,2BAAA;EACA,wBAAA;AbyyFF;;AatyFA;EACE,2BAAA;EACA,wBAAA;EACA,mBAAA;AbyyFF;;AatyFA;EACE,4BAAA;AbyyFF;;AatyFA;EACE,iBAAA;AbyyFF;;AatyFA;EACE,aAAA;EACA,yBAAA;AbyyFF;;AatyFA;EACE,2BAAA;EACA,2BAAA;AbyyFF;;AaryFA;EACE,wBAAA;EACA,yCAAA;EACA,8BAAA;EACA,kBAAA;EACA,4DAAA;AbwyFF;;AajyFA;EAEE,uBAAA;AbmyFF;;AchkGA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AdmkGF;AcjkGE;EACE,WAAA;EACA,oBAAA;EACA,YAAA;AdmkGJ;;Ac9jGA;EACE,aAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AdikGF;;Ac9jGA;EACE,WAAA;EACA,aAAA;EACA,yEAAA;EACA,kBAAA;EACA,kFAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AdikGF;;Ac9jGA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,2BAAA;EACA,4BAAA;EACA,sBAAA;AdikGF;Ac/jGI;EACA,UAAA;AdikGJ;;Ac/iGA;EACE,WAAA;EACA,mBAAA;EACA,kFAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AdkjGF;;Ac/iGA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,0GAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AdkjGF;;Ac/iGA;EACE,0GAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AdkjGF;;Ac/iGA;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACC,YAAA;AdkjGH;;Ac9iGA;EACE,qBAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,sBAAA;AdijGF;;Ac9iGA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gDAAA;AdijGF;Ac/iGE;EAEE,6GAAA;EACA,4BAAA;AdgjGJ;;Ac5iGA;EACE,eAAA;Ad+iGF;Ac7iGI;EACE,4BAAA;Ad+iGN;Ac1iGI;EACE,6BAAA;Ad4iGN;;AcviGA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;Ad0iGF;;AcviGA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;Ad0iGF;;AcviGA;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,6GAAA;EACA,mBAAA;EACA,oBAAA;Ad0iGF;AcxiGE;EACE,cAAA;Ad0iGJ;;ActiGA;EACE,YAAA;EACA,YAAA;EACA,kFAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EAEA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,SAAA;AdwiGF;;AcpiGA;EACE,YAAA;EACA,aAAA;EACA,6GAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;AduiGF;;AcpiGA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AduiGF;;AcpiGA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;AduiGF;;AcpiGA;EACE,aAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,aAAA;AduiGF;ActiGE;EACE,kBAAA;AdwiGJ;;AcpiGA;EACE,YAAA;EACA,oBAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,6GAAA;EAEA,aAAA;EACA,mBAAA;EACA,kBAAA;AdsiGF;AcpiGE;EACE,YAAA;AdsiGJ;AcpiGI;EACE,aAAA;AdsiGN;AcniGI;EACE,cAAA;AdqiGN;AcliGI;EACE,aAAA;AdoiGN;AchiGE;EACE,YAAA;AdkiGJ;AchiGI;EACE,aAAA;AdkiGN;Ac/hGI;EACE,cAAA;AdiiGN;Ac1hGM;EACE,aAAA;Ad4hGR;ActhGI;EACE,WAAA;EACA,iBAAA;EACA,iBAAA;AdwhGN;AcrhGI;EACE,eAAA;EACA,kBAAA;AduhGN;AcrhGM;EACE,eAAA;AduhGR;AcnhGI;EACE,aAAA;AdqhGN;AclhGI;EACE,aAAA;AdohGN;AchhGE;EACE,YAAA;EACA,6BAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AdkhGJ;AchhGI;EACE,cAAA;AdkhGN;Ac9gGE;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,6GAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AdghGJ;Ac9gGI;EACE,UAAA;EACA,kBAAA;EACA,oBAAA;AdghGN;Ac5gGE;EACE,aAAA;Ad8gGJ;AczgGQ;EACE,mBAAA;EACA,UAAA;Ad2gGV;AcrgGE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AdugGJ;;AcngGA;EACE,6GAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AdsgGF;;AcngGA;EAEE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,gFAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,eAAA;AdogGF;;AcjgGA;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,sFAAA;EACA,mBAAA;EACA,kBAAA;AdogGF;;AchgGA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AdmgGF;AchgGI;EACE,mBAAA;EACA,UAAA;EACA,kBAAA;AdkgGN;;Ac5/FA;EACE,oBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,0BAAA;EACA,6GAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;Ad+/FF;;Ac5/FA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,cAAA;EACA,WAAA;EAGA,wBAAA;EACA,iBAAA;Ad6/FF;Ac3/FE;EACE,UAAA;EACA,mBAAA;Ad6/FJ;;Acz/FA;EACE,kBAAA;EACA,0GAAA;EACA,0BAAA;Ad4/FF;;Acz/FA;EACE,aAAA;EACA,YAAA;EACA,YAAA;EACA,qGAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;Ad4/FF;;Acz/FA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,eAAA;Ad4/FF;Acz/FE;EAEE,6GAAA;Ad0/FJ;Acx/FI;EACE,2HAAA;Ad0/FN;;Ae3+GA;EACE,kBAAA;Af8+GF;Ae7+GE;EACE,iBAAA;EACA,kBAAA;Af++GJ;Ae7+GI;EACE,mBAAA;EACA,kBAAA;Af++GN;Ae9+GM;EACE,mBAAA;EACA,uBAAA;Afg/GR;Aev+GI;EACE,6BAAA;Afy+GN;Aet+GI;EACE,cAAA;Afw+GN;Aer+GI;EACE,cAAA;EACA,iBAAA;Afu+GN;Aer+GI;EACE,gBAAA;EACA,oBAAA;EACA,mBAAA;Afu+GN;Aer+GI;EACE,iBAAA;Afu+GN;;Aej+GA;EACE,UAAA;EACA,aAAA;EAIA,kBAAA;EACA,SAAA;EACA,MAAA;EACA,aAAA;Afi+GF;;Aeh+GE;EACE,cAAA;EACA,yBAAA;UAAA,iBAAA;Afm+GJ;;Aej+GA;EACE,WAAA;EACA,WAAA;EACA,mBAAA;EACA,4DAAA;EACA,4BAAA;EACA,kBAAA;EACA,SAAA;Afo+GF;;Aen+GA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,6EAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;Afs+GF;;Aer+GE;EACE,mBAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,iGAAA;Afw+GJ;;Aev+GA;EACE,YAAA;EACA,WAAA;EAEA,mBAAA;EAEA,kBAAA;EACA,SAAA;EACA,MAAA;EACA,aAAA;Afw+GF;;Aev+GE;EACE,yBAAA;UAAA,iBAAA;EACA,cAAA;Af0+GJ;;Aez+GA;EACE,UAAA;EACA,YAAA;EACA,mBAAA;EACA,4DAAA;EACA,4BAAA;EACA,kBAAA;EACA,OAAA;Af4+GF;;Ae3+GA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,6EAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,eAAA;Af8+GF;;Ae7+GE;EACE,mBAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,iGAAA;Afg/GJ;;Ae7+GI;EACE,YAAA;EACA,aAAA;Afg/GN;;Ae1+GQ;EACM,yBAAA;EACA,0BAAA;EACA,2BAAA;EACA,4BAAA;Af6+Gd;;AgBznHE;EAEE,mBAAA;EACA,aAAA;AhB2nHJ;;AgBvnHA;EACE,YAAA;EAEA,6GAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AhBynHF;;AgBtnHA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AhBynHF;;AiBhpHA;EACE;IACE,yBAAA;EjBmpHF;EiBjpHA;IACE,yBAAA;EjBmpHF;AACF;AiBhpHA;EACE;IACE,wBAAA;EjBkpHF;EiBhpHA;IACE,yBAAA;EjBkpHF;AACF;AiB/oHA;EACE;IACE,uBAAA;EjBipHF;EiB/oHA;IACE,yBAAA;EjBipHF;AACF;AiB9oHA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;AjBgpHF;;AiB7oHA;EACE,aAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,2CAAA;AjBgpHF;;AiB7oHA;EACE,aAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,uDAAA;AjBgpHF;;AiB7oHA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,8CAAA;AjBgpHF;;AiB7oHA;EACE,aAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,4BAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;AjBgpHF;;AiB7oHA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,sFAAA;EACA,kBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AjBgpHF;;AiB7oHA;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;AjBgpHF;;AiB7oHA;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,6GAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AjBgpHF;AiB7oHE;EACE,WAAA;EACA,6BAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AjB+oHJ;AiB7oHI;EACE,cAAA;AjB+oHN;;AiBzoHA;EACE,YAAA;EACA,YAAA;EACA,kFAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,SAAA;AjB4oHF;;AiBxoHA;EACE,eAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;AjB2oHF;;AiBxoHA;EACE,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,sFAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EAGA,oBAAA;AjByoHF;AiBvoHE;EACE,mBAAA;EACA,UAAA;AjByoHJ;;AiBroHA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AjBwoHF;;AkBr1HA;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AlBw1HF;;AkBt1HA;EACE,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;EACA,8DAAA;EACA,sDAAA;AlBy1HF;;AkBv1HA;EACE,uBAAA;AlB01HF;;AkBx1HA;EACE,sBAAA;AlB21HF;;AkBz1HA;EACE,uBAAA;AlB41HF;;AkB11HA;EACE;IACE,uBAAA;ElB61HF;EkB31HA;IACE,yBAAA;ElB61HF;AACF;AkB11HA;EACE;IACE,yBAAA;ElB41HF;EkB11HA;IACE,yBAAA;ElB41HF;AACF;AkBz1HA;EACE;IACE,wBAAA;ElB21HF;EkBz1HA;IACE,yBAAA;ElB21HF;AACF;AkBx1HA;EACE;IACE,uBAAA;ElB01HF;EkBx1HA;IACE,yBAAA;ElB01HF;AACF;AkBv1HA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AlBy1HF;;AkBt1HA;EACE,qBAAA;AlBy1HF;;AkBt1HA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AlBy1HF;;AkBt1HA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,4CAAA;AlBy1HF;;AkBt1HA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,wBAAA;EACA,oDAAA;AlBy1HF;;AkBt1HA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,6BAAA;EACA,8CAAA;AlBy1HF;;AkBt1HA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;AlBy1HF;;AkBt1HA;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;AlBy1HF;;AmBn/HA;;EAEI,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;AnBs/HJ;;AmBn/HA;EAGI,WAAA;AnBo/HJ;;AoBhgIA;EXJA;IACE,WAAA;IACA,YAAA;IACA,gBAAA;IACA,mBAAA;IACA,kBAAA;ETwgIA;ESvgIA;IACE,WAAA;IACA,YAAA;ETygIF;EStgIA;IACE,QAAA;IACA,SAAA;IACA,kBAAA;IACA,MAAA;IACA,OAAA;IACA,QAAA;IACA,SAAA;IACA,YAAA;IACA,oBAAA;ETwgIF;ESpgIF;IACE,WAAA;IACA,aAAA;IACA,mBAAA;IACA,kGAAA;IACA,eAAA;IACA,MAAA;IACA,OAAA;IACA,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,UAAA;IACA,mBAAA;IACA,oBAAA;ETsgIA;ESpgIA;IACE,YAAA;ETsgIF;ESrgIE;IACE,YAAA;ETugIJ;ESrgIE;IACE,aAAA;ETugIJ;ESrgIE;IACE,qBAAA;IACA,WAAA;IACA,YAAA;ETugIJ;ESpgIE;IACE,YAAA;ETsgIJ;ESpgII;IACE,eAAA;IACA,kBAAA;IACA,UAAA;IACA,mBAAA;IACA,cAAA;ETsgIN;ESjgIA;IACE,qBAAA;IACA,YAAA;IACA,aAAA;IACA,sBAAA;ETmgIF;EShgIA;IACE,mBAAA;ETkgIF;EShgIE;IACE,gBAAA;ETkgIJ;ES9/HA;IACE,eAAA;IACA,qBAAA;IACA,aAAA;IACA,oBAAA;IACA,cAAA;IACA,oBAAA;IACA,WAAA;IACA,YAAA;IACA,mBAAA;IACA,uBAAA;ETggIF;ES9/HE;IAEE,mBAAA;IACA,6JAAA;IACA,mBAAA;IACA,cAAA;ET+/HJ;ES7/HI;IACE,4HAAA;ET+/HN;ES1/HE;IAEE,kBAAA;IACA,UAAA;ET2/HJ;ESx/HE;IACE,oBAAA;IACA,kBAAA;IACA,kBAAA;IACA,iBAAA;IACA,mBAAA;IACA,YAAA;IACA,yDAAA;IACA,UAAA;IACA,kBAAA;IACA,kBAAA;ET0/HJ;ESr/HF;IACE,YAAA;ETu/HA;ESp/HF;IACE,mBAAA;IACA,sGAAA;IACA,YAAA;IACA,aAAA;IACA,kBAAA;IACA,kBAAA;IACA,QAAA;IACA,YAAA;IACA,iDAAA;IACA,oBAAA;ETs/HA;ESn/HE;IACE,yBAAA;ETq/HJ;ES/+HF;IACE,WAAA;IACA,YAAA;IACA,kBAAA;IACA,mBAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,gFAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,mBAAA;IACA,MAAA;IACA,SAAA;IACA,UAAA;IACA,oBAAA;ETi/HA;EQxpIF;IACE,YAAA;IACA,gBAAA;IACA,mHAAA;IACA,WAAA;IACA,mBAAA;IACA,uBAAA;IACA,kBAAA;IACA,UAAA;IACA,oBAAA;ER0pIA;EQxpIA;IACE,mBAAA;ER0pIF;EQvpIA;IACE,YAAA;IACA,mBAAA;ERypIF;EQtpIA;IACE,gBAAA;IACA,iBAAA;IACA,eAAA;IACA,oBAAA;ERwpIF;EQtpIE;IACE,eAAA;IACA,iBAAA;ERwpIJ;EQppIA;IACE,aAAA;IACA,iBAAA;IACA,mBAAA;IACA,YAAA;ERspIF;EQlpIF;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;ERopIA;EQlpIA;IACE,SAAA;IACA,6BAAA;IACA,eAAA;IACA,eAAA;IACA,kBAAA;IACA,cAAA;ERopIF;EQjpIA;IACE,mBAAA;IACA,iDAAA;IACA,WAAA;IACA,YAAA;IACA,kBAAA;IACA,kBAAA;IACA,SAAA;IACA,WAAA;ERmpIF;EQ/oIF;IACE,YAAA;IACA,YAAA;IACA,kBAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,cAAA;IACA,eAAA;IACA,oBAAA;IACA,eAAA;ERipIA;EQ/oIA;IACE,mBAAA;IACA,YAAA;IACA,aAAA;IACA,mBAAA;IACA,kFAAA;IACA,sBAAA;ERipIF;EQ/oIE;IACE,oBAAA;ERipIJ;EQ9oIE;IAEE,aAAA;ER+oIJ;EQ3oIA;IAEE,WAAA;IACA,yDAAA;IACA,mBAAA;IACA,YAAA;IACA,UAAA;IACA,kBAAA;IACA,MAAA;ER4oIF;EQzoIA;IACE,OAAA;ER2oIF;EQxoIA;IACE,QAAA;ER0oIF;EQvoIA;IACE,WAAA;IACA,YAAA;IACA,kBAAA;IACA,kBAAA;ERyoIF;EQtoIA;IACE,gBAAA;IACA,eAAA;IACA,iBAAA;ERwoIF;EQpoIA;IACE,WAAA;IACA,eAAA;IACA,mBAAA;IACA,uBAAA;IACA,kBAAA;IACA,iBAAA;IACA,mBAAA;IACA,aAAA;ERsoIF;EQpoIE;IACE,kBAAA;IACA,MAAA;IACA,WAAA;IACA,YAAA;IACA,WAAA;IACA,6GAAA;IACA,mBAAA;ERsoIJ;EQloIA;IACE,iBAAA;ERooIF;EQhoIF;IACE,SAAA;IACA,eAAA;IACA,cAAA;IACA,eAAA;ERkoIA;EQ/nIF;IACE,kBAAA;IACA,eAAA;ERioIA;EQhoIA;;IAEE,kBAAA;IACA,WAAA;IACA,YAAA;IACA,MAAA;IACA,OAAA;IACA,SAAA;IACA,QAAA;IACA,YAAA;IACA,qBAAA;IACA,wBAAA;ERkoIF;EQ/nIA;IACE,UAAA;IACA,kBAAA;ERioIF;EoB9yIE;IACE,UAAA;IACA,mBAAA;EpBgzIJ;EqBzzIF;IACE,WAAA;ErB2zIA;EqBxzIF;IACE,YAAA;IACA,gBAAA;IACA,kBAAA;ErB0zIA;EqBtzIF;IACE,WAAA;IACA,YAAA;IACA,eAAA;ErBwzIA;EqBtzIA;IAEE,kBAAA;ErBuzIF;EqBnzIF;IACE,gBAAA;IACA,aAAA;IACA,kBAAA;IACA,mBAAA;ErBqzIA;EqBjzIF;IACE,eAAA;ErBmzIA;EqBhzIF;IACE,gBAAA;ErBkzIA;EqB/yIF;IACE,YAAA;IACA,aAAA;ErBizIA;EqB9yIF;;IAEE,WAAA;IACA,YAAA;ErBgzIA;EqB7yIF;IACE,eAAA;IACA,iBAAA;ErB+yIA;EqB5yIF;IACE,eAAA;ErB8yIA;EqB1yIF;IACE,0BAAA;ErB4yIA;EqBzyIF;IACE,WAAA;IACA,YAAA;IACA,eAAA;ErB2yIA;EqBxyIF;IACE,aAAA;IACA,mBAAA;ErB0yIA;EqBvyIF;IACE,YAAA;IACA,mBAAA;IACA,eAAA;ErByyIA;EqBtyIF;IACE,eAAA;ErBwyIA;EqBryIF;IACE,iBAAA;ErBuyIA;EqBpyIF;IACE,mBAAA;ErBsyIA;EqBnyIF;IACE,WAAA;IACA,YAAA;ErBqyIA;EqBlyIF;IACE,UAAA;ErBoyIA;EqB7xIF;IACE,SAAA;IACA,UAAA;ErB+xIA;EqB5xIF;IACE,eAAA;IACA,iBAAA;ErB8xIA;EqB3xIF;IACE,UAAA;IACA,aAAA;ErB6xIA;EqB1xIF;IACE,WAAA;IACA,YAAA;IACA,UAAA;ErB4xIA;EqBzxIF;IACE,aAAA;IACA,WAAA;IACA,YAAA;IACA,eAAA;ErB2xIA;EqBxxIF;IACE,eAAA;ErB0xIA;EqBvxIF;;IAEE,WAAA;IACA,YAAA;IACA,mBAAA;ErByxIA;EqBtxIF;IACE,YAAA;IACA,SAAA;IACA,eAAA;IACA,UAAA;ErBwxIA;EqBrxIF;IACE,YAAA;ErBuxIA;EqBnxIF;IACE,WAAA;IACA,YAAA;ErBqxIA;EqBlxIF;IACE,WAAA;IACA,YAAA;ErBoxIA;EqBjxIF;IACE,eAAA;IACA,iBAAA;IACA,kBAAA;IACA,gBAAA;ErBmxIA;EqBhxIF;IACE,WAAA;IACA,YAAA;ErBkxIA;EqB/wIF;IACE,WAAA;IACA,YAAA;ErBixIA;EqB9wIF;IACE,eAAA;ErBgxIA;EqB7wIF;IACE,eAAA;IACA,iBAAA;IACA,mBAAA;IACA,gBAAA;ErB+wIA;EqB3wIF;IACE,cAAA;IACA,yBAAA;IACA,yBAAA;IACA,aAAA;ErB6wIA;EqB1wIF;IACE,YAAA;IACA,UAAA;IACA,SAAA;ErB4wIA;EqB1wIF;IACE,WAAA;ErB4wIA;EqB1wIF;IACE,yBAAA;IACA,YAAA;ErB4wIA;EqB1wIF;IACE,eAAA;ErB4wIA;EqB1wIF;IACE,WAAA;IACA,YAAA;IACA,kBAAA;ErB4wIA;EqB1wIF;IACE,UAAA;IACA,YAAA;ErB4wIA;EqB1wIF;IACE,kBAAA;ErB4wIA;EqB1wIF;IACE,YAAA;IACA,aAAA;ErB4wIA;EqBzwIF;IACE,YAAA;IACA,YAAA;IACA,mBAAA;IACA,eAAA;IACA,iBAAA;IACA,kBAAA;ErB2wIA;EqBxwIF;IACE,WAAA;IACA,YAAA;ErB0wIA;EqBvwIF;IACE,WAAA;IACA,YAAA;ErBywIA;EqBtwIF;IACE,iBAAA;ErBwwIA;EqBpwIF;IACE,YAAA;IACA,WAAA;ErBswIA;EqBnwIF;IACE,WAAA;IACA,YAAA;ErBqwIA;EqBlwIF;IACE,WAAA;IACA,YAAA;ErBowIA;EqBjwIF;IACE,eAAA;IACA,YAAA;IACA,aAAA;ErBmwIA;EqBhwIF;IACE,aAAA;IACA,mBAAA;ErBkwIA;EqBhwIA;IACE,YAAA;IACA,aAAA;ErBkwIF;EqB/vIA;IACE,YAAA;IACA,aAAA;IACA,kBAAA;ErBiwIF;EqB9vIA;IACE,WAAA;IACA,YAAA;ErBgwIF;EqB7vIA;;IAEE,eAAA;IACA,iBAAA;ErB+vIF;EqB3vIF;IACE,eAAA;IACA,kBAAA;IACA,iBAAA;ErB6vIA;EqB1vIF;IACE,eAAA;ErB4vIA;EqBxvIF;IACE,kBAAA;IACA,mBAAA;ErB0vIA;EqBxvIA;IACE,WAAA;IACA,YAAA;IACA,MAAA;ErB0vIF;EqBvvIA;;IAEE,eAAA;ErByvIF;EqBtvIA;IACE,WAAA;IACA,WAAA;ErBwvIF;EqBhvIF;IACE,WAAA;ErBkvIA;EqB/uIF;IACE,mBAAA;IACA,YAAA;ErBivIA;EqB9uIF;IACE,WAAA;IACA,YAAA;IACA,YAAA;ErBgvIA;EqB5uIF;IACE,uBAAA;ErB8uIA;EqB3uIF;IACE,WAAA;IACA,YAAA;ErB6uIA;EqB1uIF;;IAEE,WAAA;IACA,YAAA;IACA,eAAA;ErB4uIA;EqBxuIA;IACE,UAAA;ErB0uIF;EqBvuIA;IACE,iBAAA;ErByuIF;EqBnuIF;IACE,eAAA;IACA,kBAAA;ErBquIA;EqBluIF;;IAEE,eAAA;ErBouIA;EqBjuIF;;IAEE,YAAA;ErBmuIA;EqBhuIF;IACE,eAAA;IACA,YAAA;ErBkuIA;EqB3tIF;IACE,WAAA;IACA,cAAA;IACA,UAAA;IACA,UAAA;ErB6tIA;EqB1tIF;IACE,WAAA;IACA,YAAA;IACA,kBAAA;ErB4tIA;EqBztIF;IACE,YAAA;IACA,WAAA;ErB2tIA;EqBxtIF;IACG,YAAA;IAED,cAAA;ErBytIA;EqBttIF;IACE,YAAA;IACA,aAAA;IACA,mBAAA;ErBwtIA;EqBntIA;IACE,gBAAA;ErBqtIF;EqBltIA;IACE,eAAA;ErBotIF;EqBhtIF;IACE,wBAAA;IACA,yBAAA;ErBktIA;EqB/sIF;IACE,uBAAA;IACA,wBAAA;ErBitIA;EqB9sIF;IACE,uBAAA;IACA,wBAAA;ErBgtIA;EqB7sIF;IACE,uBAAA;IACA,wBAAA;ErB+sIA;EqB5sIF;IACE,uBAAA;IACA,wBAAA;ErB8sIA;EqB3sIF;IACE,YAAA;IACA,YAAA;ErB6sIA;EqB1sIF;IACE,YAAA;ErB4sIA;EqBzsIF;IACE,mBAAA;ErB2sIA;EqBxsIF;;IAEE,YAAA;IACA,aAAA;ErB0sIA;EqBvsIF;;IAEE,WAAA;IACA,YAAA;ErBysIA;EqBtsIF;;IAEE,eAAA;ErBwsIA;EqBrsIF;;IAEE,WAAA;IACA,WAAA;ErBusIA;EqBpsIF;;IAEE,UAAA;ErBssIA;EqBnsIF;IACE,eAAA;IACA,cAAA;ErBqsIA;EqBlsIF;IACE,SAAA;IACA,iBAAA;ErBosIA;EqBjsIF;IACE,WAAA;IACA,YAAA;IACA,YAAA;ErBmsIA;EqBhsIF;IACE,WAAA;IACA,YAAA;ErBksIA;EqB/rIF;IACE,WAAA;IACA,YAAA;ErBisIA;EqB9rIF;IACE,YAAA;IACA,aAAA;IACA,SAAA;ErBgsIA;EqB7rIF;IACE,WAAA;IACA,YAAA;ErB+rIA;EqB5rIF;IACE,eAAA;ErB8rIA;EqB3rIF;IACE,0BAAA;ErB6rIA;EqB1rIF;;IAEE,eAAA;ErB4rIA;EqBzrIF;IACE,YAAA;IACA,YAAA;IACA,mBAAA;IACA,YAAA;IACA,kBAAA;ErB2rIA;EqBxrIF;IACE,WAAA;IACA,YAAA;IACA,YAAA;ErB0rIA;EqBvrIF;IACE,kBAAA;IACA,WAAA;IACA,YAAA;ErByrIA;EqBtrIF;IACE,eAAA;ErBwrIA;EqBrrIF;IACE,aAAA;ErBurIA;EqBprIF;IACE,YAAA;IACA,aAAA;IACA,4BAAA;ErBsrIA;EqBlrIF;IACE,YAAA;IACA,aAAA;ErBorIA;EqBjrIF;IACE,WAAA;IACA,YAAA;ErBmrIA;EqBhrIF;IACE,eAAA;IACA,iBAAA;IACA,gBAAA;ErBkrIA;EqB/qIF;IACE,eAAA;IACA,iBAAA;IACA,gBAAA;ErBirIA;EqB9qIF;IACE,eAAA;IACA,iBAAA;IACA,WAAA;ErBgrIA;EqB7qIF;IACE,WAAA;ErB+qIA;EqB5qIF;IACE,mBAAA;ErB8qIA;EqB3qIF;IACE,WAAA;IACA,YAAA;ErB6qIA;EqBvqIF;IACE,WAAA;IACA,YAAA;ErByqIA;EqBlqIF;IACE,YAAA;IACA,aAAA;ErBoqIA;EqBjqIF;IACE,wBAAA;ErBmqIA;EqBhqIF;IACE,SAAA;IACA,UAAA;ErBkqIA;EqB/pIF;IACE,0BAAA;IACA,4BAAA;ErBiqIA;EqB7pIF;IACE,uBAAA;ErB+pIA;EqB5pIF;IACE,uBAAA;ErB8pIA;EqB1pIA;IACE,WAAA;IACA,YAAA;ErB4pIF;EqBtpIE;IACE,YAAA;IACA,YAAA;ErBwpIJ;EqBnpIF;IACE,qBAAA;ErBqpIA;EqBlpIF;IACE,qBAAA;ErBopIA;EqBjpIF;IACE,uBAAA;IACA,gBAAA;IACA,YAAA;IACA,aAAA;IACA,mBAAA;ErBmpIA;EqB/oIA;IAEE,UAAA;ErBgpIF;EqB1oIF;IACE,iBAAA;IACA,kBAAA;ErB4oIA;EqBzoIF;IACE,iBAAA;IACA,yBAAA;ErB2oIA;EqBxoIF;IACE,eAAA;IACA,YAAA;ErB0oIA;EqBvoIF;IACE,uBAAA;IACA,sBAAA;ErByoIA;EqBloIF;IACE,YAAA;ErBooIA;EoB72JA;IC4uBF,mBAAA;ErBooIE;EqBvnIA;IACE,aAAA;IACA,6BAAA;IACA,iBAAA;IACA,iBAAA;ErBynIF;EqBvnIA;IACE,6CAAA;ErBynIF;EqBlnIA;IACE,sBAAA;IACA,gBAAA;IACA,eAAA;IACA,kBAAA;IACA,cAAA;ErBonIF;EqBlnIA;IACE,sBAAA;IACA,gBAAA;IACA,eAAA;IACC,mBAAA;IACD,iBAAA;IACA,cAAA;ErBonIF;EoBh4JE;IACE,cAAA;EpBk4JJ;EoBh4JE;IACE,mBAAA;IACA,UAAA;EpBk4JJ;EoBh4JE;IACE,UAAA;IACA,kBAAA;EpBk4JJ;AACF;AoB53JA;EC5BA;IACE,WAAA;ErB25JA;EqBx5JF;IACE,YAAA;IACA,gBAAA;IACA,kBAAA;ErB05JA;EqBt5JF;IACE,WAAA;IACA,YAAA;IACA,eAAA;ErBw5JA;EqBt5JA;IAEE,kBAAA;ErBu5JF;EqBn5JF;IACE,gBAAA;IACA,aAAA;IACA,kBAAA;IACA,mBAAA;ErBq5JA;EqBj5JF;IACE,eAAA;ErBm5JA;EqBh5JF;IACE,gBAAA;ErBk5JA;EqB/4JF;IACE,YAAA;IACA,aAAA;ErBi5JA;EqB94JF;;IAEE,WAAA;IACA,YAAA;ErBg5JA;EqB74JF;IACE,eAAA;IACA,iBAAA;ErB+4JA;EqB54JF;IACE,eAAA;ErB84JA;EqB14JF;IACE,0BAAA;ErB44JA;EqBz4JF;IACE,WAAA;IACA,YAAA;IACA,eAAA;ErB24JA;EqBx4JF;IACE,aAAA;IACA,mBAAA;ErB04JA;EqBv4JF;IACE,YAAA;IACA,mBAAA;IACA,eAAA;ErBy4JA;EqBt4JF;IACE,eAAA;ErBw4JA;EqBr4JF;IACE,iBAAA;ErBu4JA;EqBp4JF;IACE,mBAAA;ErBs4JA;EqBn4JF;IACE,WAAA;IACA,YAAA;ErBq4JA;EqBl4JF;IACE,UAAA;ErBo4JA;EqB73JF;IACE,SAAA;IACA,UAAA;ErB+3JA;EqB53JF;IACE,eAAA;IACA,iBAAA;ErB83JA;EqB33JF;IACE,UAAA;IACA,aAAA;ErB63JA;EqB13JF;IACE,WAAA;IACA,YAAA;IACA,UAAA;ErB43JA;EqBz3JF;IACE,aAAA;IACA,WAAA;IACA,YAAA;IACA,eAAA;ErB23JA;EqBx3JF;IACE,eAAA;ErB03JA;EqBv3JF;;IAEE,WAAA;IACA,YAAA;IACA,mBAAA;ErBy3JA;EqBt3JF;IACE,YAAA;IACA,SAAA;IACA,eAAA;IACA,UAAA;ErBw3JA;EqBr3JF;IACE,YAAA;ErBu3JA;EqBn3JF;IACE,WAAA;IACA,YAAA;ErBq3JA;EqBl3JF;IACE,WAAA;IACA,YAAA;ErBo3JA;EqBj3JF;IACE,eAAA;IACA,iBAAA;IACA,kBAAA;IACA,gBAAA;ErBm3JA;EqBh3JF;IACE,WAAA;IACA,YAAA;ErBk3JA;EqB/2JF;IACE,WAAA;IACA,YAAA;ErBi3JA;EqB92JF;IACE,eAAA;ErBg3JA;EqB72JF;IACE,eAAA;IACA,iBAAA;IACA,mBAAA;IACA,gBAAA;ErB+2JA;EqB32JF;IACE,cAAA;IACA,yBAAA;IACA,yBAAA;IACA,aAAA;ErB62JA;EqB12JF;IACE,YAAA;IACA,UAAA;IACA,SAAA;ErB42JA;EqB12JF;IACE,WAAA;ErB42JA;EqB12JF;IACE,yBAAA;IACA,YAAA;ErB42JA;EqB12JF;IACE,eAAA;ErB42JA;EqB12JF;IACE,WAAA;IACA,YAAA;IACA,kBAAA;ErB42JA;EqB12JF;IACE,UAAA;IACA,YAAA;ErB42JA;EqB12JF;IACE,kBAAA;ErB42JA;EqB12JF;IACE,YAAA;IACA,aAAA;ErB42JA;EqBz2JF;IACE,YAAA;IACA,YAAA;IACA,mBAAA;IACA,eAAA;IACA,iBAAA;IACA,kBAAA;ErB22JA;EqBx2JF;IACE,WAAA;IACA,YAAA;ErB02JA;EqBv2JF;IACE,WAAA;IACA,YAAA;ErBy2JA;EqBt2JF;IACE,iBAAA;ErBw2JA;EqBp2JF;IACE,YAAA;IACA,WAAA;ErBs2JA;EqBn2JF;IACE,WAAA;IACA,YAAA;ErBq2JA;EqBl2JF;IACE,WAAA;IACA,YAAA;ErBo2JA;EqBj2JF;IACE,eAAA;IACA,YAAA;IACA,aAAA;ErBm2JA;EqBh2JF;IACE,aAAA;IACA,mBAAA;ErBk2JA;EqBh2JA;IACE,YAAA;IACA,aAAA;ErBk2JF;EqB/1JA;IACE,YAAA;IACA,aAAA;IACA,kBAAA;ErBi2JF;EqB91JA;IACE,WAAA;IACA,YAAA;ErBg2JF;EqB71JA;;IAEE,eAAA;IACA,iBAAA;ErB+1JF;EqB31JF;IACE,eAAA;IACA,kBAAA;IACA,iBAAA;ErB61JA;EqB11JF;IACE,eAAA;ErB41JA;EqBx1JF;IACE,kBAAA;IACA,mBAAA;ErB01JA;EqBx1JA;IACE,WAAA;IACA,YAAA;IACA,MAAA;ErB01JF;EqBv1JA;;IAEE,eAAA;ErBy1JF;EqBt1JA;IACE,WAAA;IACA,WAAA;ErBw1JF;EqBh1JF;IACE,WAAA;ErBk1JA;EqB/0JF;IACE,mBAAA;IACA,YAAA;ErBi1JA;EqB90JF;IACE,WAAA;IACA,YAAA;IACA,YAAA;ErBg1JA;EqB50JF;IACE,uBAAA;ErB80JA;EqB30JF;IACE,WAAA;IACA,YAAA;ErB60JA;EqB10JF;;IAEE,WAAA;IACA,YAAA;IACA,eAAA;ErB40JA;EqBx0JA;IACE,UAAA;ErB00JF;EqBv0JA;IACE,iBAAA;ErBy0JF;EqBn0JF;IACE,eAAA;IACA,kBAAA;ErBq0JA;EqBl0JF;;IAEE,eAAA;ErBo0JA;EqBj0JF;;IAEE,YAAA;ErBm0JA;EqBh0JF;IACE,eAAA;IACA,YAAA;ErBk0JA;EqB3zJF;IACE,WAAA;IACA,cAAA;IACA,UAAA;IACA,UAAA;ErB6zJA;EqB1zJF;IACE,WAAA;IACA,YAAA;IACA,kBAAA;ErB4zJA;EqBzzJF;IACE,YAAA;IACA,WAAA;ErB2zJA;EqBxzJF;IACG,YAAA;IAED,cAAA;ErByzJA;EqBtzJF;IACE,YAAA;IACA,aAAA;IACA,mBAAA;ErBwzJA;EqBnzJA;IACE,gBAAA;ErBqzJF;EqBlzJA;IACE,eAAA;ErBozJF;EqBhzJF;IACE,wBAAA;IACA,yBAAA;ErBkzJA;EqB/yJF;IACE,uBAAA;IACA,wBAAA;ErBizJA;EqB9yJF;IACE,uBAAA;IACA,wBAAA;ErBgzJA;EqB7yJF;IACE,uBAAA;IACA,wBAAA;ErB+yJA;EqB5yJF;IACE,uBAAA;IACA,wBAAA;ErB8yJA;EqB3yJF;IACE,YAAA;IACA,YAAA;ErB6yJA;EqB1yJF;IACE,YAAA;ErB4yJA;EqBzyJF;IACE,mBAAA;ErB2yJA;EqBxyJF;;IAEE,YAAA;IACA,aAAA;ErB0yJA;EqBvyJF;;IAEE,WAAA;IACA,YAAA;ErByyJA;EqBtyJF;;IAEE,eAAA;ErBwyJA;EqBryJF;;IAEE,WAAA;IACA,WAAA;ErBuyJA;EqBpyJF;;IAEE,UAAA;ErBsyJA;EqBnyJF;IACE,eAAA;IACA,cAAA;ErBqyJA;EqBlyJF;IACE,SAAA;IACA,iBAAA;ErBoyJA;EqBjyJF;IACE,WAAA;IACA,YAAA;IACA,YAAA;ErBmyJA;EqBhyJF;IACE,WAAA;IACA,YAAA;ErBkyJA;EqB/xJF;IACE,WAAA;IACA,YAAA;ErBiyJA;EqB9xJF;IACE,YAAA;IACA,aAAA;IACA,SAAA;ErBgyJA;EqB7xJF;IACE,WAAA;IACA,YAAA;ErB+xJA;EqB5xJF;IACE,eAAA;ErB8xJA;EqB3xJF;IACE,0BAAA;ErB6xJA;EqB1xJF;;IAEE,eAAA;ErB4xJA;EqBzxJF;IACE,YAAA;IACA,YAAA;IACA,mBAAA;IACA,YAAA;IACA,kBAAA;ErB2xJA;EqBxxJF;IACE,WAAA;IACA,YAAA;IACA,YAAA;ErB0xJA;EqBvxJF;IACE,kBAAA;IACA,WAAA;IACA,YAAA;ErByxJA;EqBtxJF;IACE,eAAA;ErBwxJA;EqBrxJF;IACE,aAAA;ErBuxJA;EqBpxJF;IACE,YAAA;IACA,aAAA;IACA,4BAAA;ErBsxJA;EqBlxJF;IACE,YAAA;IACA,aAAA;ErBoxJA;EqBjxJF;IACE,WAAA;IACA,YAAA;ErBmxJA;EqBhxJF;IACE,eAAA;IACA,iBAAA;IACA,gBAAA;ErBkxJA;EqB/wJF;IACE,eAAA;IACA,iBAAA;IACA,gBAAA;ErBixJA;EqB9wJF;IACE,eAAA;IACA,iBAAA;IACA,WAAA;ErBgxJA;EqB7wJF;IACE,WAAA;ErB+wJA;EqB5wJF;IACE,mBAAA;ErB8wJA;EqB3wJF;IACE,WAAA;IACA,YAAA;ErB6wJA;EqBvwJF;IACE,WAAA;IACA,YAAA;ErBywJA;EqBlwJF;IACE,YAAA;IACA,aAAA;ErBowJA;EqBjwJF;IACE,wBAAA;ErBmwJA;EqBhwJF;IACE,SAAA;IACA,UAAA;ErBkwJA;EqB/vJF;IACE,0BAAA;IACA,4BAAA;ErBiwJA;EqB7vJF;IACE,uBAAA;ErB+vJA;EqB5vJF;IACE,uBAAA;ErB8vJA;EqB1vJA;IACE,WAAA;IACA,YAAA;ErB4vJF;EqBtvJE;IACE,YAAA;IACA,YAAA;ErBwvJJ;EqBnvJF;IACE,qBAAA;ErBqvJA;EqBlvJF;IACE,qBAAA;ErBovJA;EqBjvJF;IACE,uBAAA;IACA,gBAAA;IACA,YAAA;IACA,aAAA;IACA,mBAAA;ErBmvJA;EqB/uJA;IAEE,UAAA;ErBgvJF;EqB1uJF;IACE,iBAAA;IACA,kBAAA;ErB4uJA;EqBzuJF;IACE,iBAAA;IACA,yBAAA;ErB2uJA;EqBxuJF;IACE,eAAA;IACA,YAAA;ErB0uJA;EqBvuJF;IACE,uBAAA;IACA,sBAAA;ErByuJA;EqBluJF;IACE,YAAA;ErBouJA;EqBjuJF,mBAAA;EAaE;IACE,aAAA;IACA,6BAAA;IACA,iBAAA;IACA,iBAAA;ErButJF;EqBrtJA;IACE,6CAAA;ErButJF;EqBhtJA;IACE,sBAAA;IACA,gBAAA;IACA,eAAA;IACA,kBAAA;IACA,cAAA;ErBktJF;EqBhtJA;IACE,sBAAA;IACA,gBAAA;IACA,eAAA;IACC,mBAAA;IACD,iBAAA;IACA,cAAA;ErBktJF;AACF;AoBr8KA;EEvCA;IACI,sBAAA;EtB++KF;AACF","sourcesContent":["$path: './../../';\n\n@font-face {\n  font-family: 'Assistant';\n  src: url('#{$path}fonts/Assistant-Regular.eot');\n  src: url('#{$path}fonts/Assistant-Regular.eot?#iefix') format('embedded-opentype'),\n  url('#{$path}fonts/Assistant-Regular.woff2') format('woff2'),\n  url('#{$path}fonts/Assistant-Regular.woff') format('woff'),\n  url('#{$path}fonts/Assistant-Regular.ttf') format('truetype'),\n  url('#{$path}fonts/Assistant-Regular.svg#Assistant-Regular') format('svg');\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Assistant';\n  src: url('#{$path}fonts/Assistant-ExtraBold.eot');\n  src: url('#{$path}fonts/Assistant-ExtraBold.eot?#iefix') format('embedded-opentype'),\n  url('#{$path}fonts/Assistant-ExtraBold.woff2') format('woff2'),\n  url('#{$path}fonts/Assistant-ExtraBold.woff') format('woff'),\n  url('#{$path}fonts/Assistant-ExtraBold.ttf') format('truetype'),\n  url('#{$path}fonts/Assistant-ExtraBold.svg#Assistant-ExtraBold') format('svg');\n  font-weight: bold;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Assistant';\n  src: url('#{$path}fonts/Assistant-Bold.eot');\n  src: url('#{$path}fonts/Assistant-Bold.eot?#iefix') format('embedded-opentype'),\n  url('#{$path}fonts/Assistant-Bold.woff2') format('woff2'),\n  url('#{$path}fonts/Assistant-Bold.woff') format('woff'),\n  url('#{$path}fonts/Assistant-Bold.ttf') format('truetype'),\n  url('#{$path}fonts/Assistant-Bold.svg#Assistant-Bold') format('svg');\n  font-weight: bold;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Assistant';\n  src: url('#{$path}fonts/Assistant-ExtraLight.eot');\n  src: url('#{$path}fonts/Assistant-ExtraLight.eot?#iefix') format('embedded-opentype'),\n  url('#{$path}fonts/Assistant-ExtraLight.woff2') format('woff2'),\n  url('#{$path}fonts/Assistant-ExtraLight.woff') format('woff'),\n  url('#{$path}fonts/Assistant-ExtraLight.ttf') format('truetype'),\n  url('#{$path}fonts/Assistant-ExtraLight.svg#Assistant-ExtraLight') format('svg');\n  font-weight: 200;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Assistant';\n  src: url('#{$path}fonts/Assistant-Medium.eot');\n  src: url('#{$path}fonts/Assistant-Medium.eot?#iefix') format('embedded-opentype'),\n  url('#{$path}fonts/Assistant-Medium.woff2') format('woff2'),\n  url('#{$path}fonts/Assistant-Medium.woff') format('woff'),\n  url('#{$path}fonts/Assistant-Medium.ttf') format('truetype'),\n  url('#{$path}fonts/Assistant-Medium.svg#Assistant-Medium') format('svg');\n  font-weight: 500;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Assistant';\n  src: url('#{$path}fonts/Assistant-Light.eot');\n  src: url('#{$path}fonts/Assistant-Light.eot?#iefix') format('embedded-opentype'),\n  url('#{$path}fonts/Assistant-Light.woff2') format('woff2'),\n  url('#{$path}fonts/Assistant-Light.woff') format('woff'),\n  url('#{$path}fonts/Assistant-Light.ttf') format('truetype'),\n  url('#{$path}fonts/Assistant-Light.svg#Assistant-Light') format('svg');\n  font-weight: 300;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Assistant';\n  src: url('#{$path}fonts/Assistant-SemiBold.eot');\n  src: url('#{$path}fonts/Assistant-SemiBold.eot?#iefix') format('embedded-opentype'),\n  url('#{$path}fonts/Assistant-SemiBold.woff2') format('woff2'),\n  url('#{$path}fonts/Assistant-SemiBold.woff') format('woff'),\n  url('#{$path}fonts/Assistant-SemiBold.ttf') format('truetype'),\n  url('#{$path}fonts/Assistant-SemiBold.svg#Assistant-SemiBold') format('svg');\n  font-weight: 600;\n  font-style: normal;\n  font-display: swap;\n}\n\n","@import \"../icomoon/style.css\";\n@font-face {\n  font-family: \"Assistant\";\n  src: url(\"./../../fonts/Assistant-Regular.eot\");\n  src: url(\"./../../fonts/Assistant-Regular.eot?#iefix\") format(\"embedded-opentype\"), url(\"./../../fonts/Assistant-Regular.woff2\") format(\"woff2\"), url(\"./../../fonts/Assistant-Regular.woff\") format(\"woff\"), url(\"./../../fonts/Assistant-Regular.ttf\") format(\"truetype\"), url(\"./../../fonts/Assistant-Regular.svg#Assistant-Regular\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: \"Assistant\";\n  src: url(\"./../../fonts/Assistant-ExtraBold.eot\");\n  src: url(\"./../../fonts/Assistant-ExtraBold.eot?#iefix\") format(\"embedded-opentype\"), url(\"./../../fonts/Assistant-ExtraBold.woff2\") format(\"woff2\"), url(\"./../../fonts/Assistant-ExtraBold.woff\") format(\"woff\"), url(\"./../../fonts/Assistant-ExtraBold.ttf\") format(\"truetype\"), url(\"./../../fonts/Assistant-ExtraBold.svg#Assistant-ExtraBold\") format(\"svg\");\n  font-weight: bold;\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: \"Assistant\";\n  src: url(\"./../../fonts/Assistant-Bold.eot\");\n  src: url(\"./../../fonts/Assistant-Bold.eot?#iefix\") format(\"embedded-opentype\"), url(\"./../../fonts/Assistant-Bold.woff2\") format(\"woff2\"), url(\"./../../fonts/Assistant-Bold.woff\") format(\"woff\"), url(\"./../../fonts/Assistant-Bold.ttf\") format(\"truetype\"), url(\"./../../fonts/Assistant-Bold.svg#Assistant-Bold\") format(\"svg\");\n  font-weight: bold;\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: \"Assistant\";\n  src: url(\"./../../fonts/Assistant-ExtraLight.eot\");\n  src: url(\"./../../fonts/Assistant-ExtraLight.eot?#iefix\") format(\"embedded-opentype\"), url(\"./../../fonts/Assistant-ExtraLight.woff2\") format(\"woff2\"), url(\"./../../fonts/Assistant-ExtraLight.woff\") format(\"woff\"), url(\"./../../fonts/Assistant-ExtraLight.ttf\") format(\"truetype\"), url(\"./../../fonts/Assistant-ExtraLight.svg#Assistant-ExtraLight\") format(\"svg\");\n  font-weight: 200;\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: \"Assistant\";\n  src: url(\"./../../fonts/Assistant-Medium.eot\");\n  src: url(\"./../../fonts/Assistant-Medium.eot?#iefix\") format(\"embedded-opentype\"), url(\"./../../fonts/Assistant-Medium.woff2\") format(\"woff2\"), url(\"./../../fonts/Assistant-Medium.woff\") format(\"woff\"), url(\"./../../fonts/Assistant-Medium.ttf\") format(\"truetype\"), url(\"./../../fonts/Assistant-Medium.svg#Assistant-Medium\") format(\"svg\");\n  font-weight: 500;\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: \"Assistant\";\n  src: url(\"./../../fonts/Assistant-Light.eot\");\n  src: url(\"./../../fonts/Assistant-Light.eot?#iefix\") format(\"embedded-opentype\"), url(\"./../../fonts/Assistant-Light.woff2\") format(\"woff2\"), url(\"./../../fonts/Assistant-Light.woff\") format(\"woff\"), url(\"./../../fonts/Assistant-Light.ttf\") format(\"truetype\"), url(\"./../../fonts/Assistant-Light.svg#Assistant-Light\") format(\"svg\");\n  font-weight: 300;\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: \"Assistant\";\n  src: url(\"./../../fonts/Assistant-SemiBold.eot\");\n  src: url(\"./../../fonts/Assistant-SemiBold.eot?#iefix\") format(\"embedded-opentype\"), url(\"./../../fonts/Assistant-SemiBold.woff2\") format(\"woff2\"), url(\"./../../fonts/Assistant-SemiBold.woff\") format(\"woff\"), url(\"./../../fonts/Assistant-SemiBold.ttf\") format(\"truetype\"), url(\"./../../fonts/Assistant-SemiBold.svg#Assistant-SemiBold\") format(\"svg\");\n  font-weight: 600;\n  font-style: normal;\n  font-display: swap;\n}\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml {\n  font-size: 16px;\n}\n\nbody {\n  font-family: \"Assistant\", sans-serif;\n  background: #fff;\n  color: #364048;\n  overflow: hidden;\n}\nbody.setting__body .main,\nbody.setting__body .wrapper {\n  overflow: unset;\n  height: auto;\n}\nbody.setting__body {\n  overflow: auto;\n}\n\n.wrapper {\n  width: 100%;\n  overflow: hidden;\n  margin: 0 auto;\n  position: relative;\n  background: #F0F0F3;\n}\n\n.row {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.clear {\n  clear: both;\n}\n\n/* width */\n::-webkit-scrollbar {\n  width: 8px;\n  display: block;\n}\n\n.filter__block .asset__block::-webkit-scrollbar {\n  width: inherit !important;\n}\n\n.recycle__layout {\n  position: fixed;\n  top: 60px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  box-shadow: inset 4px 4px 4px rgba(174, 174, 192, 0.2);\n  border-radius: 67px;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: transparent;\n  border-radius: 8px;\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: transparent;\n}\n\n.add__defi__item, .card__product__stake__amount__max, .wallet__addresses__top__right__btn, .zoom__page__btn,\n.layout__list,\n.layout__grid, .to__top, .reset__btn, .risk__btn, .card__product__unstacked, .card__product__stake, .card__risk__alert, .card__settings {\n  transition: all 0.4s;\n}\n\n.limit__block__top, .wallet__type__btn {\n  transition: all 0.4s;\n}\n\n.login__btn, .password__change__btn, .card__product__stake__amount__confirm, .wallet__type__save {\n  transition: all 0.4s;\n}\n.login__btn:hover, .password__change__btn:hover, .card__product__stake__amount__confirm:hover, .wallet__type__save:hover {\n  background: #1762A2;\n}\n\n.card__risk__alert.active {\n  transition: all 0.4s;\n  box-shadow: inset 3px 3px 3px rgba(174, 174, 192, 0.2), inset -3px -3px 3px rgba(255, 255, 255, 0.6980392157);\n}\n\n.limit__block__top.active {\n  transition: all 0.4s;\n  box-shadow: 3px 3px 3px rgba(174, 174, 192, 0.2), -3px -3px 3px rgba(255, 255, 255, 0.6980392157);\n}\n\n.align-items-center {\n  align-items: center;\n}\n\n.dropdown {\n  position: relative;\n  width: 272px;\n}\n.dropdown.open .dropdown__selected {\n  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);\n}\n.dropdown.open .dropdown__selected .dropdown__arrow {\n  transform: rotate(-180deg);\n}\n.dropdown.open .dropdown__body {\n  display: block;\n}\n\n.dropdown__selected {\n  height: 48px;\n  width: 100%;\n  background: #EDEDEF;\n  box-shadow: -3px -3px 9px #FFFFFF, 3px 3px 9px rgba(174, 174, 192, 0.4039215686);\n  border-radius: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 20px;\n  position: relative;\n  z-index: 2;\n  cursor: pointer;\n}\n\n.dropdown__arrow {\n  display: flex;\n  right: 25px;\n  position: absolute;\n}\n\n.dropdown__body {\n  background: #F0F0F3;\n  box-shadow: 0 5px 15px rgba(56, 70, 82, 0.2549019608);\n  border-radius: 0 0 20px 20px;\n  padding: 35px 16px 16px;\n  position: absolute;\n  width: 100%;\n  z-index: 1;\n  top: 25px;\n  display: none;\n}\n\n.dropdown__copy {\n  width: 100%;\n  border-radius: 80px;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #A9B6C1;\n  font-weight: 600;\n  font-size: 20px;\n  position: relative;\n  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);\n}\n\n.dropdown__copy__icon__wrapper {\n  width: 32px;\n  height: 32px;\n  box-shadow: -3px -3px 9px #FFFFFF, 3px 3px 9px rgba(174, 174, 192, 0.4039215686);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  right: 8px;\n  top: 8px;\n  cursor: pointer;\n}\n\n.dropdown__sub {\n  margin-top: 16px;\n  position: relative;\n  width: 248px;\n}\n.dropdown__sub.open .dropdown__sub__selected {\n  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);\n}\n.dropdown__sub.open .dropdown__sub__selected .dropdown__arrow {\n  transform: rotate(-180deg);\n}\n.dropdown__sub.open .dropdown__sub__body {\n  display: block;\n}\n\n.dropdown__sub__selected {\n  height: 48px;\n  width: 100%;\n  background: #EDEDEF;\n  box-shadow: -3px -3px 9px #FFFFFF, 3px 3px 9px rgba(174, 174, 192, 0.4039215686);\n  border-radius: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 20px;\n  position: relative;\n  z-index: 2;\n  cursor: pointer;\n}\n\n.dropdown__sub__body {\n  position: absolute;\n  box-shadow: 0 5px 15px rgba(56, 70, 82, 0.2549019608);\n  border-radius: 0 0 25px 25px;\n  background: #F0F0F3;\n  width: 100%;\n  top: 35px;\n  padding: 20px 16px 16px;\n}\n\n.dropdown__sub__item {\n  color: #364048;\n  font-weight: 600;\n  font-size: 20px;\n  padding: 13px 0;\n  border-bottom: 1px solid #A9B6C1;\n  cursor: pointer;\n}\n.dropdown__sub__item:last-child {\n  border-bottom: 0;\n  padding-bottom: 3px;\n}\n.dropdown__sub__item:first-child {\n  padding-top: 0;\n}\n\ninput:autofill {\n  background: transparent !important; /* or any other */\n}\n\n.modal__wrapper {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  width: fit-content;\n  margin: auto;\n  min-height: 500px;\n  height: auto;\n  display: flex;\n  justify-content: center;\n  z-index: 9999999;\n  overflow-y: auto;\n  overflow-x: hidden;\n  box-shadow: 0 5px 15px 0 rgb(56, 70, 82);\n  margin-top: 115px;\n  border-radius: 20px;\n}\n\n.modal {\n  width: 992px;\n  border-radius: 20px;\n  box-shadow: 0 5px 15px 0 rgba(56, 70, 82, 0.25);\n  background-color: #f0f0f3;\n  padding: 24px 24px;\n  height: 500px;\n  overflow-y: scroll;\n}\n.modal__header {\n  display: flex;\n  position: relative;\n  padding-right: 24px;\n}\n\n::-webkit-scrollbar-track {\n  background: none !important;\n  box-shadow: none !important;\n}\n\n.card {\n  width: 312px;\n  height: 488px;\n  background: #F0F0F3;\n  box-shadow: -8px -8px 24px #FFFFFF, 8px 8px 24px rgba(174, 174, 192, 0.4039215686);\n  border-radius: 24px;\n  margin-right: 40px;\n  margin-bottom: 40px;\n  padding: 24px;\n  position: relative;\n}\n.card.aside__card__big {\n  margin: 49px auto 8px;\n  padding: 0;\n  box-shadow: unset;\n}\n.card.aside__card__big .card__wallet__row {\n  background-color: transparent;\n}\n.card.aside__card__big .card__title {\n  font-size: 18px;\n  text-align: center;\n  max-width: 225px;\n  margin: 0 auto;\n}\n.card.aside__card__big .card__wallet__usd {\n  font-size: 20px;\n  color: #364048;\n  font-weight: 700;\n}\n.card.aside__card__big .card__product__number.cold {\n  color: #4DC7B5;\n}\n.card.aside__card__big .card__product__number.cold.empty {\n  color: #889096;\n}\n.card.aside__card__big .card__product__number.hold {\n  color: #EFB661;\n}\n.card.aside__card__big .card__product__number.hold.empty {\n  color: #889096;\n}\n.card.aside__card__big .card__product__number.risky {\n  color: #F27281;\n}\n.card.aside__card__big .card__product__number.risky.empty {\n  color: #889096;\n}\n.card .add__wallet {\n  display: none;\n}\n.card.new .new__layer {\n  border-radius: 24px;\n  background: rgba(240, 240, 243, 0.7);\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  z-index: 1;\n  position: absolute;\n}\n.card.new .add__wallet {\n  background: #F0F0F3;\n  box-shadow: inset 10px 10px 10px rgba(174, 174, 192, 0.2), inset -10px -10px 10px rgba(255, 255, 255, 0.6980392157);\n  width: 136px;\n  height: 136px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.4s;\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin: auto;\n  z-index: 2;\n}\n.card.new .add__wallet .save__text {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  margin: auto;\n  opacity: 0;\n  visibility: hidden;\n  color: #ffffff;\n  text-transform: uppercase;\n  font-size: 18px;\n  font-weight: normal;\n  max-width: max-content;\n  max-height: max-content;\n}\n.card.new .add__wallet .plus__wrapper {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  opacity: 0;\n  visibility: hidden;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  margin: auto;\n}\n.card.new .add__wallet .plus__wrapper span {\n  width: 30px;\n  height: 5px;\n  background: #F0F0F3;\n  border-radius: 2px;\n  position: absolute;\n}\n.card.new .add__wallet .plus__wrapper span:nth-child(2) {\n  transform: rotate(90deg);\n}\n.card.new .add__wallet.new .plus__wrapper {\n  visibility: visible;\n  opacity: 1;\n}\n.card.new .add__wallet.save {\n  top: 288px;\n}\n.card.new .add__wallet.save .plus__wrapper {\n  position: absolute;\n  visibility: hidden;\n  opacity: 0;\n}\n.card.new .add__wallet.save .save__text {\n  opacity: 1;\n  visibility: visible;\n}\n.card.new .add__wallet .add__wallet__btn__bg {\n  background: #1762A2;\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: inset 2px 2px 2px rgba(255, 255, 255, 0.44), 10px 10px 30px rgba(174, 174, 192, 0.44), inset -2px -2px 2px rgba(29, 29, 29, 0.2549019608), -10px -10px 30px #FFFFFF;\n  position: relative;\n}\n.card.trash .trash__layer {\n  border-radius: 24px;\n  background: rgba(240, 240, 243, 0.7);\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  z-index: 1;\n  position: absolute;\n}\n.card.trash .trash__wallet {\n  background: #F0F0F3;\n  box-shadow: -8px -8px 24px #FFFFFF, 10px 10px 30px rgba(174, 174, 192, 0.4039215686);\n  width: 136px;\n  height: 136px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.4s;\n  cursor: pointer;\n  position: absolute;\n  top: 110px;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin: auto;\n  z-index: 2;\n}\n.card.trash .unstacking {\n  display: none;\n}\n.card.trash .trash__wallet__icon {\n  width: 44px;\n  height: 48px;\n}\n.card.trash .card__settings {\n  opacity: 0;\n  visibility: hidden;\n}\n.card.new__defi .card__risk {\n  margin-top: 0;\n}\n.card.empty .card__nft__img,\n.card.empty .card__risk__range,\n.card.empty .unstacking {\n  opacity: 0;\n  visibility: hidden;\n}\n.card.empty .card__product__unstacked,\n.card.empty .card__product__stake,\n.card.empty .card__risk__chart__number__of,\n.card.empty .card__risk__chart__number,\n.card.empty .card__risk__alert__title,\n.card.empty .card__risk__alert__number,\n.card.empty .card__price {\n  color: #C4C4C4;\n}\n.card.empty .card__risk__chart__min {\n  box-shadow: inset 0 3px 6px rgba(0, 0, 0, 0.1607843137);\n  border-color: transparent;\n  width: 130px;\n  height: 130px;\n  position: relative;\n}\n.card.empty .card__risk__chart__min:after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  display: inline-flex;\n  margin: 0 auto;\n  width: 9px;\n  height: 9px;\n  background: #c3c3c3;\n  border-radius: 50%;\n}\n.card.empty .card__wallet__row {\n  opacity: 0;\n  visibility: hidden;\n}\n.card.empty .add__wallet {\n  background: #F0F0F3;\n  box-shadow: inset 10px 10px 10px rgba(174, 174, 192, 0.2), inset -10px -10px 10px rgba(255, 255, 255, 0.6980392157);\n  width: 136px;\n  height: 136px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.4s;\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin: auto;\n  z-index: 2;\n}\n.card.empty .add__wallet .save__text {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  margin: auto;\n  opacity: 0;\n  visibility: hidden;\n  color: #ffffff;\n  text-transform: uppercase;\n  font-size: 18px;\n  font-weight: normal;\n  max-width: max-content;\n  max-height: max-content;\n}\n.card.empty .add__wallet .plus__wrapper {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  opacity: 0;\n  visibility: hidden;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  margin: auto;\n}\n.card.empty .add__wallet .plus__wrapper span {\n  width: 30px;\n  height: 5px;\n  background: #F0F0F3;\n  border-radius: 2px;\n  position: absolute;\n}\n.card.empty .add__wallet .plus__wrapper span:nth-child(2) {\n  transform: rotate(90deg);\n}\n.card.empty .add__wallet.new .plus__wrapper {\n  visibility: visible;\n  opacity: 1;\n}\n.card.empty .add__wallet.save {\n  top: 305px;\n}\n.card.empty .add__wallet.save .plus__wrapper {\n  position: absolute;\n  visibility: hidden;\n  opacity: 0;\n}\n.card.empty .add__wallet.save .save__text {\n  opacity: 1;\n  visibility: visible;\n}\n.card.empty .add__wallet .add__wallet__btn__bg {\n  background: #1762A2;\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: inset 2px 2px 2px rgba(255, 255, 255, 0.44), 10px 10px 30px rgba(174, 174, 192, 0.44), inset -2px -2px 2px rgba(29, 29, 29, 0.2549019608), -10px -10px 30px #FFFFFF;\n  position: relative;\n}\n.card.cold .card__risk__chart__min {\n  border-color: #4DC7B5;\n}\n.card.cold .card__product__number,\n.card.cold .card__risk__chart__number__of,\n.card.cold .card__risk__chart__number {\n  color: #4DC7B5;\n}\n.card.cold .card__product__number.empty,\n.card.cold .card__risk__chart__number__of.empty,\n.card.cold .card__risk__chart__number.empty {\n  color: #889096;\n}\n.card.cold .card__risk__info:hover {\n  background: #4DC7B5;\n  color: #ffffff;\n}\n.card.hold .card__risk__chart__min {\n  border-color: #EFB661;\n}\n.card.hold .card__product__number,\n.card.hold .card__risk__chart__number__of,\n.card.hold .card__risk__chart__number {\n  color: #EFB661;\n}\n.card.hold .card__product__number.empty,\n.card.hold .card__risk__chart__number__of.empty,\n.card.hold .card__risk__chart__number.empty {\n  color: #889096;\n}\n.card.hold .card__risk__info:hover {\n  background: #EFB661;\n  color: #ffffff;\n}\n.card.risky .card__risk__chart__min {\n  border-color: #F27281;\n}\n.card.risky .card__product__number,\n.card.risky .card__risk__chart__number__of,\n.card.risky .card__risk__chart__number {\n  color: #F27281;\n}\n.card.risky .card__product__number.empty,\n.card.risky .card__risk__chart__number__of.empty,\n.card.risky .card__risk__chart__number.empty {\n  color: #889096;\n}\n.card.risky .card__risk__info:hover {\n  background: #F27281;\n  color: #ffffff;\n}\n.card__header {\n  margin-bottom: 8px;\n}\n.card__header .row {\n  align-items: flex-start;\n  justify-content: space-between;\n}\n.card__settings {\n  border: 0;\n  width: 17px;\n  height: 17px;\n  background: #F0F0F3;\n  border-radius: 50%;\n  box-shadow: -2px -2px 2px #FFFFFF, 2px 2px 2px rgba(174, 174, 192, 0.4039215686);\n  color: #364048;\n  cursor: pointer;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  left: 40px;\n  cursor: pointer;\n}\n.card__title {\n  font-weight: 600;\n  font-size: 18px;\n  color: #364048;\n  text-align: center;\n}\n.card__title span {\n  display: block;\n}\n.card__close {\n  width: 16px;\n  height: 16px;\n  border: 0;\n  background-color: transparent;\n  position: relative;\n  display: flex;\n  align-items: center;\n  text-align: center;\n  justify-content: center;\n}\n.card__close span {\n  height: 100%;\n  position: absolute;\n  top: 0;\n  width: 2px;\n  background: #364048;\n  transform: rotate(45deg);\n}\n.card__close span:nth-child(2) {\n  transform: rotate(-45deg);\n}\n.card__price {\n  height: 48px;\n  width: 100%;\n  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);\n  border-radius: 80px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #4DC7B5;\n  font-size: 18px;\n  line-height: 23px;\n  font-weight: bold;\n  margin-bottom: 16px;\n}\n.card__wallet {\n  width: 100%;\n  height: 108px;\n  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);\n  border-radius: 17px;\n  background: rgba(240, 240, 243, 0.05);\n  overflow-x: hidden;\n  overflow-y: auto;\n  margin-bottom: 34px;\n}\n.card__wallet::-webkit-scrollbar-track {\n  display: none;\n}\n.card__wallet::-webkit-scrollbar-thumb {\n  display: none;\n}\n.card__wallet__row {\n  display: flex;\n  justify-content: space-between;\n  height: 35px;\n  padding: 0 15px;\n  align-items: center;\n  overflow: hidden;\n  width: 100%;\n  transition: all 0.4s;\n}\n.card__wallet__row:nth-child(2n+1) {\n  background: rgba(132, 132, 132, 0.05);\n}\n.card__wallet__usd, .card__wallet__rates {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 26px;\n  color: #364049;\n}\n.card__wallet__usd {\n  color: #889096;\n  font-weight: 400;\n}\n.card__risk {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n}\n.card__risk__title {\n  color: #717679;\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 23px;\n  margin-bottom: 15px;\n}\n.card__risk__chart {\n  width: 144px;\n  height: 144px;\n  box-shadow: inset 6px 6px 6px rgba(174, 174, 192, 0.2), inset -6px -6px 6px rgba(255, 255, 255, 0.6980392157);\n  background: #F0F0F3;\n  border-radius: 92px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.card__risk__chart__min {\n  width: 108px;\n  height: 108px;\n  box-shadow: inset 0 3px 6px rgba(0, 0, 0, 0.1607843137), 0 3px 6px rgba(0, 0, 0, 0.1607843137);\n  border-width: 10px;\n  border-style: solid;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n.card__risk__chart__number {\n  font-weight: bold;\n  font-size: 26px;\n  line-height: 34px;\n}\n.card__risk__chart__number__of {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 18px;\n}\n.card__risk__alert {\n  width: 65px;\n  height: 65px;\n  border-radius: 50%;\n  background: #F0F0F3;\n  box-shadow: -3px -3px 9px #FFFFFF, 3px 3px 9px rgba(174, 174, 192, 0.4039215686);\n  position: absolute;\n  right: 0;\n  top: 19px;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  transition: all 0.4s;\n}\n.card__risk__alert__title {\n  color: #889096;\n  font-size: 18px;\n  line-height: 18px;\n}\n.card__risk__alert__number {\n  color: #f27281;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 18px;\n}\n.card__risk__info {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  background: #EBEBEB;\n  border-radius: 50%;\n  color: #cbcbcb;\n  font-size: 12px;\n  position: absolute;\n  bottom: -10px;\n  left: 48px;\n  box-shadow: -2px -2px 2px #FFFFFF, 2px 2px 2px rgba(145, 145, 165, 0.4039215686);\n  transition: all 0.4s;\n  cursor: pointer;\n}\n.card__product__row {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  align-items: center;\n  margin-bottom: 5px;\n  padding-bottom: 5px;\n  position: relative;\n  width: 100%;\n}\n.card__product__row:after {\n  content: \"\";\n  width: 100%;\n  border-radius: 67px;\n  height: 3px;\n  box-shadow: inset 10px 10px 10px rgba(174, 174, 192, 0.2), inset -10px -10px 10px rgba(255, 255, 255, 0.6980392157);\n}\n.card__product__row .product__row__dropdown {\n  width: 100%;\n  background: #F0F0F3;\n  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.1529411765), -8px -8px 24px #FFFFFF;\n  border-radius: 0 0 8px 8px;\n  position: absolute;\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.4s;\n  padding: 4px 16px;\n  z-index: 9999;\n  top: 30px;\n  left: 0;\n}\n.card__product__row .product__row__dropdown .product__row__dropdown__item {\n  color: #889096;\n  font-size: 18px;\n  line-height: 23px;\n  width: 100%;\n  border-bottom: 1px solid #c9c9ca;\n  text-transform: uppercase;\n  padding: 5px 0;\n  cursor: pointer;\n}\n.card__product__row .product__row__dropdown .product__row__dropdown__item:last-child {\n  border-bottom: 0;\n}\n.card__product__row .product__row__dropdown.open {\n  visibility: visible;\n  opacity: 1;\n}\n.card__product__title {\n  color: #889096;\n  font-size: 18px;\n  line-height: 23px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.4s;\n}\n.card__product__number {\n  font-size: 24px;\n  line-height: 32px;\n  text-shadow: 0 3px 6px rgba(77, 199, 181, 0.2039215686);\n  font-weight: bold;\n}\n.card__product__unstacked, .card__product__stake {\n  background: #F0F0F3;\n  box-shadow: inset -5px -5px 5px rgba(127, 127, 173, 0.1294117647), -5px -5px 15px #FFFFFF, inset 5px 5px 5px #FFFFFF, 5px 5px 15px rgba(142, 142, 181, 0.2);\n  border-radius: 20px;\n  cursor: pointer;\n  width: 112px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 0;\n  outline: none;\n  font-size: 18px;\n  line-height: 22px;\n}\n.card__product__stake__block {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  position: relative;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.card__product__unstacked {\n  color: #BA8557;\n}\n.card__product__stake {\n  color: #5781BA;\n}\n.card__risk__range {\n  width: 8px;\n  height: 176px;\n  position: absolute;\n  left: 5px;\n  top: 0;\n  display: none;\n}\n.card__risk__range.active {\n  display: block;\n}\n.card__risk__range__bg {\n  width: 100%;\n  height: 50%;\n  background: #F27281;\n  box-shadow: inset 3px 3px 3px rgba(64, 64, 80, 0.3254901961);\n  border-radius: 0 0 20px 20px;\n  position: absolute;\n  bottom: 0;\n}\n.card__risk__range__btn {\n  width: 24px;\n  height: 24px;\n  background: #F0F0F3;\n  box-shadow: -2px -2px 6px #FFFFFF, 2px 2px 6px rgba(54, 54, 77, 0.4039215686);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  position: absolute;\n  top: 50%;\n  left: -8px;\n  cursor: pointer;\n}\n.card__risk__range__btn__min {\n  background: #F27281;\n  width: 16px;\n  display: flex;\n  height: 16px;\n  border-radius: 50%;\n  box-shadow: inset 2px 2px 2px rgba(54, 54, 70, 0.6), inset -2px -2px 2px rgba(255, 255, 255, 0.6);\n}\n.card__risk__range__hr {\n  width: 176px;\n  height: 8px;\n  border-radius: 88px;\n  position: absolute;\n  left: 5px;\n  top: 0;\n  display: none;\n}\n.card__risk__range__hr.active {\n  display: block;\n}\n.card__risk__range__bg__hr {\n  width: 50%;\n  height: 100%;\n  border-radius: 20px 0 0 20px;\n  position: absolute;\n  left: 0;\n}\n.card__risk__range__btn__hr {\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  position: absolute;\n  top: -8px;\n  left: 50%;\n  cursor: pointer;\n}\n.card__risk__range__btn__hr__min {\n  background: #F27281;\n  width: 16px;\n  display: flex;\n  height: 16px;\n  border-radius: 50%;\n  box-shadow: inset 2px 2px 2px rgba(54, 54, 70, 0.6), inset -2px -2px 2px rgba(255, 255, 255, 0.6);\n}\n.card__nft__wrapper {\n  width: 264px;\n  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);\n  border-radius: 17px;\n  margin-bottom: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.card__nft__img {\n  width: 232px;\n  height: 160px;\n  border-radius: 17px;\n}\n\n.card__list {\n  width: 344px;\n  height: 88px;\n  background: #F0F0F3;\n  box-shadow: -8px -8px 24px #FFFFFF, 8px 8px 24px rgba(174, 174, 192, 0.4039215686);\n  border-radius: 24px;\n  display: flex;\n  align-items: center;\n  position: relative;\n  padding: 16px;\n  margin-right: 80px;\n  margin-bottom: 48px;\n  cursor: pointer;\n}\n.list.active .card__list:not(.active) {\n  opacity: 0.5;\n  user-select: none;\n  cursor: default;\n}\n.card__list.cold .card__risk__chart__list__min {\n  border-color: #4DC7B5;\n}\n.card__list.cold .card__risk__chart__list__number {\n  color: #4DC7B5;\n}\n.card__list.cold .card__risk__chart__list__number.empty {\n  color: #889096;\n}\n.card__list.hold .card__risk__chart__list__min {\n  border-color: #EFB661;\n}\n.card__list.hold .card__risk__chart__list__number {\n  color: #EFB661;\n}\n.card__list.hold .card__risk__chart__list__number.empty {\n  color: #889096;\n}\n.card__list.risky .card__risk__chart__list__min {\n  border-color: #F27281;\n}\n.card__list.risky .card__risk__chart__list__number {\n  color: #F27281;\n}\n.card__list.risky .card__risk__chart__list__number.empty {\n  color: #889096;\n}\n\n.card__list__percent {\n  display: flex;\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);\n  font-size: 16px;\n  font-weight: bold;\n  align-items: center;\n  justify-content: center;\n  margin-right: 16px;\n}\n\n.card__risk__chart__list {\n  width: 104px;\n  height: 104px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #F0F0F3;\n  position: absolute;\n  right: -52px;\n  top: -10px;\n  border-radius: 50%;\n  box-shadow: inset 6px 6px 6px rgba(174, 174, 192, 0.2), inset -6px -6px 6px rgba(255, 255, 255, 0.6980392157);\n}\n\n.card__risk__chart__list__min {\n  width: 56px;\n  height: 56px;\n  display: flex;\n  border-radius: 50%;\n  align-items: center;\n  justify-content: center;\n  border-width: 8px;\n  border-style: solid;\n  box-shadow: inset 0 3px 6px rgba(0, 0, 0, 0.1607843137), 0 3px 6px rgba(0, 0, 0, 0.1607843137);\n}\n\n.card__risk__chart__list__number {\n  font-size: 24px;\n  font-weight: bold;\n}\n\n.card__list__anchor,\n.card__list__title {\n  font-weight: 600;\n  font-size: 18px;\n  color: #364048;\n}\n\n.card__risk__alert {\n  cursor: pointer !important;\n}\n\n.unstacking {\n  cursor: pointer;\n}\n\n.card__risk__alert:hover {\n  background: #F5F5FA;\n  color: #1762A2;\n}\n\n.unstacking:hover {\n  background: #F5F5FA;\n  color: #1762A2;\n}\n\n.card__risk__chart__list__number {\n  font-size: 24px;\n  font-weight: bold;\n}\n\n.card__list__anchor,\n.card__list__title {\n  font-weight: 600;\n  font-size: 18px;\n  color: #364048;\n}\n\n.card__product__unstacked:hover,\n.card__product__stake:hover,\n.wallet__addresses__top__right__btn:hover,\n.anomalies_detection:hover,\n.limit__block__tabs__list:hover,\n.wallet__addresses__top__input__add:hover,\n.alerts__input__add:hover,\n.layout__grid:hover,\n.layout__list:hover,\n.card__settings:hover,\n.wallet__type:hover,\n.to__top:hover,\n.dropdown__selected:hover,\n.dropdown__sub__selectedm:hover,\n.limit__block__top:hover {\n  background: #F5F5FA !important;\n}\n\n.upload_label:hover,\n.add__wallet__btn__plus__bg:hover {\n  background: #1762A2;\n}\n\n.add__wallet__btn__bg:hover,\n.card.new .add__wallet .add__wallet__btn__bg:hover {\n  background: #214175 !important;\n}\n\n.card__risk__chart > div {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.card.empty .error__message.requests__message ~ .add__wallet.save {\n  top: 295px;\n}\n\n.ntf__filter__content input {\n  align-items: center;\n  margin: 0 10px;\n}\n.ntf__filter__content input::placeholder {\n  color: #889096 !important;\n  font-size: 15px !important;\n  font-weight: 500 !important;\n  line-height: 26px !important;\n  text-decoration: none !important;\n}\n\n.layout__block {\n  position: fixed;\n  z-index: 9;\n  right: 355px;\n  top: 90px;\n}\n\n.recycle__layout {\n  position: fixed;\n  top: 35px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.wallet__type__item:hover {\n  color: #214175 !important;\n}\n\n.card__chart__wrapper {\n  width: 736px;\n  height: 530px;\n  background: #f0f0f3;\n  box-shadow: -8px -8px 24px #ffffff, 8px 8px 24px rgba(174, 174, 192, 0.4039215686);\n  border-radius: 24px;\n  position: absolute;\n  padding: 25px 40px 32px 72px;\n  transition: opacity 0.4s;\n  margin: auto;\n  position: relative;\n}\n\n.card__chart {\n  width: 624px;\n  height: 384px;\n  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);\n  border-radius: 24px;\n}\n\n.card__chart__title {\n  font-weight: 600;\n  font-size: 18px;\n  color: #364048;\n  margin-right: 25px;\n}\n\n.card__chart__header {\n  margin-bottom: 24px;\n  display: flex;\n  align-items: center;\n}\n\n.check__wrapper {\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n  margin-right: 24px;\n  cursor: pointer;\n}\n.check__wrapper:last-child {\n  margin-right: 0;\n}\n.check__wrapper [type=checkbox] {\n  display: none;\n}\n.check__wrapper [type=checkbox]:checked ~ .checkbox__label .check__icon {\n  opacity: 1;\n  visibility: visible;\n}\n.check__wrapper.white .checkbox__box {\n  background: #ebebeb;\n}\n.check__wrapper.purple .checkbox__box {\n  background: #c9ceff;\n}\n.check__wrapper.blue .checkbox__box {\n  background: #97eaea;\n}\n.check__wrapper.yellow .checkbox__box {\n  background: #f0dc8b;\n}\n.check__wrapper .checkbox__box {\n  width: 24px;\n  height: 24px;\n  box-shadow: inset 2px 2px 2px rgba(174, 174, 192, 0.2), inset -2px -2px 2px rgba(255, 255, 255, 0.6980392157);\n  border-radius: 6px;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.check__wrapper .checkbox__box .check__icon {\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.4s;\n  width: 12px;\n  height: 12px;\n}\n.check__wrapper .checkbox__text {\n  display: inline-flex;\n  margin-left: 7px;\n  cursor: pointer;\n}\n.check__wrapper .checkbox__label {\n  display: flex;\n  align-items: center;\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 23px;\n  color: #889096;\n}\n\n.check__wrapper__all {\n  flex-grow: 1;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.card__chart__dropdown {\n  width: 72px;\n  position: relative;\n  cursor: pointer;\n}\n\n.card__chart__dropdown__selected {\n  font-size: 16px;\n  line-height: 23px;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  color: #2267a4;\n  position: relative;\n}\n.card__chart__dropdown__selected:after {\n  content: \"\";\n  position: absolute;\n  width: 72px;\n  height: 3px;\n  box-shadow: inset 10px 10px 10px rgba(174, 174, 192, 0.2), inset -10px -10px 10px rgba(255, 255, 255, 0.6980392157);\n  border-radius: 67px;\n  opacity: 0.93;\n  bottom: -2px;\n}\n.card__chart__dropdown__selected .card__chart__dropdown__selected__arrow {\n  width: 7px;\n  height: 7px;\n  border-bottom: 1px solid #2267a4;\n  border-right: 1px solid #2267a4;\n  transform: rotate(45deg);\n}\n\n.card__chart__dropdown__block {\n  background: #f0f0f3;\n  width: 100%;\n  padding: 4px 0 4px 7px;\n  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.1529411765);\n  border-radius: 0 0 8px 8px;\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  top: 25px;\n  z-index: 9;\n  transition: opacity 0.4s;\n}\n.open .card__chart__dropdown__block {\n  opacity: 1;\n  visibility: visible;\n}\n\n.card__chart__dropdown__list {\n  color: #889096;\n  font-size: 14px;\n  line-height: 23px;\n}\n.card__chart__dropdown__list:hover {\n  color: #2267a4;\n}\n\n.chart__open__btn {\n  position: absolute;\n  left: 10px;\n  width: 24px;\n  height: 24px;\n  cursor: pointer;\n}\n\n.chart__open__btn__icon,\n.chart__opened__btn__icon {\n  width: 24px;\n  height: 24px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  transition: all 0.4s;\n}\n\n.card__chart__close {\n  position: absolute;\n  right: 10px;\n  top: 0;\n  bottom: 0;\n  margin-top: auto;\n  margin-bottom: auto;\n  width: 20px;\n  height: 20px;\n  transform: rotate(180deg);\n}\n\n.card__chart__close__icon {\n  height: 100%;\n  width: 100%;\n  cursor: pointer;\n}\n\n.card__chart__dropdown__selected .card__chart__dropdown__selected__arrow:hover {\n  border-bottom: 2px solid #2658aa;\n  border-right: 2px solid #2658aa;\n  transform: rotate(45deg);\n  width: 7px;\n  height: 7px;\n}\n\n.filter__block {\n  position: fixed;\n  right: -100%;\n  bottom: 0;\n  height: calc(100% - 90px);\n  width: 338px;\n  box-shadow: 10px 10px 30px rgba(174, 174, 192, 0.4);\n  z-index: 2;\n  border-radius: 0 15px 15px 15px;\n}\n.filter__block.open {\n  right: 0;\n}\n\n.filter__block__scroll {\n  overflow-x: hidden;\n  overflow-y: auto;\n  position: relative;\n  width: 100%;\n  height: 100%;\n  padding: 15px;\n  background: #F0F0F3;\n  z-index: 2;\n}\n\n.filter__block__btn__block {\n  position: absolute;\n  top: 0;\n  left: -75px;\n  width: 90px;\n  height: 60px;\n  background: #F0F0F3;\n  box-shadow: 10px 10px 30px rgba(174, 174, 192, 0.4);\n  border-radius: 15px 0 0 15px;\n  z-index: 1;\n}\n\n.filter__block__title {\n  text-align: center;\n  margin-bottom: 30px;\n  font-weight: bold;\n  font-size: 22px;\n  line-height: 28px;\n  color: #364048;\n}\n\n.risk__btn__row {\n  display: flex;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.risk__btn {\n  width: 40px;\n  height: 40px;\n  background: #F0F0F3;\n  box-shadow: -2px -2px 6px #FFFFFF, 2px 2px 6px rgba(174, 174, 192, 0.4039215686);\n  border-radius: 8px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.4s;\n  cursor: pointer;\n  outline: none;\n  margin-right: 16px;\n  border: 0;\n}\n\n.risk__btn__text {\n  font-weight: 600;\n  font-size: 18px;\n  display: inline-flex;\n  color: #364048;\n}\n\n.asset__wrapper {\n  margin-bottom: 10px;\n}\n\n.asset__title {\n  text-align: center;\n  margin-bottom: 12px;\n  font-size: 22px;\n  line-height: 28px;\n  color: #364048;\n}\n\n.asset__block {\n  width: 100%;\n  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.7);\n  border-radius: 17px;\n  list-style-type: none;\n  overflow: hidden;\n  max-height: 160px;\n  overflow: auto;\n  min-height: auto;\n}\n\n.asset__list:nth-child(2n+1) {\n  background: #ebebee;\n  width: 98%;\n}\n\n.disabled__asset__list {\n  background: #ebebee !important;\n}\n\n.asset__list__check {\n  display: none;\n}\n.asset__list__check:checked ~ .asset__list__label .asset__list__box:after {\n  opacity: 1;\n}\n\n.asset__list__label {\n  display: inline-flex;\n  align-items: center;\n  padding: 8px;\n}\n\n.asset__list__box {\n  width: 24px;\n  height: 24px;\n  box-shadow: inset 2px 2px 2px rgba(174, 174, 192, 0.2), inset -2px -2px 2px rgba(255, 255, 255, 0.7);\n  border-radius: 6px;\n  display: inline-flex;\n  margin-right: 14px;\n  position: relative;\n}\n.asset__list__box:after {\n  content: \"\";\n  width: 6px;\n  height: 12px;\n  border-bottom: 2px solid #364048;\n  border-right: 2px solid #364048;\n  transform: rotate(40deg) skew(2deg);\n  position: absolute;\n  left: 8px;\n  top: 2px;\n  display: inline-flex;\n  opacity: 0;\n  transition: all 0.4s;\n}\n\n.asset__list__text {\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 23px;\n}\n\n.reset__btn {\n  position: absolute;\n  right: 8px;\n  top: 8px;\n  width: 40px;\n  height: 40px;\n  background: #F0F0F3;\n  box-shadow: -2px -2px 6px #FFFFFF, 2px 2px 6px rgba(174, 174, 192, 0.4039215686);\n  border-radius: 8px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.4s;\n  cursor: pointer;\n  outline: none;\n  border: 0;\n}\n\n.filter__icon {\n  position: relative;\n  z-index: 9999;\n}\n\n.header {\n  height: 80px;\n  min-height: 80px;\n  box-shadow: inset 10px 10px 10px rgba(174, 174, 192, 0.2), inset -10px -10px 10px rgba(255, 255, 255, 0.5019607843);\n  width: 100%;\n  background: #F0F0F3;\n  padding: 0 25px 0 120px;\n  position: relative;\n  z-index: 1;\n  transition: all 0.4s;\n}\n.header.open {\n  padding-left: 296px;\n}\n.header .row {\n  height: 100%;\n  align-items: center;\n}\n.header__title {\n  font-weight: 700;\n  line-height: 27px;\n  font-size: 22px;\n  transition: all 0.4s;\n}\n.open .header__title {\n  font-size: 26px;\n  line-height: 32px;\n}\n.header__right {\n  display: flex;\n  margin-left: auto;\n  align-items: center;\n  height: 100%;\n}\n\n.notification {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.notification__btn {\n  border: 0;\n  background-color: transparent;\n  cursor: pointer;\n  font-size: 17px;\n  position: relative;\n  color: #868e95;\n}\n.notification__status {\n  background: #F5B452;\n  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.2509803922);\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  position: absolute;\n  top: -5px;\n  right: -2px;\n}\n\n.user {\n  height: 48px;\n  width: 145px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 40px;\n  flex-wrap: wrap;\n  transition: all 0.4s;\n  cursor: pointer;\n}\n.user.open {\n  border-radius: 24px;\n  width: 145px;\n  height: 136px;\n  background: #F0F0F3;\n  box-shadow: -4px -4px 12px #FFFFFF, 4px 4px 12px rgba(174, 174, 192, 0.4039215686);\n  align-self: flex-start;\n}\n.user.open .log__out {\n  display: inline-flex;\n}\n.user.open:before, .user.open:after {\n  display: none;\n}\n.user:before, .user:after {\n  content: \"\";\n  box-shadow: inset 10px 10px 10px rgba(174, 174, 192, 0.2);\n  border-radius: 67px;\n  height: 100%;\n  width: 3px;\n  position: absolute;\n  top: 0;\n}\n.user:before {\n  left: 0;\n}\n.user:after {\n  right: 0;\n}\n.user__avatar {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  margin-right: 20px;\n}\n.user__name {\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 18px;\n}\n.user .log__out {\n  width: 100%;\n  cursor: pointer;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  padding-top: 14px;\n  margin-bottom: 10px;\n  display: none;\n}\n.user .log__out:before {\n  position: absolute;\n  top: 0;\n  content: \"\";\n  width: 112px;\n  height: 4px;\n  box-shadow: inset 2px 2px 2px rgba(174, 174, 192, 0.2), inset -2px -2px 2px rgba(255, 255, 255, 0.6980392157);\n  border-radius: 67px;\n}\n.user .log__out__icon {\n  margin-right: 8px;\n}\n\n.setting__btn {\n  border: 0;\n  cursor: pointer;\n  color: #868e95;\n  font-size: 16px;\n}\n\n.zoom__page__btn {\n  position: relative;\n  cursor: pointer;\n}\n.zoom__page__btn .zoom__page__btn__minus,\n.zoom__page__btn .zoom__page__btn__plus {\n  position: absolute;\n  width: 25px;\n  height: 25px;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  margin: auto;\n  display: inline-block;\n  transition: opacity 0.4s;\n}\n.zoom__page__btn .zoom__page__btn__minus {\n  opacity: 0;\n  visibility: hidden;\n}\n\n.logo {\n  width: 32px;\n  height: 36px;\n  margin-top: 10px;\n  margin-bottom: 45px;\n  position: relative;\n}\n.logo__img {\n  width: 100%;\n  height: 100%;\n}\n.logo__img__big {\n  width: 0;\n  height: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  margin: auto;\n  transition: all 0.4s;\n}\n\n.nav {\n  width: 96px;\n  height: 100vh;\n  background: #F0F0F3;\n  box-shadow: inset 0 3px 6px rgba(0, 0, 0, 0.1607843137), 3px 0 6px rgba(67, 96, 121, 0.1490196078);\n  position: fixed;\n  top: 0;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  z-index: 3;\n  padding-right: 10px;\n  transition: all 0.4s;\n}\n.nav.open {\n  width: 272px;\n}\n.nav.open .logo {\n  width: 200px;\n}\n.nav.open .logo__img {\n  display: none;\n}\n.nav.open .logo__img__big {\n  display: inline-block;\n  width: 100%;\n  height: 100%;\n}\n.nav.open .nav__link {\n  width: 208px;\n}\n.nav.open .nav__link .nav__text {\n  font-size: 20px;\n  position: relative;\n  opacity: 1;\n  visibility: visible;\n  color: #364048;\n}\n.nav__block {\n  list-style-type: none;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.nav__list {\n  margin-bottom: 10px;\n}\n.nav__list.trash {\n  margin-top: auto;\n}\n.nav__link {\n  font-size: 30px;\n  text-decoration: none;\n  padding: 16px;\n  display: inline-flex;\n  color: #7e92a3;\n  transition: all 0.4s;\n  width: 64px;\n  height: 64px;\n  align-items: center;\n  justify-content: center;\n}\n.nav__link:hover, .nav__link.active {\n  background: #F0F0F3;\n  box-shadow: inset -3px -3px 3px rgba(255, 255, 255, 0.6980392157), inset 0px 3px 6px rgba(0, 0, 0, 0.1607843137), 3px 0px 6px rgba(67, 96, 121, 0.1490196078);\n  border-radius: 12px;\n  color: #2267a4;\n}\n.nav__link:hover .trash__icon, .nav__link.active .trash__icon {\n  filter: brightness(0) saturate(100%) invert(33%) sepia(7%) saturate(5984%) hue-rotate(169deg) brightness(102%) contrast(91%);\n}\n.nav__link i {\n  position: relative;\n  z-index: 1;\n}\n.nav__link .nav__text {\n  display: inline-flex;\n  color: transparent;\n  margin-right: auto;\n  margin-left: 15px;\n  white-space: nowrap;\n  font-size: 0;\n  transition: font-size 0.2s, visibility 0.4s, opacity 0.4s;\n  opacity: 0;\n  visibility: hidden;\n  position: absolute;\n}\n\n.trash__icon {\n  height: 25px;\n}\n\n.menu__open {\n  background: #F0F0F3;\n  box-shadow: inset 0px 3px 6px rgba(0, 0, 0, 0.1607843137), 3px 0px 6px rgba(67, 96, 121, 0.1490196078);\n  width: 106px;\n  height: 106px;\n  position: absolute;\n  border-radius: 50%;\n  top: 50%;\n  right: -53px;\n  clip-path: polygon(0 0, 50% 0, 50% 100%, 0% 100%);\n  transition: all 0.4s;\n}\n.menu__open.open .menu__open__btn {\n  transform: rotate(180deg);\n}\n\n.menu__open__btn {\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  background: #F0F0F3;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: -2px -2px 6px #FFFFFF, 2px 2px 6px rgba(174, 174, 192, 0.4039215686);\n  cursor: pointer;\n  position: absolute;\n  margin-top: auto;\n  margin-bottom: auto;\n  top: 0;\n  bottom: 0;\n  left: 10px;\n  transition: all 0.4s;\n}\n\n.main {\n  height: calc(100vh - 56px);\n  overflow: hidden;\n  padding-left: 72px;\n  background: #F0F0F3;\n  display: flex;\n  width: 100%;\n  transition: padding-left 0.4s;\n}\n.main.open {\n  padding-left: 325px;\n}\n.main.setting_main:after {\n  display: none;\n}\n.main.empty__trash {\n  position: relative;\n}\n.main.empty__trash + .main:after {\n  display: none;\n}\n.main:after {\n  content: \"\";\n  width: 8px;\n  height: calc(100vh - 110px);\n  position: absolute;\n  right: 338px;\n  top: 100px;\n  box-shadow: inset 4px 4px 4px rgba(174, 174, 192, 0.2), inset -4px -4px 4px rgba(255, 255, 255, 0.6980392157);\n  border-radius: 67px;\n}\n.main .content {\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 56px 24px 24px 24px;\n  height: 100%;\n  width: calc(100% - 338px);\n  margin-left: 24px;\n  margin-top: -24px;\n  position: relative;\n}\n.main .content::-webkit-scrollbar-track {\n  box-shadow: unset;\n}\n.main .content::-webkit-scrollbar-track-piece:end {\n  background: transparent;\n}\n.main .content::-webkit-scrollbar-track-piece:start {\n  background: transparent;\n}\n.main .content.list {\n  padding-left: 120px;\n}\n\n.to__top {\n  position: fixed;\n  right: 362px;\n  margin-left: auto;\n  bottom: 24px;\n  z-index: 3;\n  width: 40px;\n  height: 40px;\n  background: #F0F0F3;\n  box-shadow: -2px -2px 6px #FFFFFF, 2px 2px 6px rgba(174, 174, 192, 0.4039215686);\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.4s;\n  cursor: pointer;\n}\n.to__top__icon {\n  width: 26px;\n  height: 26px;\n}\n\n.zoom__page__btn,\n.layout__list,\n.layout__grid {\n  margin-left: auto;\n  width: 45px;\n  height: 45px;\n  background: #F0F0F3;\n  box-shadow: -2px -2px 6px #FFFFFF, 2px 2px 6px rgba(174, 174, 192, 0.4039215686);\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.4s;\n  margin-bottom: 24px;\n  margin-top: 10px;\n  cursor: pointer;\n}\n\n.empty__trash__title {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  margin: auto;\n  width: max-content;\n  height: max-content;\n  font-size: 100px;\n  font-weight: normal;\n  font-style: normal;\n  letter-spacing: 0;\n  color: transparent;\n  background: rgba(102, 102, 102, 0.2);\n  -webkit-background-clip: text;\n  -moz-background-clip: text;\n  background-clip: text;\n  padding-right: 5px;\n  text-shadow: 0px 3px 3px rgba(255, 255, 255, 0.5);\n}\n\n.light_core_activate_title {\n  font-size: 30px;\n}\n\n.light_core_activate_text {\n  font-size: 40px;\n}\n\n.light_core_activate_text, .light_core_activate_title {\n  margin: auto;\n  width: max-content;\n  height: max-content;\n  font-weight: normal;\n  font-style: normal;\n  letter-spacing: 0;\n  color: transparent;\n  background: rgba(102, 102, 102, 0.4);\n  -webkit-background-clip: text;\n  -moz-background-clip: text;\n  background-clip: text;\n  text-shadow: 0 3px 3px rgba(255, 255, 255, 0.5);\n}\n\n.trash__clean {\n  position: fixed;\n  display: inline-flex;\n  bottom: 58px;\n  left: -1px;\n  z-index: 3;\n  width: 80px;\n  height: 60px !important;\n  background: #f7f7f9;\n  box-shadow: unset;\n  color: #2267A4;\n  backdrop-filter: blur(7px);\n  -webkit-backdrop-filter: blur(7px);\n  border-radius: 14px;\n  justify-content: flex-start;\n}\n.trash__clean:hover .trash__text__all {\n  text-decoration: none;\n}\n.trash__clean .trash__text__all {\n  text-decoration: underline;\n  margin-left: 10px;\n}\n\n.trash__icon__wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin-left: 20px;\n  margin-top: 10px;\n}\n.trash__icon__wrapper .trash__icon {\n  filter: brightness(0) saturate(100%) invert(33%) sepia(7%) saturate(5984%) hue-rotate(169deg) brightness(102%) contrast(91%);\n}\n\n.aside {\n  width: 338px;\n  padding: 24px;\n  overflow-y: auto;\n  height: 100%;\n  flex-direction: column;\n  align-items: center;\n  overflow-x: hidden;\n}\n\n.add__wallet__btn {\n  box-shadow: -4px -4px 12px #FFFFFF, 4px 4px 12px rgba(174, 174, 192, 0.4039215686);\n  background-color: #f0f0f3;\n  border-radius: 24px;\n  width: 288px;\n  height: 88px;\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  padding-left: 24px;\n  padding-right: 30px;\n  justify-content: space-between;\n  font-size: 24px;\n  color: #364048;\n  text-transform: capitalize;\n  font-weight: 600;\n  transition: all 0.4s;\n}\n.add__wallet__btn:hover {\n  background: #F5F5FA;\n  color: #1762A2;\n}\n.add__wallet__btn.defi {\n  padding: 0 16px;\n}\n.add__wallet__btn.defi .add__wallet__btn__plus {\n  width: 88px;\n  height: 56px;\n  border-radius: 157px;\n  padding: 0 8px;\n  margin-right: 12px;\n}\n\n.add__wallet__btn__plus {\n  background: #F0F0F3;\n  box-shadow: inset 10px 10px 10px rgba(174, 174, 192, 0.2), inset -10px -10px 10px rgba(255, 255, 255, 0.6980392157);\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.add__wallet__btn__plus.defi {\n  width: auto;\n}\n.add__wallet__btn__plus .fox {\n  width: 32px;\n  height: 25px;\n  margin-right: 8px;\n}\n.add__wallet__btn__plus .coinbase {\n  width: 25px;\n  height: 25px;\n}\n\n.add__wallet__btn__plus__bg {\n  background: #1762A2;\n  width: 35px;\n  height: 35px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: inset 2px 2px 2px rgba(255, 255, 255, 0.44), 10px 10px 30px rgba(174, 174, 192, 0.44), inset -2px -2px 2px rgba(29, 29, 29, 0.2549019608), -10px -10px 30px #FFFFFF;\n  position: relative;\n  cursor: pointer;\n}\n.add__wallet__btn__plus__bg span {\n  width: 12px;\n  height: 2px;\n  background: #F0F0F3;\n  border-radius: 2px;\n  position: absolute;\n}\n.add__wallet__btn__plus__bg span:nth-child(2) {\n  transform: rotate(90deg);\n}\n\n.aside__wallet__title {\n  color: #364048;\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 32px;\n  margin-top: 39px;\n  margin-bottom: 25px;\n  text-align: center;\n}\n\n.aside__chart__wrapper {\n  position: relative;\n  margin-bottom: 45px;\n  height: 315px;\n}\n.aside__chart__wrapper.cold .card__risk__chart__min {\n  border-color: #4DC7B5;\n}\n.aside__chart__wrapper.cold .card__risk__chart__number__of,\n.aside__chart__wrapper.cold .card__risk__chart__number {\n  color: #4DC7B5;\n}\n.aside__chart__wrapper.cold .card__risk__info:hover {\n  background: #4DC7B5;\n  color: #ffffff;\n}\n.aside__chart__wrapper.hold .card__risk__chart__min {\n  border-color: #EFB661;\n}\n.aside__chart__wrapper.hold .card__risk__chart__number__of,\n.aside__chart__wrapper.hold .card__risk__chart__number {\n  color: #EFB661;\n}\n.aside__chart__wrapper.hold .card__risk__info:hover {\n  background: #EFB661;\n  color: #ffffff;\n}\n.aside__chart__wrapper.risky .card__risk__chart__min {\n  border-color: #F27281;\n}\n.aside__chart__wrapper.risky .card__risk__chart__number__of,\n.aside__chart__wrapper.risky .card__risk__chart__number {\n  color: #F27281;\n}\n.aside__chart__wrapper.risky .card__risk__info:hover {\n  background: #F27281;\n  color: #ffffff;\n}\n.aside__chart__wrapper .card__risk__chart {\n  width: 232px;\n  height: 232px;\n  border-radius: 50%;\n  margin: 0 auto;\n}\n.aside__chart__wrapper .card__risk__chart > div {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.aside__chart__wrapper .card__risk__chart__min {\n  width: 178px;\n  height: 178px;\n  border-width: 20px;\n}\n.aside__chart__wrapper .card__risk__chart__number {\n  font-size: 35px;\n}\n.aside__chart__wrapper .card__risk__chart__number__of {\n  font-size: 19px;\n}\n.aside__chart__wrapper .card__risk__alert {\n  width: 90px;\n  height: 90px;\n  top: unset;\n  bottom: 6px;\n  right: -8px;\n  cursor: pointer;\n}\n.aside__chart__wrapper .card__risk__alert__title {\n  font-size: 20px;\n  line-height: 26px;\n}\n.aside__chart__wrapper .card__risk__alert__number {\n  font-size: 20px;\n  line-height: 26px;\n}\n.aside__chart__wrapper .card__risk__range__hr {\n  top: unset;\n  bottom: 47px;\n  left: 0;\n}\n\n.aside__tabs {\n  display: flex;\n  list-style-type: none;\n  justify-content: space-between;\n  position: relative;\n  margin-bottom: 34px;\n}\n.aside__tabs:after {\n  content: \"\";\n  width: calc(100% + 24px);\n  left: -12px;\n  bottom: -10px;\n  height: 3px;\n  box-shadow: inset 4px 4px 4px rgba(174, 174, 192, 0.2), inset -4px -4px 0px rgba(255, 255, 255, 0.6980392157);\n  position: absolute;\n  background: #F0F0F3;\n}\n.aside__tabs__link {\n  text-decoration: none;\n  color: #9CA3A8;\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 23px;\n  position: relative;\n  display: flex;\n  border: none;\n  outline: none;\n}\n.aside__tabs__link:after {\n  content: \"\";\n  width: 0;\n  transition: all 0.4s;\n  height: 3px;\n  background: #2658AA;\n  box-shadow: inset -2px -2px 2px rgba(29, 29, 29, 0.2549019608), -10px -10px 30px #FFFFFF;\n  border-radius: 67px;\n  position: absolute;\n  bottom: -10px;\n  z-index: 1;\n}\n.aside__tabs__link:hover, .aside__tabs__link.active {\n  color: #364048;\n}\n.aside__tabs__link:hover:after, .aside__tabs__link.active:after {\n  width: 100%;\n}\n\n.aside__card {\n  background: #F0F0F3;\n  box-shadow: -5px -5px 15px #FFFFFF, 5px 5px 15px rgba(174, 174, 192, 0.4039215686);\n  border-radius: 24px;\n  padding: 21px 24px 15px;\n  position: relative;\n  margin-bottom: 24px;\n}\n.aside__card.cold .aside__card__progress__bg {\n  background: #28B663;\n}\n.aside__card.hot .aside__card__progress__bg {\n  background: #EFB661;\n}\n.aside__card__title {\n  color: #9CA3A8;\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 23px;\n  margin-bottom: 8px;\n}\n.aside__card__numbers {\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 32px;\n  display: flex;\n  align-items: flex-end;\n  margin-bottom: 15px;\n}\n.aside__card__numbers span {\n  font-size: 14px;\n  display: flex;\n  margin-bottom: -10px;\n}\n.aside__card__progress {\n  width: 100%;\n  height: 8px;\n  box-shadow: inset 4px 4px 4px rgba(174, 174, 192, 0.2), inset -4px -4px 0px rgba(255, 255, 255, 0.6980392157);\n  border-radius: 67px;\n  background: #F0F0F3;\n}\n.aside__card__progress__bg {\n  height: 100%;\n  box-shadow: inset -2px -2px 2px rgba(29, 29, 29, 0.2549019608), -10px -10px 30px #FFFFFF, inset 4px 4px 4px rgba(174, 174, 192, 0.2);\n  border-radius: 67px;\n  transition: all 0.4s;\n}\n.aside__card .card__risk__alert {\n  position: relative;\n  margin-left: auto;\n  font-weight: 600;\n  width: 64px;\n  height: 64px;\n  top: 4px;\n  right: -11px;\n}\n.aside__card .card__risk__alert__number,\n.aside__card .card__risk__alert__title {\n  line-height: 16px;\n  font-size: 16px;\n}\n.aside__card .card__risk__range__hr {\n  width: 105px;\n  top: 60px;\n  left: 80px;\n}\n\n.wallet__type {\n  width: 168px;\n  padding: 9px 0;\n  position: relative;\n  border-radius: 24px;\n  box-shadow: -3px -3px 9px 0 #fff, 3px 3px 9px 0 rgba(174, 174, 192, 0.4);\n  background-color: #ededef;\n  cursor: pointer;\n  position: absolute;\n}\n.wallet__type__item {\n  font-size: 18px;\n  font-weight: 600;\n  letter-spacing: normal;\n  text-align: center;\n  width: 100%;\n  margin-top: 12px;\n  display: flex;\n  align-items: center;\n  padding-left: 18px;\n  color: #364048;\n}\n.wallet__type__item:nth-of-type(1) {\n  margin-top: 0;\n}\n.wallet__type .wallet__type__arrow {\n  position: absolute;\n  right: 17px;\n  top: 17px;\n  filter: brightness(0) saturate(100%) invert(24%) sepia(8%) saturate(958%) hue-rotate(165deg) brightness(93%) contrast(94%);\n  height: 8px;\n  cursor: pointer;\n}\n\n.wallet__type__btn {\n  width: 336px;\n  height: 48px;\n  border-radius: 80px;\n  background: #F0F0F3;\n  margin-left: 40px;\n  color: #889096;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 500;\n  font-size: 18px;\n  box-shadow: inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157), inset 5px 5px 5px rgba(174, 174, 192, 0.2);\n  border: none;\n  outline: none;\n  text-align: center;\n  padding: 0 10px;\n}\n\n.wallet__type__btn::placeholder {\n  font-weight: 600;\n  font-size: 18px;\n  color: #889096;\n  font-weight: 500;\n}\n\n.wallet__type__save {\n  width: 104px;\n  height: 40px;\n  border-radius: 67px;\n  box-shadow: -5px -5px 15px 0 #fff, 5px 5px 15px 0 rgba(174, 174, 192, 0.4);\n  background-color: #214175;\n  font-size: 18px;\n  font-weight: 400;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  margin-left: auto;\n  cursor: pointer;\n  border: 0;\n}\n\n.wallet__addresses {\n  border-radius: 22px;\n  background-color: #ededef;\n  padding: 24px;\n  margin-top: 24px;\n}\n\n.wallet__addresses__top {\n  position: relative;\n}\n.wallet__addresses__top .card__close {\n  position: absolute;\n}\n\n.wallet__addresses__top__left {\n  margin-right: 16px;\n}\n.wallet__addresses__top__label {\n  margin-bottom: 4px;\n  font-size: 22px;\n  font-weight: 600;\n  line-height: 1.36;\n  text-align: left;\n  color: #364048;\n}\n\n.wallet__addresses__top__middle {\n  margin-right: 16px;\n}\n.wallet__addresses__top__middle .wallet__addresses__top__label {\n  margin-left: 70px;\n}\n\n.wallet__addresses__top__input__wrapper {\n  width: 584px;\n  height: 48px;\n  border-radius: 80px;\n  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);\n  background: #EDEDEF;\n  margin-bottom: 8px;\n  display: flex;\n  align-items: center;\n  padding: 8px;\n}\n\n.wallet__addresses__top__input {\n  width: calc(100% - 32px);\n  height: 100%;\n  background-color: transparent;\n  border: 0;\n  text-align: center;\n  outline: none;\n  font-size: 18px;\n  font-weight: 600;\n  color: #364048;\n}\n\n.wallet__addresses__top__input__add {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  background: #EDEDEF;\n  box-shadow: -2px -2px 6px #FFFFFF, 2px 2px 6px rgba(174, 174, 192, 0.4039215686);\n  border-radius: 24px;\n  width: 32px;\n  height: 32px;\n  border: 0;\n  outline: none;\n  cursor: pointer;\n}\n.wallet__addresses__top__input__add span {\n  width: 12px;\n  height: 2px;\n  background: #2167A4;\n  border-radius: 2px;\n  position: absolute;\n}\n.wallet__addresses__top__input__add span:nth-child(2) {\n  transform: rotate(90deg);\n}\n\n.wallet__addresses__top__right__btn {\n  width: 112px;\n  height: 48px;\n  padding: 9px 0;\n  position: relative;\n  border-radius: 24px;\n  box-shadow: -3px -3px 9px 0 #fff, 3px 3px 9px 0 rgba(174, 174, 192, 0.4);\n  background-color: #ededef;\n  font-size: 18px;\n  color: #364048;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 0;\n  cursor: pointer;\n  outline: none;\n  font-weight: 500;\n}\n\n.limit__block {\n  width: 168px;\n  height: 96px;\n  background: #EDEDEF;\n  border-radius: 21px;\n}\n.limit__block__bottom, .limit__block__top {\n  height: 50%;\n  font-size: 18px;\n  line-height: 23px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  outline: none;\n  width: 100%;\n  text-align: center;\n  cursor: pointer;\n}\n.limit__block .limit__block__bottom::placeholder {\n  color: #4DC7B5;\n  font-weight: 600;\n  font-size: 13px;\n  line-height: 23px;\n}\n.limit__block__top {\n  color: #364048;\n  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);\n  border-radius: 21px 21px 0 0;\n}\n.limit__block__top.active .limit__block__top__slider {\n  opacity: 1;\n  visibility: visible;\n}\n.limit__block__top {\n  position: relative;\n}\n.limit__block__bottom {\n  color: #4DC7B5;\n  font-weight: 600;\n  background-color: #f0f0f3;\n  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);\n  border-radius: 0 0 21px 21px;\n}\n\n.limit__block__wrapper {\n  display: flex;\n  padding: 16px;\n  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);\n  border-radius: 0 21px 21px 21px;\n}\n\n.wallet__addresses__bottom {\n  display: flex;\n  align-items: flex-end;\n  margin-top: 10px;\n}\n.wallet__addresses__bottom .limit__block {\n  margin-right: 16px;\n}\n.wallet__addresses__bottom .limit__block:last-child {\n  margin-right: 0;\n}\n\n.wallet__addresses__bottom__right,\n.wallet__addresses__bottom__left {\n  padding-bottom: 15px;\n}\n\n.wallet__addresses__bottom__middle {\n  margin-left: 16px;\n  margin-right: 32px;\n}\n\n.limit__block__tabs {\n  list-style-type: none;\n  display: flex;\n}\n\n.limit__block__tabs__list {\n  padding: 14px 16px 8px;\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 26px;\n  color: #364048;\n  background: #EDEDEF;\n  box-shadow: -2px 0px 6px rgba(174, 174, 192, 0.1843137255);\n  border-radius: 24px 24px 0 0;\n  cursor: pointer;\n  transition: all 0.4s;\n}\n.limit__block__tabs__list.active {\n  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);\n}\n\n.anomalies__label {\n  width: 112px;\n  height: 112px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: -3px -3px 9px #FFFFFF, 3px 3px 9px rgba(174, 174, 192, 0.4039215686);\n}\n\n.anomalies__check {\n  display: none;\n}\n.anomalies__check:checked ~ .anomalies__label {\n  background: transparent linear-gradient(51deg, #EDEDEF 0%, #DEE5F0 100%) 0% 0% no-repeat padding-box;\n  box-shadow: inset 4px 4px 4px rgba(174, 174, 192, 0.2), inset -4px -4px 2px rgba(255, 255, 255, 0.6980392157);\n}\n.anomalies__check:checked ~ .anomalies__label .anomalies__check__box:after {\n  opacity: 1;\n  visibility: visible;\n}\n\n.anomalies__text {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 18px;\n  color: #364048;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  flex-direction: column;\n  margin-bottom: 6px;\n}\n\n.anomalies__check__box {\n  width: 24px;\n  display: flex;\n  height: 24px;\n  box-shadow: inset 2px 2px 2px rgba(174, 174, 192, 0.2), inset -2px -2px 2px rgba(255, 255, 255, 0.6980392157);\n  border-radius: 6px;\n  position: relative;\n  margin-top: 12px;\n}\n.anomalies__check__box:after {\n  content: \"\";\n  width: 6px;\n  position: absolute;\n  left: 8px;\n  top: 2px;\n  height: 12px;\n  border-bottom: 2px solid #364048;\n  border-right: 2px solid #364048;\n  transform: rotate(45deg) skew(10deg);\n  opacity: 0;\n  visibility: hidden;\n}\n\n.limit__block__top__slider {\n  background: #EDEDEF;\n  box-shadow: -2px -2px 6px #ffffff, 2px 2px 6px rgba(174, 174, 192, 0.4);\n  width: 150px;\n  height: 150px;\n  border-radius: 50%;\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  top: -51px;\n  opacity: 0;\n  transition: all 0.4s;\n  visibility: hidden;\n  margin: auto;\n  left: 10px;\n  flex-direction: column;\n}\n\n.limit__block__top__slider__info {\n  width: 152px;\n  height: 152px;\n  box-shadow: inset 0 3px 6px rgba(0, 0, 0, 0.1607843137), 0 3px 6px rgba(0, 0, 0, 0.1607843137);\n  border-radius: 50%;\n  border: 20px solid #214175;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n\n.limit__block__top__slider__info__time {\n  color: #214175;\n  font-weight: bold;\n  font-size: 26px;\n  line-height: 34px;\n}\n\n.limit__block__top__slider__info__time__of {\n  color: #214175;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 18px;\n}\n\n.whitelist__ad__block {\n  position: absolute;\n  background: #F0F0F3;\n  box-shadow: 0 5px 15px rgba(56, 70, 82, 0.2509803922);\n  border-radius: 20px;\n  width: 920px;\n  padding: 32px 32px 24px;\n  left: 0;\n  top: 90px;\n  z-index: 1;\n}\n.whitelist__ad__block .row {\n  justify-content: space-between;\n}\n\n.whitelist__ad__block__bottom {\n  width: 100%;\n  position: relative;\n  margin-top: 8px;\n}\n.whitelist__ad__block__bottom .add__wallet__btn__plus__bg {\n  margin: 0 auto;\n  cursor: pointer;\n  display: flex;\n}\n.whitelist__ad__block__bottom .dropdown {\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.whitelist__ad__block__input__wrapper {\n  width: 416px;\n  height: 48px;\n  border-radius: 80px;\n  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);\n  background: #EDEDEF;\n  margin: 8px 8px 8px 0;\n  display: flex;\n  align-items: center;\n  padding: 8px;\n}\n\n.whitelist__ad__block__input {\n  width: 100%;\n  height: 100%;\n  background-color: transparent;\n  border: 0;\n  text-align: center;\n  outline: none;\n  font-size: 15px;\n  line-height: 23px;\n  color: #364048;\n}\n\n.wallet__unstaking .unstacking {\n  right: -45px;\n  bottom: -40px;\n}\n\n.card__unstaking__slider .rangeslider-vertical .rangeslider__handle-label {\n  background: #385483;\n}\n\n.card__unstaking__slider .rangeslider-vertical .rangeslider__fill {\n  background: #385483;\n}\n\n.card.defi {\n  padding-top: 8px;\n  position: relative;\n}\n.card.defi .card__header .row {\n  align-items: center;\n}\n.card.defi .card__wallet__row {\n  background-color: transparent;\n}\n.card.defi .card__wallet__rates {\n  color: #889096;\n}\n.card.defi .card__wallet__usd {\n  color: #364048;\n  font-weight: bold;\n}\n.card.defi .card__product__row {\n  padding-bottom: 0;\n}\n.card.defi .card__title {\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n}\n.card.defi .card__header {\n  padding: 10px 0;\n}\n.card.defi .card__header .row {\n  align-items: center;\n  justify-content: center;\n}\n.card.defi .card__price {\n  margin-bottom: 5px;\n}\n.card.defi .card__risk__title {\n  margin-bottom: 10px;\n}\n\n.card__product__stake__amount {\n  opacity: 0;\n  visibility: hidden;\n  position: fixed;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  width: 408px;\n  background: #F0F0F3;\n  box-shadow: 10px 10px 30px rgba(111, 111, 132, 0.4039215686);\n  border-radius: 12px;\n  z-index: 999999999999999;\n  padding: 24px 16px 16px 24px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  margin: auto;\n}\n.card__product__stake__amount.open {\n  visibility: visible;\n  opacity: 1;\n}\n\n.card__product__stake__amount__input__wrapper {\n  width: 224px;\n  height: 48px;\n  border-radius: 80px;\n  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);\n  background: #EDEDEF;\n  margin-bottom: 8px;\n  display: flex;\n  align-items: center;\n  padding: 8px;\n}\n\n.card__product__stake__amount__input {\n  width: 100%;\n  height: 100%;\n  background-color: transparent;\n  border: 0;\n  text-align: center;\n  outline: none;\n  font-size: 18px;\n  font-weight: 600;\n  color: #364048;\n}\n\n.card__product__stake__amount__max {\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 23px;\n  width: 128px;\n  height: 48px;\n  color: #364048;\n  border-radius: 24px;\n  box-shadow: -3px -3px 9px 0 #fff, 3px 3px 9px 0 rgba(174, 174, 192, 0.4);\n  background-color: #ededef;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 0;\n  cursor: pointer;\n  outline: none;\n}\n\n.card__product__stake__amount__confirm {\n  width: 100%;\n  height: 40px;\n  border-radius: 67px;\n  box-shadow: -5px -5px 15px 0 #fff, 5px 5px 15px 0 rgba(174, 174, 192, 0.4);\n  background-color: #214175;\n  font-size: 18px;\n  font-weight: 400;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  cursor: pointer;\n  border: 0;\n  margin-top: 8px;\n}\n\n.unstacking {\n  width: 95px;\n  height: 95px;\n  border-radius: 50%;\n  background: #F0F0F3;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: -3px -3px 9px #FFFFFF, 3px 3px 9px rgba(174, 174, 192, 0.4039215686);\n  color: #889096;\n  font-size: 16px;\n  line-height: 18px;\n  flex-direction: column;\n  text-align: center;\n  position: absolute;\n  right: -13px;\n  bottom: -18px;\n  transition: all 0.4s;\n}\n.unstacking span {\n  color: #F27281;\n}\n.unstacking.active, .unstacking:hover {\n  box-shadow: unset;\n  color: rgba(136, 144, 150, 0.49);\n}\n.unstacking.active span, .unstacking:hover span {\n  color: rgba(136, 144, 150, 0.49);\n}\n\n.add__defi__block {\n  width: 56px;\n  padding: 16px 0;\n  background: #F0F0F3;\n  box-shadow: inset 4px 4px 4px rgba(174, 174, 192, 0.2), inset -4px -4px 4px rgba(255, 255, 255, 0.6980392157);\n  border-radius: 10px;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  position: absolute;\n  right: 0px;\n  top: 320px;\n}\n\n.contract__address_container {\n  width: 660px;\n  height: fit-content;\n  background: #F0F0F3;\n  box-shadow: -8px -8px 24px #ffffff, 8px 8px 24px rgba(174, 174, 192, 0.4);\n  padding: 20px;\n  border-radius: 24px;\n  position: absolute;\n  z-index: 9999;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  top: 0;\n}\n\n.add__defi__item {\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #F0F0F3;\n  border-radius: 8px;\n  margin-bottom: 16px;\n  cursor: pointer;\n}\n.add__defi__item:nth-child(1) {\n  height: auto;\n  margin-bottom: 8px;\n  box-shadow: unset;\n  background-color: transparent;\n}\n.add__defi__item:last-child {\n  margin-bottom: 0;\n}\n\n.defi_shild__modal .ReactModal__Content .ReactModal__Content--after-open {\n  background: none !important;\n  border: none !important;\n  max-width: 320px !important;\n  height: 490px !important;\n}\n\n.defi_shild__modal {\n  max-width: 320px !important;\n  height: 490px !important;\n  margin: 112px 116px;\n}\n\n.add_investment_btn {\n  margin: 20px auto !important;\n}\n\n.card__product__title_item {\n  font-weight: bold;\n}\n\n.title_item {\n  display: flex;\n  justify-content: flex-end;\n}\n\n::-webkit-scrollbar-track {\n  background: none !important;\n  box-shadow: none !important;\n}\n\n.defi__select__wrapper {\n  display: flex !important;\n  justify-content: space-between !important;\n  align-items: center !important;\n  text-align: center;\n  border-bottom: 1px solid rgba(174, 174, 192, 0.2) !important;\n}\n\n.investment_card .rangeslider-horizontal {\n  width: 117px !important;\n}\n\n.setting {\n  height: 100%;\n  width: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  padding-top: 50px;\n}\n.setting > .row {\n  width: 100%;\n  align-items: stretch;\n  height: 100%;\n}\n\n.user__info {\n  height: 865px;\n  width: 368px;\n  position: relative;\n  margin-left: 100px;\n  margin-right: 70px;\n}\n\n.user__info__avatar__block {\n  width: 100%;\n  height: 368px;\n  background: #F0F0F3 linear-gradient(132deg, #ECECF0 0%, #F2F2F5 100%) 0 0;\n  border-radius: 50%;\n  box-shadow: -8px -8px 15px #FFFFFF, 8px 8px 15px rgba(174, 174, 192, 0.4039215686);\n  position: relative;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.user__info__avatar__wrapper {\n  width: 336px;\n  height: 336px;\n  border-radius: 50%;\n  position: relative;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n.user__info__avatar__wrapper:hover .upload__content {\n  opacity: 1;\n}\n\n.user__info__desc__block {\n  width: 100%;\n  background: #F0F0F3;\n  box-shadow: -5px -5px 15px #FFFFFF, 5px 5px 15px rgba(174, 174, 192, 0.4039215686);\n  border-radius: 30px;\n  padding-top: 200px;\n  margin-top: -200px;\n  display: flex;\n  flex-direction: column;\n}\n\n.user__info__name {\n  font-weight: 600;\n  font-size: 22px;\n  line-height: 28px;\n  color: #364048;\n  text-align: center;\n  box-shadow: inset 0 5px 5px rgba(174, 174, 192, 0.2), inset 0px -5px 5px rgba(255, 255, 255, 0.6980392157);\n  margin-top: 25px;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.user__info__desc {\n  box-shadow: inset 0 5px 5px rgba(174, 174, 192, 0.2), inset 0px -5px 5px rgba(255, 255, 255, 0.6980392157);\n  text-align: center;\n  margin-top: 24px;\n  padding: 24px 32px;\n  margin-bottom: 99px;\n}\n\n.user__info__desc__text {\n  font-size: 22px;\n  line-height: 28px;\n  color: #364048;\n  border: none;\n  outline: none;\n  background: none;\n  text-align: center;\n  height: 250px;\n  resize: none;\n}\n\n.settings__tabs {\n  list-style-type: none;\n  display: flex;\n  position: relative;\n  z-index: 1;\n  max-width: max-content;\n}\n\n.settings__tabs__link {\n  padding: 32px 28px;\n  font-weight: 600;\n  font-size: 22px;\n  line-height: 28px;\n  color: #364048;\n  text-align: center;\n  text-decoration: none;\n  display: inline-flex;\n  width: 295px;\n  justify-content: center;\n  align-items: center;\n  transition: all 0.4s;\n  box-shadow: 5px 5px 5px rgba(174, 174, 192, 0.2);\n}\n.settings__tabs__link.active, .settings__tabs__link:hover {\n  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);\n  border-radius: 21px 21px 0 0;\n}\n\n.settings__tabs__list {\n  cursor: pointer;\n}\n.settings__tabs__list:first-child .settings__tabs__link {\n  border-top-left-radius: 21px;\n}\n.settings__tabs__list:last-child .settings__tabs__link {\n  border-top-right-radius: 21px;\n}\n\n.password__change__block {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 400px;\n  margin-left: 88px;\n}\n\n.password__change__block__title {\n  font-weight: 600;\n  font-size: 17px;\n  line-height: 19px;\n  color: #364048;\n  text-align: center;\n  margin-bottom: 16px;\n  margin-top: 10px;\n}\n\n.password__change__input {\n  width: 304px;\n  height: 48px;\n  background: #F0F0F3;\n  border: 0;\n  border-radius: 67px;\n  text-align: center;\n  font-size: 18px;\n  line-height: 23px;\n  font-weight: 600;\n  outline: none;\n  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);\n  margin-bottom: 16px;\n  display: inline-flex;\n}\n.password__change__input::placeholder {\n  color: #939A9F;\n}\n\n.password__change__btn {\n  width: 304px;\n  height: 40px;\n  box-shadow: -5px -5px 15px #FFFFFF, 5px 5px 15px rgba(174, 174, 192, 0.4039215686);\n  background: #214175;\n  color: #FFFFFF;\n  font-weight: 600;\n  font-size: 18px;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 67px;\n  cursor: pointer;\n  outline: none;\n  border: 0;\n}\n\n.qr__wrapper {\n  width: 112px;\n  height: 112px;\n  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);\n  border-radius: 16px;\n  padding: 8px;\n  margin-top: 16px;\n}\n\n.qr__img {\n  width: 96px;\n  height: 96px;\n  overflow: hidden;\n  border-right: 16px;\n}\n\n.alerts__input__box {\n  width: 350px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n\n.alerts__input__box__all {\n  display: flex;\n  width: 100%;\n  flex-wrap: wrap;\n  flex-direction: column;\n  height: 515px;\n}\n.alerts__input__box__all .alerts__input__wrapper {\n  margin-right: 40px;\n}\n\n.alerts__input__wrapper {\n  width: 370px;\n  transition: all 0.4s;\n  height: 48px;\n  background: #F0F0F3;\n  border-radius: 67px;\n  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n.alerts__input__wrapper.disable {\n  width: 370px;\n}\n.alerts__input__wrapper.disable .alerts__input__add {\n  display: none;\n}\n.alerts__input__wrapper.disable .alerts__input {\n  color: #939A9F;\n}\n.alerts__input__wrapper.disable .alerts__input__check {\n  display: flex;\n}\n.alerts__input__wrapper.active {\n  width: 370px;\n}\n.alerts__input__wrapper.active .alerts__input__add {\n  display: none;\n}\n.alerts__input__wrapper.active .alerts__input {\n  color: #364048;\n}\n.alerts__input__wrapper.active.one .alerts__input__add {\n  display: flex;\n}\n.alerts__input__wrapper.links .alerts__input__icon__wrapper {\n  width: auto;\n  box-shadow: unset;\n  padding-left: 8px;\n}\n.alerts__input__wrapper.links .alerts__input__icon {\n  cursor: pointer;\n  margin-right: 10px;\n}\n.alerts__input__wrapper.links .alerts__input__icon:last-child {\n  margin-right: 0;\n}\n.alerts__input__wrapper.links .alerts__input {\n  display: none;\n}\n.alerts__input__wrapper.links .alerts__input__check {\n  display: none;\n}\n.alerts__input__wrapper .alerts__input {\n  width: 270px;\n  background-color: transparent;\n  border: 0;\n  outline: none;\n  text-align: center;\n  font-size: 18px;\n  line-height: 23px;\n  transition: all 0.4s;\n}\n.alerts__input__wrapper .alerts__input::placeholder {\n  color: #939A9F;\n}\n.alerts__input__wrapper .alerts__input__check {\n  width: 24px;\n  min-width: 24px;\n  height: 24px;\n  min-height: 24px;\n  box-shadow: inset 2px 2px 2px rgba(174, 174, 192, 0.2), inset -2px -2px 2px rgba(255, 255, 255, 0.6980392157);\n  border-radius: 6px;\n  margin-right: 15px;\n  margin-left: 10px;\n  transition: all 0.4s;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.alerts__input__wrapper .alerts__input__check .alerts__input__check__icon {\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.4s;\n}\n.alerts__input__wrapper .alerts__check__input {\n  display: none;\n}\n.alerts__input__wrapper .alerts__check__input:checked ~ .alerts__input__check .alerts__input__check__icon {\n  visibility: visible;\n  opacity: 1;\n}\n.alerts__input__wrapper .remove__input {\n  position: absolute;\n  width: 11px;\n  height: 11px;\n  right: -20px;\n  cursor: pointer;\n}\n\n.alerts__input__icon__wrapper {\n  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);\n  display: flex;\n  border-radius: 50%;\n  width: 48px;\n  height: 48px;\n  align-items: center;\n  justify-content: center;\n}\n\n.alerts__input__add {\n  width: 370px;\n  height: 48px;\n  border-radius: 24px;\n  box-shadow: -2px -2px 6px #FFFFFF, 2px 2px 6px rgba(174, 174, 192, 0.4039215686);\n  background: #EDEDEF;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.login__settings__wrapper {\n  width: 1208px;\n  height: 865px;\n  background: #F0F0F3;\n  box-shadow: -10px -10px 30px #FFFFFF, 10px 10px 30px rgba(174, 174, 192, 0.4039215686);\n  border-radius: 30px;\n  position: relative;\n}\n\n.password__change__label {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n.password__change__label.hasValue .password__change__label__text {\n  visibility: visible;\n  opacity: 1;\n  position: relative;\n}\n\n.password__change__label__text {\n  display: inline-flex;\n  width: 95px;\n  height: 16px;\n  justify-content: center;\n  align-items: center;\n  border-radius: 8px 8px 0 0;\n  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);\n  position: absolute;\n  visibility: hidden;\n  opacity: 0;\n  transition: all 0.4s;\n}\n\n.login__settings {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  width: 100%;\n  transition: opacity 0.4s;\n  padding-top: 40px;\n}\n.login__settings.active {\n  opacity: 1;\n  visibility: visible;\n}\n\n.login__settings__body {\n  position: relative;\n  box-shadow: inset 0 5px 5px rgba(174, 174, 192, 0.2), inset 0px -5px 5px rgba(255, 255, 255, 0.6980392157);\n  height: calc(100% - 152px);\n}\n\n.login__settings__tabs {\n  display: flex;\n  width: 370px;\n  height: 48px;\n  box-shadow: 5px 5px 5px rgba(174, 174, 192, 0.2039215686), inset 5px 5px 5px rgba(174, 174, 192, 0.2);\n  border-radius: 67px;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 15px;\n  margin-left: 88px;\n}\n\n.login__settings__tabs__list {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.4s;\n  cursor: pointer;\n}\n.login__settings__tabs__list.active, .login__settings__tabs__list:hover {\n  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);\n}\n.login__settings__tabs__list.active .login__settings__tabs__icon, .login__settings__tabs__list:hover .login__settings__tabs__icon {\n  filter: brightness(0) saturate(100%) invert(27%) sepia(99%) saturate(929%) hue-rotate(182deg) brightness(92%) contrast(83%);\n}\n\n.card {\n  position: relative;\n}\n.card.light {\n  padding-top: 25px;\n  position: relative;\n}\n.card.light .card__header {\n  margin-bottom: 30px;\n  position: relative;\n}\n.card.light .card__header .row {\n  align-items: center;\n  justify-content: center;\n}\n.card.light .card__wallet__row {\n  background-color: transparent;\n}\n.card.light .card__wallet__rates {\n  color: #889096;\n}\n.card.light .card__wallet__usd {\n  color: #364048;\n  font-weight: bold;\n}\n.card.light .card__title {\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n}\n.card.light .card__product__arrow {\n  margin-left: 10px;\n}\n\n.card__risk__range {\n  width: 8px;\n  height: 176px;\n  position: absolute;\n  left: 8px;\n  top: 0;\n  display: none;\n}\n\n.card__risk__range.active {\n  display: block;\n  user-select: none;\n}\n\n.card__risk__range__bg {\n  width: 100%;\n  height: 50%;\n  background: #F27281;\n  box-shadow: inset 3px 3px 3px rgba(64, 64, 80, 0.3254901961);\n  border-radius: 0 0 20px 20px;\n  position: absolute;\n  bottom: 0;\n}\n\n.card__risk__range__btn {\n  width: 24px;\n  height: 24px;\n  background: #F0F0F3;\n  box-shadow: -2px -2px 6px #FFFFFF, 2px 2px 6px rgba(54, 54, 77, 0.4039215686);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  position: absolute;\n  top: 50%;\n  left: -8px;\n  cursor: pointer;\n}\n\n.card__risk__range__btn__min {\n  background: #F27281;\n  width: 16px;\n  display: flex;\n  height: 16px;\n  border-radius: 50%;\n  box-shadow: inset 2px 2px 2px rgba(54, 54, 70, 0.6), inset -2px -2px 2px rgba(255, 255, 255, 0.6);\n}\n\n.card__risk__range__hr {\n  width: 176px;\n  height: 8px;\n  border-radius: 88px;\n  position: absolute;\n  left: 5px;\n  top: 0;\n  display: none;\n}\n\n.card__risk__range__hr.active {\n  user-select: none;\n  display: block;\n}\n\n.card__risk__range__bg__hr {\n  width: 50%;\n  height: 100%;\n  background: #F27281;\n  box-shadow: inset 3px 3px 3px rgba(64, 64, 80, 0.3254901961);\n  border-radius: 20px 0 0 20px;\n  position: absolute;\n  left: 0;\n}\n\n.card__risk__range__btn__hr {\n  width: 24px;\n  height: 24px;\n  background: #F0F0F3;\n  box-shadow: -2px -2px 6px #FFFFFF, 2px 2px 6px rgba(54, 54, 77, 0.4039215686);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  position: absolute;\n  top: -8px;\n  left: 50%;\n  cursor: pointer;\n}\n\n.card__risk__range__btn__hr__min {\n  background: #F27281;\n  width: 16px;\n  display: flex;\n  height: 16px;\n  border-radius: 50%;\n  box-shadow: inset 2px 2px 2px rgba(54, 54, 70, 0.6), inset -2px -2px 2px rgba(255, 255, 255, 0.6);\n}\n\n.light_defi__unstaking .unstacking {\n  right: -20px;\n  bottom: -30px;\n}\n\n.card__price input::placeholder {\n  color: #889096 !important;\n  font-size: 14px !important;\n  font-weight: 600 !important;\n  line-height: 26px !important;\n}\n\n.nft .card__title {\n  align-items: center;\n  margin: 8px 0;\n}\n\n.card__nft__wrapper {\n  width: 264px;\n  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);\n  border-radius: 17px;\n  margin-bottom: 15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.card__nft__img {\n  width: 232px;\n  height: 160px;\n  border-radius: 17px;\n  object-fit: inherit;\n}\n\n@keyframes rotation_big {\n  from {\n    transform: rotate(243deg);\n  }\n  to {\n    transform: rotate(603deg);\n  }\n}\n@keyframes rotation__middle {\n  from {\n    transform: rotate(77deg);\n  }\n  to {\n    transform: rotate(437deg);\n  }\n}\n@keyframes rotation__small {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n.login__wrapper {\n  width: 100%;\n  min-height: 100vh;\n  max-height: 1080px;\n  overflow: hidden;\n  margin: auto;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  position: relative;\n}\n\n.login__big {\n  width: 1790px;\n  height: 1782px;\n  position: absolute;\n  object-fit: contain;\n  object-position: 44px;\n  padding-left: 44px;\n  z-index: 4;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  animation: rotation_big 30s infinite linear;\n}\n\n.login__middle {\n  width: 1100px;\n  height: 1100px;\n  position: absolute;\n  object-fit: contain;\n  z-index: 3;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  animation: rotation__middle 30s infinite linear reverse;\n}\n\n.login__small {\n  width: 828px;\n  height: 828px;\n  position: absolute;\n  object-fit: contain;\n  z-index: 2;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  animation: rotation__small 30s infinite linear;\n}\n\n.login__round {\n  width: 1208px;\n  height: 1208px;\n  position: absolute;\n  object-fit: contain;\n  object-position: center 55px;\n  z-index: 1;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n}\n\n.login__form {\n  width: 554px;\n  height: 554px;\n  background: #F0F0F3;\n  box-shadow: -10px -10px 30px #FFFFFF, 10px 10px 30px rgba(174, 174, 192, 0.4039215686);\n  border-radius: 50%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  margin: auto;\n  z-index: 5;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.login__logo {\n  width: 200px;\n  height: 36px;\n  margin-bottom: 20px;\n  display: inline-flex;\n}\n\n.login__input__wrapper {\n  width: 304px;\n  height: 48px;\n  background: #F0F0F3;\n  border-radius: 67px;\n  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.6980392157);\n  margin-bottom: 20px;\n  display: flex;\n  align-items: center;\n}\n.login__input__wrapper .login__input {\n  width: 100%;\n  background-color: transparent;\n  border: 0;\n  outline: none;\n  text-align: center;\n  font-size: 18px;\n  line-height: 23px;\n  transition: all 0.4s;\n}\n.login__input__wrapper .login__input::placeholder {\n  color: #939A9F;\n}\n\n.login__btn {\n  width: 304px;\n  height: 40px;\n  box-shadow: -5px -5px 15px #FFFFFF, 5px 5px 15px rgba(174, 174, 192, 0.4039215686);\n  background: #214175;\n  color: #FFFFFF;\n  font-weight: 600;\n  font-size: 18px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 67px;\n  cursor: pointer;\n  outline: none;\n  border: 0;\n}\n\n.login__user__btn {\n  position: fixed;\n  cursor: pointer;\n  width: 128px;\n  height: 128px;\n  bottom: 24px;\n  right: 16px;\n  z-index: 99;\n}\n\n.purchase__form {\n  background: #F0F0F3;\n  width: 408px;\n  border-radius: 67px;\n  box-shadow: -10px -10px 30px #FFFFFF, 10px 10px 30px rgba(174, 174, 192, 0.4039215686);\n  padding: 40px 48px 33px;\n  position: fixed;\n  bottom: 24px;\n  right: 16px;\n  z-index: 100;\n  transition: all 0.4s;\n}\n.purchase__form.open {\n  visibility: visible;\n  opacity: 1;\n}\n\n.purchase__form__title {\n  text-align: center;\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 23px;\n  margin-bottom: 32px;\n}\n\n.lds-ring {\n  display: inline-block;\n  position: relative;\n  width: 20px;\n  height: 20px;\n}\n\n.lds-ring div {\n  box-sizing: border-box;\n  display: block;\n  position: absolute;\n  width: 20px;\n  height: 20px;\n  margin: 0 10px;\n  border: 3px solid #fff;\n  border-radius: 50%;\n  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n  border-color: #fff transparent transparent transparent;\n}\n\n.lds-ring div:nth-child(1) {\n  animation-delay: -0.45s;\n}\n\n.lds-ring div:nth-child(2) {\n  animation-delay: -0.3s;\n}\n\n.lds-ring div:nth-child(3) {\n  animation-delay: -0.15s;\n}\n\n@keyframes lds-ring {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n@keyframes rotation_l_big {\n  from {\n    transform: rotate(153deg);\n  }\n  to {\n    transform: rotate(513deg);\n  }\n}\n@keyframes rotation_l_mid {\n  from {\n    transform: rotate(77deg);\n  }\n  to {\n    transform: rotate(437deg);\n  }\n}\n@keyframes rotation_l_small {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n.loading__layer {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #f0f0f3;\n}\n\n.logo-loading {\n  z-index: 0 !important;\n}\n\n.loading__wrapper {\n  width: 232px;\n  height: 232px;\n  position: relative;\n  overflow: hidden;\n  margin: auto;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.l_big {\n  width: 225px;\n  height: 225px;\n  position: absolute;\n  object-fit: contain;\n  object-position: 8px 8px;\n  z-index: 4;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  animation: rotation_l_big 5s infinite linear;\n}\n\n.l_mid {\n  width: 135px;\n  height: 135px;\n  position: absolute;\n  object-fit: contain;\n  z-index: 3;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  object-position: 4px 4px;\n  animation: rotation_l_mid 5s infinite linear reverse;\n}\n\n.l_small {\n  width: 110px;\n  height: 110px;\n  position: absolute;\n  object-fit: contain;\n  z-index: 2;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  object-position: 0.5px -0.5px;\n  animation: rotation_l_small 5s infinite linear;\n}\n\n.l_round {\n  width: 155px;\n  height: 155px;\n  position: absolute;\n  object-fit: contain;\n  z-index: 1;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n}\n\n.l_logo {\n  width: 36px;\n  height: 36px;\n  display: inline-block;\n  object-fit: contain;\n}\n\n.error__message,\n.custom__error__message {\n  text-align: center;\n  font-size: 13px;\n  line-height: 23px;\n  color: #be6161;\n  display: flex;\n  justify-content: center;\n  margin: 3px 0 5px 0;\n  line-break: anywhere;\n  padding-bottom: 20px;\n}\n\n.custom__error__message {\n  width: 100%;\n}\n\n@media only screen and (min-width: 1701px) and (max-width: 1930px) {\n  .wrapper.zoom__page .logo {\n    width: 32px;\n    height: 36px;\n    margin-top: 10px;\n    margin-bottom: 45px;\n    position: relative;\n  }\n  .wrapper.zoom__page .logo__img {\n    width: 100%;\n    height: 100%;\n  }\n  .wrapper.zoom__page .logo__img__big {\n    width: 0;\n    height: 0;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    margin: auto;\n    transition: all 0.4s;\n  }\n  .wrapper.zoom__page .nav {\n    width: 96px;\n    height: 100vh;\n    background: #F0F0F3;\n    box-shadow: inset 0 3px 6px rgba(0, 0, 0, 0.1607843137), 3px 0 6px rgba(67, 96, 121, 0.1490196078);\n    position: fixed;\n    top: 0;\n    left: 0;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    z-index: 3;\n    padding-right: 10px;\n    transition: all 0.4s;\n  }\n  .wrapper.zoom__page .nav.open {\n    width: 272px;\n  }\n  .wrapper.zoom__page .nav.open .logo {\n    width: 200px;\n  }\n  .wrapper.zoom__page .nav.open .logo__img {\n    display: none;\n  }\n  .wrapper.zoom__page .nav.open .logo__img__big {\n    display: inline-block;\n    width: 100%;\n    height: 100%;\n  }\n  .wrapper.zoom__page .nav.open .nav__link {\n    width: 208px;\n  }\n  .wrapper.zoom__page .nav.open .nav__link .nav__text {\n    font-size: 20px;\n    position: relative;\n    opacity: 1;\n    visibility: visible;\n    color: #364048;\n  }\n  .wrapper.zoom__page .nav__block {\n    list-style-type: none;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n  }\n  .wrapper.zoom__page .nav__list {\n    margin-bottom: 10px;\n  }\n  .wrapper.zoom__page .nav__list.trash {\n    margin-top: auto;\n  }\n  .wrapper.zoom__page .nav__link {\n    font-size: 30px;\n    text-decoration: none;\n    padding: 16px;\n    display: inline-flex;\n    color: #7e92a3;\n    transition: all 0.4s;\n    width: 64px;\n    height: 64px;\n    align-items: center;\n    justify-content: center;\n  }\n  .wrapper.zoom__page .nav__link:hover, .wrapper.zoom__page .nav__link.active {\n    background: #F0F0F3;\n    box-shadow: inset -3px -3px 3px rgba(255, 255, 255, 0.6980392157), inset 0px 3px 6px rgba(0, 0, 0, 0.1607843137), 3px 0px 6px rgba(67, 96, 121, 0.1490196078);\n    border-radius: 12px;\n    color: #2267a4;\n  }\n  .wrapper.zoom__page .nav__link:hover .trash__icon, .wrapper.zoom__page .nav__link.active .trash__icon {\n    filter: brightness(0) saturate(100%) invert(33%) sepia(7%) saturate(5984%) hue-rotate(169deg) brightness(102%) contrast(91%);\n  }\n  .wrapper.zoom__page .nav__link i {\n    position: relative;\n    z-index: 1;\n  }\n  .wrapper.zoom__page .nav__link .nav__text {\n    display: inline-flex;\n    color: transparent;\n    margin-right: auto;\n    margin-left: 15px;\n    white-space: nowrap;\n    font-size: 0;\n    transition: font-size 0.2s, visibility 0.4s, opacity 0.4s;\n    opacity: 0;\n    visibility: hidden;\n    position: absolute;\n  }\n  .wrapper.zoom__page .trash__icon {\n    height: 25px;\n  }\n  .wrapper.zoom__page .menu__open {\n    background: #F0F0F3;\n    box-shadow: inset 0px 3px 6px rgba(0, 0, 0, 0.1607843137), 3px 0px 6px rgba(67, 96, 121, 0.1490196078);\n    width: 106px;\n    height: 106px;\n    position: absolute;\n    border-radius: 50%;\n    top: 50%;\n    right: -53px;\n    clip-path: polygon(0 0, 50% 0, 50% 100%, 0% 100%);\n    transition: all 0.4s;\n  }\n  .wrapper.zoom__page .menu__open.open .menu__open__btn {\n    transform: rotate(180deg);\n  }\n  .wrapper.zoom__page .menu__open__btn {\n    width: 38px;\n    height: 38px;\n    border-radius: 50%;\n    background: #F0F0F3;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: -2px -2px 6px #FFFFFF, 2px 2px 6px rgba(174, 174, 192, 0.4039215686);\n    cursor: pointer;\n    position: absolute;\n    margin-top: auto;\n    margin-bottom: auto;\n    top: 0;\n    bottom: 0;\n    left: 10px;\n    transition: all 0.4s;\n  }\n  .wrapper.zoom__page .header {\n    height: 80px;\n    min-height: 80px;\n    box-shadow: inset 10px 10px 10px rgba(174, 174, 192, 0.2), inset -10px -10px 10px rgba(255, 255, 255, 0.5019607843);\n    width: 100%;\n    background: #F0F0F3;\n    padding: 0 25px 0 120px;\n    position: relative;\n    z-index: 1;\n    transition: all 0.4s;\n  }\n  .wrapper.zoom__page .header.open {\n    padding-left: 296px;\n  }\n  .wrapper.zoom__page .header .row {\n    height: 100%;\n    align-items: center;\n  }\n  .wrapper.zoom__page .header__title {\n    font-weight: 700;\n    line-height: 27px;\n    font-size: 22px;\n    transition: all 0.4s;\n  }\n  .open .wrapper.zoom__page .header__title {\n    font-size: 26px;\n    line-height: 32px;\n  }\n  .wrapper.zoom__page .header__right {\n    display: flex;\n    margin-left: auto;\n    align-items: center;\n    height: 100%;\n  }\n  .wrapper.zoom__page .notification {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  .wrapper.zoom__page .notification__btn {\n    border: 0;\n    background-color: transparent;\n    cursor: pointer;\n    font-size: 17px;\n    position: relative;\n    color: #868e95;\n  }\n  .wrapper.zoom__page .notification__status {\n    background: #F5B452;\n    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.2509803922);\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    position: absolute;\n    top: -5px;\n    right: -2px;\n  }\n  .wrapper.zoom__page .user {\n    height: 48px;\n    width: 145px;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0 40px;\n    flex-wrap: wrap;\n    transition: all 0.4s;\n    cursor: pointer;\n  }\n  .wrapper.zoom__page .user.open {\n    border-radius: 24px;\n    width: 145px;\n    height: 136px;\n    background: #F0F0F3;\n    box-shadow: -4px -4px 12px #FFFFFF, 4px 4px 12px rgba(174, 174, 192, 0.4039215686);\n    align-self: flex-start;\n  }\n  .wrapper.zoom__page .user.open .log__out {\n    display: inline-flex;\n  }\n  .wrapper.zoom__page .user.open:before, .wrapper.zoom__page .user.open:after {\n    display: none;\n  }\n  .wrapper.zoom__page .user:before, .wrapper.zoom__page .user:after {\n    content: \"\";\n    box-shadow: inset 10px 10px 10px rgba(174, 174, 192, 0.2);\n    border-radius: 67px;\n    height: 100%;\n    width: 3px;\n    position: absolute;\n    top: 0;\n  }\n  .wrapper.zoom__page .user:before {\n    left: 0;\n  }\n  .wrapper.zoom__page .user:after {\n    right: 0;\n  }\n  .wrapper.zoom__page .user__avatar {\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n    margin-right: 20px;\n  }\n  .wrapper.zoom__page .user__name {\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 18px;\n  }\n  .wrapper.zoom__page .user .log__out {\n    width: 100%;\n    cursor: pointer;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    padding-top: 14px;\n    margin-bottom: 10px;\n    display: none;\n  }\n  .wrapper.zoom__page .user .log__out:before {\n    position: absolute;\n    top: 0;\n    content: \"\";\n    width: 112px;\n    height: 4px;\n    box-shadow: inset 2px 2px 2px rgba(174, 174, 192, 0.2), inset -2px -2px 2px rgba(255, 255, 255, 0.6980392157);\n    border-radius: 67px;\n  }\n  .wrapper.zoom__page .user .log__out__icon {\n    margin-right: 8px;\n  }\n  .wrapper.zoom__page .setting__btn {\n    border: 0;\n    cursor: pointer;\n    color: #868e95;\n    font-size: 16px;\n  }\n  .wrapper.zoom__page .zoom__page__btn {\n    position: relative;\n    cursor: pointer;\n  }\n  .wrapper.zoom__page .zoom__page__btn .zoom__page__btn__minus,\n  .wrapper.zoom__page .zoom__page__btn .zoom__page__btn__plus {\n    position: absolute;\n    width: 25px;\n    height: 25px;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    margin: auto;\n    display: inline-block;\n    transition: opacity 0.4s;\n  }\n  .wrapper.zoom__page .zoom__page__btn .zoom__page__btn__minus {\n    opacity: 0;\n    visibility: hidden;\n  }\n  .wrapper.zoom__page .zoom__page__btn .zoom__page__btn__minus {\n    opacity: 1;\n    visibility: visible;\n  }\n  .wrapper.zoom__page .nav {\n    width: 71px;\n  }\n  .wrapper.zoom__page .header {\n    height: 56px;\n    min-height: 56px;\n    padding-left: 90px;\n  }\n  .wrapper.zoom__page .nav__link {\n    width: 40px;\n    height: 40px;\n    font-size: 22px;\n  }\n  .wrapper.zoom__page .nav__link:hover, .wrapper.zoom__page .nav__link.active {\n    border-radius: 8px;\n  }\n  .wrapper.zoom__page .card {\n    max-width: 240px;\n    height: 352px;\n    margin-right: 30px;\n    margin-bottom: 30px;\n  }\n  .wrapper.zoom__page .card__product__title {\n    font-size: 14px;\n  }\n  .wrapper.zoom__page .card__risk {\n    margin-top: 12px;\n  }\n  .wrapper.zoom__page .card__risk__chart {\n    width: 112px;\n    height: 112px;\n  }\n  .wrapper.zoom__page .card.empty .card__risk__chart__min,\n  .wrapper.zoom__page .card__risk__chart__min {\n    width: 90px;\n    height: 90px;\n  }\n  .wrapper.zoom__page .card__risk__chart__number {\n    font-size: 20px;\n    line-height: 26px;\n  }\n  .wrapper.zoom__page .card__wallet__usd, .wrapper.zoom__page .card__wallet__rates {\n    font-size: 13px;\n  }\n  .wrapper.zoom__page .cart__walet__text__title {\n    font-size: 12px !important;\n  }\n  .wrapper.zoom__page .unstacking {\n    width: 80px;\n    height: 80px;\n    font-size: 14px;\n  }\n  .wrapper.zoom__page .card {\n    padding: 16px;\n    border-radius: 24px;\n  }\n  .wrapper.zoom__page .card__price {\n    height: 32px;\n    border-radius: 80px;\n    font-size: 14px;\n  }\n  .wrapper.zoom__page .card__title {\n    font-size: 14px;\n  }\n  .wrapper.zoom__page .card.light {\n    padding-top: 20px;\n  }\n  .wrapper.zoom__page .card.light .card__header {\n    margin-bottom: 12px;\n  }\n  .wrapper.zoom__page .card__close {\n    width: 12px;\n    height: 12px;\n  }\n  .wrapper.zoom__page .card__close span {\n    width: 1px;\n  }\n  .wrapper.zoom__page .card__product__row {\n    margin: 0;\n    padding: 0;\n  }\n  .wrapper.zoom__page .card__product__number {\n    font-size: 18px;\n    line-height: 23px;\n  }\n  .wrapper.zoom__page .card__risk__range {\n    width: 6px;\n    height: 133px;\n  }\n  .wrapper.zoom__page .card__risk__range__btn {\n    width: 18px;\n    height: 18px;\n    left: -6px;\n  }\n  .wrapper.zoom__page .card__risk__info {\n    bottom: -15px;\n    width: 19px;\n    height: 19px;\n    font-size: 10px;\n  }\n  .wrapper.zoom__page .card__wallet__row {\n    padding: 0 10px;\n  }\n  .wrapper.zoom__page .zoom__page__btn,\n  .wrapper.zoom__page .layout__list, .wrapper.zoom__page .layout__grid {\n    width: 45px;\n    height: 45px;\n    margin-bottom: 16px;\n  }\n  .wrapper.zoom__page .layout__block {\n    right: 250px;\n    top: 65px;\n    position: fixed;\n    z-index: 9;\n  }\n  .wrapper.zoom__page .contract__address_container {\n    width: 510px;\n  }\n  .wrapper.zoom__page .layout__grid__icon {\n    width: 18px;\n    height: 18px;\n  }\n  .wrapper.zoom__page .layout__list__icon {\n    width: 19px;\n    height: 19px;\n  }\n  .wrapper.zoom__page .card__risk__title {\n    font-size: 14px;\n    line-height: 15px;\n    margin-bottom: 5px;\n    margin-top: 10px;\n  }\n  .wrapper.zoom__page .card__risk__range__btn__min {\n    width: 12px;\n    height: 12px;\n  }\n  .wrapper.zoom__page .card__risk__alert {\n    width: 48px;\n    height: 48px;\n  }\n  .wrapper.zoom__page .card__risk__alert__title {\n    font-size: 13px;\n  }\n  .wrapper.zoom__page .aside__wallet__title {\n    font-size: 16px;\n    line-height: 21px;\n    margin-bottom: 20px;\n    margin-top: 25px;\n  }\n  .wrapper.zoom__page .main .content {\n    margin-left: 0;\n    width: calc(100% - 234px);\n    padding: 16px 24px 0 17px;\n    margin-top: 0;\n  }\n  .wrapper.zoom__page .main:after {\n    right: 234px;\n    width: 5px;\n    top: 72px;\n  }\n  .wrapper.zoom__page .filter__block__btn__block {\n    left: -90px;\n  }\n  .wrapper.zoom__page .filter__block {\n    height: calc(100% - 62px);\n    width: 228px;\n  }\n  .wrapper.zoom__page .asset__list__text {\n    font-size: 14px;\n  }\n  .wrapper.zoom__page .asset__list__box {\n    width: 20px;\n    height: 20px;\n    border-radius: 4px;\n  }\n  .wrapper.zoom__page .asset__list__box:after {\n    width: 5px;\n    height: 10px;\n  }\n  .wrapper.zoom__page .asset__block {\n    border-radius: 8px;\n  }\n  .wrapper.zoom__page .aside {\n    width: 234px;\n    padding: 16px;\n  }\n  .wrapper.zoom__page .add__wallet__btn {\n    width: 200px;\n    height: 64px;\n    border-radius: 18px;\n    font-size: 16px;\n    line-height: 21px;\n    padding-left: 16px;\n  }\n  .wrapper.zoom__page .add__wallet__btn__plus {\n    width: 40px;\n    height: 40px;\n  }\n  .wrapper.zoom__page .add__wallet__btn__plus__bg {\n    width: 25px;\n    height: 25px;\n  }\n  .wrapper.zoom__page .setting {\n    margin-left: 30px;\n  }\n  .wrapper.zoom__page .card__risk__range__hr {\n    width: 121px;\n    height: 5px;\n  }\n  .wrapper.zoom__page .card__risk__range__btn__hr {\n    width: 17px;\n    height: 17px;\n  }\n  .wrapper.zoom__page .card__risk__range__btn__hr__min {\n    width: 11px;\n    height: 11px;\n  }\n  .wrapper.zoom__page .aside__tabs__link {\n    font-size: 14px;\n    border: none;\n    outline: none;\n  }\n  .wrapper.zoom__page .aside__chart__wrapper {\n    height: 235px;\n    margin-bottom: 30px;\n  }\n  .wrapper.zoom__page .aside__chart__wrapper .card__risk__chart {\n    width: 158px;\n    height: 158px;\n  }\n  .wrapper.zoom__page .aside__chart__wrapper .card__risk__chart__min {\n    width: 122px;\n    height: 122px;\n    border-width: 14px;\n  }\n  .wrapper.zoom__page .aside__chart__wrapper .card__risk__alert {\n    width: 64px;\n    height: 64px;\n  }\n  .wrapper.zoom__page .aside__chart__wrapper .card__risk__alert__title,\n  .wrapper.zoom__page .aside__chart__wrapper .card__risk__alert__number {\n    font-size: 14px;\n    line-height: 18px;\n  }\n  .wrapper.zoom__page .aside__card__title {\n    font-size: 13px;\n    margin-bottom: 3px;\n    line-height: 17px;\n  }\n  .wrapper.zoom__page .aside__card__numbers {\n    font-size: 16px;\n  }\n  .wrapper.zoom__page .aside__card {\n    padding: 14px 16px;\n    border-radius: 18px;\n  }\n  .wrapper.zoom__page .aside__card .card__risk__alert {\n    width: 44px;\n    height: 44px;\n    top: 0;\n  }\n  .wrapper.zoom__page .aside__card .card__risk__alert__number,\n  .wrapper.zoom__page .aside__card .card__risk__alert__title {\n    font-size: 13px;\n  }\n  .wrapper.zoom__page .aside__card .card__risk__range__hr {\n    width: 71px;\n    height: 6px;\n  }\n  .wrapper.zoom__page .aside__card__progress {\n    height: 6px;\n  }\n  .wrapper.zoom__page .card__wallet {\n    margin-bottom: 10px;\n    height: 70px;\n  }\n  .wrapper.zoom__page .to__top {\n    width: 32px;\n    height: 32px;\n    right: 249px;\n  }\n  .wrapper.zoom__page .recycle_top {\n    right: 180px !important;\n  }\n  .wrapper.zoom__page .to__top__icon {\n    width: 20px;\n    height: 20px;\n  }\n  .wrapper.zoom__page .card__product__unstacked,\n  .wrapper.zoom__page .card__product__stake {\n    width: 70px;\n    height: 32px;\n    font-size: 14px;\n  }\n  .wrapper.zoom__page .card.defi .card__header {\n    padding: 0;\n  }\n  .wrapper.zoom__page .card.defi .card__risk {\n    margin-top: -10px;\n  }\n  .wrapper.zoom__page .card__product__stake__block {\n    margin-top: 5px;\n    margin-bottom: 5px;\n  }\n  .wrapper.zoom__page .card__product__stake__amount__max,\n  .wrapper.zoom__page .card__product__stake__amount__input {\n    font-size: 14px;\n  }\n  .wrapper.zoom__page .card__product__stake__amount__max,\n  .wrapper.zoom__page .card__product__stake__amount__input__wrapper {\n    height: 40px;\n  }\n  .wrapper.zoom__page .card__product__stake__amount__confirm {\n    font-size: 14px;\n    height: 35px;\n  }\n  .wrapper.zoom__page .add__defi__block {\n    width: 42px;\n    padding: 8px 0;\n    top: 300px;\n    right: 0px;\n  }\n  .wrapper.zoom__page .add__defi__item {\n    width: 28px;\n    height: 28px;\n    margin-bottom: 8px;\n  }\n  .wrapper.zoom__page .add__defi__item__icon {\n    height: 20px;\n    width: auto;\n  }\n  .wrapper.zoom__page .card__nft__wrapper {\n    width: 192px;\n    margin: 0 auto;\n  }\n  .wrapper.zoom__page .card__nft__img {\n    width: 165px;\n    height: 110px;\n    object-fit: inherit;\n  }\n  .wrapper.zoom__page .card.nft .card__header {\n    margin-bottom: 0;\n  }\n  .wrapper.zoom__page .card.nft .card__risk {\n    margin-top: 4px;\n  }\n  .wrapper.zoom__page .login__big {\n    width: 1376.9230769231px;\n    height: 1370.7692307692px;\n  }\n  .wrapper.zoom__page .login__middle {\n    width: 846.1538461538px;\n    height: 846.1538461538px;\n  }\n  .wrapper.zoom__page .login__small {\n    width: 636.9230769231px;\n    height: 636.9230769231px;\n  }\n  .wrapper.zoom__page .login__round {\n    width: 929.2307692308px;\n    height: 929.2307692308px;\n  }\n  .wrapper.zoom__page .login__form {\n    width: 418.4615384615px;\n    height: 418.4615384615px;\n  }\n  .wrapper.zoom__page .login__input__wrapper {\n    width: 285px;\n    height: 40px;\n  }\n  .wrapper.zoom__page .login__btn {\n    width: 285px;\n  }\n  .wrapper.zoom__page .login__logo {\n    margin-bottom: 20px;\n  }\n  .wrapper.zoom__page .card.new .add__wallet,\n  .wrapper.zoom__page .card.empty .add__wallet {\n    width: 112px;\n    height: 112px;\n  }\n  .wrapper.zoom__page .card.new .add__wallet .add__wallet__btn__bg,\n  .wrapper.zoom__page .card.empty .add__wallet .add__wallet__btn__bg {\n    width: 60px;\n    height: 60px;\n  }\n  .wrapper.zoom__page .card.new .add__wallet .save__text,\n  .wrapper.zoom__page .card.empty .add__wallet .save__text {\n    font-size: 16px;\n  }\n  .wrapper.zoom__page .card.new .add__wallet .plus__wrapper span,\n  .wrapper.zoom__page .card.empty .add__wallet .plus__wrapper span {\n    width: 20px;\n    height: 3px;\n  }\n  .wrapper.zoom__page .card.new .add__wallet.save,\n  .wrapper.zoom__page .card.empty .add__wallet.save {\n    top: 190px;\n  }\n  .wrapper.zoom__page .card__product__row .product__row__dropdown .product__row__dropdown__item {\n    font-size: 14px;\n    padding: 3px 0;\n  }\n  .wrapper.zoom__page .card__product__row .product__row__dropdown {\n    top: 24px;\n    padding: 2px 12px;\n  }\n  .wrapper.zoom__page .menu__open {\n    width: 80px;\n    height: 80px;\n    right: -40px;\n  }\n  .wrapper.zoom__page .menu__open__btn {\n    width: 24px;\n    height: 24px;\n  }\n  .wrapper.zoom__page .menu__open__icon {\n    width: 14px;\n    height: 14px;\n  }\n  .wrapper.zoom__page .card.trash .trash__wallet {\n    width: 100px;\n    height: 100px;\n    top: 60px;\n  }\n  .wrapper.zoom__page .trash__wallet__icon {\n    width: 33px;\n    height: 36px;\n  }\n  .wrapper.zoom__page .empty__trash__title {\n    font-size: 76px;\n  }\n  .wrapper.zoom__page .light_core_activate_title {\n    font-size: 40px !important;\n  }\n  .wrapper.zoom__page .card__list__anchor,\n  .wrapper.zoom__page .card__list__title {\n    font-size: 14px;\n  }\n  .wrapper.zoom__page .card__list {\n    width: 256px;\n    height: 64px;\n    border-radius: 20px;\n    padding: 8px;\n    margin-right: 70px;\n  }\n  .wrapper.zoom__page .card__risk__chart__list {\n    width: 80px;\n    height: 80px;\n    right: -40px;\n  }\n  .wrapper.zoom__page .card__list__percent {\n    margin-right: 13px;\n    width: 48px;\n    height: 48px;\n  }\n  .wrapper.zoom__page .card__risk__chart__list__number {\n    font-size: 18px;\n  }\n  .wrapper.zoom__page .zoom__page__btn {\n    display: none;\n  }\n  .wrapper.zoom__page .card__chart__wrapper {\n    width: 572px;\n    height: 410px;\n    padding: 17px 40px 17px 56px;\n  }\n  .wrapper.zoom__page .card__chart {\n    width: 464px;\n    height: 282px;\n  }\n  .wrapper.zoom__page .check__wrapper .checkbox__box {\n    width: 18px;\n    height: 18px;\n  }\n  .wrapper.zoom__page .check__wrapper .checkbox__label {\n    font-size: 14px;\n    line-height: 18px;\n    font-weight: 600;\n  }\n  .wrapper.zoom__page .card__chart__title {\n    font-size: 14px;\n    line-height: 18px;\n    font-weight: 600;\n  }\n  .wrapper.zoom__page .card__chart__dropdown__selected {\n    font-size: 14px;\n    line-height: 18px;\n    width: 70px;\n  }\n  .wrapper.zoom__page .card__chart__dropdown__selected:after {\n    width: 70px;\n  }\n  .wrapper.zoom__page .card__chart__header {\n    margin-bottom: 17px;\n  }\n  .wrapper.zoom__page .card__chart__close {\n    width: 15px;\n    height: 15px;\n  }\n  .wrapper.zoom__page .card__round__shadow {\n    width: 90px;\n    height: 90px;\n  }\n  .wrapper.zoom__page .round__shdow {\n    width: 120px;\n    height: 120px;\n  }\n  .wrapper.zoom__page .rangeslider-vertical {\n    height: 133px !important;\n  }\n  .wrapper.zoom__page .card__round__shadow__defi__list {\n    top: 13px;\n    left: 13px;\n  }\n  .wrapper.zoom__page .aside__nth__title {\n    font-size: 14px !important;\n    line-height: 20px !important;\n  }\n  .wrapper.zoom__page .card__product__title {\n    width: 168px !important;\n  }\n  .wrapper.zoom__page .current__card .rangeslider-horizontal {\n    width: 105px !important;\n  }\n  .wrapper.zoom__page .card .card__risk__chart svg {\n    width: 95px;\n    height: 95px;\n  }\n  .wrapper.zoom__page .aside__chart__wrapper .card__risk__chart svg {\n    width: 128px;\n    width: 128px;\n  }\n  .wrapper.zoom__page .login_requests__message {\n    width: 85% !important;\n  }\n  .wrapper.zoom__page .psw_requests__message {\n    width: 80% !important;\n  }\n  .wrapper.zoom__page .ntf__security__title {\n    text-overflow: ellipsis;\n    overflow: hidden;\n    width: 118px;\n    height: 1.2em;\n    white-space: nowrap;\n  }\n  .wrapper.zoom__page .card.empty .error__message.requests__message ~ .add__wallet.save {\n    top: 160px;\n  }\n  .wrapper.zoom__page .user__info {\n    margin-left: 30px;\n    margin-right: 30px;\n  }\n  .wrapper.zoom__page .login__settings__wrapper {\n    max-width: 1208px;\n    width: calc(100% - 460px);\n  }\n  .wrapper.zoom__page .settings__tabs__link {\n    font-size: 18px;\n    width: 230px;\n  }\n  .wrapper.zoom__page .unstake__error__modal {\n    width: 247px !important;\n    left: -19px !important;\n  }\n  .wrapper.zoom__page .contract__address_content {\n    width: 340px;\n  }\n  .wrapper.zoom__page {\n    /*Staking Risk CSS*/\n  }\n  .wrapper.zoom__page .card__product__wrapper .card_product_scroller_item {\n    display: flex;\n    justify-content: space-around;\n    flex-wrap: nowrap;\n    padding: 5px 10px;\n  }\n  .wrapper.zoom__page .card__product__wrapper .card_product_scroller_item:nth-child(odd) {\n    background: rgba(132, 132, 132, 0.0509803922);\n  }\n  .wrapper.zoom__page .card__product__wrapper .card_product_scroller_item_title {\n    font-family: Assistant;\n    font-weight: 600;\n    font-size: 14px;\n    padding-left: 10px;\n    color: #364048;\n  }\n  .wrapper.zoom__page .card__product__wrapper .card_product_scroller_item_level {\n    font-family: Assistant;\n    font-weight: 600;\n    font-size: 14px;\n    padding-right: 10px;\n    text-align: right;\n    color: #4DC7B5;\n  }\n  .wrapper.zoom__page .zoom__page__btn {\n    display: block;\n  }\n  .wrapper.zoom__page .zoom__page__btn__minus {\n    visibility: visible;\n    opacity: 1;\n  }\n  .wrapper.zoom__page .zoom__page__btn__plus {\n    opacity: 0;\n    visibility: hidden;\n  }\n}\n@media only screen and (max-width: 1700px) {\n  .nav {\n    width: 71px;\n  }\n  .header {\n    height: 56px;\n    min-height: 56px;\n    padding-left: 90px;\n  }\n  .nav__link {\n    width: 40px;\n    height: 40px;\n    font-size: 22px;\n  }\n  .nav__link:hover, .nav__link.active {\n    border-radius: 8px;\n  }\n  .card {\n    max-width: 240px;\n    height: 352px;\n    margin-right: 30px;\n    margin-bottom: 30px;\n  }\n  .card__product__title {\n    font-size: 14px;\n  }\n  .card__risk {\n    margin-top: 12px;\n  }\n  .card__risk__chart {\n    width: 112px;\n    height: 112px;\n  }\n  .card.empty .card__risk__chart__min,\n  .card__risk__chart__min {\n    width: 90px;\n    height: 90px;\n  }\n  .card__risk__chart__number {\n    font-size: 20px;\n    line-height: 26px;\n  }\n  .card__wallet__usd, .card__wallet__rates {\n    font-size: 13px;\n  }\n  .cart__walet__text__title {\n    font-size: 12px !important;\n  }\n  .unstacking {\n    width: 80px;\n    height: 80px;\n    font-size: 14px;\n  }\n  .card {\n    padding: 16px;\n    border-radius: 24px;\n  }\n  .card__price {\n    height: 32px;\n    border-radius: 80px;\n    font-size: 14px;\n  }\n  .card__title {\n    font-size: 14px;\n  }\n  .card.light {\n    padding-top: 20px;\n  }\n  .card.light .card__header {\n    margin-bottom: 12px;\n  }\n  .card__close {\n    width: 12px;\n    height: 12px;\n  }\n  .card__close span {\n    width: 1px;\n  }\n  .card__product__row {\n    margin: 0;\n    padding: 0;\n  }\n  .card__product__number {\n    font-size: 18px;\n    line-height: 23px;\n  }\n  .card__risk__range {\n    width: 6px;\n    height: 133px;\n  }\n  .card__risk__range__btn {\n    width: 18px;\n    height: 18px;\n    left: -6px;\n  }\n  .card__risk__info {\n    bottom: -15px;\n    width: 19px;\n    height: 19px;\n    font-size: 10px;\n  }\n  .card__wallet__row {\n    padding: 0 10px;\n  }\n  .zoom__page__btn,\n  .layout__list, .layout__grid {\n    width: 45px;\n    height: 45px;\n    margin-bottom: 16px;\n  }\n  .layout__block {\n    right: 250px;\n    top: 65px;\n    position: fixed;\n    z-index: 9;\n  }\n  .contract__address_container {\n    width: 510px;\n  }\n  .layout__grid__icon {\n    width: 18px;\n    height: 18px;\n  }\n  .layout__list__icon {\n    width: 19px;\n    height: 19px;\n  }\n  .card__risk__title {\n    font-size: 14px;\n    line-height: 15px;\n    margin-bottom: 5px;\n    margin-top: 10px;\n  }\n  .card__risk__range__btn__min {\n    width: 12px;\n    height: 12px;\n  }\n  .card__risk__alert {\n    width: 48px;\n    height: 48px;\n  }\n  .card__risk__alert__title {\n    font-size: 13px;\n  }\n  .aside__wallet__title {\n    font-size: 16px;\n    line-height: 21px;\n    margin-bottom: 20px;\n    margin-top: 25px;\n  }\n  .main .content {\n    margin-left: 0;\n    width: calc(100% - 234px);\n    padding: 16px 24px 0 17px;\n    margin-top: 0;\n  }\n  .main:after {\n    right: 234px;\n    width: 5px;\n    top: 72px;\n  }\n  .filter__block__btn__block {\n    left: -90px;\n  }\n  .filter__block {\n    height: calc(100% - 62px);\n    width: 228px;\n  }\n  .asset__list__text {\n    font-size: 14px;\n  }\n  .asset__list__box {\n    width: 20px;\n    height: 20px;\n    border-radius: 4px;\n  }\n  .asset__list__box:after {\n    width: 5px;\n    height: 10px;\n  }\n  .asset__block {\n    border-radius: 8px;\n  }\n  .aside {\n    width: 234px;\n    padding: 16px;\n  }\n  .add__wallet__btn {\n    width: 200px;\n    height: 64px;\n    border-radius: 18px;\n    font-size: 16px;\n    line-height: 21px;\n    padding-left: 16px;\n  }\n  .add__wallet__btn__plus {\n    width: 40px;\n    height: 40px;\n  }\n  .add__wallet__btn__plus__bg {\n    width: 25px;\n    height: 25px;\n  }\n  .setting {\n    margin-left: 30px;\n  }\n  .card__risk__range__hr {\n    width: 121px;\n    height: 5px;\n  }\n  .card__risk__range__btn__hr {\n    width: 17px;\n    height: 17px;\n  }\n  .card__risk__range__btn__hr__min {\n    width: 11px;\n    height: 11px;\n  }\n  .aside__tabs__link {\n    font-size: 14px;\n    border: none;\n    outline: none;\n  }\n  .aside__chart__wrapper {\n    height: 235px;\n    margin-bottom: 30px;\n  }\n  .aside__chart__wrapper .card__risk__chart {\n    width: 158px;\n    height: 158px;\n  }\n  .aside__chart__wrapper .card__risk__chart__min {\n    width: 122px;\n    height: 122px;\n    border-width: 14px;\n  }\n  .aside__chart__wrapper .card__risk__alert {\n    width: 64px;\n    height: 64px;\n  }\n  .aside__chart__wrapper .card__risk__alert__title,\n  .aside__chart__wrapper .card__risk__alert__number {\n    font-size: 14px;\n    line-height: 18px;\n  }\n  .aside__card__title {\n    font-size: 13px;\n    margin-bottom: 3px;\n    line-height: 17px;\n  }\n  .aside__card__numbers {\n    font-size: 16px;\n  }\n  .aside__card {\n    padding: 14px 16px;\n    border-radius: 18px;\n  }\n  .aside__card .card__risk__alert {\n    width: 44px;\n    height: 44px;\n    top: 0;\n  }\n  .aside__card .card__risk__alert__number,\n  .aside__card .card__risk__alert__title {\n    font-size: 13px;\n  }\n  .aside__card .card__risk__range__hr {\n    width: 71px;\n    height: 6px;\n  }\n  .aside__card__progress {\n    height: 6px;\n  }\n  .card__wallet {\n    margin-bottom: 10px;\n    height: 70px;\n  }\n  .to__top {\n    width: 32px;\n    height: 32px;\n    right: 249px;\n  }\n  .recycle_top {\n    right: 180px !important;\n  }\n  .to__top__icon {\n    width: 20px;\n    height: 20px;\n  }\n  .card__product__unstacked,\n  .card__product__stake {\n    width: 70px;\n    height: 32px;\n    font-size: 14px;\n  }\n  .card.defi .card__header {\n    padding: 0;\n  }\n  .card.defi .card__risk {\n    margin-top: -10px;\n  }\n  .card__product__stake__block {\n    margin-top: 5px;\n    margin-bottom: 5px;\n  }\n  .card__product__stake__amount__max,\n  .card__product__stake__amount__input {\n    font-size: 14px;\n  }\n  .card__product__stake__amount__max,\n  .card__product__stake__amount__input__wrapper {\n    height: 40px;\n  }\n  .card__product__stake__amount__confirm {\n    font-size: 14px;\n    height: 35px;\n  }\n  .add__defi__block {\n    width: 42px;\n    padding: 8px 0;\n    top: 300px;\n    right: 0px;\n  }\n  .add__defi__item {\n    width: 28px;\n    height: 28px;\n    margin-bottom: 8px;\n  }\n  .add__defi__item__icon {\n    height: 20px;\n    width: auto;\n  }\n  .card__nft__wrapper {\n    width: 192px;\n    margin: 0 auto;\n  }\n  .card__nft__img {\n    width: 165px;\n    height: 110px;\n    object-fit: inherit;\n  }\n  .card.nft .card__header {\n    margin-bottom: 0;\n  }\n  .card.nft .card__risk {\n    margin-top: 4px;\n  }\n  .login__big {\n    width: 1376.9230769231px;\n    height: 1370.7692307692px;\n  }\n  .login__middle {\n    width: 846.1538461538px;\n    height: 846.1538461538px;\n  }\n  .login__small {\n    width: 636.9230769231px;\n    height: 636.9230769231px;\n  }\n  .login__round {\n    width: 929.2307692308px;\n    height: 929.2307692308px;\n  }\n  .login__form {\n    width: 418.4615384615px;\n    height: 418.4615384615px;\n  }\n  .login__input__wrapper {\n    width: 285px;\n    height: 40px;\n  }\n  .login__btn {\n    width: 285px;\n  }\n  .login__logo {\n    margin-bottom: 20px;\n  }\n  .card.new .add__wallet,\n  .card.empty .add__wallet {\n    width: 112px;\n    height: 112px;\n  }\n  .card.new .add__wallet .add__wallet__btn__bg,\n  .card.empty .add__wallet .add__wallet__btn__bg {\n    width: 60px;\n    height: 60px;\n  }\n  .card.new .add__wallet .save__text,\n  .card.empty .add__wallet .save__text {\n    font-size: 16px;\n  }\n  .card.new .add__wallet .plus__wrapper span,\n  .card.empty .add__wallet .plus__wrapper span {\n    width: 20px;\n    height: 3px;\n  }\n  .card.new .add__wallet.save,\n  .card.empty .add__wallet.save {\n    top: 190px;\n  }\n  .card__product__row .product__row__dropdown .product__row__dropdown__item {\n    font-size: 14px;\n    padding: 3px 0;\n  }\n  .card__product__row .product__row__dropdown {\n    top: 24px;\n    padding: 2px 12px;\n  }\n  .menu__open {\n    width: 80px;\n    height: 80px;\n    right: -40px;\n  }\n  .menu__open__btn {\n    width: 24px;\n    height: 24px;\n  }\n  .menu__open__icon {\n    width: 14px;\n    height: 14px;\n  }\n  .card.trash .trash__wallet {\n    width: 100px;\n    height: 100px;\n    top: 60px;\n  }\n  .trash__wallet__icon {\n    width: 33px;\n    height: 36px;\n  }\n  .empty__trash__title {\n    font-size: 76px;\n  }\n  .light_core_activate_title {\n    font-size: 40px !important;\n  }\n  .card__list__anchor,\n  .card__list__title {\n    font-size: 14px;\n  }\n  .card__list {\n    width: 256px;\n    height: 64px;\n    border-radius: 20px;\n    padding: 8px;\n    margin-right: 70px;\n  }\n  .card__risk__chart__list {\n    width: 80px;\n    height: 80px;\n    right: -40px;\n  }\n  .card__list__percent {\n    margin-right: 13px;\n    width: 48px;\n    height: 48px;\n  }\n  .card__risk__chart__list__number {\n    font-size: 18px;\n  }\n  .zoom__page__btn {\n    display: none;\n  }\n  .card__chart__wrapper {\n    width: 572px;\n    height: 410px;\n    padding: 17px 40px 17px 56px;\n  }\n  .card__chart {\n    width: 464px;\n    height: 282px;\n  }\n  .check__wrapper .checkbox__box {\n    width: 18px;\n    height: 18px;\n  }\n  .check__wrapper .checkbox__label {\n    font-size: 14px;\n    line-height: 18px;\n    font-weight: 600;\n  }\n  .card__chart__title {\n    font-size: 14px;\n    line-height: 18px;\n    font-weight: 600;\n  }\n  .card__chart__dropdown__selected {\n    font-size: 14px;\n    line-height: 18px;\n    width: 70px;\n  }\n  .card__chart__dropdown__selected:after {\n    width: 70px;\n  }\n  .card__chart__header {\n    margin-bottom: 17px;\n  }\n  .card__chart__close {\n    width: 15px;\n    height: 15px;\n  }\n  .card__round__shadow {\n    width: 90px;\n    height: 90px;\n  }\n  .round__shdow {\n    width: 120px;\n    height: 120px;\n  }\n  .rangeslider-vertical {\n    height: 133px !important;\n  }\n  .card__round__shadow__defi__list {\n    top: 13px;\n    left: 13px;\n  }\n  .aside__nth__title {\n    font-size: 14px !important;\n    line-height: 20px !important;\n  }\n  .card__product__title {\n    width: 168px !important;\n  }\n  .current__card .rangeslider-horizontal {\n    width: 105px !important;\n  }\n  .card .card__risk__chart svg {\n    width: 95px;\n    height: 95px;\n  }\n  .aside__chart__wrapper .card__risk__chart svg {\n    width: 128px;\n    width: 128px;\n  }\n  .login_requests__message {\n    width: 85% !important;\n  }\n  .psw_requests__message {\n    width: 80% !important;\n  }\n  .ntf__security__title {\n    text-overflow: ellipsis;\n    overflow: hidden;\n    width: 118px;\n    height: 1.2em;\n    white-space: nowrap;\n  }\n  .card.empty .error__message.requests__message ~ .add__wallet.save {\n    top: 160px;\n  }\n  .user__info {\n    margin-left: 30px;\n    margin-right: 30px;\n  }\n  .login__settings__wrapper {\n    max-width: 1208px;\n    width: calc(100% - 460px);\n  }\n  .settings__tabs__link {\n    font-size: 18px;\n    width: 230px;\n  }\n  .unstake__error__modal {\n    width: 247px !important;\n    left: -19px !important;\n  }\n  .contract__address_content {\n    width: 340px;\n  }\n  /*Staking Risk CSS*/\n  .card__product__wrapper .card_product_scroller_item {\n    display: flex;\n    justify-content: space-around;\n    flex-wrap: nowrap;\n    padding: 5px 10px;\n  }\n  .card__product__wrapper .card_product_scroller_item:nth-child(odd) {\n    background: rgba(132, 132, 132, 0.0509803922);\n  }\n  .card__product__wrapper .card_product_scroller_item_title {\n    font-family: Assistant;\n    font-weight: 600;\n    font-size: 14px;\n    padding-left: 10px;\n    color: #364048;\n  }\n  .card__product__wrapper .card_product_scroller_item_level {\n    font-family: Assistant;\n    font-weight: 600;\n    font-size: 14px;\n    padding-right: 10px;\n    text-align: right;\n    color: #4DC7B5;\n  }\n}\n@media only screen and (max-width: 992px) {\n  .active__page__main {\n    width: 100% !important;\n  }\n}","* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml {\n  //scroll-behavior: smooth;\n  font-size: $fz;\n}\n\nbody {\n  font-family: $ff_A;\n  background: $white;\n  color: $main_c;\n  overflow: hidden;\n  &.setting__body{\n    .main,\n    .wrapper{\n      overflow: unset;\n      height: auto;\n    }\n    overflow: auto;\n  }\n}\n\n.wrapper {\n  width: 100%;\n  overflow: hidden;\n  margin: 0 auto;\n  position: relative;\n  background: #F0F0F3;\n}\n\n.row {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.clear {\n  clear: both;\n}\n\n\n/* width */\n::-webkit-scrollbar {\n  width: 8px;\n  display: block;\n}\n\n.filter__block{\n  .asset__block::-webkit-scrollbar\n  {\n    width: inherit !important;\n  }  \n}\n\n.recycle__layout{\n  position: fixed;\n    top: 60px;\n    left: 0;\n    right: 0;\n    bottom: 0;\n}\n\n\n/* Track */\n::-webkit-scrollbar-track {\n  box-shadow: inset 4px 4px 4px #AEAEC033;\n  border-radius: 67px;\n}\n\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: transparent;\n  border-radius: 8px;\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: transparent;\n}\n\n%hover__btn__inset {\n  transition: all 0.4s;\n\n  // &:hover {\n  //   box-shadow: inset 3px 3px 3px #AEAEC033, inset -3px -3px 3px #FFFFFFB2;\n  // }\n}\n\n%hover__btn {\n  transition: all 0.4s;\n\n  // &:hover {\n  //   box-shadow: -3px -3px 9px 0 #fff, 3px 3px 9px 0 rgba(174, 174, 192, 0.4);\n  // }\n}\n\n%hover__btn__blue {\n  transition: all 0.4s;\n\n  &:hover {\n    background: #1762A2;\n  }\n}\n\n%active__btn__inset {\n  transition: all 0.4s;\n  box-shadow: inset 3px 3px 3px #AEAEC033, inset -3px -3px 3px #FFFFFFB2;\n}\n\n%active__btn {\n  transition: all 0.4s;\n  box-shadow:  3px 3px 3px #AEAEC033,  -3px -3px 3px #FFFFFFB2;\n}\n.align-items-center{\n  align-items: center;\n}\n","$path: \"../\";\n$black: #000;\n$white: #fff;\n$main_c :#364048;\n$fz: 16px;\n$ff_A: 'Assistant', sans-serif;\n\n",".dropdown {\n  position: relative;\n  width: 272px;\n\n  &.open {\n    .dropdown__selected {\n      box-shadow: inset 5px 5px 5px #AEAEC033, inset -5px -5px 5px #FFFFFFB2;\n\n      .dropdown__arrow {\n        transform: rotate(-180deg);\n      }\n    }\n\n    .dropdown__body {\n      display: block;\n    }\n  }\n}\n\n.dropdown__selected {\n  height: 48px;\n  width: 100%;\n  background: #EDEDEF;\n  box-shadow: -3px -3px 9px #FFFFFF, 3px 3px 9px #AEAEC067;\n  border-radius: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 20px;\n  position: relative;\n  z-index: 2;\n  cursor: pointer;\n}\n\n.dropdown__arrow {\n  display: flex;\n  right: 25px;\n  position: absolute;\n}\n\n.dropdown__body {\n  background: #F0F0F3;\n  box-shadow: 0 5px 15px #38465241;\n  border-radius: 0 0 20px 20px;\n  padding: 35px 16px 16px;\n  position: absolute;\n  width: 100%;\n  z-index: 1;\n  top: 25px;\n  display: none;\n}\n\n.dropdown__copy {\n  width: 100%;\n  border-radius: 80px;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #A9B6C1;\n  font-weight: 600;\n  font-size: 20px;\n  position: relative;\n  box-shadow: inset 5px 5px 5px #AEAEC033, inset -5px -5px 5px #FFFFFFB2;\n}\n\n.dropdown__copy__icon__wrapper {\n  width: 32px;\n  height: 32px;\n  box-shadow: -3px -3px 9px #FFFFFF, 3px 3px 9px #AEAEC067;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  right: 8px;\n  top: 8px;\n  cursor: pointer;\n}\n\n.dropdown__sub {\n  margin-top: 16px;\n  position: relative;\n  width: 248px;\n\n  &.open {\n    .dropdown__sub__selected {\n      box-shadow: inset 5px 5px 5px #AEAEC033, inset -5px -5px 5px #FFFFFFB2;\n\n      .dropdown__arrow {\n        transform: rotate(-180deg);\n      }\n    }\n\n    .dropdown__sub__body {\n      display: block;\n    }\n  }\n\n}\n\n.dropdown__sub__selected {\n  height: 48px;\n  width: 100%;\n  background: #EDEDEF;\n  box-shadow: -3px -3px 9px #FFFFFF, 3px 3px 9px #AEAEC067;\n  border-radius: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 20px;\n  position: relative;\n  z-index: 2;\n  cursor: pointer; \n\n}\n\n.dropdown__sub__body {\n  position: absolute;\n  box-shadow: 0 5px 15px #38465241;\n  border-radius: 0 0 25px 25px;\n  background: #F0F0F3;\n  width: 100%;\n  top: 35px;\n  padding: 20px 16px 16px;\n // display: none;\n\n}\n\n.dropdown__sub__item {\n  color: #364048;\n  font-weight: 600;\n  font-size: 20px;\n  padding: 13px 0;\n  border-bottom: 1px solid #A9B6C1;\n  cursor: pointer;\n\n  &:last-child {\n    border-bottom: 0;\n    padding-bottom: 3px;\n  }\n\n  &:first-child {\n    padding-top: 0;\n  }\n}\n\n\ninput:autofill {\n  background: transparent !important; /* or any other */\n}",".modal__wrapper {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  width: fit-content;\n  margin: auto;\n  min-height: 500px;\n  height: auto;\n  display: flex;\n  justify-content: center;\n  z-index: 9999999;\n  overflow-y: auto;\n  overflow-x: hidden;\n  box-shadow: 0 5px 15px 0 rgba(56, 70, 82, 2.5);\n  margin-top: 115px;\n  border-radius: 20px;\n}\n\n.modal {\n  width: 992px;\n  border-radius: 20px;\n  box-shadow: 0 5px 15px 0 rgba(56, 70, 82, 0.25);\n  background-color: #f0f0f3;\n  padding: 24px 24px;\n  //height: 990px;\n  height: 500px;\n //overflow-x: hidden;\n overflow-y: scroll;\n\n  &__header {\n    display: flex;\n    position: relative;\n    //align-items: center;\n   // padding-left: 24px;\n    padding-right: 24px;\n  }\n}\n\n::-webkit-scrollbar-track{\n  background: none !important;\n  box-shadow: none !important;\n}\n",".card {\n  width: 312px;\n  // width: 100%;\n  height: 488px;\n  background: #F0F0F3;\n  box-shadow: -8px -8px 24px #FFFFFF, 8px 8px 24px #AEAEC067;\n  border-radius: 24px;\n  margin-right: 40px;\n  margin-bottom: 40px;\n  padding: 24px;\n  position: relative;\n\n  // &:nth-child(4n + 3),\n  // &:nth-child(4n + 4) {\n  //   .card__product__stake__amount {\n  //     right: 20px;\n  //   }\n  // }\n\n  // &:nth-child(1n + 1),\n  // &:nth-child(1n + 2) {\n  //   .card__product__stake__amount {\n  //     right: -168px;\n  //   }\n  // }\n\n  &.aside__card__big {\n    margin: 49px auto 8px;\n    padding: 0;\n    box-shadow: unset;\n\n    .card__wallet__row {\n      background-color: transparent;\n    }\n\n    .card__title {\n      font-size: 18px;\n      text-align: center;\n      max-width: 225px;\n      margin: 0 auto;\n    }\n\n    .card__wallet__usd {\n      font-size: 20px;\n      color: #364048;\n      font-weight: 700;\n    }\n\n    .card__product__number {\n      &.cold {\n        color: #4DC7B5;\n\n        &.empty {\n          color: #889096;\n        }\n      }\n\n      &.hold {\n        color: #EFB661;\n\n        &.empty {\n          color: #889096;\n        }\n      }\n\n      &.risky {\n        color: #F27281;\n\n        &.empty {\n          color: #889096;\n        }\n      }\n\n    }\n  }\n\n\n  .add__wallet {\n    display: none;\n  }\n\n  &.new {\n    .new__layer {\n      border-radius: 24px;\n      background: rgba(#F0F0F3, 0.7);\n      width: 100%;\n      height: 100%;\n      top: 0;\n      left: 0;\n      z-index: 1;\n      position: absolute;\n    }\n\n    .add__wallet {\n      background: #F0F0F3;\n      box-shadow: inset 10px 10px 10px #AEAEC033, inset -10px -10px 10px #FFFFFFB2;\n      width: 136px;\n      height: 136px;\n      border-radius: 50%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      transition: all 0.4s;\n      cursor: pointer;\n      position: absolute;\n      top: 0;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      margin: auto;\n      z-index: 2;\n\n      .save__text {\n        position: absolute;\n        top: 0;\n        left: 0;\n        bottom: 0;\n        right: 0;\n        margin: auto;\n        opacity: 0;\n        visibility: hidden;\n        color: #ffffff;\n        text-transform: uppercase;\n        font-size: 18px;\n        font-weight: normal;\n        max-width: max-content;\n        max-height: max-content;\n      }\n\n      .plus__wrapper {\n        width: 100%;\n        height: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        opacity: 0;\n        visibility: hidden;\n        position: absolute;\n        top: 0;\n        left: 0;\n        bottom: 0;\n        right: 0;\n        margin: auto;\n\n        span {\n          width: 30px;\n          height: 5px;\n          background: #F0F0F3;\n          border-radius: 2px;\n          position: absolute;\n\n          &:nth-child(2) {\n            transform: rotate(90deg);\n          }\n        }\n      }\n\n      &.new {\n        .plus__wrapper {\n          visibility: visible;\n          opacity: 1;\n        }\n      }\n\n      &.save {\n        top: 288px;\n\n        .plus__wrapper {\n          position: absolute;\n          visibility: hidden;\n          opacity: 0;\n        }\n\n        .save__text {\n          opacity: 1;\n          visibility: visible;\n        }\n      }\n\n      .add__wallet__btn__bg {\n        background: #1762A2;\n        width: 80px;\n        height: 80px;\n        border-radius: 50%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        box-shadow: inset 2px 2px 2px rgba(255, 255, 255, 0.44), 10px 10px 30px rgba(174, 174, 192, 0.44), inset -2px -2px 2px #1D1D1D41, -10px -10px 30px #FFFFFF;\n        position: relative;\n\n\n      }\n    }\n\n\n  }\n\n  &.trash {\n    .trash__layer {\n      border-radius: 24px;\n      background: rgba(#F0F0F3, 0.7);\n      width: 100%;\n      height: 100%;\n      top: 0;\n      left: 0;\n      z-index: 1;\n      position: absolute;\n    }\n\n    .trash__wallet {\n      background: #F0F0F3;\n      box-shadow: -8px -8px 24px #FFFFFF, 10px 10px 30px #AEAEC067;\n      ;\n      width: 136px;\n      height: 136px;\n      border-radius: 50%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      transition: all 0.4s;\n      cursor: pointer;\n      position: absolute;\n      top: 110px;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      margin: auto;\n      z-index: 2;\n    }\n\n    .unstacking {\n      display: none;\n    }\n\n    .trash__wallet__icon {\n      width: 44px;\n      height: 48px;\n    }\n\n    .card__settings {\n      opacity: 0;\n      visibility: hidden;\n\n    }\n  }\n\n  &.new__defi {\n    .card__risk {\n      margin-top: 0;\n    }\n  }\n\n  &.empty {\n\n    .card__nft__img,\n    .card__risk__range,\n    .unstacking {\n      opacity: 0;\n      visibility: hidden;\n    }\n\n    .card__product__unstacked,\n    .card__product__stake,\n    .card__risk__chart__number__of,\n    .card__risk__chart__number,\n    .card__risk__alert__title,\n    .card__risk__alert__number,\n    .card__price {\n      color: #C4C4C4;\n    }\n\n    .card__risk__chart__min {\n      box-shadow: inset 0 3px 6px #00000029;\n      border-color: transparent;\n      width: 130px;\n      height: 130px;\n      position: relative;\n\n      &:after {\n        content: \"\";\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        display: inline-flex;\n        margin: 0 auto;\n        width: 9px;\n        height: 9px;\n        background: #c3c3c3;\n        border-radius: 50%;\n      }\n    }\n\n    .card__wallet__row {\n      opacity: 0;\n      visibility: hidden;\n    }\n\n    .add__wallet {\n      background: #F0F0F3;\n      box-shadow: inset 10px 10px 10px #AEAEC033, inset -10px -10px 10px #FFFFFFB2;\n      width: 136px;\n      height: 136px;\n      border-radius: 50%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      transition: all 0.4s;\n      cursor: pointer;\n      position: absolute;\n      top: 0;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      margin: auto;\n      z-index: 2;\n\n      .save__text {\n        position: absolute;\n        top: 0;\n        left: 0;\n        bottom: 0;\n        right: 0;\n        margin: auto;\n        opacity: 0;\n        visibility: hidden;\n        color: #ffffff;\n        text-transform: uppercase;\n        font-size: 18px;\n        font-weight: normal;\n        max-width: max-content;\n        max-height: max-content;\n      }\n\n      .plus__wrapper {\n        width: 100%;\n        height: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        opacity: 0;\n        visibility: hidden;\n        position: absolute;\n        top: 0;\n        left: 0;\n        bottom: 0;\n        right: 0;\n        margin: auto;\n\n        span {\n          width: 30px;\n          height: 5px;\n          background: #F0F0F3;\n          border-radius: 2px;\n          position: absolute;\n\n          &:nth-child(2) {\n            transform: rotate(90deg);\n          }\n        }\n      }\n\n      &.new {\n        .plus__wrapper {\n          visibility: visible;\n          opacity: 1;\n        }\n      }\n\n      &.save {\n        top: 305px;\n\n        .plus__wrapper {\n          position: absolute;\n          visibility: hidden;\n          opacity: 0;\n        }\n\n        .save__text {\n          opacity: 1;\n          visibility: visible;\n        }\n      }\n\n      .add__wallet__btn__bg {\n        background: #1762A2;\n        width: 80px;\n        height: 80px;\n        border-radius: 50%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        box-shadow: inset 2px 2px 2px rgba(255, 255, 255, 0.44), 10px 10px 30px rgba(174, 174, 192, 0.44), inset -2px -2px 2px #1D1D1D41, -10px -10px 30px #FFFFFF;\n        position: relative;\n\n\n      }\n    }\n  }\n\n  &.cold {\n    .card__risk__chart__min {\n      border-color: #4DC7B5;\n    }\n\n    .card__product__number,\n    .card__risk__chart__number__of,\n    .card__risk__chart__number {\n      color: #4DC7B5;\n\n      &.empty {\n        color: #889096;\n      }\n    }\n\n    .card__risk__info:hover {\n      background: #4DC7B5;\n      color: #ffffff;\n    }\n  }\n\n  &.hold {\n    .card__risk__chart__min {\n      border-color: #EFB661;\n    }\n\n    .card__product__number,\n    .card__risk__chart__number__of,\n    .card__risk__chart__number {\n      color: #EFB661;\n\n      &.empty {\n        color: #889096;\n      }\n    }\n\n    .card__risk__info:hover {\n      background: #EFB661;\n      color: #ffffff;\n    }\n  }\n\n  &.risky {\n    .card__risk__chart__min {\n      border-color: #F27281;\n    }\n\n    .card__product__number,\n    .card__risk__chart__number__of,\n    .card__risk__chart__number {\n      color: #F27281;\n\n      &.empty {\n        color: #889096;\n      }\n    }\n\n    .card__risk__info:hover {\n      background: #F27281;\n      color: #ffffff;\n    }\n  }\n\n  &__header {\n    margin-bottom: 8px;\n\n    .row {\n      align-items: flex-start;\n      justify-content: space-between;\n    }\n\n\n  }\n\n  &__settings {\n    border: 0;\n    width: 17px;\n    height: 17px;\n    background: #F0F0F3;\n    border-radius: 50%;\n    box-shadow: -2px -2px 2px #FFFFFF, 2px 2px 2px #AEAEC067;\n    color: #364048;\n    cursor: pointer;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    left: 40px;\n    cursor: pointer;\n    @extend %hover__btn__inset;\n  }\n\n  &__title {\n    font-weight: 600;\n    font-size: 18px;\n    color: #364048;\n    text-align: center;\n\n    span {\n      display: block;\n\n    }\n\n  }\n\n  &__close {\n    width: 16px;\n    height: 16px;\n    border: 0;\n    background-color: transparent;\n    position: relative;\n    display: flex;\n    align-items: center;\n    text-align: center;\n    justify-content: center;\n    //padding: 9px;\n    //cursor: pointer;\n\n    span {\n      height: 100%;\n      position: absolute;\n      top: 0;\n      width: 2px;\n      background: #364048;\n      transform: rotate(45deg);\n\n      &:nth-child(2) {\n        transform: rotate(-45deg);\n      }\n    }\n  }\n\n  &__price {\n    height: 48px;\n    width: 100%;\n    box-shadow: inset 5px 5px 5px #AEAEC033, inset -5px -5px 5px #FFFFFFB2;\n    border-radius: 80px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #4DC7B5;\n    font-size: 18px;\n    line-height: 23px;\n    font-weight: bold;\n    margin-bottom: 16px;\n  }\n\n  &__wallet {\n    width: 100%;\n    height: 108px;\n    box-shadow: inset 5px 5px 5px #AEAEC033, inset -5px -5px 5px #FFFFFFB2;\n    border-radius: 17px;\n    background: rgba(#F0F0F3, 0.05);\n    overflow-x: hidden;\n    overflow-y: auto;\n    margin-bottom: 34px;\n\n    &::-webkit-scrollbar-track {\n      display: none;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      display: none;\n    }\n\n  }\n\n  &__wallet__row {\n    display: flex;\n    justify-content: space-between;\n    height: 35px;\n    padding: 0 15px;\n    align-items: center;\n    overflow: hidden;\n    width: 100%;\n    transition: all 0.4s;\n\n    &:nth-child(2n + 1) {\n      background: rgba(#848484, 0.05);\n    }\n  }\n\n  &__wallet__usd,\n  &__wallet__rates {\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 26px;\n    color: #364049;\n  }\n\n  &__wallet__usd {\n    color: #889096;\n    font-weight: 400;\n  }\n\n  &__risk {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    position: relative;\n  }\n\n  &__risk__title {\n    color: #717679;\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 23px;\n    margin-bottom: 15px;\n  }\n\n  &__risk__chart {\n    width: 144px;\n    height: 144px;\n    box-shadow: inset 6px 6px 6px #AEAEC033, inset -6px -6px 6px #FFFFFFB2;\n    background: #F0F0F3;\n    border-radius: 92px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n  }\n\n  &__risk__chart__min {\n    width: 108px;\n    height: 108px;\n    box-shadow: inset 0 3px 6px #00000029, 0 3px 6px #00000029;\n    border-width: 10px;\n    border-style: solid;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n  }\n\n  &__risk__chart__number {\n    font-weight: bold;\n    font-size: 26px;\n    line-height: 34px;\n  }\n\n  &__risk__chart__number__of {\n\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 18px;\n  }\n\n  &__risk__alert {\n    width: 65px;\n    height: 65px;\n    border-radius: 50%;\n    background: #F0F0F3;\n    box-shadow: -3px -3px 9px #FFFFFF, 3px 3px 9px #AEAEC067;\n    position: absolute;\n    right: 0;\n    top: 19px;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    transition: all 0.4s;\n\n    &.active {\n      @extend %active__btn__inset;\n    }\n\n    @extend %hover__btn__inset;\n  }\n\n  &__risk__alert__title {\n    color: #889096;\n    font-size: 18px;\n    line-height: 18px;\n  }\n\n  &__risk__alert__number {\n    color: #f27281;\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 18px;\n  }\n\n  &__risk__info {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    height: 24px;\n    background: #EBEBEB;\n    border-radius: 50%;\n    color: #cbcbcb;\n    font-size: 12px;\n    position: absolute;\n    bottom: -10px;\n    left: 48px;\n    box-shadow: -2px -2px 2px #FFFFFF, 2px 2px 2px #9191A567;\n    transition: all 0.4s;\n    cursor: pointer;\n  }\n\n  &__product__row {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    align-items: center;\n    margin-bottom: 5px;\n    padding-bottom: 5px;\n    position: relative;\n    width: 100%;\n\n    &:after {\n      content: \"\";\n      width: 100%;\n      border-radius: 67px;\n      height: 3px;\n      box-shadow: inset 10px 10px 10px #AEAEC033, inset -10px -10px 10px #FFFFFFB2;\n    }\n\n\n    .product__row__dropdown {\n      width: 100%;\n      background: #F0F0F3;\n      box-shadow: 0 8px 15px #00000027, -8px -8px 24px #FFFFFF;\n      ;\n      border-radius: 0 0 8px 8px;\n      position: absolute;\n      opacity: 0;\n      visibility: hidden;\n      transition: all 0.4s;\n      padding: 4px 16px;\n      z-index: 9999;\n      top: 30px;\n      left: 0;\n\n      .product__row__dropdown__item {\n        color: #889096;\n        font-size: 18px;\n        line-height: 23px;\n        width: 100%;\n        border-bottom: 1px solid #c9c9ca;\n        text-transform: uppercase;\n        padding: 5px 0;\n        cursor: pointer;\n\n        &:last-child {\n          border-bottom: 0;\n        }\n      }\n\n      &.open {\n        visibility: visible;\n        opacity: 1;\n      }\n    }\n\n  }\n\n  &__product__title {\n    color: #889096;\n    font-size: 18px;\n    line-height: 23px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.4s;\n  }\n\n  &__product__number {\n    font-size: 24px;\n    line-height: 32px;\n    text-shadow: 0 3px 6px #4DC7B534;\n    font-weight: bold;\n  }\n\n  &__product__unstacked,\n  &__product__stake {\n    background: #F0F0F3;\n    box-shadow: inset -5px -5px 5px #7F7FAD21, -5px -5px 15px #FFFFFF, inset 5px 5px 5px #FFFFFF, 5px 5px 15px #8E8EB533;\n    ;\n    border-radius: 20px;\n    cursor: pointer;\n    width: 112px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 0;\n    outline: none;\n    font-size: 18px;\n    line-height: 22px;\n    @extend %hover__btn__inset;\n  }\n\n  &__product__stake__block {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    position: relative;\n    margin-top: 10px;\n    margin-bottom: 10px;\n  }\n\n  &__product__unstacked {\n    color: #BA8557;\n  }\n\n  &__product__stake {\n    color: #5781BA;\n  }\n\n  &__risk__range {\n    width: 8px;\n    height: 176px;\n    // box-shadow: inset 3px 3px 3px #AEAEC033, inset -3px -3px 3px #FFFFFFB2;\n    //border-radius: 88px;\n    // background: #F0F0F3;\n    position: absolute;\n    left: 5px;\n    top: 0;\n    display: none;\n\n    &.active {\n      display: block;\n    }\n  }\n\n  &__risk__range__bg {\n    width: 100%;\n    height: 50%;\n    background: #F27281;\n    box-shadow: inset 3px 3px 3px #40405053;\n    border-radius: 0 0 20px 20px;\n    position: absolute;\n    bottom: 0;\n  }\n\n  &__risk__range__btn {\n    width: 24px;\n    height: 24px;\n    background: #F0F0F3;\n    box-shadow: -2px -2px 6px #FFFFFF, 2px 2px 6px #36364D67;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    position: absolute;\n    top: 50%;\n    left: -8px;\n    cursor: pointer;\n\n    &__min {\n\n      background: #F27281;\n      width: 16px;\n      display: flex;\n      height: 16px;\n      border-radius: 50%;\n      box-shadow: inset 2px 2px 2px rgba(54, 54, 70, 0.6), inset -2px -2px 2px rgba(255, 255, 255, 0.6);\n    }\n  }\n\n  &__risk__range__hr {\n    width: 176px;\n    height: 8px;\n    // box-shadow: inset 3px 3px 3px #AEAEC033, inset -3px -3px 3px #FFFFFFB2;\n    border-radius: 88px;\n    // background: #F0F0F3;\n    position: absolute;\n    left: 5px;\n    top: 0;\n    display: none;\n\n    &.active {\n      display: block;\n    }\n  }\n\n  &__risk__range__bg__hr {\n    width: 50%;\n    height: 100%;\n    //  background: #F27281;\n    //  box-shadow: inset 3px 3px 3px #40405053;\n    border-radius: 20px 0 0 20px;\n    position: absolute;\n    left: 0;\n  }\n\n  &__risk__range__btn__hr {\n    width: 24px;\n    height: 24px;\n    // background: #F0F0F3;\n    // box-shadow: -2px -2px 6px #FFFFFF, 2px 2px 6px #36364D67;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    position: absolute;\n    top: -8px;\n    left: 50%;\n    cursor: pointer;\n\n    &__min {\n\n      background: #F27281;\n      width: 16px;\n      display: flex;\n      height: 16px;\n      border-radius: 50%;\n      box-shadow: inset 2px 2px 2px rgba(54, 54, 70, 0.6), inset -2px -2px 2px rgba(255, 255, 255, 0.6);\n    }\n  }\n\n  &__nft__wrapper {\n    width: 264px;\n    // height: 192px;\n    box-shadow: inset 5px 5px 5px #AEAEC033, inset -5px -5px 5px #FFFFFFB2;\n    border-radius: 17px;\n    margin-bottom: 14px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  &__nft__img {\n    width: 232px;\n    height: 160px;\n    border-radius: 17px;\n  }\n\n\n}\n\n.card__list {\n  width: 344px;\n  height: 88px;\n  background: #F0F0F3;\n  box-shadow: -8px -8px 24px #FFFFFF, 8px 8px 24px #AEAEC067;\n  border-radius: 24px;\n  display: flex;\n  align-items: center;\n  position: relative;\n  padding: 16px;\n  margin-right: 80px;\n  margin-bottom: 48px;\n  cursor: pointer;\n\n  .list.active & {\n    &:not(.active) {\n      opacity: 0.5;\n      user-select: none;\n      cursor: default;\n    }\n  }\n\n  &.cold {\n    .card__risk__chart__list__min {\n      border-color: #4DC7B5;\n    }\n\n    .card__risk__chart__list__number {\n      color: #4DC7B5;\n\n      &.empty {\n        color: #889096;\n      }\n    }\n\n  }\n\n  &.hold {\n    .card__risk__chart__list__min {\n      border-color: #EFB661;\n    }\n\n    .card__risk__chart__list__number {\n      color: #EFB661;\n\n      &.empty {\n        color: #889096;\n      }\n    }\n\n  }\n\n  &.risky {\n    .card__risk__chart__list__min {\n      border-color: #F27281;\n    }\n\n    .card__risk__chart__list__number {\n      color: #F27281;\n\n      &.empty {\n        color: #889096;\n      }\n    }\n  }\n}\n\n.card__list__percent {\n  display: flex;\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  box-shadow: inset 5px 5px 5px #AEAEC033, inset -5px -5px 5px #FFFFFFB2;\n  font-size: 16px;\n  font-weight: bold;\n  align-items: center;\n  justify-content: center;\n  margin-right: 16px;\n}\n\n.card__risk__chart__list {\n  width: 104px;\n  height: 104px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #F0F0F3;\n  position: absolute;\n  right: -52px;\n  top: -10px;\n  border-radius: 50%;\n  box-shadow: inset 6px 6px 6px #AEAEC033, inset -6px -6px 6px #FFFFFFB2;\n}\n\n.card__risk__chart__list__min {\n  width: 56px;\n  height: 56px;\n  display: flex;\n  border-radius: 50%;\n  align-items: center;\n  justify-content: center;\n  border-width: 8px;\n  border-style: solid;\n  box-shadow: inset 0 3px 6px #00000029, 0 3px 6px #00000029;\n}\n\n.card__risk__chart__list__number {\n  font-size: 24px;\n  font-weight: bold;\n}\n\n.card__list__anchor,\n.card__list__title {\n  font-weight: 600;\n  font-size: 18px;\n  color: #364048;\n}\n\n\n.card__risk__chart__list__number {}\n\n.card__risk__alert {\n  cursor: pointer !important;\n}\n\n.unstacking {\n  cursor: pointer;\n}\n\n.card__risk__alert {\n  &:hover {\n    background: #F5F5FA;\n    color: #1762A2;\n  }\n}\n\n.unstacking {\n  &:hover {\n    background: #F5F5FA;\n    color: #1762A2;\n  }\n}\n\n.card__risk__chart__list__number {\n  font-size: 24px;\n  font-weight: bold;\n}\n\n.card__list__anchor,\n.card__list__title {\n  font-weight: 600;\n  font-size: 18px;\n  color: #364048;\n}\n\n\n.card__product__unstacked,\n.card__product__stake,\n.wallet__addresses__top__right__btn,\n.anomalies_detection,\n.limit__block__tabs__list,\n.wallet__addresses__top__input__add,\n.alerts__input__add,\n.layout__grid,\n.layout__list,\n.card__settings,\n// .add__defi__item,\n.wallet__type,\n.to__top,\n.dropdown__selected,\n.dropdown__sub__selectedm,\n.limit__block__top {\n  &:hover {\n    background: #F5F5FA !important;\n  }\n}\n\n.upload_label,\n.add__wallet__btn__plus__bg {\n  &:hover {\n    background: #1762A2;\n  }\n}\n\n.add__wallet__btn__bg,\n.card.new .add__wallet .add__wallet__btn__bg {\n  &:hover {\n    background: #214175 !important;\n  }\n}\n\n// .content_list {\n//   padding-left: 120px !important;\n// }\n\n\n\n\n.card__risk__chart {\n  &>div {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n}\n\n.card.empty {\n  .error__message.requests__message~.add__wallet.save {\n\n    top: 295px;\n\n  }\n\n}\n\n\n.ntf__filter__content {\n  input {\n    align-items: center;\n    margin: 0 10px;\n\n    &::placeholder {\n      color: #889096 !important;\n      font-size: 15px !important;\n      font-weight: 500 !important;\n      line-height: 26px !important;\n      text-decoration: none !important;\n    }\n  }\n\n}\n\n\n.layout__block {\n  position: fixed;\n  z-index: 9;\n  right: 355px;\n  top: 90px;\n}\n.recycle__layout{\n  position: fixed;\n    top: 35px;\n    left: 0;\n    right: 0;\n    bottom: 0;\n}\n\n\n\n.wallet__type__item{\n  &:hover{\n    color:#214175 !important;\n  }\n}",".card__chart__wrapper {\n  width: 736px;\n  height: 530px;\n  background: #f0f0f3;\n  box-shadow: -8px -8px 24px #ffffff, 8px 8px 24px #aeaec067;\n  border-radius: 24px;\n  position: absolute;\n  // left: 282px;\n  // top: 0;\n  // z-index: 99999;\n  padding: 25px 40px 32px 72px;\n  // opacity: 0;\n  // visibility: hidden;\n  transition: opacity 0.4s;\n  margin: auto;\n  position: relative;\n  // .chart__open &{\n  //   opacity: 1;\n  //   visibility: visible;\n  // }\n}\n\n.card__chart {\n  width: 624px;\n  height: 384px;\n  box-shadow: inset 5px 5px 5px #aeaec033, inset -5px -5px 5px #ffffffb2;\n  border-radius: 24px;\n}\n\n.card__chart__title {\n  font-weight: 600;\n  font-size: 18px;\n  color: #364048;\n  margin-right: 25px;\n}\n\n.card__chart__header {\n  margin-bottom: 24px;\n  display: flex;\n  align-items: center;\n}\n\n.check__wrapper {\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n  margin-right: 24px;\n  cursor: pointer;\n\n  &:last-child {\n    margin-right: 0;\n  }\n\n  [type=\"checkbox\"] {\n    display: none;\n\n    &:checked ~ {\n      .checkbox__label {\n        .check__icon {\n          opacity: 1;\n          visibility: visible;\n        }\n      }\n    }\n  }\n\n  &.white .checkbox__box {\n    background: #ebebeb;\n  }\n\n  &.purple .checkbox__box {\n    background: #c9ceff;\n  }\n\n  &.blue .checkbox__box {\n    background: #97eaea;\n  }\n\n  &.yellow .checkbox__box {\n    background: #f0dc8b;\n  }\n\n  .checkbox__box {\n    width: 24px;\n    height: 24px;\n    box-shadow: inset 2px 2px 2px #aeaec033, inset -2px -2px 2px #ffffffb2;\n    border-radius: 6px;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n\n    .check__icon {\n      opacity: 0;\n      visibility: hidden;\n      transition: all 0.4s;\n      width: 12px;\n      height: 12px;\n    }\n  }\n\n  .checkbox__text {\n    display: inline-flex;\n    margin-left: 7px;\n    cursor: pointer;\n  }\n\n  .checkbox__label {\n    display: flex;\n    align-items: center;\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 23px;\n    color: #889096;\n  }\n}\n\n.check__wrapper__all {\n  flex-grow: 1;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.card__chart__dropdown {\n  width: 72px;\n  position: relative;\n  cursor: pointer;\n}\n\n.card__chart__dropdown__selected {\n  font-size: 16px;\n  line-height: 23px;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  color: #2267a4;\n  position: relative;\n\n  &:after {\n    content: \"\";\n    position: absolute;\n    width: 72px;\n    height: 3px;\n    box-shadow: inset 10px 10px 10px #aeaec033, inset -10px -10px 10px #ffffffb2;\n    border-radius: 67px;\n    opacity: 0.93;\n    bottom: -2px;\n  }\n\n  .card__chart__dropdown__selected__arrow {\n    width: 7px;\n    height: 7px;\n    border-bottom: 1px solid #2267a4;\n    border-right: 1px solid #2267a4;\n    transform: rotate(45deg);\n  }\n}\n\n.card__chart__dropdown__block {\n  background: #f0f0f3;\n  width: 100%;\n  padding: 4px 0 4px 7px;\n  box-shadow: 0 8px 15px #00000027;\n  border-radius: 0 0 8px 8px;\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  top: 25px;\n  z-index: 9;\n  //opacity: 0;\n  //visibility: hidden;\n  transition: opacity 0.4s;\n  .open & {\n    opacity: 1;\n    visibility: visible;\n  }\n}\n.card__chart__dropdown__list {\n  color: #889096;\n  font-size: 14px;\n  line-height: 23px;\n  &:hover {\n    color: #2267a4;\n  }\n}\n.chart__open__btn {\n  position: absolute;\n  //  top: 0;\n  left: 10px;\n  width: 24px;\n  height: 24px;\n  cursor: pointer;\n}\n.chart__open__btn__icon,\n.chart__opened__btn__icon {\n  width: 24px;\n  height: 24px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  transition: all 0.4s;\n}\n// .chart__opened__btn__icon{\n//   opacity: 0;\n//   visibility: hidden;\n// }\n// .chart__open{\n//   .chart__opened__btn__icon{\n//     visibility: visible;\n//     opacity: 1;\n//   }\n//   .chart__open__btn__icon{\n//     opacity: 0;\n//     visibility: hidden;\n//   }\n// }\n.card__chart__close {\n  position: absolute;\n  right: 10px;\n  top: 0;\n  bottom: 0;\n  margin-top: auto;\n  margin-bottom: auto;\n  width: 20px;\n  height: 20px;\n  transform: rotate(180deg);\n}\n.card__chart__close__icon {\n  height: 100%;\n  width: 100%;\n  cursor: pointer;\n}\n\n.card__chart__dropdown__selected .card__chart__dropdown__selected__arrow:hover {\n  border-bottom: 2px solid #2658aa;\n  border-right: 2px solid #2658aa;\n  transform: rotate(45deg);\n  width: 7px;\n  height: 7px;\n}\n",".filter__block {\n  position: fixed;\n  right: -100%;\n  bottom: 0;\n  height: calc(100% - 90px);\n  width: 338px;\n\n  box-shadow: 10px 10px 30px rgba(174, 174, 192, 0.4);\n  z-index: 2;\n\n\n  border-radius: 0 15px 15px 15px;\n\n  &.open {\n    right: 0;\n  }\n\n}\n\n.filter__block__scroll {\n  overflow-x: hidden;\n  overflow-y: auto;\n  position: relative;\n  width: 100%;\n  height: 100%;\n  padding: 15px;\n  background: #F0F0F3;\n  z-index: 2;\n}\n\n.filter__block__btn__block {\n  position: absolute;\n  top: 0;\n  left: -75px;\n  width: 90px;\n  height: 60px;\n  background: #F0F0F3;\n  box-shadow: 10px 10px 30px rgba(174, 174, 192, 0.4);\n  border-radius: 15px 0 0 15px;\n  z-index: 1;\n}\n\n.filter__block__title {\n  text-align: center;\n  margin-bottom: 30px;\n  font-weight: bold;\n  font-size: 22px;\n  line-height: 28px;\n  color: #364048;\n}\n\n.risk__btn__row {\n  display: flex;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.risk__btn {\n  width: 40px;\n  height: 40px;\n  background: #F0F0F3;\n  box-shadow: -2px -2px 6px #FFFFFF, 2px 2px 6px #AEAEC067;\n  border-radius: 8px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.4s;\n  @extend %hover__btn__inset;\n  cursor: pointer;\n  outline: none;\n  margin-right: 16px;\n  border: 0;\n}\n\n.risk__btn__text {\n  font-weight: 600;\n  font-size: 18px;\n  display: inline-flex;\n  color: #364048;\n}\n\n.asset__wrapper {\n  margin-bottom: 10px;\n}\n\n.asset__title {\n  text-align: center;\n  margin-bottom: 12px;\n  font-size: 22px;\n  line-height: 28px;\n  color: #364048;\n}\n\n.asset__block {\n  width: 100%;\n  box-shadow: inset 5px 5px 5px rgba(174, 174, 192, 0.2), inset -5px -5px 5px rgba(255, 255, 255, 0.7);\n  border-radius: 17px;\n  list-style-type: none;\n  overflow: hidden;\n  max-height: 160px;\n  overflow: auto;\n  min-height: auto;\n}\n\n.asset__list {\n  &:nth-child(2n + 1) {\n    background: #ebebee;\n    width: 98%;\n  }\n}\n\n.disabled__asset__list{\n  background: #ebebee !important;\n}\n\n.asset__list__check {\n  display: none;\n\n  &:checked ~ .asset__list__label {\n    .asset__list__box {\n      &:after {\n        opacity: 1;\n      }\n    }\n  }\n}\n\n.asset__list__label {\n  display: inline-flex;\n  align-items: center;\n  padding: 8px;\n}\n\n.asset__list__box {\n  width: 24px;\n  height: 24px;\n  box-shadow: inset 2px 2px 2px rgba(174, 174, 192, 0.2), inset -2px -2px 2px rgba(255, 255, 255, 0.7);;\n  border-radius: 6px;\n  display: inline-flex;\n  margin-right: 14px;\n  position: relative;\n\n  &:after {\n    content: \"\";\n    width: 6px;\n    height: 12px;\n    border-bottom: 2px solid #364048;\n    border-right: 2px solid #364048;\n    transform: rotate(40deg) skew(2deg);\n    position: absolute;\n    left: 8px;\n    top: 2px;\n    display: inline-flex;\n    opacity: 0;\n    transition: all 0.4s;\n  }\n}\n\n.asset__list__text {\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 23px;\n}\n\n.reset__btn {\n  position: absolute;\n  right: 8px;\n  top: 8px;\n  width: 40px;\n  height: 40px;\n  background: #F0F0F3;\n  box-shadow: -2px -2px 6px #FFFFFF, 2px 2px 6px #AEAEC067;\n  border-radius: 8px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.4s;\n  @extend %hover__btn__inset;\n  cursor: pointer;\n  outline: none;\n  border: 0;\n}\n.filter__icon{\n  position: relative;\n  z-index: 9999;\n}\n",".header {\n  height: 80px;\n  min-height: 80px;\n  box-shadow: inset 10px 10px 10px #AEAEC033, inset -10px -10px 10px #FFFFFF80;\n  width: 100%;\n  background: #F0F0F3;\n  padding: 0 25px 0 120px;\n  position: relative;\n  z-index: 1;\n  transition: all 0.4s;\n\n  &.open {\n    padding-left: 296px;\n  }\n\n  .row {\n    height: 100%;\n    align-items: center;\n  }\n\n  &__title {\n    font-weight: 700;\n    line-height: 27px;\n    font-size: 22px;\n    transition: all 0.4s;\n\n    .open & {\n      font-size: 26px;\n      line-height: 32px;\n    }\n  }\n\n  &__right {\n    display: flex;\n    margin-left: auto;\n    align-items: center;\n    height: 100%;\n  }\n}\n\n.notification {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &__btn {\n    border: 0;\n    background-color: transparent;\n    cursor: pointer;\n    font-size: 17px;\n    position: relative;\n    color: #868e95;\n  }\n\n  &__status {\n    background: #F5B452;\n    box-shadow: 0 3px 6px #00000040;\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    position: absolute;\n    top: -5px;\n    right: -2px;\n  }\n}\n\n.user {\n  height: 48px;\n  width: 145px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 40px;\n  flex-wrap: wrap;\n  transition: all 0.4s;\n  cursor: pointer;\n\n  &.open {\n    border-radius: 24px;\n    width: 145px;\n    height: 136px;\n    background: #F0F0F3;\n    box-shadow: -4px -4px 12px #FFFFFF, 4px 4px 12px #AEAEC067;\n    align-self: flex-start;\n\n    .log__out {\n      display: inline-flex;\n    }\n\n    &:before,\n    &:after {\n      display: none;\n    }\n  }\n\n  &:before,\n  &:after {\n    content: \"\";\n    box-shadow: inset 10px 10px 10px #AEAEC033;\n    border-radius: 67px;\n    height: 100%;\n    width: 3px;\n    position: absolute;\n    top: 0;\n  }\n\n  &:before {\n    left: 0;\n  }\n\n  &:after {\n    right: 0;\n  }\n\n  &__avatar {\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n    margin-right: 20px;\n  }\n\n  &__name {\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 18px;\n    //max-width: 32px;\n  }\n\n  .log__out {\n    width: 100%;\n    cursor: pointer;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    padding-top: 14px;\n    margin-bottom: 10px;\n    display: none;\n\n    &:before {\n      position: absolute;\n      top: 0;\n      content: \"\";\n      width: 112px;\n      height: 4px;\n      box-shadow: inset 2px 2px 2px #AEAEC033, inset -2px -2px 2px #FFFFFFB2;\n      border-radius: 67px;\n    }\n  }\n\n  .log__out__icon {\n    margin-right: 8px;\n  }\n}\n\n.setting__btn {\n  border: 0;\n  cursor: pointer;\n  color: #868e95;\n  font-size: 16px;\n}\n\n.zoom__page__btn {\n  position: relative;\n  cursor: pointer;\n  .zoom__page__btn__minus,\n  .zoom__page__btn__plus {\n    position: absolute;\n    width: 25px;\n    height: 25px;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    margin: auto;\n    display: inline-block;\n    transition: opacity 0.4s;\n\n  }\n  .zoom__page__btn__minus{\n    opacity: 0;\n    visibility: hidden;\n  }\n}\n",".logo {\n  width: 32px;\n  height: 36px;\n  margin-top: 10px;\n  margin-bottom: 45px;\n  position: relative;\n  &__img {\n    width: 100%;\n    height: 100%;\n  }\n\n  &__img__big {\n    width: 0;\n    height: 0;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    margin: auto;\n    transition: all 0.4s;\n  }\n}\n\n.nav {\n  width: 96px;\n  height: 100vh;\n  background: #F0F0F3;\n  box-shadow: inset 0 3px 6px #00000029, 3px 0 6px #43607926;\n  position: fixed;\n  top: 0;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  z-index: 3;\n  padding-right: 10px;\n  transition: all 0.4s;\n\n  &.open {\n    width: 272px;\n    .logo{\n      width: 200px;\n    }\n    .logo__img {\n      display: none;\n    }\n    .logo__img__big{\n      display: inline-block;\n      width: 100%;\n      height: 100%;\n    }\n\n    .nav__link {\n      width: 208px;\n\n      .nav__text {\n        font-size: 20px;\n        position: relative;\n        opacity: 1;\n        visibility: visible;\n        color: #364048;\n      }\n    }\n  }\n\n  &__block {\n    list-style-type: none;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n  }\n\n  &__list {\n    margin-bottom: 10px;\n\n    &.trash {\n      margin-top: auto;\n    }\n  }\n\n  &__link {\n    font-size: 30px;\n    text-decoration: none;\n    padding: 16px;\n    display: inline-flex;\n    color: #7e92a3;\n    transition: all 0.4s;\n    width: 64px;\n    height: 64px;\n    align-items: center;\n    justify-content: center;\n\n    &:hover,\n    &.active {\n      background: #F0F0F3;\n      box-shadow: inset -3px -3px 3px #FFFFFFB2, inset 0px 3px 6px #00000029, 3px 0px 6px #43607926;\n      border-radius: 12px;\n      color: #2267a4;\n\n      .trash__icon {\n        filter: brightness(0) saturate(100%) invert(33%) sepia(7%) saturate(5984%) hue-rotate(169deg) brightness(102%) contrast(91%);\n\n      }\n    }\n\n    i {\n      // width: 30px;\n      position: relative;\n      z-index: 1;\n    }\n\n    .nav__text {\n      display: inline-flex;\n      color: transparent;\n      margin-right: auto;\n      margin-left: 15px;\n      white-space: nowrap;\n      font-size: 0;\n      transition: font-size 0.2s, visibility 0.4s, opacity 0.4s;\n      opacity: 0;\n      visibility: hidden;\n      position: absolute;\n    }\n  }\n}\n\n.trash__icon {\n  height: 25px;\n}\n\n.menu__open {\n  background: #F0F0F3;\n  box-shadow: inset 0px 3px 6px #00000029, 3px 0px 6px #43607926;\n  width: 106px;\n  height: 106px;\n  position: absolute;\n  border-radius: 50%;\n  top: 50%;\n  right: -53px;\n  clip-path: polygon(0 0, 50% 0, 50% 100%, 0% 100%);\n  transition: all 0.4s;\n\n  &.open {\n    .menu__open__btn {\n      transform: rotate(180deg);\n    }\n\n  }\n}\n\n.menu__open__btn {\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  background: #F0F0F3;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: -2px -2px 6px #FFFFFF, 2px 2px 6px #AEAEC067;\n  cursor: pointer;\n  position: absolute;\n  margin-top: auto;\n  margin-bottom: auto;\n  top: 0;\n  bottom: 0;\n  left: 10px;\n  transition: all 0.4s;\n}\n\n",".main {\n  height: calc(100vh - 56px);\n  overflow: hidden;\n  padding-left: 72px;\n  background: #F0F0F3;\n  display: flex;\n  width: 100%;\n  transition: padding-left 0.4s;\n\n  &.open {\n    padding-left: 325px;\n  }\n\n  &.setting_main {\n    &:after {\n      display: none;\n    }\n  }\n\n  &.empty__trash {\n    position: relative;\n\n    & + .main {\n      &:after {\n        display: none;\n      }\n    }\n  }\n\n  &:after {\n    content: \"\";\n    width: 8px;\n    height: calc(100vh - 110px);\n    position: absolute;\n    right: 338px;\n    top: 100px;\n    box-shadow: inset 4px 4px 4px #AEAEC033, inset -4px -4px 4px #FFFFFFB2;\n    border-radius: 67px;\n  }\n\n  .content {\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding: 56px 24px 24px 24px;\n    height: 100%;\n    width: calc(100% - 338px);\n    margin-left: 24px;\n    margin-top: -24px;\n    position: relative;\n\n    &::-webkit-scrollbar-track {\n      box-shadow: unset;\n    }\n\n    &::-webkit-scrollbar-track-piece:end {\n      background: transparent;\n    }\n\n    &::-webkit-scrollbar-track-piece:start {\n      background: transparent;\n    }\n\n    &.list {\n      padding-left: 120px;\n    }\n  }\n\n}\n\n.to__top {\n  position: fixed;\n  right: 362px;\n  margin-left: auto;\n  bottom: 24px;\n  z-index: 3;\n  width: 40px;\n  height: 40px;\n  background: #F0F0F3;\n  box-shadow: -2px -2px 6px #FFFFFF, 2px 2px 6px #AEAEC067;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.4s;\n  cursor: pointer;\n\n  &__icon {\n    width: 26px;\n    height: 26px;\n  }\n\n  @extend %hover__btn__inset;\n}\n\n.zoom__page__btn,\n.layout__list,\n.layout__grid {\n  margin-left: auto;\n  width: 45px;\n  height: 45px;\n  background: #F0F0F3;\n  box-shadow: -2px -2px 6px #FFFFFF, 2px 2px 6px #AEAEC067;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.4s;\n  margin-bottom: 24px;\n  margin-top: 10px;\n  @extend %hover__btn__inset;\n  cursor: pointer;\n}\n\n.empty__trash__title {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  margin: auto;\n  width: max-content;\n  height: max-content;\n  font-size: 100px;\n  font-weight: normal;\n  font-style: normal;\n  letter-spacing: 0;\n  color: transparent;\n  background: rgba(102, 102, 102, 0.2);\n  -webkit-background-clip: text;\n  -moz-background-clip: text;\n  background-clip: text;\n  padding-right: 5px;\n  text-shadow: 0px 3px 3px rgba(255, 255, 255, 0.5);\n}\n\n.light_core_activate_title {\n  font-size: 30px;\n}\n\n.light_core_activate_text {\n  font-size: 40px;\n}\n\n.light_core_activate_text, .light_core_activate_title {\n  margin: auto;\n  width: max-content;\n  height: max-content;\n  font-weight: normal;\n  font-style: normal;\n  letter-spacing: 0;\n  color: transparent;\n  background: rgba(102, 102, 102, 0.4);\n  -webkit-background-clip: text;\n  -moz-background-clip: text;\n  background-clip: text;\n  text-shadow: 0 3px 3px rgba(255, 255, 255, 0.5);\n}\n\n\n\n.trash__clean {\n  position: fixed;\n  display: inline-flex;\n  bottom: 58px;\n  left: -1px;\n  z-index: 3;\n  width: 80px;\n  height: 60px !important;\n  background: #f7f7f9;\n  box-shadow: unset;\n  color: #2267A4;\n  backdrop-filter: blur(7px);\n  -webkit-backdrop-filter: blur(7px);\n  border-radius: 14px;\n  justify-content: flex-start;\n&:hover{\n  .trash__text__all{\n    text-decoration: none;\n  }\n}\n  .trash__text__all {\n    text-decoration: underline;\n    margin-left: 10px;\n  }\n}\n\n.trash__icon__wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin-left: 20px;\n  margin-top: 10px;\n\n  .trash__icon {\n    filter: brightness(0) saturate(100%) invert(33%) sepia(7%) saturate(5984%) hue-rotate(169deg) brightness(102%) contrast(91%);\n  }\n}\n",".aside {\n  width: 338px;\n  padding: 24px;\n  overflow-y: auto;\n  height: 100%;\n  flex-direction: column;\n  align-items: center;\n  overflow-x: hidden;\n}\n\n.add__wallet__btn {\n  box-shadow: -4px -4px 12px #FFFFFF, 4px 4px 12px #AEAEC067;\n  background-color: #f0f0f3;\n  border-radius: 24px;\n  width: 288px;\n  height: 88px;\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  padding-left: 24px;\n  padding-right: 30px;\n  justify-content: space-between;\n  font-size: 24px;\n  color: #364048;\n  text-transform: capitalize;\n  font-weight: 600;\n  transition: all 0.4s;\n\n  &:hover {\n    background: #F5F5FA;\n    color: #1762A2;\n  }\n\n  &.defi{\n    padding: 0 16px;\n    .add__wallet__btn__plus{\n      width: 88px;\n      height: 56px;\n      border-radius: 157px;\n      padding:  0 8px;\n      margin-right: 12px;\n    }\n  }\n}\n\n.add__wallet__btn__plus {\n  background: #F0F0F3;\n  box-shadow: inset 10px 10px 10px #AEAEC033, inset -10px -10px 10px #FFFFFFB2;\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &.defi {\n    width: auto;\n  }\n\n  .fox {\n    width: 32px;\n    height: 25px;\n    margin-right: 8px;\n  }\n\n  .coinbase {\n    width: 25px;\n    height: 25px;\n  }\n}\n\n.add__wallet__btn__plus__bg {\n  background: #1762A2;\n  width: 35px;\n  height: 35px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: inset 2px 2px 2px rgba(255, 255, 255, 0.44), 10px 10px 30px rgba(174, 174, 192, 0.44), inset -2px -2px 2px #1D1D1D41, -10px -10px 30px #FFFFFF;\n  position: relative;\n  cursor: pointer;\n\n  span {\n    width: 12px;\n    height: 2px;\n    background: #F0F0F3;\n    border-radius: 2px;\n    position: absolute;\n\n    &:nth-child(2) {\n      transform: rotate(90deg);\n    }\n  }\n}\n\n.aside__wallet__title {\n  color: #364048;\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 32px;\n  margin-top: 39px;\n  margin-bottom: 25px;\n  text-align: center;\n}\n\n.aside__chart__wrapper {\n  position: relative;\n  margin-bottom: 45px;\n  height: 315px;\n\n  &.cold {\n    .card__risk__chart__min {\n      border-color: #4DC7B5;\n    }\n\n    .card__risk__chart__number__of,\n    .card__risk__chart__number {\n      color: #4DC7B5;\n    }\n\n    .card__risk__info:hover {\n      background: #4DC7B5;\n      color: #ffffff;\n    }\n  }\n\n  &.hold {\n    .card__risk__chart__min {\n      border-color: #EFB661;\n    }\n\n    .card__risk__chart__number__of,\n    .card__risk__chart__number {\n      color: #EFB661;\n    }\n\n    .card__risk__info:hover {\n      background: #EFB661;\n      color: #ffffff;\n    }\n  }\n\n  &.risky {\n    .card__risk__chart__min {\n      border-color: #F27281;\n    }\n\n    .card__risk__chart__number__of,\n    .card__risk__chart__number {\n      color: #F27281;\n    }\n\n    .card__risk__info:hover {\n      background: #F27281;\n      color: #ffffff;\n    }\n  }\n\n  .card__risk__chart {\n    width: 232px;\n    height: 232px;\n    border-radius: 50%;\n    margin: 0 auto;\n    &>div{\n      display: flex;\n      align-items: center;\n      justify-content: center; \n    }\n  }\n\n  .card__risk__chart__min {\n    width: 178px;\n    height: 178px;\n    border-width: 20px;\n  }\n\n  .card__risk__chart__number {\n    font-size: 35px;\n  }\n\n  .card__risk__chart__number__of {\n    font-size: 19px;\n  }\n\n  .card__risk__alert {\n    width: 90px;\n    height: 90px;\n    top: unset;\n    bottom: 6px;\n    right: -8px;\n    cursor: pointer;\n  }\n\n  .card__risk__alert__title {\n    font-size: 20px;\n    line-height: 26px;\n  }\n\n  .card__risk__alert__number {\n    font-size: 20px;\n    line-height: 26px;\n  }\n  .card__risk__range__hr{\n    top: unset;\n    bottom: 47px;\n    left: 0;\n  }\n}\n\n.aside__tabs {\n  display: flex;\n  list-style-type: none;\n  justify-content: space-between;\n  position: relative;\n  margin-bottom: 34px;\n\n  &:after {\n    content: \"\";\n    width: calc(100% + 24px);\n    left: -12px;\n    bottom: -10px;\n    height: 3px;\n    box-shadow: inset 4px 4px 4px #AEAEC033, inset -4px -4px 0px #FFFFFFB2;\n    position: absolute;\n    background: #F0F0F3;\n\n  }\n\n  &__link {\n    text-decoration: none;\n    color: #9CA3A8;\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 23px;\n    position: relative;\n    display: flex;\n    border: none;\n    outline: none;\n\n    &:after {\n      content: \"\";\n      width: 0;\n      transition: all 0.4s;\n      height: 3px;\n      background: #2658AA;\n      box-shadow: inset -2px -2px 2px #1D1D1D41, -10px -10px 30px #FFFFFF;\n      border-radius: 67px;\n      position: absolute;\n      bottom: -10px;\n      z-index: 1;\n    }\n\n    &:hover,\n    &.active {\n      color: #364048;\n\n      &:after {\n        width: 100%;\n      }\n\n    }\n  }\n}\n.aside__card {\n  background: #F0F0F3;\n  box-shadow: -5px -5px 15px #FFFFFF, 5px 5px 15px #AEAEC067;\n  border-radius: 24px;\n  padding: 21px 24px 15px;\n  position: relative;\n  margin-bottom: 24px;\n  &.cold {\n    .aside__card__progress__bg {\n      background: #28B663;\n    }\n  }\n\n  &.hot {\n    .aside__card__progress__bg {\n      background: #EFB661;\n    }\n  }\n\n  &__title {\n    color: #9CA3A8;\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 23px;\n    margin-bottom: 8px;\n  }\n\n  &__numbers {\n    font-weight: 700;\n    font-size: 24px;\n    line-height: 32px;\n    display: flex;\n    align-items: flex-end;\n    margin-bottom: 15px;\n\n    span {\n      font-size: 14px;\n      display: flex;\n      margin-bottom: -10px;\n    }\n  }\n\n  &__progress {\n    width: 100%;\n    height: 8px;\n    box-shadow: inset 4px 4px 4px #AEAEC033, inset -4px -4px 0px #FFFFFFB2;\n    border-radius: 67px;\n    background: #F0F0F3;\n\n    &__bg {\n      height: 100%;\n      box-shadow: inset -2px -2px 2px #1D1D1D41, -10px -10px 30px #FFFFFF, inset 4px 4px 4px #AEAEC033;\n      border-radius: 67px;\n      transition: all 0.4s;\n    }\n  }\n\n  .card__risk__alert {\n    position: relative;\n    margin-left: auto;\n    font-weight: 600;\n    width: 64px;\n    height: 64px;\n    top: 4px;\n    right: -11px;\n  }\n\n  .card__risk__alert__number,\n  .card__risk__alert__title {\n    line-height: 16px;\n    font-size: 16px;\n  }\n  .card__risk__range__hr{\n    width: 105px;\n    top: 60px;\n    left: 80px;\n  }\n}\n",".wallet__type {\n  width: 168px;\n  padding: 9px 0;\n  position: relative;\n  border-radius: 24px;\n  box-shadow: -3px -3px 9px 0 #fff, 3px 3px 9px 0 rgba(174, 174, 192, 0.4);\n  background-color: #ededef;\n  cursor: pointer;\n  position: absolute;\n\n  &__item {\n    font-size: 18px;\n    font-weight: 600;\n    letter-spacing: normal;\n    text-align: center;\n    width: 100%;\n    margin-top: 12px;\n    display: flex;\n    align-items: center;\n    padding-left: 18px;\n    color: #364048;\n\n    &:nth-of-type(1) {\n      margin-top: 0;\n    }\n  }\n\n  .wallet__type__arrow {\n    position: absolute;\n    right: 17px;\n    top: 17px;\n    filter: brightness(0) saturate(100%) invert(24%) sepia(8%) saturate(958%) hue-rotate(165deg) brightness(93%) contrast(94%);\n    height: 8px;\n    cursor: pointer;\n  }\n}\n\n.wallet__type__btn {\n  width: 336px;\n  height: 48px;\n  border-radius: 80px;\n  background: #F0F0F3;\n  margin-left: 40px;\n  color:#889096;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 500;\n  font-size: 18px;\n  box-shadow: inset -5px -5px 5px #FFFFFFB2, inset 5px 5px 5px #AEAEC033;\n  border: none;\n  outline: none;\n  text-align: center;\n  padding: 0 10px;\n  @extend %hover__btn;\n}\n\n.wallet__type__btn::placeholder {\n  font-weight: 600;\n  font-size: 18px;\n  color:#889096;\n  font-weight: 500;\n}\n\n.wallet__type__save {\n  width: 104px;\n  height: 40px;\n  border-radius: 67px;\n  box-shadow: -5px -5px 15px 0 #fff, 5px 5px 15px 0 rgba(174, 174, 192, 0.4);\n  background-color: #214175;\n  font-size: 18px;\n  font-weight: 400;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  margin-left: auto;\n  cursor: pointer;\n  border: 0;\n  @extend %hover__btn__blue;\n}\n\n.wallet__addresses {\n  border-radius: 22px;\n  background-color: #ededef;\n  padding: 24px;\n  margin-top: 24px;\n}\n\n.wallet__addresses__top {\n  //display: flex;\n  position: relative;\n\n  .card__close {\n    position: absolute;\n   // right: 0;\n  }\n}\n\n.wallet__addresses__top__left {\n  margin-right: 16px;\n\n  .wallet__addresses__top__label {\n  //  text-align: center;\n  }\n}\n\n.wallet__addresses__top__label {\n  margin-bottom: 4px;\n  font-size: 22px;\n  font-weight: 600;\n  line-height: 1.36;\n  text-align: left;\n  color: #364048;\n}\n\n.wallet__addresses__top__middle {\n  margin-right: 16px;\n\n  .wallet__addresses__top__label {\n    margin-left: 70px;\n  }\n}\n\n.wallet__addresses__top__input__wrapper {\n  width: 584px;\n  height: 48px;\n  border-radius: 80px;\n  box-shadow: inset 5px 5px 5px #AEAEC033, inset -5px -5px 5px #FFFFFFB2;\n  background: #EDEDEF;\n  margin-bottom: 8px;\n  display: flex;\n  align-items: center;\n  padding: 8px;\n}\n\n.wallet__addresses__top__input {\n  width: calc(100% - 32px);\n  height: 100%;\n  background-color: transparent;\n  border: 0;\n  text-align: center;\n  outline: none;\n  font-size: 18px;\n  font-weight: 600;\n  color: #364048;\n}\n\n.wallet__addresses__top__input__add {\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  background: #EDEDEF;\n  box-shadow: -2px -2px 6px #FFFFFF, 2px 2px 6px #AEAEC067;\n  border-radius: 24px;\n  width: 32px;\n  height: 32px;\n  border: 0;\n  outline: none;\n  cursor: pointer;\n\n  span {\n    width: 12px;\n    height: 2px;\n    background: #2167A4;\n    border-radius: 2px;\n    position: absolute;\n\n    &:nth-child(2) {\n      transform: rotate(90deg);\n    }\n  }\n}\n\n.wallet__addresses__top__right__btn {\n  width: 112px;\n  height: 48px;\n  // margin-top: 28px;\n  padding: 9px 0;\n  position: relative;\n  border-radius: 24px;\n  box-shadow: -3px -3px 9px 0 #fff, 3px 3px 9px 0 rgba(174, 174, 192, 0.4);\n  background-color: #ededef;\n  font-size: 18px;\n  color: #364048;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 0;\n  cursor: pointer;\n  outline: none;\n // top: 7px;\n  font-weight: 500;\n  @extend %hover__btn__inset;\n}\n\n.limit__block {\n  width: 168px;\n  height: 96px;\n  background: #EDEDEF;\n  border-radius: 21px;\n\n  &__bottom,\n  &__top {\n    height: 50%;\n    font-size: 18px;\n    line-height: 23px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: none;\n    outline: none;\n    width: 100%;\n    text-align: center;\n    cursor: pointer;\n  }\n\n  .limit__block__bottom::placeholder {\n    color: #4DC7B5;\n    font-weight: 600;\n    font-size: 13px;\n    line-height: 23px;\n  }\n\n  &__top {\n    color: #364048;\n    box-shadow: inset 5px 5px 5px #AEAEC033, inset -5px -5px 5px #FFFFFFB2;\n    ;\n    border-radius: 21px 21px 0 0;\n    @extend %hover__btn;\n\n    &.active {\n      @extend %active__btn;\n\n      .limit__block__top__slider {\n        opacity: 1;\n        visibility: visible;\n      }\n    }\n\n    position: relative;\n  }\n\n  &__bottom {\n    color: #4DC7B5;\n    font-weight: 600;\n    background-color: #f0f0f3;\n    box-shadow: inset 5px 5px 5px #AEAEC033, inset -5px -5px 5px #FFFFFFB2;\n    ;\n    border-radius: 0 0 21px 21px;\n  }\n}\n\n.limit__block__wrapper {\n  display: flex;\n  padding: 16px;\n  box-shadow: inset 5px 5px 5px #AEAEC033, inset -5px -5px 5px #FFFFFFB2;\n  border-radius: 0 21px 21px 21px;\n}\n\n.wallet__addresses__bottom {\n  display: flex;\n  align-items: flex-end;\n  margin-top: 10px;\n\n  .limit__block {\n    margin-right: 16px;\n\n    &:last-child {\n      margin-right: 0;\n    }\n  }\n}\n\n.wallet__addresses__bottom__right,\n.wallet__addresses__bottom__left {\n  padding-bottom: 15px;\n}\n\n.wallet__addresses__bottom__middle {\n  margin-left: 16px;\n  margin-right: 32px;\n}\n\n.limit__block__tabs {\n  list-style-type: none;\n  display: flex;\n}\n\n.limit__block__tabs__list {\n  padding: 14px 16px 8px;\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 26px;\n  color: #364048;\n  background: #EDEDEF;\n  box-shadow: -2px 0px 6px #AEAEC02F;\n  border-radius: 24px 24px 0 0;\n  cursor: pointer;\n  transition: all 0.4s;\n\n\n  &.active {\n    box-shadow: inset 5px 5px 5px #AEAEC033, inset -5px -5px 5px #FFFFFFB2;\n  }\n}\n\n.anomalies__label {\n  width: 112px;\n  height: 112px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: -3px -3px 9px #FFFFFF, 3px 3px 9px #AEAEC067;\n  //box-shadow: inset 4px 4px 4px #AEAEC033, inset -4px -4px 2px #FFFFFFB2;\n  //background: transparent linear-gradient(51deg, #EDEDEF 0%, #DEE5F0 100%) 0 0 no-repeat padding-box;\n}\n\n.anomalies__check {\n  display: none;\n\n  &:checked {\n    &~.anomalies__label {\n      background: transparent linear-gradient(51deg, #EDEDEF 0%, #DEE5F0 100%) 0% 0% no-repeat padding-box;\n      box-shadow: inset 4px 4px 4px #AEAEC033, inset -4px -4px 2px #FFFFFFB2;\n\n      .anomalies__check__box {\n        &:after {\n          opacity: 1;\n          visibility: visible;\n        }\n      }\n    }\n  }\n}\n\n.anomalies__text {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 18px;\n  color: #364048;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  flex-direction: column;\n  margin-bottom: 6px;\n}\n\n.anomalies__check__box {\n  width: 24px;\n  display: flex;\n  height: 24px;\n  box-shadow: inset 2px 2px 2px #AEAEC033, inset -2px -2px 2px #FFFFFFB2;\n  border-radius: 6px;\n  position: relative;\n  margin-top: 12px;\n\n  &:after {\n    content: \"\";\n    width: 6px;\n    position: absolute;\n    left: 8px;\n    top: 2px;\n    height: 12px;\n    border-bottom: 2px solid #364048;\n    border-right: 2px solid #364048;\n    transform: rotate(45deg) skew(10deg);\n    opacity: 0;\n    visibility: hidden;\n  }\n}\n\n.limit__block__top__slider {\n  background: #EDEDEF;\n    box-shadow: -2px -2px 6px #ffffff, 2px 2px 6px rgba(174, 174, 192, 0.4);\n    width: 150px;\n    height: 150px;\n    border-radius: 50%;\n    position: absolute;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    top: -51px;\n    opacity: 0;\n    transition: all 0.4s;\n    visibility: hidden;\n    margin: auto;\n    left: 10px;\n    flex-direction: column;\n}\n\n.limit__block__top__slider__info {\n  width: 152px;\n  height: 152px;\n  box-shadow: inset 0 3px 6px #00000029, 0 3px 6px #00000029;\n  border-radius: 50%;\n  border: 20px solid #214175;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n\n}\n\n.limit__block__top__slider__info__time {\n  color: #214175;\n  font-weight: bold;\n  font-size: 26px;\n  line-height: 34px;\n}\n\n.limit__block__top__slider__info__time__of {\n  color: #214175;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 18px;\n}\n\n.whitelist__ad__block {\n  position: absolute;\n  background: #F0F0F3;\n  box-shadow: 0 5px 15px #38465240;\n  border-radius: 20px;\n  width: 920px;\n  padding: 32px 32px 24px;\n  left: 0;\n  top: 90px;\n  z-index: 1;\n\n  .row {\n    justify-content: space-between;\n  }\n}\n\n.whitelist__ad__block__bottom {\n  width: 100%;\n  position: relative;\n  margin-top: 8px;\n\n  .add__wallet__btn__plus__bg {\n    margin: 0 auto;\n    cursor: pointer;\n    display: flex;\n  }\n\n  .dropdown {\n    position: absolute;\n    right: 0;\n    top: 0;\n  }\n}\n\n.whitelist__ad__block__input__wrapper {\n  width: 416px;\n  height: 48px;\n  border-radius: 80px;\n  box-shadow: inset 5px 5px 5px #AEAEC033, inset -5px -5px 5px #FFFFFFB2;\n  background: #EDEDEF;\n  margin: 8px 8px 8px 0;\n  display: flex;\n  align-items: center;\n  padding: 8px;\n}\n\n.whitelist__ad__block__input {\n  width: 100%;\n  height: 100%;\n  background-color: transparent;\n  border: 0;\n  text-align: center;\n  outline: none;\n  font-size: 15px;\n  line-height: 23px;\n  color: #364048;\n}\n\n.wallet__unstaking .unstacking {\n  right: -45px;\n  bottom: -40px;\n}\n\n.card__unstaking__slider .rangeslider-vertical .rangeslider__handle-label{\n  background: #385483 ;\n}\n\n.card__unstaking__slider .rangeslider-vertical .rangeslider__fill {\n  background:#385483;\n}\n\n\n\n\n",".card {\n  &.defi {\n    padding-top: 8px;\n    position: relative;\n\n    .card__header .row {\n      align-items: center;\n    }\n\n    .card__wallet__row {\n      background-color: transparent;\n    }\n\n    .card__wallet__rates {\n      color: #889096;\n    }\n\n    .card__wallet__usd {\n      color: #364048;\n      font-weight: bold;\n    }\n\n    .card__product__row {\n      padding-bottom: 0;\n    }\n\n    .card__title {\n      font-weight: 600;\n      display: inline-flex;\n      align-items: center;\n    }\n\n    .card__header {\n      padding: 10px 0;\n    }\n\n    .card__header .row {\n      align-items: center;\n      justify-content: center;\n    }\n\n    .card__header .card__close {\n     // position: absolute;\n     // top: 22px;\n     // right: 15px;\n    }\n\n    .card__price {\n      margin-bottom: 5px;\n    }\n\n    .card__risk__title {\n      margin-bottom: 10px;\n    }\n  }\n}\n\n.card__product__stake__amount {\n  opacity: 0;\n  visibility: hidden;\n  position: fixed;\n  // right: -100%;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  width: 408px;\n  background: #F0F0F3;\n  box-shadow: 10px 10px 30px #6F6F8467;\n  border-radius: 12px;\n  z-index: 999999999999999;\n  padding: 24px 16px 16px 24px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  margin: auto;\n\n  &.open {\n    visibility: visible;\n    opacity: 1;\n  }\n}\n\n.card__product__stake__amount__input__wrapper {\n  width: 224px;\n  height: 48px;\n  border-radius: 80px;\n  box-shadow: inset 5px 5px 5px #AEAEC033, inset -5px -5px 5px #FFFFFFB2;\n  background: #EDEDEF;\n  margin-bottom: 8px;\n  display: flex;\n  align-items: center;\n  padding: 8px;\n\n}\n\n.card__product__stake__amount__input {\n  width: 100%;\n  height: 100%;\n  background-color: transparent;\n  border: 0;\n  text-align: center;\n  outline: none;\n  font-size: 18px;\n  font-weight: 600;\n  color: #364048;\n}\n\n.card__product__stake__amount__max {\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 23px;\n  width: 128px;\n  height: 48px;\n  color: #364048;\n  border-radius: 24px;\n  box-shadow: -3px -3px 9px 0 #fff, 3px 3px 9px 0 rgba(174, 174, 192, 0.4);\n  background-color: #ededef;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 0;\n  cursor: pointer;\n  outline: none;\n  @extend %hover__btn__inset;\n}\n\n.card__product__stake__amount__confirm {\n  width: 100%;\n  height: 40px;\n  border-radius: 67px;\n  box-shadow: -5px -5px 15px 0 #fff, 5px 5px 15px 0 rgba(174, 174, 192, 0.4);\n  background-color: #214175;\n  font-size: 18px;\n  font-weight: 400;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  cursor: pointer;\n  border: 0;\n  margin-top: 8px;\n  @extend %hover__btn__blue;\n}\n\n.unstacking {\n  width: 95px;\n  height: 95px;\n  border-radius: 50%;\n  background: #F0F0F3;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: -3px -3px 9px #FFFFFF, 3px 3px 9px #AEAEC067;\n  color: #889096;\n  font-size: 16px;\n  line-height: 18px;\n  flex-direction: column;\n  text-align: center;\n  position: absolute;\n  right: -13px;\n  bottom: -18px;\n  transition: all 0.4s;\n\n  span {\n    color: #F27281;\n  }\n\n  &.active,\n  &:hover {\n    box-shadow: unset;\n    color: rgba(#889096, 0.49);\n\n    span {\n      color: rgba(#889096, 0.49);\n    }\n  }\n}\n\n.add__defi__block {\n  width: 56px;\n  padding: 16px 0;\n  background: #F0F0F3;\n  box-shadow: inset 4px 4px 4px #AEAEC033, inset -4px -4px 4px #FFFFFFB2;\n  border-radius: 10px;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  position: absolute;\n  right: 0px;\n  top: 320px;\n}\n\n\n\n\n.contract__address_container{\n  width: 660px;\n  height: fit-content;\n  background: #F0F0F3;\n  box-shadow: -8px -8px 24px #ffffff, 8px 8px 24px rgb(174 174 192 / 40%);\n  padding: 20px;\n  border-radius: 24px;\n  position: absolute;\n  z-index: 9999;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  top: 0;\n}\n\n\n.add__defi__item {\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #F0F0F3;\n  // box-shadow: -2px -2px 6px #FFFFFF, 2px 2px 6px #AEAEC067;\n  border-radius: 8px;\n  margin-bottom: 16px;\n  cursor: pointer;\n  @extend %hover__btn__inset;\n\n  &:nth-child(1) {\n    height: auto;\n    margin-bottom: 8px;\n    box-shadow: unset;\n    background-color: transparent;\n  }\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n\n\n.defi_shild__modal .ReactModal__Content .ReactModal__Content--after-open {\n  background: none !important;\n  border: none !important;\n  max-width: 320px !important;\n  height: 490px !important;\n}\n\n.defi_shild__modal {\n  max-width: 320px !important;\n  height: 490px !important;\n  margin: 112px 116px;\n}\n\n.add_investment_btn {\n  margin: 20px auto !important;\n}\n\n.card__product__title_item {\n  font-weight: bold;\n}\n\n.title_item {\n  display: flex;\n  justify-content: flex-end;\n}\n\n::-webkit-scrollbar-track {\n  background: none !important;\n  box-shadow: none !important;\n}\n\n\n.defi__select__wrapper {\n  display: flex !important;\n  justify-content: space-between !important;\n  align-items: center !important;\n  text-align: center;\n  border-bottom: 1px solid rgba(174, 174, 192, 0.2) !important;\n}\n\n\n\n\n.investment_card{\n.rangeslider-horizontal {\n\n  width: 117px !important;\n}}\n",".setting {\n  height: 100%;\n  width: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  padding-top: 50px;\n\n  & > .row {\n    width: 100%;\n    align-items: stretch;\n    height: 100%;\n  }\n}\n\n\n.user__info {\n  height: 865px;\n  width: 368px;\n  position: relative;\n  margin-left: 100px;\n  margin-right: 70px;\n}\n\n.user__info__avatar__block {\n  width: 100%;\n  height: 368px;\n  background: #F0F0F3 linear-gradient(132deg, #ECECF0 0%, #F2F2F5 100%) 0 0;\n  border-radius: 50%;\n  box-shadow: -8px -8px 15px #FFFFFF, 8px 8px 15px #AEAEC067;\n  position: relative;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.user__info__avatar__wrapper {\n  width: 336px;\n  height: 336px;\n  border-radius: 50%;\n  position: relative;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n    &:hover{\n    .upload__content{\n    opacity: 1;\n    }\n    }\n\n  // &:after {\n  //   content: \"\";\n  //   width: 100%;\n  //   height: 100%;\n  //   position: absolute;\n  //   top: 0;\n  //   left: 0;\n  //   border-radius: 50%;\n  //   box-shadow: -8px -8px 15px #FFFFFF, 8px 8px 15px #AEAEC067;\n  //   z-index: 2;\n  //   background: transparent radial-gradient(closest-side at 50% 50%, #69686F00 0%, #6A697180 94%, #727179 100%) 0% 0% no-repeat padding-box;\n  // }\n}\n\n.user__info__desc__block {\n  width: 100%;\n  background: #F0F0F3;\n  box-shadow: -5px -5px 15px #FFFFFF, 5px 5px 15px #AEAEC067;\n  border-radius: 30px;\n  padding-top: 200px;\n  margin-top: -200px;\n  display: flex;\n  flex-direction: column;\n}\n\n.user__info__name {\n  font-weight: 600;\n  font-size: 22px;\n  line-height: 28px;\n  color: #364048;\n  text-align: center;\n  box-shadow: inset 0 5px 5px #AEAEC033, inset 0px -5px 5px #FFFFFFB2;\n  margin-top: 25px;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.user__info__desc {\n  box-shadow: inset 0 5px 5px #AEAEC033, inset 0px -5px 5px #FFFFFFB2;\n  text-align: center;\n  margin-top: 24px;\n  padding: 24px 32px;\n  margin-bottom: 99px;\n}\n\n.user__info__desc__text {\n  font-size: 22px;\n  line-height: 28px;\n  color: #364048;\n  border: none;\n  outline: none;\n  background: none;\n  text-align: center;\n  height: 250px;\n   resize: none;\n}\n\n\n.settings__tabs {\n  list-style-type: none;\n  display: flex;\n  position: relative;\n  z-index: 1;\n  max-width: max-content;\n}\n\n.settings__tabs__link {\n  padding: 32px 28px;\n  font-weight: 600;\n  font-size: 22px;\n  line-height: 28px;\n  color: #364048;\n  text-align: center;\n  text-decoration: none;\n  display: inline-flex;\n  width: 295px;\n  justify-content: center;\n  align-items: center;\n  transition: all 0.4s;\n  box-shadow: 5px 5px 5px #AEAEC033;\n\n  &.active,\n  &:hover {\n    box-shadow: inset 5px 5px 5px #AEAEC033, inset -5px -5px 5px #FFFFFFB2;\n    border-radius: 21px 21px 0 0;\n  }\n}\n\n.settings__tabs__list {\n  cursor: pointer;\n  &:first-child {\n    .settings__tabs__link {\n      border-top-left-radius: 21px;\n    }\n  }\n\n  &:last-child {\n    .settings__tabs__link {\n      border-top-right-radius: 21px;\n    }\n  }\n}\n\n.password__change__block {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 400px;\n  margin-left: 88px;\n}\n\n.password__change__block__title {\n  font-weight: 600;\n  font-size: 17px;\n  line-height: 19px;\n  color: #364048;\n  text-align: center;\n  margin-bottom: 16px;\n  margin-top: 10px;\n}\n\n.password__change__input {\n  width: 304px;\n  height: 48px;\n  background: #F0F0F3;\n  border: 0;\n  border-radius: 67px;\n  text-align: center;\n  font-size: 18px;\n  line-height: 23px;\n  font-weight: 600;\n  outline: none;\n  box-shadow: inset 5px 5px 5px #AEAEC033, inset -5px -5px 5px #FFFFFFB2;\n  margin-bottom: 16px;\n  display: inline-flex;\n\n  &::placeholder {\n    color: #939A9F;\n  }\n}\n\n.password__change__btn {\n  width: 304px;\n  height: 40px;\n  box-shadow: -5px -5px 15px #FFFFFF, 5px 5px 15px #AEAEC067;\n  background: #214175;\n  color: #FFFFFF;\n  font-weight: 600;\n  font-size: 18px;\n  // line-height: 23;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 67px;\n  cursor: pointer;\n  outline: none;\n  border: 0;\n  @extend %hover__btn__blue;\n}\n\n.qr__wrapper {\n  width: 112px;\n  height: 112px;\n  box-shadow: inset 5px 5px 5px #AEAEC033, inset -5px -5px 5px #FFFFFFB2;\n  border-radius: 16px;\n  padding: 8px;\n  margin-top: 16px;\n}\n\n.qr__img {\n  width: 96px;\n  height: 96px;\n  overflow: hidden;\n  border-right: 16px;\n}\n\n.alerts__input__box {\n  width: 350px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n\n.alerts__input__box__all {\n  display: flex;\n  width: 100%;\n  flex-wrap: wrap;\n  flex-direction: column;\n  height: 515px;\n  .alerts__input__wrapper {\n    margin-right: 40px;\n  }\n}\n\n.alerts__input__wrapper {\n  width: 370px;\n  transition: all 0.4s;\n  height: 48px;\n  background: #F0F0F3;\n  border-radius: 67px;\n  box-shadow: inset 5px 5px 5px #AEAEC033, inset -5px -5px 5px #FFFFFFB2;\n // margin-bottom: 16px;\n  display: flex;\n  align-items: center;\n  position: relative;\n\n  &.disable {\n    width: 370px;\n\n    .alerts__input__add {\n      display: none;\n    }\n\n    .alerts__input {\n      color: #939A9F;\n    }\n\n    .alerts__input__check {\n      display: flex;\n    }\n  }\n\n  &.active {\n    width: 370px;\n\n    .alerts__input__add {\n      display: none;\n    }\n\n    .alerts__input {\n      color: #364048;\n    }\n\n\n    &.one {\n      // width: 100%;\n\n      .alerts__input__add {\n        display: flex;\n      }\n    }\n  }\n\n  &.links {\n    .alerts__input__icon__wrapper {\n      width: auto;\n      box-shadow: unset;\n      padding-left: 8px;\n    }\n\n    .alerts__input__icon {\n      cursor: pointer;\n      margin-right: 10px;\n\n      &:last-child {\n        margin-right: 0;\n      }\n    }\n\n    .alerts__input {\n      display: none;\n    }\n\n    .alerts__input__check {\n      display: none;\n    }\n  }\n\n  .alerts__input {\n    width: 270px;\n    background-color: transparent;\n    border: 0;\n    outline: none;\n    text-align: center;\n    font-size:18px;\n    line-height: 23px;\n    transition: all 0.4s;\n\n    &::placeholder {\n      color: #939A9F;\n    }\n  }\n\n  .alerts__input__check {\n    width: 24px;\n    min-width: 24px;\n    height: 24px;\n    min-height: 24px;\n    box-shadow: inset 2px 2px 2px #AEAEC033, inset -2px -2px 2px #FFFFFFB2;\n    border-radius: 6px;\n    margin-right: 15px;\n    margin-left: 10px;\n    transition: all 0.4s;\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    .alerts__input__check__icon {\n      opacity: 0;\n      visibility: hidden;\n      transition: all 0.4s;\n    }\n  }\n\n  .alerts__check__input {\n    display: none;\n\n    &:checked {\n      & ~ .alerts__input__check {\n\n        .alerts__input__check__icon {\n          visibility: visible;\n          opacity: 1;\n        }\n      }\n    }\n  }\n\n  .remove__input {\n    position: absolute;\n    width: 11px;\n    height: 11px;\n    right: -20px;\n    cursor: pointer;\n  }\n}\n\n.alerts__input__icon__wrapper {\n  box-shadow: inset 5px 5px 5px #AEAEC033, inset -5px -5px 5px #FFFFFFB2;\n  display: flex;\n  border-radius: 50%;\n  width: 48px;\n  height: 48px;\n  align-items: center;\n  justify-content: center;\n}\n\n.alerts__input__add {\n  // width: 304px;\n  width: 370px;\n  height: 48px;\n  border-radius: 24px;\n  box-shadow: -2px -2px 6px #FFFFFF, 2px 2px 6px #AEAEC067;\n  background: #EDEDEF;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  // margin: 0 10px;\n  cursor: pointer;\n}\n\n.login__settings__wrapper {\n  width: 1208px;\n  height: 865px;\n  background: #F0F0F3;\n  box-shadow: -10px -10px 30px #FFFFFF, 10px 10px 30px #AEAEC067;;\n  border-radius: 30px;\n  position: relative;\n}\n\n\n.password__change__label {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  &.hasValue {\n    .password__change__label__text {\n      visibility: visible;\n      opacity: 1;\n      position: relative;\n    }\n\n  }\n}\n\n.password__change__label__text {\n  display: inline-flex;\n  width: 95px;\n  height: 16px;\n  justify-content: center;\n  align-items: center;\n  border-radius: 8px 8px 0 0;\n  box-shadow: inset 5px 5px 5px #aeaec033, inset -5px -5px 5px #ffffffb2;\n  position: absolute;\n  visibility: hidden;\n  opacity: 0;\n  transition: all 0.4s;\n}\n\n.login__settings {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  width: 100%;\n  // opacity: 0;\n  // visibility: hidden;\n  transition: opacity 0.4s;\n  padding-top: 40px;\n\n  &.active {\n    opacity: 1;\n    visibility: visible;\n  }\n}\n\n.login__settings__body {\n  position: relative;\n  box-shadow: inset 0 5px 5px #aeaec033, inset 0px -5px 5px #ffffffb2;\n  height: calc(100% - 152px);\n}\n\n.login__settings__tabs {\n  display: flex;\n  width: 370px;\n  height: 48px;\n  box-shadow: 5px 5px 5px #AEAEC034, inset 5px 5px 5px #AEAEC033;\n  border-radius: 67px;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 15px;\n  margin-left: 88px;\n}\n\n.login__settings__tabs__list {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.4s;\n  cursor: pointer;\n\n\n  &.active,\n  &:hover {\n    box-shadow: inset 5px 5px 5px #aeaec033, inset -5px -5px 5px #ffffffb2;\n\n    .login__settings__tabs__icon {\n      filter: brightness(0) saturate(100%) invert(27%) sepia(99%) saturate(929%) hue-rotate(182deg) brightness(92%) contrast(83%);\n    }\n  }\n}\n",".card {\n  position: relative;\n  &.light {\n    padding-top: 25px;\n    position: relative;\n\n    .card__header{\n      margin-bottom: 30px;\n      position: relative;\n      .row {\n        align-items: center;\n        justify-content: center;\n      }\n      .card__close{\n     //   position: absolute;\n       // top: 5px;\n      //  right: 0;\n      }\n    }\n\n    .card__wallet__row {\n      background-color: transparent;\n    }\n\n    .card__wallet__rates {\n      color: #889096;\n    }\n\n    .card__wallet__usd {\n      color: #364048;\n      font-weight: bold;\n    }\n    .card__title{\n      font-weight: 600;\n      display: inline-flex;\n      align-items: center;\n    }\n    .card__product__arrow{\n      margin-left: 10px;\n    }\n  }\n}\n\n\n.card__risk__range {\n  width: 8px;\n  height: 176px;\n  //box-shadow: inset 3px 3px 3px #AEAEC033, inset -3px -3px 3px #FFFFFFB2;\n // border-radius: 88px;\n // background: #F0F0F3;\n  position: absolute;\n  left: 8px;\n  top: 0;\n  display: none; }\n  .card__risk__range.active {\n    display: block; \n    user-select: none;\n  }\n.card__risk__range__bg {\n  width: 100%;\n  height: 50%;\n  background: #F27281;\n  box-shadow: inset 3px 3px 3px #40405053;\n  border-radius: 0 0 20px 20px;\n  position: absolute;\n  bottom: 0; }\n.card__risk__range__btn {\n  width: 24px;\n  height: 24px;\n  background: #F0F0F3;\n  box-shadow: -2px -2px 6px #FFFFFF, 2px 2px 6px #36364D67;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  position: absolute;\n  top: 50%;\n  left: -8px;\n  cursor: pointer; }\n  .card__risk__range__btn__min {\n    background: #F27281;\n    width: 16px;\n    display: flex;\n    height: 16px;\n    border-radius: 50%;\n    box-shadow: inset 2px 2px 2px rgba(54, 54, 70, 0.6), inset -2px -2px 2px rgba(255, 255, 255, 0.6); }\n.card__risk__range__hr {\n  width: 176px;\n  height: 8px;\n  //box-shadow: inset 3px 3px 3px #AEAEC033, inset -3px -3px 3px #FFFFFFB2;\n  border-radius: 88px;\n // background: #F0F0F3;\n  position: absolute;\n  left: 5px;\n  top: 0;\n  display: none; }\n  .card__risk__range__hr.active {\n    user-select: none;\n    display: block; }\n.card__risk__range__bg__hr {\n  width: 50%;\n  height: 100%;\n  background: #F27281;\n  box-shadow: inset 3px 3px 3px #40405053;\n  border-radius: 20px 0 0 20px;\n  position: absolute;\n  left: 0; }\n.card__risk__range__btn__hr {\n  width: 24px;\n  height: 24px;\n  background: #F0F0F3;\n  box-shadow: -2px -2px 6px #FFFFFF, 2px 2px 6px #36364D67;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  position: absolute;\n  top: -8px;\n  left: 50%;\n  cursor: pointer; }\n  .card__risk__range__btn__hr__min {\n    background: #F27281;\n    width: 16px;\n    display: flex;\n    height: 16px;\n    border-radius: 50%;\n    box-shadow: inset 2px 2px 2px rgba(54, 54, 70, 0.6), inset -2px -2px 2px rgba(255, 255, 255, 0.6); }\n\n\n    .light_defi__unstaking .unstacking {\n      right: -20px;\n      bottom: -30px;\n    }\n\n    \n    .card__price{\n      input{\n        &::placeholder{\n              color: #889096 !important;\n              font-size: 14px !important;\n              font-weight: 600 !important;\n              line-height: 26px !important;\n            }\n      }\n    }\n    \n",".nft {\n  .card__title {\n    //height: 48px;\n    align-items: center;\n    margin: 8px 0;\n  }\n}\n\n.card__nft__wrapper {\n  width: 264px;\n // height: 192px;\n  box-shadow: inset 5px 5px 5px #AEAEC033, inset -5px -5px 5px #FFFFFFB2;\n  border-radius: 17px;\n  margin-bottom: 15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.card__nft__img {\n  width: 232px;\n  height: 160px;\n  border-radius: 17px;\n  object-fit: inherit;\n}\n","@keyframes  rotation_big {\n  from {\n    transform: rotate(243deg);\n  }\n  to{\n    transform: rotate(603deg);\n  }\n}\n\n@keyframes rotation__middle {\n  from {\n    transform: rotate(77deg);\n  }\n  to {\n    transform: rotate(437deg);\n  }\n}\n\n@keyframes rotation__small {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.login__wrapper {\n  width: 100%;\n  min-height: 100vh;\n  max-height: 1080px;\n  overflow: hidden;\n  margin: auto;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  position: relative;\n}\n\n.login__big {\n  width: 1790px;\n  height: 1782px;\n  position: absolute;\n  object-fit: contain;\n  object-position:  44px;\n  padding-left: 44px;\n  z-index: 4;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  animation: rotation_big 30s infinite  linear;\n}\n\n.login__middle {\n  width: 1100px;\n  height: 1100px;\n  position: absolute;\n  object-fit: contain;\n  z-index: 3;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  animation: rotation__middle 30s infinite linear reverse;\n}\n\n.login__small {\n  width: 828px;\n  height: 828px;\n  position: absolute;\n  object-fit: contain;\n  z-index: 2;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  animation: rotation__small 30s infinite  linear;\n}\n\n.login__round {\n  width: 1208px;\n  height: 1208px;\n  position: absolute;\n  object-fit: contain;\n  object-position: center 55px;\n  z-index: 1;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n}\n\n.login__form {\n  width: 554px;\n  height: 554px;\n  background: #F0F0F3;\n  box-shadow: -10px -10px 30px #FFFFFF, 10px 10px 30px #AEAEC067;\n  border-radius: 50%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  margin: auto;\n  z-index: 5;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.login__logo {\n  width: 200px;\n  height: 36px;\n  margin-bottom: 20px;\n  display: inline-flex;\n}\n\n.login__input__wrapper {\n  width: 304px;\n  height: 48px;\n  background: #F0F0F3;\n  border-radius: 67px;\n  box-shadow: inset 5px 5px 5px #AEAEC033, inset -5px -5px 5px #FFFFFFB2;\n  margin-bottom: 20px;\n  display: flex;\n  align-items: center;\n\n\n  .login__input {\n    width: 100%;\n    background-color: transparent;\n    border: 0;\n    outline: none;\n    text-align: center;\n    font-size: 18px;\n    line-height: 23px;\n    transition: all 0.4s;\n\n    &::placeholder {\n      color: #939A9F;\n    }\n  }\n\n}\n\n.login__btn {\n  width: 304px;\n  height: 40px;\n  box-shadow: -5px -5px 15px #FFFFFF, 5px 5px 15px #AEAEC067;\n  background: #214175;\n  color: #FFFFFF;\n  font-weight: 600;\n  font-size: 18px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 67px;\n  cursor: pointer;\n  outline: none;\n  border: 0;\n  @extend %hover__btn__blue;\n}\n\n.login__user__btn {\n  position: fixed;\n  cursor: pointer;\n  width: 128px;\n  height: 128px;\n  bottom: 24px;\n  right: 16px;\n  z-index: 99;\n}\n\n.purchase__form {\n  background: #F0F0F3;\n  width: 408px;\n  border-radius: 67px;\n  box-shadow: -10px -10px 30px #FFFFFF, 10px 10px 30px #AEAEC067;\n  padding: 40px 48px 33px;\n  position: fixed;\n  bottom: 24px;\n  right: 16px;\n  z-index: 100;\n  //visibility: hidden;\n  //opacity: 0;\n  transition: all 0.4s;\n\n  &.open {\n    visibility: visible;\n    opacity: 1;\n  }\n}\n\n.purchase__form__title {\n  text-align: center;\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 23px;\n  margin-bottom: 32px;\n\n}\n",".lds-ring {\n  display: inline-block;\n  position: relative;\n  width: 20px;\n  height: 20px;\n}\n.lds-ring div {\n  box-sizing: border-box;\n  display: block;\n  position: absolute;\n  width: 20px;\n  height: 20px;\n  margin: 0 10px;\n  border: 3px solid #fff;\n  border-radius: 50%;\n  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n  border-color: #fff transparent transparent transparent;\n}\n.lds-ring div:nth-child(1) {\n  animation-delay: -0.45s;\n}\n.lds-ring div:nth-child(2) {\n  animation-delay: -0.3s;\n}\n.lds-ring div:nth-child(3) {\n  animation-delay: -0.15s;\n}\n@keyframes lds-ring {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes rotation_l_big {\n  from {\n    transform: rotate(153deg);\n  }\n  to {\n    transform: rotate(513deg);\n  }\n}\n\n@keyframes rotation_l_mid {\n  from {\n    transform: rotate(77deg);\n  }\n  to {\n    transform: rotate(437deg);\n  }\n}\n\n@keyframes rotation_l_small {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.loading__layer {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #f0f0f3;\n}\n\n.logo-loading {\n  z-index: 0 !important;\n}\n\n.loading__wrapper {\n  width: 232px;\n  height: 232px;\n  position: relative;\n  overflow: hidden;\n  margin: auto;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.l_big {\n  width: 225px;\n  height: 225px;\n  position: absolute;\n  object-fit: contain;\n  object-position: 8px 8px;\n  z-index: 4;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  animation: rotation_l_big 5s infinite linear;\n}\n\n.l_mid {\n  width: 135px;\n  height: 135px;\n  position: absolute;\n  object-fit: contain;\n  z-index: 3;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  object-position: 4px 4px;\n  animation: rotation_l_mid 5s infinite linear reverse;\n}\n\n.l_small {\n  width: 110px;\n  height: 110px;\n  position: absolute;\n  object-fit: contain;\n  z-index: 2;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  object-position: 0.5px -0.5px;\n  animation: rotation_l_small 5s infinite linear;\n}\n\n.l_round {\n  width: 155px;\n  height: 155px;\n  position: absolute;\n  object-fit: contain;\n  z-index: 1;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n}\n\n.l_logo {\n  width: 36px;\n  height: 36px;\n  display: inline-block;\n  object-fit: contain;\n}\n",".error__message,\n.custom__error__message {\n    text-align: center;\n    font-size: 13px;\n    line-height: 23px;\n    color: #be6161;\n    display: flex;\n    justify-content: center;\n    margin: 3px 0 5px 0;\n    line-break: anywhere;\n    padding-bottom: 20px;\n}\n\n.custom__error__message {\n    //position: absolute;\n   // bottom: -25px;\n    width: 100%;\n}\n","@media (pointer: coarse) {\n  @import \"touch\";\n}\n\n@media only screen and (min-width: 1701px) and (max-width: 1930px) {\n  .wrapper.zoom__page {\n    @import \"../layout/nav\";\n    @import \"../layout/header\";\n    .zoom__page__btn .zoom__page__btn__minus{\n      opacity: 1;\n      visibility: visible;\n    }\n    @import \"mx1440\";\n    .zoom__page__btn{\n      display: block;\n    }\n    .zoom__page__btn__minus{\n      visibility: visible;\n      opacity: 1;\n    }\n    .zoom__page__btn__plus{\n      opacity: 0;\n      visibility: hidden;\n    }\n\n  }\n\n}\n\n@media only screen and (max-width: 1700px) {\n  @import \"mx1440\";\n}\n\n@media only screen and (max-width: 1365px) {\n  @import \"mx1366\";\n}\n@media only screen and (max-width: 1200px) {\n  @import \"mx1200\";\n}\n@media only screen and (max-width: 992px) {\n  @import \"mx992\";\n}\n\n@media only screen and (max-width: 767px) {\n  @import \"mx767\";\n}\n\n@media only screen and (max-width: 374px) {\n  @import \"mx374\";\n}\n","\n.nav {\n  width: 71px;\n}\n\n.header {\n  height: 56px;\n  min-height: 56px;\n  padding-left: 90px;\n\n}\n\n.nav__link {\n  width: 40px;\n  height: 40px;\n  font-size: 22px;\n\n  &:hover,\n  &.active {\n    border-radius: 8px;\n  }\n}\n\n.card {\n  max-width: 240px;\n  height: 352px;\n  margin-right: 30px;\n  margin-bottom: 30px;\n}\n\n\n.card__product__title {\n  font-size: 14px;\n}\n\n.card__risk {\n  margin-top: 12px;\n}\n\n.card__risk__chart {\n  width: 112px;\n  height: 112px;\n}\n\n.card.empty .card__risk__chart__min,\n.card__risk__chart__min {\n  width: 90px;\n  height: 90px;\n}\n\n.card__risk__chart__number {\n  font-size: 20px;\n  line-height: 26px;\n}\n\n.card__wallet__usd, .card__wallet__rates {\n  font-size: 13px;\n}\n\n\n.cart__walet__text__title{\n  font-size: 12px !important;\n}\n\n.unstacking {\n  width: 80px;\n  height: 80px;\n  font-size: 14px;\n}\n\n.card {\n  padding: 16px;\n  border-radius: 24px;\n}\n\n.card__price {\n  height: 32px;\n  border-radius: 80px;\n  font-size: 14px;\n}\n\n.card__title {\n  font-size: 14px;\n}\n\n.card.light {\n  padding-top: 20px;\n}\n\n.card.light .card__header {\n  margin-bottom: 12px;\n}\n\n.card__close {\n  width: 12px;\n  height: 12px;\n}\n\n.card__close span {\n  width: 1px;\n}\n\n.card.light .card__header .card__close {\n  // top: 1px;\n}\n\n.card__product__row {\n  margin: 0;\n  padding: 0;\n}\n\n.card__product__number {\n  font-size: 18px;\n  line-height: 23px;\n}\n\n.card__risk__range {\n  width: 6px;\n  height: 133px;\n}\n\n.card__risk__range__btn {\n  width: 18px;\n  height: 18px;\n  left: -6px;\n}\n\n.card__risk__info {\n  bottom: -15px;\n  width: 19px;\n  height: 19px;\n  font-size: 10px;\n}\n\n.card__wallet__row {\n  padding: 0 10px;\n}\n\n.zoom__page__btn,\n.layout__list, .layout__grid {\n  width: 45px;\n  height: 45px;\n  margin-bottom: 16px;\n}\n\n.layout__block {\n  right: 250px;\n  top: 65px;\n  position: fixed;\n  z-index: 9;\n}\n\n.contract__address_container {\n  width: 510px;\n \n}\n\n.layout__grid__icon {\n  width: 18px;\n  height: 18px;\n}\n\n.layout__list__icon {\n  width: 19px;\n  height: 19px;\n}\n\n.card__risk__title {\n  font-size: 14px;\n  line-height: 15px;\n  margin-bottom: 5px;\n  margin-top: 10px;\n}\n\n.card__risk__range__btn__min {\n  width: 12px;\n  height: 12px;\n}\n\n.card__risk__alert {\n  width: 48px;\n  height: 48px;\n}\n\n.card__risk__alert__title {\n  font-size: 13px;\n}\n\n.aside__wallet__title {\n  font-size: 16px;\n  line-height: 21px;\n  margin-bottom: 20px;\n  margin-top: 25px;\n}\n\n\n.main .content {\n  margin-left: 0;\n  width: calc(100% - 234px);\n  padding: 16px 24px 0 17px;\n  margin-top: 0;\n}\n\n.main:after {\n  right: 234px;\n  width: 5px;\n  top: 72px;\n}\n.filter__block__btn__block{\n  left: -90px;\n}\n.filter__block {\n  height: calc(100% - 62px);\n  width: 228px;\n}\n.asset__list__text {\n  font-size: 14px;\n}\n.asset__list__box{\n  width: 20px;\n  height: 20px;\n  border-radius: 4px;\n}\n.asset__list__box:after{\n  width: 5px;\n  height: 10px;\n}\n.asset__block{\n  border-radius: 8px;\n}\n.aside {\n  width: 234px;\n  padding: 16px;\n}\n\n.add__wallet__btn {\n  width: 200px;\n  height: 64px;\n  border-radius: 18px;\n  font-size: 16px;\n  line-height: 21px;\n  padding-left: 16px;\n}\n\n.add__wallet__btn__plus {\n  width: 40px;\n  height: 40px;\n}\n\n.add__wallet__btn__plus__bg {\n  width: 25px;\n  height: 25px;\n}\n\n.setting {\n  margin-left: 30px;\n}\n\n\n.card__risk__range__hr {\n  width: 121px;\n  height: 5px;\n}\n\n.card__risk__range__btn__hr {\n  width: 17px;\n  height: 17px;\n}\n\n.card__risk__range__btn__hr__min {\n  width: 11px;\n  height: 11px;\n}\n\n.aside__tabs__link {\n  font-size: 14px;\n  border: none;\n  outline: none;\n}\n\n.aside__chart__wrapper {\n  height: 235px;\n  margin-bottom: 30px;\n\n  .card__risk__chart {\n    width: 158px;\n    height: 158px;\n  }\n\n  .card__risk__chart__min {\n    width: 122px;\n    height: 122px;\n    border-width: 14px;\n  }\n\n  .card__risk__alert {\n    width: 64px;\n    height: 64px;\n  }\n\n  .card__risk__alert__title,\n  .card__risk__alert__number {\n    font-size: 14px;\n    line-height: 18px;\n  }\n}\n\n.aside__card__title {\n  font-size: 13px;\n  margin-bottom: 3px;\n  line-height: 17px;\n}\n\n.aside__card__numbers {\n  font-size: 16px;\n}\n\n\n.aside__card {\n  padding: 14px 16px;\n  border-radius: 18px;\n\n  .card__risk__alert {\n    width: 44px;\n    height: 44px;\n    top: 0;\n  }\n\n  .card__risk__alert__number,\n  .card__risk__alert__title {\n    font-size: 13px;\n  }\n\n  .card__risk__range__hr {\n    width: 71px;\n    height: 6px;\n  }\n\n  .card__risk__range__btn__hr {\n\n  }\n}\n\n.aside__card__progress {\n  height: 6px;\n}\n\n.card__wallet {\n  margin-bottom: 10px;\n  height: 70px;\n}\n\n.to__top {\n  width: 32px;\n  height: 32px;\n  right: 249px;\n\n}\n\n.recycle_top{\n  right: 180px !important;\n}\n\n.to__top__icon {\n  width: 20px;\n  height: 20px;\n}\n\n.card__product__unstacked,\n.card__product__stake {\n  width: 70px;\n  height: 32px;\n  font-size: 14px;\n}\n\n.card.defi {\n  .card__header {\n    padding: 0;\n  }\n\n  .card__risk {\n    margin-top: -10px;\n  }\n\n}\n\n\n.card__product__stake__block {\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\n\n.card__product__stake__amount__max,\n.card__product__stake__amount__input {\n  font-size: 14px;\n}\n\n.card__product__stake__amount__max,\n.card__product__stake__amount__input__wrapper {\n  height: 40px;\n}\n\n.card__product__stake__amount__confirm {\n  font-size: 14px;\n  height: 35px;\n}\n\n//.card__product__stake__amount {\n//  right: -145%;\n//}\n\n.add__defi__block {\n  width: 42px;\n  padding: 8px 0;\n  top: 300px;\n  right: 0px;\n}\n\n.add__defi__item {\n  width: 28px;\n  height: 28px;\n  margin-bottom: 8px;\n}\n\n.add__defi__item__icon {\n  height: 20px;\n  width: auto;\n}\n\n.card__nft__wrapper {\n   width: 192px;\n // height: 124px;\n  margin: 0 auto;\n}\n\n.card__nft__img {\n  width: 165px;\n  height: 110px;\n  object-fit: inherit;\n}\n\n.card.nft {\n\n  .card__header {\n    margin-bottom: 0;\n  }\n\n  .card__risk {\n    margin-top: 4px;\n  }\n}\n\n.login__big {\n  width: calc(1790 / 1.3 * 1px);\n  height: calc(1782 / 1.3 * 1px);\n}\n\n.login__middle {\n  width: calc(1100 / 1.3 * 1px);\n  height: calc(1100 / 1.3 * 1px);\n}\n\n.login__small {\n  width: calc(828 / 1.3 * 1px);\n  height: calc(828 / 1.3 * 1px);\n}\n\n.login__round {\n  width: calc(1208 / 1.3 * 1px);\n  height: calc(1208 / 1.3 * 1px);\n}\n\n.login__form {\n  width: calc(544 / 1.3 * 1px);\n  height: calc(544 / 1.3 * 1px);\n}\n\n.login__input__wrapper {\n  width: 285px;\n  height: 40px;\n}\n\n.login__btn {\n  width: 285px;\n}\n\n.login__logo {\n  margin-bottom: 20px;\n}\n\n.card.new .add__wallet,\n.card.empty .add__wallet {\n  width: 112px;\n  height: 112px;\n}\n\n.card.new .add__wallet .add__wallet__btn__bg,\n.card.empty .add__wallet .add__wallet__btn__bg {\n  width: 60px;\n  height: 60px;\n}\n\n.card.new .add__wallet .save__text,\n.card.empty .add__wallet .save__text {\n  font-size: 16px;\n}\n\n.card.new .add__wallet .plus__wrapper span,\n.card.empty .add__wallet .plus__wrapper span {\n  width: 20px;\n  height: 3px;\n}\n\n.card.new .add__wallet.save,\n.card.empty .add__wallet.save {\n  top: 190px;\n}\n\n.card__product__row .product__row__dropdown .product__row__dropdown__item {\n  font-size: 14px;\n  padding: 3px 0;\n}\n\n.card__product__row .product__row__dropdown {\n  top: 24px;\n  padding: 2px 12px;\n}\n\n.menu__open {\n  width: 80px;\n  height: 80px;\n  right: -40px;\n}\n\n.menu__open__btn {\n  width: 24px;\n  height: 24px;\n}\n\n.menu__open__icon {\n  width: 14px;\n  height: 14px;\n}\n\n.card.trash .trash__wallet {\n  width: 100px;\n  height: 100px;\n  top: 60px;\n}\n\n.trash__wallet__icon {\n  width: 33px;\n  height: 36px;\n}\n\n.empty__trash__title {\n  font-size: 76px;\n}\n\n.light_core_activate_title {\n  font-size: 40px !important;\n}\n\n.card__list__anchor,\n.card__list__title {\n  font-size: 14px;\n}\n\n.card__list {\n  width: 256px;\n  height: 64px;\n  border-radius: 20px;\n  padding: 8px;\n  margin-right: 70px;\n}\n\n.card__risk__chart__list {\n  width: 80px;\n  height: 80px;\n  right: -40px;\n}\n\n.card__list__percent {\n  margin-right: 13px;\n  width: 48px;\n  height: 48px;\n}\n\n.card__risk__chart__list__number {\n  font-size: 18px;\n}\n\n.zoom__page__btn {\n  display: none;\n}\n\n.card__chart__wrapper {\n  width: 572px;\n  height: 410px;\n  padding: 17px 40px 17px 56px;\n  // left: 205px;\n}\n\n.card__chart {\n  width: 464px;\n  height: 282px;\n}\n\n.check__wrapper .checkbox__box {\n  width: 18px;\n  height: 18px;\n}\n\n.check__wrapper .checkbox__label {\n  font-size: 14px;\n  line-height: 18px;\n  font-weight: 600;\n}\n\n.card__chart__title {\n  font-size: 14px;\n  line-height: 18px;\n  font-weight: 600;\n}\n\n.card__chart__dropdown__selected {\n  font-size: 14px;\n  line-height: 18px;\n  width: 70px;\n}\n\n.card__chart__dropdown__selected:after {\n  width: 70px;\n}\n\n.card__chart__header {\n  margin-bottom: 17px;\n}\n\n.card__chart__close {\n  width: 15px;\n  height: 15px;\n}\n\n\n/////////@\n\n.card__round__shadow {\n  width: 90px;\n  height: 90px;\n}\n\n// .card__risk__chart__min__wrapper_aside{\n//   top: 32% !important;\n// }\n\n.round__shdow {\n  width: 120px;\n  height: 120px;\n}\n\n.rangeslider-vertical {\n  height: 133px !important;\n}\n\n.card__round__shadow__defi__list {\n  top: 13px;\n  left: 13px;\n}\n\n.aside__nth__title {\n  font-size: 14px !important;\n  line-height: 20px !important;\n\n}\n\n.card__product__title {\n  width: 168px !important;\n}\n\n.current__card .rangeslider-horizontal {\n  width: 105px !important;\n}\n\n.card .card__risk__chart {\n  svg {\n    width: 95px;\n    height: 95px;\n  }\n}\n\n.aside__chart__wrapper {\n  .card__risk__chart {\n    svg {\n      width: 128px;\n      width: 128px;\n    }\n  }\n}\n\n.login_requests__message {\n  width: 85% !important;\n}\n\n.psw_requests__message {\n  width: 80% !important;\n}\n\n.ntf__security__title {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  width: 118px;\n  height: 1.2em;\n  white-space: nowrap;\n}\n\n.card.empty {\n  .error__message.requests__message ~ .add__wallet.save {\n\n    top: 160px;\n\n  }\n\n}\n\n.user__info {\n  margin-left: 30px;\n  margin-right: 30px;\n}\n\n.login__settings__wrapper {\n  max-width: 1208px;\n  width: calc(100% - 460px);\n}\n\n.settings__tabs__link {\n  font-size: 18px;\n  width: 230px;\n}\n\n.unstake__error__modal {\n  width: 247px !important;\n  left: -19px !important;\n}\n\n.unstake__error__modal__title {\n  // width: 220px !important;\n}\n\n.contract__address_content{\n  width: 340px;\n}\n\n/*Staking Risk CSS*/\n\n.card__product__wrapper{\n\n  // .card_product_scroller{   \n  //   height: 98px;   \n  //   border-radius: 16px;\n  //   box-shadow: -5px -5px 5px 0px #FFFFFFBF inset,\n  //                5px 5px 5px 0px #AEAEC033 inset;\n  //   width: 100%;\n  //   overflow-y: auto;\n\n  // }\n  .card_product_scroller_item{\n    display: flex;\n    justify-content: space-around;\n    flex-wrap: nowrap;\n    padding: 5px 10px;\n  }\n  .card_product_scroller_item:nth-child(odd){\n    background: #8484840D;\n   \n  }\n  .card_product_scroller_item:nth-child(even){\n   \n  }\n\n  .card_product_scroller_item_title{\n    font-family: Assistant;\n    font-weight: 600;\n    font-size: 14px;\n    padding-left: 10px;   \n    color: #364048;\n  }\n  .card_product_scroller_item_level{\n    font-family: Assistant;\n    font-weight: 600;\n    font-size: 14px;   \n     padding-right: 10px;\n    text-align: right;\n    color: #4DC7B5;\n    }\n    \n   \n}\n",".active__page__main{\n    width: 100% !important;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
